var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16, _symbol17, _symbol18, _symbol19, _symbol20, _symbol21, _symbol22, _symbol23, _symbol24, _symbol25, _symbol26, _symbol27, _symbol28, _symbol29, _symbol30, _symbol31, _symbol32, _symbol33, _symbol34, _symbol35, _symbol36, _symbol37, _symbol38, _symbol39, _symbol40, _symbol41, _symbol42, _symbol43, _symbol44, _symbol45, _symbol46, _symbol47, _symbol48, _symbol49, _symbol50, _symbol51, _symbol52, _symbol53, _symbol54, _symbol55, _symbol56, _symbol57, _symbol58, _symbol59, _symbol60, _symbol61, _symbol62, _symbol63, _symbol64, _symbol65, _symbol66, _symbol67, _symbol68, _symbol69, _symbol70, _symbol71, _symbol72, _symbol73, _symbol74, _symbol75, _symbol76, _symbol77, _symbol78, _symbol79, _symbol80, _symbol81, _symbol82, _symbol83, _symbol84, _symbol85, _symbol86, _symbol87, _symbol88, _symbol89, _symbol90, _symbol91, _symbol92, _symbol93, _symbol94, _symbol95, _symbol96, _symbol97, _symbol98, _symbol99, _symbol100, _symbol101, _symbol102, _symbol103, _symbol104, _symbol105, _symbol106, _symbol107, _symbol108, _symbol109, _symbol110, _symbol111, _symbol112, _symbol113, _symbol114, _symbol115, _symbol116, _symbol117, _symbol118, _symbol119, _symbol120, _symbol121, _symbol122, _symbol123, _symbol124, _symbol125, _symbol126, _symbol127, _symbol128, _symbol129, _symbol130, _symbol131, _symbol132, _symbol133, _symbol134, _symbol135, _symbol136, _symbol137, _symbol138, _symbol139, _symbol140, _symbol141, _symbol142, _symbol143, _symbol144, _symbol145, _symbol146, _symbol147, _symbol148, _symbol149, _symbol150, _symbol151, _symbol152, _symbol153, _symbol154, _symbol155, _symbol156, _symbol157, _symbol158, _symbol159, _symbol160, _symbol161, _symbol162, _symbol163, _symbol164, _symbol165, _symbol166, _symbol167, _symbol168, _symbol169, _symbol170, _symbol171, _symbol172, _symbol173, _symbol174, _symbol175, _symbol176, _symbol177, _symbol178, _symbol179, _symbol180, _symbol181, _symbol182, _symbol183, _symbol184, _symbol185, _symbol186, _symbol187, _symbol188, _symbol189, _symbol190, _symbol191, _symbol192, _symbol193, _symbol194, _symbol195, _symbol196, _symbol197, _symbol198, _symbol199, _symbol200, _symbol201, _symbol202, _symbol203, _symbol204, _symbol205, _symbol206, _symbol207, _symbol208, _symbol209, _symbol210, _symbol211, _symbol212, _symbol213, _symbol214, _symbol215, _symbol216, _symbol217, _symbol218, _symbol219, _symbol220, _symbol221, _symbol222, _symbol223, _symbol224, _symbol225, _symbol226, _symbol227, _symbol228, _symbol229, _symbol230, _symbol231, _symbol232, _symbol233, _symbol234, _symbol235, _symbol236, _symbol237, _symbol238, _symbol239, _symbol240, _symbol241, _symbol242, _symbol243, _symbol244, _symbol245, _symbol246, _symbol247, _symbol248, _symbol249, _symbol250, _symbol251, _symbol252, _symbol253, _symbol254, _symbol255, _symbol256, _symbol257, _symbol258, _symbol259, _symbol260, _symbol261, _symbol262, _symbol263, _symbol264, _symbol265, _symbol266, _symbol267, _symbol268, _symbol269, _symbol270, _symbol271, _symbol272, _symbol273, _symbol274, _symbol275, _symbol276, _symbol277, _symbol278, _symbol279, _symbol280, _symbol281, _symbol282, _symbol283, _symbol284, _symbol285, _symbol286, _symbol287, _symbol288, _symbol289, _symbol290, _symbol291, _symbol292, _symbol293, _symbol294, _symbol295, _symbol296, _symbol297, _symbol298, _symbol299, _symbol300, _symbol301, _symbol302, _symbol303, _symbol304, _symbol305, _symbol306, _symbol307, _symbol308, _symbol309, _symbol310, _symbol311, _symbol312, _symbol313, _symbol314, _symbol315, _symbol316, _symbol317, _symbol318, _symbol319, _symbol320, _symbol321, _symbol322, _symbol323, _symbol324, _symbol325, _symbol326, _symbol327, _symbol328, _symbol329, _symbol330, _symbol331, _symbol332, _symbol333, _symbol334, _symbol335, _symbol336, _symbol337, _symbol338, _symbol339, _symbol340, _symbol341, _symbol342, _symbol343, _symbol344, _symbol345, _symbol346, _symbol347, _symbol348, _symbol349, _symbol350, _symbol351, _symbol352, _symbol353, _symbol354, _symbol355, _symbol356, _symbol357, _symbol358, _symbol359, _symbol360, _symbol361, _symbol362, _symbol363, _symbol364, _symbol365, _symbol366, _symbol367, _symbol368, _symbol369, _symbol370, _symbol371, _symbol372, _symbol373, _symbol374, _symbol375, _symbol376, _symbol377, _symbol378, _symbol379, _symbol380, _symbol381, _symbol382, _symbol383, _symbol384, _symbol385, _symbol386, _symbol387, _symbol388, _symbol389, _symbol390, _symbol391, _symbol392, _symbol393, _symbol394, _symbol395, _symbol396, _symbol397, _symbol398, _symbol399, _symbol400, _symbol401, _symbol402, _symbol403, _symbol404, _symbol405, _symbol406, _symbol407, _symbol408, _symbol409, _symbol410, _symbol411, _symbol412, _symbol413, _symbol414, _symbol415, _symbol416, _symbol417, _symbol418, _symbol419, _symbol420, _symbol421, _symbol422, _symbol423, _symbol424, _symbol425, _symbol426, _symbol427, _symbol428, _symbol429, _symbol430, _symbol431, _symbol432, _symbol433, _symbol434, _symbol435, _symbol436, _symbol437, _symbol438, _symbol439, _symbol440, _symbol441, _symbol442, _symbol443, _symbol444, _symbol445, _symbol446, _symbol447, _symbol448, _symbol449, _symbol450, _symbol451, _symbol452, _symbol453, _symbol454, _symbol455, _symbol456, _symbol457, _symbol458, _symbol459, _symbol460, _symbol461, _symbol462, _symbol463, _symbol464, _symbol465, _symbol466, _symbol467, _symbol468, _symbol469, _symbol470, _symbol471, _symbol472, _symbol473, _symbol474, _symbol475, _symbol476, _symbol477, _symbol478, _symbol479, _symbol480, _symbol481, _symbol482, _symbol483, _symbol484, _symbol485, _symbol486, _symbol487, _symbol488, _symbol489, _symbol490, _symbol491, _symbol492, _symbol493, _symbol494, _symbol495, _symbol496, _symbol497, _symbol498, _symbol499, _symbol500, _symbol501, _symbol502, _symbol503, _symbol504, _symbol505, _symbol506, _symbol507, _symbol508, _symbol509, _symbol510, _symbol511, _symbol512, _symbol513, _symbol514, _symbol515, _symbol516, _symbol517, _symbol518, _symbol519, _symbol520, _symbol521, _symbol522, _symbol523, _symbol524, _symbol525, _symbol526, _symbol527, _symbol528, _symbol529, _symbol530, _symbol531, _symbol532, _symbol533, _symbol534, _symbol535, _symbol536, _symbol537, _symbol538, _symbol539, _symbol540, _symbol541, _symbol542, _symbol543, _symbol544, _symbol545, _symbol546, _symbol547, _symbol548, _symbol549, _symbol550, _symbol551, _symbol552, _symbol553, _symbol554, _symbol555, _symbol556, _symbol557, _symbol558, _symbol559, _symbol560, _symbol561, _symbol562, _symbol563, _symbol564, _symbol565, _symbol566, _symbol567, _symbol568, _symbol569, _symbol570, _symbol571, _symbol572, _symbol573, _symbol574, _symbol575, _symbol576, _symbol577, _symbol578, _symbol579, _symbol580, _symbol581, _symbol582, _symbol583, _symbol584, _symbol585, _symbol586, _symbol587, _symbol588, _symbol589, _symbol590, _symbol591, _symbol592, _symbol593, _symbol594, _symbol595, _symbol596, _symbol597, _symbol598, _symbol599, _symbol600, _symbol601, _symbol602, _symbol603, _symbol604, _symbol605, _symbol606, _symbol607, _symbol608, _symbol609, _symbol610, _symbol611, _symbol612, _symbol613, _symbol614, _symbol615, _symbol616, _symbol617, _symbol618, _symbol619, _symbol620, _symbol621, _symbol622, _symbol623, _symbol624, _symbol625, _symbol626, _symbol627, _symbol628, _symbol629, _symbol630, _symbol631, _symbol632, _symbol633, _symbol634, _symbol635, _symbol636, _symbol637, _symbol638, _symbol639, _symbol640, _symbol641, _symbol642, _symbol643, _symbol644, _symbol645, _symbol646, _symbol647, _symbol648, _symbol649, _symbol650, _symbol651, _symbol652, _symbol653, _symbol654, _symbol655, _symbol656, _symbol657, _symbol658, _symbol659, _symbol660, _symbol661, _symbol662, _symbol663, _symbol664, _symbol665, _symbol666, _symbol667, _symbol668, _symbol669, _symbol670, _symbol671, _symbol672, _symbol673, _symbol674, _symbol675, _symbol676, _symbol677, _symbol678, _symbol679, _symbol680, _symbol681, _symbol682, _symbol683, _symbol684, _symbol685, _symbol686, _symbol687, _symbol688, _symbol689, _symbol690, _symbol691, _symbol692, _symbol693, _symbol694, _symbol695, _symbol696, _symbol697, _symbol698, _symbol699, _symbol700, _symbol701, _symbol702, _symbol703, _symbol704, _symbol705, _symbol706, _symbol707, _symbol708, _symbol709, _symbol710, _symbol711, _symbol712, _symbol713, _symbol714, _symbol715, _symbol716, _symbol717, _symbol718, _symbol719, _symbol720, _symbol721, _symbol722, _symbol723, _symbol724, _symbol725, _symbol726, _symbol727, _symbol728, _symbol729, _symbol730, _symbol731, _symbol732, _symbol733, _symbol734, _symbol735, _symbol736, _symbol737, _symbol738, _symbol739, _symbol740, _symbol741, _symbol742;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudiSprite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      display: "none"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, ">", _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-adblue-alert-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "adblue-alert-large"), /*#__PURE__*/React.createElement("path", {
    d: "M26.5 29.5l-2.2 1.4c-1 .6-2.2.3-2.8-.7l-1-1.7L16 31l-4.5-7.5L16 21l-2.5-4L35.3 3.5c.9-.6 2.1-.3 2.7.6L46.5 17l-7 4.5m-28 7s-9 3.5-9 18h5s-.5-10.5 4-18zm34 9h-20l10-18 10 18zM35.5 25v6m0 2v2M16 21s3.45-1.811 3.5-3.5c.047 0 1.3 3 3 3 1.69 0 2.984-1.025 3-3 .05 0 1.2 3 3 3 1.788 0 2.984-1.026 3-3",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-adblue-alert-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "adblue-alert-small"), /*#__PURE__*/React.createElement("path", {
    d: "M12.6 15.5c-.9.6-2.1.4-2.7-.5l-.4-.5L7 16l-2.5-3.5 3-2-1.5-2 10.8-6.9c.9-.6 2.2-.3 2.8.6l3.7 6.3-2.8 2m-16 5S.5 18 .5 24m22.7-2.5H11.8l5.7-12 5.7 12zM17.5 14v3m0 1v2m-3-9.5c-2.067 0-3.067-1.003-3-3.01-.028 2.958-3 3.01-3 3.01h-1",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-adblue-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "adblue-large"), /*#__PURE__*/React.createElement("path", {
    d: "M16 21l-2.5-4L35.3 3.5c.9-.6 2.1-.3 2.7.6L46.5 17 24.3 30.9c-1 .6-2.2.3-2.8-.7l-1-1.7L16 31l-4.5-7.5L16 21zm-4.5 7.5s-9 3.5-9 18h5s-.5-10.5 4-18zM16 21s3.45-1.811 3.5-3.5c.047 0 1.3 3 3 3 1.69 0 2.984-1.025 3-3 .05 0 1.2 3 3 3 1.788 0 2.984-1.026 3-3 .041 0 1.3 3 3 3 1.689 0 2.983-1.026 3-3 .04 0 1.3 3 3.2 3h.082",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-adblue-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "adblue-small"), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 14.5L7 16l-2.5-3.5 3-2-1.5-2 10.5-6.8c.9-.6 2.2-.3 2.8.6l4 6.2-10.7 7c-.9.6-2.1.4-2.7-.5l-.4-.5zm-5 1S.5 18 .5 24m19.8-13.5c-2 0-2.937-.997-2.81-2.99-.029 2.956-2.99 2.99-2.99 2.99-2.067 0-3.067-1.003-3-3.01-.028 2.958-3 3.01-3 3.01h-1",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-address-book-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "address-book-large"), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 2.5h32v43h-32v-43zm32 28h4c1.1 0 2 .9 2 2v11c0 1.1-.9 2-2 2h-4m0-29h4c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2h-4m0-28h4c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2h-4m-25 19v-9c0-1.7 1.3-3 3-3h11c1.7 0 3 1.3 3 3v9h-17zm7-24h2.9c1.7 0 3.1 1.4 3.1 3.1v2.9c0 1.7-1.3 3-3 3h-3c-1.7 0-3-1.3-3-3v-3c0-1.7 1.3-3 3-3z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-address-book-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "address-book-small"), /*#__PURE__*/React.createElement("path", {
    d: "M1.5.5h17v23h-17V.5zm17 15h2c.6 0 1 .4 1 1v6c0 .6-.4 1-1 1h-2m-.5-16h2.5c.6 0 1 .4 1 1v6c0 .6-.4 1-1 1H18m.5-15h2c.6 0 1 .4 1 1v5c0 .6-.4 1-1 1h-2m-5 5c.5 0 1 .4 1 1v4h-9v-4c0-.5.5-1 1-1h7zm-3-7c1.1 0 2 .9 2 2v1c0 1.1-.9 2-2 2h-1c-1.1 0-2-.9-2-2v-1c0-1.1.9-2 2-2h1z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-administrator-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "administrator-large"), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 34.5v6l-4 4h-5l-.5-1 3-3v-1L8.5 36h-1l-3 3-1-.5v-5l4-4h6l16-16v-6l4-4h5l.5 1-3 3v1l3.5 3.5h1l3-3 1 .5v5l-4 4h-6z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-administrator-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "administrator-small"), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 17.5V21L7 23.5H4l-.5-.5L5 21.5l.5-1-2-2-1 .5L1 20.5.5 20v-3L3 14.5h3.5l8-8V3L17 .5h3l.5.5-1.8 1.7-.2.8 2 2 .8-.2L23 3.5l.5.5v3L21 9.5h-3.5z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-air-filter-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "air-filter-large"), /*#__PURE__*/React.createElement("path", {
    d: "M34.5 16V5.5h-16a4 4 0 0 0-4 4v30a4 4 0 0 0 4 4h16V39M46 15.781a11.622 11.622 0 0 0-3.429 1.719 11.638 11.638 0 0 1-13.714 0A11.635 11.635 0 0 0 20 15.438m26 8.343a11.622 11.622 0 0 0-3.429 1.719 11.638 11.638 0 0 1-13.714 0A11.635 11.635 0 0 0 20 23.438m26 8.343a11.622 11.622 0 0 0-3.429 1.719 11.638 11.638 0 0 1-13.714 0A11.635 11.635 0 0 0 20 31.438M3 17.5H2m3 1H4m3 1H6m3 0H8m3 0h-1m3-1h-1m-9 7H2m3 1H4m3 1H6m3 0H8m3 0h-1m3-1h-1m-9 7H2m3 1H4m3 1H6m3 0H8m3 0h-1m3-1h-1",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-air-filter-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "air-filter-small"), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 7V2.5h-8a2 2 0 0 0-2 2v15a2 2 0 0 0 2 2h8V20M23 7.64a5.812 5.812 0 0 0-1.714.86 5.82 5.82 0 0 1-6.857 0A5.817 5.817 0 0 0 10 7.47m13 4.17a5.812 5.812 0 0 0-1.714.86 5.82 5.82 0 0 1-6.857 0A5.817 5.817 0 0 0 10 11.47m13 4.17a5.812 5.812 0 0 0-1.714.86 5.82 5.82 0 0 1-6.857 0A5.817 5.817 0 0 0 10 15.47M4 9.5H3m-1-1H1m5 1H5m-1 4H3m-1-1H1m5 1H5m-1 4H3m-1-1H1m5 1H5",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-announcements-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "announcements-large"), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 12.5v14h-6l5.5 16h-7.5l-5-16h-7v-14h20zm0 0c7.3 0 17.5-6 17.5-6 2 0 3.5 5.2 3.5 13s-1.5 13-3.5 13c0 0-10.2-6-17.5-6",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-announcements-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "announcements-small"), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 5.5v8h-3l3 9h-4l-3-9h-4v-8h11zm0 0c3.9 0 10-3 10-3 1.2 0 2 2.5 2 7s-.8 7-2 7c0 0-6.1-3-10-3",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-anti-theft-alarm-system-alert-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "anti-theft-alarm-system-alert-large"), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 36.5h24c.6 0 1 .4 1 1v4c0 .6-.4 1-1 1h-24c-.6 0-1-.4-1-1v-4c0-.6.4-1 1-1zm2.4 0l3.8-20c0-.6.3-1 .8-1H26m6.5 9l1.9 12-1.9-12zM24.5 2v10M16 14L9 7M4 23.5h10m31.5-2h-20l10-18 10 18zM35.5 9v6m0 2v2",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-anti-theft-alarm-system-alert-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "anti-theft-alarm-system-alert-small"), /*#__PURE__*/React.createElement("path", {
    d: "M5.1 20.5H19c.3 0 .6.3.6.6V23c0 .3-.3.6-.6.6H5.1c-.3 0-.6-.3-.6-.6v-1.9c0-.3.3-.6.6-.6zm11.4-6l1 6-1-6zM6 20.5L8.2 8.8c0-.3.3-.3.6-.3H11m.5-8.5v6M6.9 7.2l-4-4M0 12.5h5m18.2 0H11.8L17.5 1l5.7 11.5zM17.5 5v3m0 1v2",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-anti-theft-alarm-system-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "anti-theft-alarm-system-large"), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 36.5h24c.6 0 1 .4 1 1v4c0 .6-.4 1-1 1h-24c-.6 0-1-.4-1-1v-4c0-.6.4-1 1-1zm2.1 0l3.9-20c0-.5.3-1 .8-1h10.1c.5 0 .9.4.9.9v.1l4 20m.7-12h10M34 14l7.1-7M24.5 2v10M16 14L9 7M4 24.5h10",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-anti-theft-alarm-system-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "anti-theft-alarm-system-small"), /*#__PURE__*/React.createElement("path", {
    d: "M5.1 20.5H19c.3 0 .6.2.6.5v2c0 .3-.3.5-.6.5H5.1c-.3 0-.6-.2-.6-.5v-2c0-.3.3-.5.6-.5zm.9 0L8.4 8.8c0-.3.2-.3.5-.3h6.2c.3 0 .5 0 .5.3L18 20.5m1-8h5m-6.8-5.3l4-4.1M11.5 0v6M6.9 7.2l-4-4.1M0 12.5h5",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-apps-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "apps-large"), /*#__PURE__*/React.createElement("path", {
    d: "M38.5 9.5h3c1.7 0 3 1.3 3 3v29c0 1.7-1.3 3-3 3h-29c-1.7 0-3-1.3-3-3v-3m-3-35h29c1.7 0 3 1.3 3 3v29c0 1.7-1.3 3-3 3h-29c-1.7 0-3-1.3-3-3v-29c0-1.7 1.3-3 3-3zm24.4 15.2a4.6 4.6 0 1 0 0-9.2 4.6 4.6 0 0 0 0 9.2zm-19.8 0a4.6 4.6 0 1 0 0-9.2 4.6 4.6 0 0 0 0 9.2zm6.6 0a4.6 4.6 0 1 0 0-9.2 4.6 4.6 0 0 0 0 9.2zm6.6 0a4.6 4.6 0 1 0 0-9.2 4.6 4.6 0 0 0 0 9.2z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-apps-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "apps-small"), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 3c1.2.5 2 1.7 2 3v14.2c0 1.8-1.5 3.3-3.3 3.3H6.1c-1.3 0-2.5-.8-3-2m.4-21h15c1.7 0 3 1.3 3 3v15c0 1.7-1.3 3-3 3h-15c-1.7 0-3-1.3-3-3v-15c0-1.7 1.3-3 3-3zm12.9 9a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zm-10.8 0a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zm3.6 0a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zm3.6 0a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol19 || (_symbol19 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-arrow-down-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "arrow-down-large"), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 19.5l9 9 9-9",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol20 || (_symbol20 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-arrow-down-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "arrow-down-small"), /*#__PURE__*/React.createElement("path", {
    d: "M7 10l5.5 5.5L18 10",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol21 || (_symbol21 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-arrow-left-light-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "arrow-left-light-large"), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 14V6.5H22M30.5 42V27.5c0-3.2-1.3-6.2-3.5-8.5L14.5 6.5",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol22 || (_symbol22 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-arrow-left-light-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "arrow-left-light-small"), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 24v-9.2c0-2.1-.8-4.2-2.3-5.7L7.5 1.5m0 6.5V1.5H14",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol23 || (_symbol23 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-arrow-left-normal-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "arrow-left-normal-large"), /*#__PURE__*/React.createElement("path", {
    d: "M19.8 27.8l-5.3-5.3 5.3-5.3M30.5 42V22.5h-16",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol24 || (_symbol24 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-arrow-left-normal-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "arrow-left-normal-small"), /*#__PURE__*/React.createElement("path", {
    d: "M10 16l-4.5-4.5L10 7m7.5 17V11.5h-12",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol25 || (_symbol25 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-arrow-left-sharp-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "arrow-left-sharp-large"), /*#__PURE__*/React.createElement("path", {
    d: "M30.5 42V6.5l-16 16m7.5 0h-7.5V15",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol26 || (_symbol26 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-arrow-left-sharp-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "arrow-left-sharp-small"), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 24V1.5l-10 10m6.5 0H7.5V5",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol27 || (_symbol27 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-arrow-left-u-turn-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "arrow-left-u-turn-large"), /*#__PURE__*/React.createElement("path", {
    d: "M20 17l-5.5 5.5L9 17m21.5 25V14.5c0-4.4-3.6-8-8-8s-8 3.6-8 8v8",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol28 || (_symbol28 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-arrow-left-u-turn-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "arrow-left-u-turn-small"), /*#__PURE__*/React.createElement("path", {
    d: "M12 8l-4.5 4.5L3 8m14.5 16V6.5c0-2.8-2.2-5-5-5s-5 2.2-5 5v6",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol29 || (_symbol29 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-arrow-right-light-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "arrow-right-light-large"), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 42V27.5c0-3.2 1.3-6.2 3.5-8.5L32.5 6.5m-7.5 0h7.5V14",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol30 || (_symbol30 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-arrow-right-light-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "arrow-right-light-small"), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 24v-9.2c0-2.1.8-4.2 2.3-5.7l7.7-7.6m-6.5 0h6.5V8",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol31 || (_symbol31 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-arrow-right-normal-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "arrow-right-normal-large"), /*#__PURE__*/React.createElement("path", {
    d: "M33.5 22.5h-17V42M28 17l5.5 5.5L28 28",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol32 || (_symbol32 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-arrow-right-normal-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "arrow-right-normal-small"), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 11.5h-12V24M14 7l4.5 4.5L14 16",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol33 || (_symbol33 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-arrow-right-sharp-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "arrow-right-sharp-large"), /*#__PURE__*/React.createElement("path", {
    d: "M32.5 22.5l-16-16V42m16-27v7.5H25",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol34 || (_symbol34 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-arrow-right-sharp-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "arrow-right-sharp-small"), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 11.5l-10-10V24m10-19v6.5H10",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol35 || (_symbol35 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-arrow-right-u-turn-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "arrow-right-u-turn-large"), /*#__PURE__*/React.createElement("path", {
    d: "M32.5 22.5v-8c0-4.4-3.6-8-8-8s-8 3.6-8 8V42M38 17l-5.5 5.5L27 17",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol36 || (_symbol36 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-arrow-right-u-turn-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "arrow-right-u-turn-small"), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 24V6.5c0-2.8 2.2-5 5-5s5 2.2 5 5v6M21 8l-4.5 4.5L12 8",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol37 || (_symbol37 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-arrow-straight-down-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "arrow-straight-down-large"), /*#__PURE__*/React.createElement("path", {
    d: "M28 37l-5.5 5.5L17 37m5.5 5.5V7",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol38 || (_symbol38 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-arrow-straight-down-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "arrow-straight-down-small"), /*#__PURE__*/React.createElement("path", {
    d: "M16 18l-4.5 4.5L7 18m4.5 4.5V0",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol39 || (_symbol39 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-arrow-straight-up-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "arrow-straight-up-large"), /*#__PURE__*/React.createElement("path", {
    d: "M17 12l5.5-5.5L28 12m-5.5 30V6.5",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol40 || (_symbol40 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-arrow-straight-up-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "arrow-straight-up-small"), /*#__PURE__*/React.createElement("path", {
    d: "M7 6l4.5-4.5L16 6m-4.5 18V1.5",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol41 || (_symbol41 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-arrow-up-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "arrow-up-large"), /*#__PURE__*/React.createElement("path", {
    d: "M33.5 28.5l-9-9-9 9",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol42 || (_symbol42 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-arrow-up-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "arrow-up-small"), /*#__PURE__*/React.createElement("path", {
    d: "M18 15.5L12.5 10 7 15.5",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol43 || (_symbol43 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-audio-volume-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "audio-volume-large"), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 30.5h-8v-13h8v13zm.2-.3l8.8 6.3v-25l-8.8 6.3m20.6-6.5s13.8 12.1.1 25.4m-5.1-20s6.8 7.1 0 14.6",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol44 || (_symbol44 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-audio-volume-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "audio-volume-small"), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 14.5h-4v-6h4v6zm0 0l4 2.9V5.6l-4 2.9m10 9.2c6.7-6.5 0-12.3 0-12.3M15 15c1.9-2 1.9-5.1 0-7.1",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol45 || (_symbol45 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-aupeo-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "aupeo-large"), /*#__PURE__*/React.createElement("path", {
    d: "M24 4C12.954 4 4 12.954 4 24c0 4.989 1.826 9.55 4.847 13.054m1.576 1.632A19.924 19.924 0 0 0 24 44c8.534 0 15.819-5.344 18.691-12.869m.704-2.228C43.79 27.334 44 25.692 44 24c0-10.326-7.825-18.824-17.868-19.888M19.5 15.5v17L34 24l-14.5-8.5z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol46 || (_symbol46 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-aupeo-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "aupeo-small"), /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5C6.201 1.5 1.5 6.201 1.5 12c0 2.53.894 4.85 2.384 6.662m1.345 1.364A10.458 10.458 0 0 0 12 22.5c4.372 0 8.12-2.673 9.7-6.473m.529-1.646c.177-.765.271-1.562.271-2.381 0-5.304-3.932-9.689-9.04-10.4M9.5 7.5v9l8-4.5-8-4.5z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol47 || (_symbol47 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-back-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "back-large"), /*#__PURE__*/React.createElement("path", {
    d: "M28.6 14.4l-9.1 9.1 9.1 9.1",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol48 || (_symbol48 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-back-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "back-small"), /*#__PURE__*/React.createElement("path", {
    d: "M14 16.9l-5.5-5.4L14 6.1",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol49 || (_symbol49 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-battery-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "battery-large"), /*#__PURE__*/React.createElement("path", {
    d: "M25 16l-5 8.98h8.2L23 34M19 8h-5v32a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4V8h-5M19 8V4h10v4M19 8h10",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol50 || (_symbol50 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-battery-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "battery-small"), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 2.5h5m-2 6.5L10 13.49h4.1L11.5 18M17 5.5v15a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2v-15h10z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol51 || (_symbol51 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-blog-post-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "blog-post-large"), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 41.5v-12c0-1.7 1.3-3 3-3h18c1.7 0 3 1.3 3 3v12h-24zm9-31h6c1.7 0 3 1.3 3 3v6c0 1.7-1.3 3-3 3h-6c-1.7 0-3-1.4-3-3v-5.9c0-1.7 1.4-3.1 3-3.1zm20-3.9s11.1 9.6 0 19.4m-5.3-15.5s5.1 5.5 0 10.7",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol52 || (_symbol52 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-blog-post-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "blog-post-small"), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 22.5v-6.9c0-.6.4-1 1-1.1h11.1c.6 0 1 .5 1 1.1v6.9H1.5zm5-18h3c1.1 0 2 .9 2 2v3c0 1.1-.9 2-2 2h-3c-1.1 0-2-.9-2-2v-3c0-1.1.9-2 2-2zm8.7-.1s3 3.2 0 6.2m3.5-8.7s6.4 5.5 0 11.1",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol53 || (_symbol53 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-bonnet-open-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "bonnet-open-large"), /*#__PURE__*/React.createElement("path", {
    d: "M33 28.5H15a4 4 0 0 1-4 4h-.5a4 4 0 0 1-4-4H3.258c-.971 0-1.758-.787-1.758-1.758v-.351c0-1.406.039-1.993.273-2.696.351-1.055 1.758-2.46 3.867-3.164 1.406-.468 3.867-.937 7.382-1.406 2.948-2.837 4.94-4.477 5.976-4.921 1.2-.514 3.717-.69 6.327-.703 2.745-.014 5.59.162 7.031.703 2.812 1.054 7.03 3.867 9.14 4.218a27.03 27.03 0 0 1 2.243.473c1.176.3 1.788 1.457 2.11 2.531.322 1.074.721 3.415.647 4.574-.075 1.16-1.008 2.216-2.167 2.3l-2.829.2a4 4 0 0 1-4 4H37a4 4 0 0 1-4-4zM11 18l-.105-.255A110.23 110.23 0 0 1 9.86 16.67C7.69 14.314 6.087 13 4.986 13 3.102 13 2.75 13.438 2 14.25",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol54 || (_symbol54 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-bonnet-open-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "bonnet-open-small"), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 15.52l-9-.02a2.25 2.25 0 0 1-2.25 2.25h-.02A2.23 2.23 0 0 1 3 15.52l-1.5-.02c-.502 0-1-.543-1-1.045v-.182c0-.727-.021-1.273.1-1.636.182-.546.96-1.273 2.05-1.637.727-.242 1.893-.484 3.711-.727 1.525-1.467 2.556-2.316 3.091-2.545.62-.266 1.923-.357 3.273-.364 1.42-.007 2.89.084 3.636.364 1.455.545 3.637 2 4.728 2.181.387.065.674.147 1.061.245.608.156 1.107.683 1.15 1.31l.2 2.633c.042.6-.387 1.12-.987 1.164L21 15.52a2.23 2.23 0 0 1-2.23 2.229h-.04a2.23 2.23 0 0 1-2.23-2.23zM5.085 9.226l-.054-.138A58.66 58.66 0 0 1 4.5 8.5c-1.114-1.284-1.935-2-2.5-2-.966 0-1.146.057-1.531.5",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol55 || (_symbol55 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-bookmark-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "bookmark-large"), /*#__PURE__*/React.createElement("path", {
    d: "M36.5 44.5l-13-13-13 13v-41h26z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol56 || (_symbol56 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-bookmark-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "bookmark-small"), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 22.5L12 16l-6.5 6.5V.5h13z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol57 || (_symbol57 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-brake-fluid-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "brake-fluid-large"), /*#__PURE__*/React.createElement("path", {
    d: "M27 42.751A18.12 18.12 0 0 1 24 43c-9.941 0-18-8.059-18-18S14.059 7 24 7c9.606 0 17.454 7.524 17.973 17M6.93 9.584A22.915 22.915 0 0 0 1 25c0 6.572 2.757 12.5 7.176 16.692M30.71 23A7 7 0 1 0 26 31.71M41.069 9.584A22.916 22.916 0 0 1 47 25c0 2.44-.38 4.793-1.085 7M27 25a3 3 0 1 0-6 0 3 3 0 0 0 6 0zm17.475 11.876c.121 4.613-3.4 8.377-8.013 8.62h-.486c-4.735-.122-8.498-3.886-8.498-8.62C27.478 32.14 35.976 20 35.976 20s8.499 12.262 8.499 16.876z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol58 || (_symbol58 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-brake-fluid-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "brake-fluid-small"), /*#__PURE__*/React.createElement("path", {
    d: "M20.639 4.432a11.457 11.457 0 0 1 2.861 7.59c0 1.399-.25 2.739-.706 3.978M3.374 4.418A11.456 11.456 0 0 0 .5 12.023a11.47 11.47 0 0 0 3.77 8.514M21 12a9 9 0 1 0-18 0 9.003 9.003 0 0 0 7.085 8.796m11.413-1.862c.065 2.442-1.8 4.435-4.242 4.564H17c-2.506-.065-4.499-2.057-4.499-4.564S17 10 17 10s4.498 6.492 4.498 8.934z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol59 || (_symbol59 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-brake-pad-alert-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "brake-pad-alert-large"), /*#__PURE__*/React.createElement("path", {
    d: "M6.931 9.584A22.916 22.916 0 0 0 1 25c0 6.572 2.757 12.5 7.176 16.692m30.833.736C43.902 38.211 47 31.967 47 25M27.66 7.372A18.079 18.079 0 0 0 24 7C14.059 7 6 15.059 6 25s8.059 18 18 18 18-8.059 18-18m-20.694-6.463A7.002 7.002 0 0 0 24 32a7 7 0 0 0 6.99-7.391M27 25a3 3 0 1 0-6 0 3 3 0 0 0 6 0zm-.5-5.5l10.03-18 9.97 18h-20zm10-4.5v2m0-10v6",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol60 || (_symbol60 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-brake-pad-alert-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "brake-pad-alert-small"), /*#__PURE__*/React.createElement("path", {
    d: "M19.589 20.663a11.473 11.473 0 0 0 3.911-8.64c0-2.91-1.08-5.566-2.861-7.591M3.373 4.418A11.456 11.456 0 0 0 .5 12.023a11.47 11.47 0 0 0 3.77 8.514M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zm.3-14.5v7m0 1.5v2",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol61 || (_symbol61 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-brake-pad-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "brake-pad-large"), /*#__PURE__*/React.createElement("path", {
    d: "M38.84 41.826a23.046 23.046 0 0 0 5.828-8.18m.698-1.879a23.425 23.425 0 0 0 1.133-7.222c0-1.824-.208-3.598-.6-5.3m-.533-1.924a23.097 23.097 0 0 0-4.47-7.958m-33.77-.027a23.102 23.102 0 0 0-4.715 8.714m-.47 1.946a23.584 23.584 0 0 0-.441 4.549c0 2.248.316 4.42.905 6.474m.652 1.945a23.06 23.06 0 0 0 5.826 8.61M24 43c9.941 0 18-8.059 18-18S33.941 7 24 7 6 15.059 6 25s8.059 18 18 18zm7-18a7 7 0 1 0-14 0 7 7 0 0 0 14 0zm-4 0a3 3 0 1 0-6 0 3 3 0 0 0 6 0z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol62 || (_symbol62 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-brake-pad-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "brake-pad-small"), /*#__PURE__*/React.createElement("path", {
    d: "M3.373 4.418A11.48 11.48 0 0 0 .965 8.775m-.24.973a11.554 11.554 0 0 0 .237 5.512m.333.972a11.521 11.521 0 0 0 2.975 4.305m15.319.126a11.53 11.53 0 0 0 2.976-4.09m.357-.94a11.49 11.49 0 0 0 .578-3.61c0-.912-.106-1.8-.307-2.65m-.272-.963a11.486 11.486 0 0 0-2.282-3.978M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol63 || (_symbol63 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-break-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "break-large"), /*#__PURE__*/React.createElement("path", {
    d: "M10 41.5h28M13.5 23c0 9 3.497 15.5 6.5 15.5h8c3.001 0 6.5-6.492 6.5-15.5 0-.75-21-.75-21 0zm20.85 3c1-1.5 6.15-3.505 6.15.5 0 5.007-7.3 6-8.3 8m-4.2-14c1.667-.92 2.5-2.086 2.5-3.5 0-2.12-2.5-2.997-2.5-5 0-1.335.167-2.335.5-3M23 20.531c1.667-.687 2.5-2.031 2.5-4.031 0-3-3-4-3-7 0-2 .833-3.833 2.5-5.5m-6 16.5c1.667-.586 2.5-1.586 2.5-3 0-2.12-3-3.004-3-5 0-1.33.333-2.497 1-3.5",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol64 || (_symbol64 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-break-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "break-small"), /*#__PURE__*/React.createElement("path", {
    d: "M5 21.5h14M17.45 13c.5-.5 3.05-1.502 3.05.5 0 2.503-3.55 3-4.05 4M6.5 11.85c0 4.5 1.63 7.65 3 7.65h5c1.374 0 3-3.146 3-7.65 0-.5-11-.5-11 0zm7-2.35c.833-.293 1.25-.793 1.25-1.5 0-1.06-1.25-1.655-1.25-2.5 0-.563.333-1.063 1-1.5M10 9.516c1-.344 1.5-1.016 1.5-2.016 0-1.5-2-2-2-3.5 0-1 .667-1.838 2-2.515",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol65 || (_symbol65 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-brush-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "brush-large"), /*#__PURE__*/React.createElement("path", {
    d: "M13.4 9.263l2.828-2.828c1.562-1.562 4.132-1.525 5.74.083l18.925 18.926c1.609 1.608 1.646 4.178.084 5.74l-2.829 2.828L13.4 9.263zm21.566 25.103l-.353.353-6.364 9.193-4.99-4.99 4.617-6.697-.334-.334-8.514 2.8L3.5 19.163l9.192-6.364.354-.354m20.86 6.01l-4.95-4.949 7.778-7.778a4 4 0 0 1 5.657 0l2.121 2.121-10.606 10.607z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol66 || (_symbol66 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-brush-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "brush-small"), /*#__PURE__*/React.createElement("path", {
    d: "M6.45 3.985l1.768-1.767c.976-.977 2.475-1.06 3.348-.188L21.84 12.304c.873.873.789 2.372-.187 3.349l-1.768 1.767L6.45 3.985zm11.667 13.789l-.354.353-2.828 4.243-2.828-2.828 1.767-3.182-.707-.707-3.182 1.767L1.5 8.935l4.243-2.828.353-.354m12 2.808L15.29 5.753l3.535-3.535a2 2 0 0 1 2.829 0l1.393 1.393-4.95 4.95z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol67 || (_symbol67 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-business-address-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "business-address-large"), /*#__PURE__*/React.createElement("path", {
    d: "M46.5 14.5c0-1.1-.9-2-2-2h-43v31c0 1.1.9 2 2 2h43v-31zM8 37.5h20m-20-5h28m-28.5-20V6.7c0-2.3 1.9-4.1 4.2-4.2h3.8c2.3 0 4.1 1.9 4 4.2v14.9c0 2.2-1.7 4-3.9 4s-4-1.8-4.1-4V7",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol68 || (_symbol68 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-business-address-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "business-address-small"), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 6.5H.5v14c0 .6.5 1 1 1h22v-14c0-.5-.5-1-1-1zM3 17.5h14M3.5 7V3.8c0-1.3 1-2.3 2.3-2.3h2.3c1.3 0 2.3 1 2.4 2.3v6.7c0 1.1-.9 3-2 3s-2-1.9-2-3V4",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol69 || (_symbol69 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-business-customer-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "business-customer-large"), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 20.5h-7c-1.6 0-3-1.4-3-3v-7c0-1.6 1.4-3 3-3h7c1.6 0 3 1.4 3 3v7c0 1.6-1.4 3-3 3zm3.5 20H7.5V27.2s.2-2.7 3.5-2.7h16m15.5 19h-5v-5h-3v5h-5v-19h13v19zm-5-16h2v2h-2v-2zm-5 0h2v2h-2v-2zm5 6h2v2h-2v-2zm-5 0h2v2h-2v-2z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol70 || (_symbol70 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-business-customer-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "business-customer-small"), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 9.5h-3c-1.1 0-2-.9-2-2v-3c0-1.1.9-2 2-2h3c1.1 0 2 .9 2 2v3c0 1.1-.9 2-2 2zm2.5 11H3.5V14s-.1-1.5 1.2-1.5H14m7.5 9h-2v-2h-2v2h-2v-9h6v9zm-4.05-5.05h.1v.1h-.1v-.1zm2 0h.1v.1h-.1v-.1zm-2-2h.1v.1h-.1v-.1zm2 0h.1v.1h-.1v-.1z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol71 || (_symbol71 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-calculator-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "calculator-large"), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 2.5h21a3 3 0 0 1 3 3v37a3 3 0 0 1-3 3h-21a3 3 0 0 1-3-3v-37a3 3 0 0 1 3-3zm12.5 24h7m-7 11h7m-7-3h7M18.5 30v-7M15 26.5h7M21.5 40v-1m-6-5v-1m0 6.5l6-6m-9-24h23v8h-23v-8z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol72 || (_symbol72 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-calculator-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "calculator-small"), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 1.5h11a2 2 0 0 1 2 2v17a2 2 0 0 1-2 2h-11a2 2 0 0 1-2-2v-17a2 2 0 0 1 2-2zm-2 8h15m-6.5 8h5m-5-2h5M10.5 19v-1m-4 .5l4-4m-4 .5v-1",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol73 || (_symbol73 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-calendar-events-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "calendar-events-large"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 38.5v5.1c0 1 .8 1.9 1.9 1.9h28.2c1 0 1.9-.8 1.9-1.9V13m-41-6v29.6c0 1 .8 1.9 1.9 1.9h22.2l9.9-9.9V7m0 21.5h-10v10M3 2.5h35",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 11.9l-3.9.9v.8l3.6-.8v11H9.1v.8h8.5v-.8H14v-12h-1v.1zm9.3 5.3h-.4l.2-4.4h7.7V12h-8.7l-.2 6c5.6.1 8.4 1.2 8.4 3.2 0 1.3-.8 2.8-4.6 2.8-1.5 0-2.9-.2-4.3-.6v.9c1.4.4 2.8.6 4.3.6 3.8 0 5.9-1.3 5.9-3.7 0-2.4-2.8-3.7-8.3-4z",
    fill: "currentColor",
    fillRule: "nonzero"
  })))), _symbol74 || (_symbol74 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-calendar-events-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "calendar-events-small"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5 19.5v3c0 .6.4 1 1 1h15c.6 0 1-.4 1-1V6M.5 3v15.5c0 .5.4 1 1 1h12l5-5V3m0 11.5h-5v5M0 .5h19",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 5.9l2.1-.5h.6v5.8h1.8v.8H4v-.8h1.8V6.3L4 6.7v-.8zm5.7 5.8v-.8c.7.2 1.5.3 2.3.4 1.4 0 2-.5 2-1.2 0-1.2-2.7-1.4-4.1-1.4l.2-3.3h4.5v.8h-3.7L10.8 8c1.9.1 4.1.5 4.1 2.1 0 1.1-.9 2-3 2-.8 0-1.5-.2-2.2-.4z",
    fill: "currentColor",
    fillRule: "nonzero"
  })))), _symbol75 || (_symbol75 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-camera-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "camera-large"), /*#__PURE__*/React.createElement("path", {
    d: "M35.5 13.5h10v23c0 1.1-.9 2-1.9 2H2.5v-23c0-1.1.9-2 1.9-2h8.1v-2c0-1.1.9-2 1.9-2h19.1c1.1 0 2 .9 2 1.9v2.1zM24 34.5a9.5 9.5 0 1 0 0-19 9.5 9.5 0 0 0 0 19z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol76 || (_symbol76 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-camera-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "camera-small"), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 7.5h5v11c0 .6-.4 1-1 1h-20v-11c0-.6.4-1 1-1h4v-1c0-.6.4-1 1-1h9c.6 0 1 .4 1 1v1zm-5.5 10a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol77 || (_symbol77 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-cancel-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "cancel-large"), /*#__PURE__*/React.createElement("path", {
    d: "M31.6 15.4L15.4 31.6m0-16.2l16.3 16.3",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol78 || (_symbol78 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-cancel-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "cancel-small"), /*#__PURE__*/React.createElement("path", {
    d: "M5.9 17.1L17.1 5.9m-11.2 0l11.2 11.2",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol79 || (_symbol79 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-car-dimensions-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "car-dimensions-large"), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 28v9m33-4.5h-33m33-4.5v9M18.003 21.5a3 3 0 1 1-6 0l-1.959-.141c-.824-.06-1.598-.776-1.541-1.6l.404-3.622a2 2 0 0 1 1.5-1.8 19.223 19.223 0 0 1 1.596-.336c1.5-.25 4.5-2.25 6.5-3 1.025-.385 3.048-.51 5-.5 1.856.009 3.647.134 4.5.5.737.315 2.153 1.482 4.25 3.5 2.5.333 4.25.666 5.25 1 1.5.5 2.5 1.5 2.75 2.25.167.5.25 1.25.25 2.25v.25c0 .69-.56 1.25-1.25 1.25h-2.25a3 3 0 1 1-6 0h-13z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol80 || (_symbol80 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-car-dimensions-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "car-dimensions-small"), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 15v5m17-2.5h-17m17-2.5v5m-12-9.5a1.5 1.5 0 0 1-3 0l-1.181-.152c-.438-.032-.85-.41-.819-.848l.216-2.006c.032-.457.353-.842.797-.956.283-.072.565-.131.848-.179.797-.132 2.39-1.195 3.453-1.593.544-.204 1.65-.27 2.686-.266.986.005 1.907.072 2.36.266.391.168 1.144.787 2.258 1.86 1.328.176 2.257.353 2.788.53.797.266 1.328.797 1.461 1.195.089.266.133.664.133 1.196l-.002.212a.664.664 0 0 1-.664.664L18.5 10.5a1.5 1.5 0 0 1-3 0h-7z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol81 || (_symbol81 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-car-handover-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "car-handover-large"), /*#__PURE__*/React.createElement("path", {
    d: "M30.5 29l11.6-3.5s5.4-1.2 5.4 1.8c0 2.5-2.4 3.5-4.1 4.3-6 2.7-15 7-15 7s-4.5 1.9-9.4 1.9H.5v-9c5 0 3.6-.8 8-3 2.6-1.3 5.9-2 8.9-2h10.7c1.4 0 2.5 1.1 2.4 2.5.1 1.4-1 2.5-2.4 2.5H15m4.003-11a3 3 0 1 1-6 0l-1.959-.141c-.824-.06-1.598-.776-1.541-1.6l.404-3.622a2 2 0 0 1 1.5-1.8 19.223 19.223 0 0 1 1.596-.336c1.5-.25 4.5-2.25 6.5-3 1.025-.385 3.048-.51 5-.5 1.856.009 3.647.134 4.5.5.737.315 2.153 1.482 4.25 3.5 2.5.333 4.25.666 5.25 1 1.5.5 2.5 1.5 2.75 2.25.167.5.25 1.25.25 2.25v.25c0 .69-.56 1.25-1.25 1.25h-2.25a3 3 0 1 1-6 0h-13z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol82 || (_symbol82 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-car-handover-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "car-handover-small"), /*#__PURE__*/React.createElement("path", {
    d: "M15.2 15.9l5.7-1.7s2.6-.6 2.6.9c0 1.2-1.2 1.7-2 2.1-2.9 1.3-7.4 3.4-7.4 3.4s-2.2.9-4.6.9h-9v-5c2.4 0 1.8.2 3.9-.9 1.3-.7 2.9-1.1 4.4-1.1h4.7c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5H7m1.5-7a1.5 1.5 0 0 1-3 0l-1.181-.152c-.438-.032-.85-.41-.819-.848l.216-2.006c.032-.457.353-.842.797-.956.283-.072.565-.131.848-.179.797-.132 2.39-1.195 3.453-1.593.544-.204 1.65-.27 2.686-.266.986.005 1.907.072 2.36.266.391.168 1.144.787 2.258 1.86 1.328.176 2.257.353 2.788.53.797.266 1.328.797 1.461 1.195.089.266.133.664.133 1.196l-.002.212a.664.664 0 0 1-.664.664L18.5 10.5a1.5 1.5 0 0 1-3 0h-7z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol83 || (_symbol83 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-car-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "car-large"), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 23v14A1.5 1.5 0 0 0 4 38.5h5a1.5 1.5 0 0 0 1.5-1.5v-1.5h27V37a1.5 1.5 0 0 0 1.5 1.5h5a1.5 1.5 0 0 0 1.5-1.5V23L41 18.5c-.933-1.833-1.767-3.333-2.5-4.5-.733-1.167-1.733-2.5-3-4-3.74-.333-7.565-.5-11.478-.5-3.913 0-7.754.167-11.522.5-1.267 1.5-2.267 2.833-3 4-.733 1.167-1.567 2.667-2.5 4.5L2.5 23zM15 27l2-2.5h14l2 2.5c-1.333 3.667-2.333 5.5-3 5.5H18c-.667 0-1.667-1.833-3-5.5zm-8.25-8.5h34.5m2.25 5.075c0 .97-.083 1.63-.25 1.978-.25.522-.75 1.022-1.25 1.022h-2c-.5 0-4.25-1-4.75-1.5a3.917 3.917 0 0 1-.75-1c1.768-.234 3.268-.4 4.5-.5 1.232-.1 2.732-.1 4.5 0zm-39 0c1.768-.1 3.268-.1 4.5 0 1.232.1 2.732.266 4.5.5a3.917 3.917 0 0 1-.75 1c-.5.5-4.25 1.5-4.75 1.5H6c-.5 0-1-.5-1.25-1.022-.167-.348-.25-1.007-.25-1.978z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol84 || (_symbol84 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-car-search-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "car-search-large"), /*#__PURE__*/React.createElement("path", {
    d: "M31 36.5h6.5V38a1.5 1.5 0 0 0 1.5 1.5h5a1.5 1.5 0 0 0 1.5-1.5V24L41 19.5c-.933-1.833-1.767-3.333-2.5-4.5-.733-1.167-1.733-2.5-3-4-2.921-.221-5.01-.446-6.5-.5M2.5 25v13A1.5 1.5 0 0 0 4 39.5h5a1.5 1.5 0 0 0 1.5-1.5v-1.5H24m-2-3h-4c-.568 0-1.45-1.343-2.5-4m8.5-4h7l2 2.5c-1.333 3.667-2.333 5.5-3 5.5h-1m-1-14h13.25M22 10.5c-2.171.03-5.26.206-9.5.5-1.267 1.5-2.267 2.833-3 4-.733 1.167-1.567 2.667-2.5 4.5h14m22.5 5.075c0 .97-.083 1.63-.25 1.978-.25.522-.75 1.022-1.25 1.022h-2c-.5 0-4.25-1-4.75-1.5a3.917 3.917 0 0 1-.75-1c1.768-.234 3.268-.4 4.5-.5 1.232-.1 2.732-.1 4.5 0zm-35.5 3H6c-.5 0-1-.5-1.25-1.022a2.126 2.126 0 0 1-.156-.542M32.2 44.2L20 24.8l12.2 19.4zm-6.7-29.8c0 7.3-5.3 12.1-11.9 12.1-6.6-.1-12-5.4-12.1-12.1C1.6 7.8 7 2.5 13.6 2.5s11.9 5.3 11.9 11.9z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol85 || (_symbol85 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-car-search-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "car-search-small"), /*#__PURE__*/React.createElement("path", {
    d: "M.5 13.419v7.083a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1.045l15 .045v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-8l-2-2c-.66-1.212-1.19-2.136-1.59-2.772-.4-.637-.87-1.364-1.41-2.182a116.715 116.715 0 0 0-3.46-.213m-5.037-.029c-1.14.04-2.64.12-4.503.242-.54.818-1.01 1.545-1.41 2.182-.276.44-.615 1.017-1.016 1.733M16.7 22.8l-6.1-9.3 6.1 9.3zM13.5 7.9c.1 3.5-2.5 6.4-6 6.5h-.4C3.5 14.4.6 11.5.5 7.8c0-3.6 3-6.5 6.6-6.4 3.5.1 6.4 3 6.4 6.5z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol86 || (_symbol86 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-car-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "car-small"), /*#__PURE__*/React.createElement("path", {
    d: "M.5 11.5v8a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1.045l15 .045v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-8l-2-2c-.66-1.212-1.19-2.136-1.59-2.773-.4-.636-.87-1.363-1.41-2.182a78.437 78.437 0 0 0-6.488-.272c-2.135 0-4.305.09-6.512.272-.54.819-1.01 1.546-1.41 2.182-.4.637-.93 1.56-1.59 2.773l-2 2zm6 2l1-1h9l1 1c-.636 2-1.136 3-1.5 3H8c-.364 0-.864-1-1.5-3zm-4-4h19m-2.5 3h4.5m-23 0H5",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol87 || (_symbol87 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-catalogue-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "catalogue-large"), /*#__PURE__*/React.createElement("path", {
    d: "M40.5 13.5h1a3 3 0 0 1 3 3v23h-39c-1 0-2-1.222-2-2.5.128 1.465 1.238 2.383 2.489 2.265L40.5 36.007V13.5a4 4 0 0 0-4-4m-33 4l29.21-7.967a3 3 0 0 1 3.79 2.895V25.5l-8 8-22.533 5.408A2 2 0 0 1 3.5 36.963V13.5zm25 20v-8h8",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol88 || (_symbol88 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-catalogue-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "catalogue-small"), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 7v13.5h-19l17-3V4m-19 2l15.75-4.07a1 1 0 0 1 1.25.968V11.5l-4 4-11.74 3.16a1 1 0 0 1-1.26-.965V6zm13 9.5v-4h4",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol89 || (_symbol89 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-caution-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "caution-large"), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 42.5l21-38 21 38h-42zm21-9.5v4m0-19v11",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol90 || (_symbol90 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-caution-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "caution-small"), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 20.5h-20l10-18 10 18zm-10-4.5v2m0-10v6",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol91 || (_symbol91 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-charge-level-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "charge-level-large"), /*#__PURE__*/React.createElement("path", {
    d: "M43.5 18v19.5H10M40.5 15v19.5H7m-2.5-22h33v19h-33v-19zm5 0v-3h5v3m13 0v-3h5v3m-3 11.5v-7M26 20.5h7m-24 0h7",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol92 || (_symbol92 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-charge-level-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "charge-level-small"), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 10v10.5H5M21.5 8v10.5H3m-1.5-13h18v11h-18v-11zm3 0v-2h3v2m6 0v-2h3v2m-2 7.5V8M12 10.5h5m-13 0h4",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol93 || (_symbol93 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-charging-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "charging-large"), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 13.5h-10s-5 0-5 5.5 5 5.5 5 5.5h4.2c2.2 0 4.8 1.7 4.8 4.5v14m15-28.3v6.8h-4.9c-1 0-9.1.2-9.1-8s8.1-8 9.1-8h4.9v9.2zm0-5.2H43m-8.5 8H43",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol94 || (_symbol94 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-charging-plate-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "charging-plate-large"), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 42.5h28v2h-28v-2zm6.253-3.81c2.02-1.375 4.529-2.19 7.247-2.19 2.407 0 4.65.64 6.536 1.741m-16.63-2.608C10.697 33.669 14.199 32.5 18 32.5c3.491 0 6.73.986 9.396 2.668M43.5 14v19.5H32M40.5 11v19.5H29M4.5 8.5h33v19h-33v-19zm5 0v-3h5v3m13 0v-3h5v3m-3 11.5v-7M26 16.5h7m-24 0h7",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol95 || (_symbol95 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-charging-plate-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "charging-plate-small"), /*#__PURE__*/React.createElement("path", {
    d: "M1 22.5h16M5.49 20.46c.8-.629 1.855-1.01 3.01-1.01 1.155 0 2.21.381 3.01 1.01m-8.415-2.034C4.512 17.262 6.412 16.55 8.5 16.55s3.988.712 5.405 1.876M23.5 8v10.5h-7.49M21.5 6v10.5H15M1.5 3.5h18v11h-18v-11zm3 0v-2h3v2m6 0v-2h3v2m-2 7.5V6M12 8.5h5m-13 0h4",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol96 || (_symbol96 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-charging-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "charging-small"), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 8.5H5.8s-2.2-.1-2.2 2 2.2 2 2.2 2H7c1 0 1.5.4 1.5 1.9V20m9-15.5H15s-4.5-.1-4.5 4 4.5 4 4.5 4h2.5v-8zm0 6H21h-3.5zm0-4H21h-3.5z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol97 || (_symbol97 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-charging-station-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "charging-station-large"), /*#__PURE__*/React.createElement("path", {
    d: "M29 44.5H3m23.5 0v-38a3 3 0 0 0-3-3h-15a3 3 0 0 0-3 3v38m18.5-24H8m32.5 1v14a4 4 0 1 1-8 0v-11a4 4 0 0 0-4-4h-2m20-11v6a6 6 0 1 1-12 0v-6h12zm-9 0v-5m6 5v-5",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol98 || (_symbol98 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-charging-station-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "charging-station-small"), /*#__PURE__*/React.createElement("path", {
    d: "M14 22.5H1m11.5 0v-19a2 2 0 0 0-2-2h-6a2 2 0 0 0-2 2v19m8.5-12H4m15.5 0v7a2 2 0 1 1-4 0v-5a2 2 0 0 0-2-2h-1m10-6v3a3 3 0 0 1-6 0v-3h6zm-5 0V1m4 3.5V1",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol99 || (_symbol99 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-city-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "city-large"), /*#__PURE__*/React.createElement("path", {
    d: "M32 17.5h7.5v4H32m0 3h7.5v4H32m0 3h7.5v4H32m0-24h12.5v34H32m-1.471 0H20.7V34.443h-7.371V45.5H3.5v-43h27.029v43zM8.414 7.414h6.143v6.143H8.414V7.414zm11.057 0h6.143v6.143h-6.143V7.414zM8.414 20.93h6.143v6.142H8.414V20.93zm11.057 0h6.143v6.142h-6.143V20.93z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol100 || (_symbol100 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-city-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "city-small"), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 21.5h-5v-5h-3v5h-5v-19h13v19zm0 0h6v-14h-6m.5 3h3m-3 3h3m-3 3h3m-8.5-11h2v2h-2v-2zm-5 0h2v2h-2v-2zm5 5h2v2h-2v-2zm-5 0h2v2h-2v-2z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol101 || (_symbol101 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-climate-auto-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "climate-auto-large"), /*#__PURE__*/React.createElement("path", {
    d: "M6 44.5h36m-5.5-40v8s-.3 3.8 1.7 7.4C40.2 23.5 42 26 42 30s-1.7 10.5-8 10.5M32 10l4.5-5.5L41 10M24.5 4.5v8s-.3 3.8 1.7 7.4C28.2 23.5 30 26 30 30s-1.7 10.5-8 10.5M20 10l4.5-5.5L29 10m-11 3.5h-3.5H18zm0-3h-3.5H18zm0-3h-3.5H18zm-3.5 13h-4 4zm0 7.5V5.5c0-1.1-.9-2-2-2s-2 .9-2 2v23.3c-2.3.8-4 3-4 5.7 0 3.3 2.7 6 6 6s6-2.7 6-6c0-2.6-1.7-4.8-4-5.7V28z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol102 || (_symbol102 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-climate-auto-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "climate-auto-small"), /*#__PURE__*/React.createElement("path", {
    d: "M0 23h24m-6-3c2 0 4.5-1.9 4.5-5.5 0-3.5-3-5-3-8V.2M16 3.7L19.5.2 23 3.7M10 20c2 0 4.5-1.9 4.5-5.5 0-3.5-3-5-3-8V.2M9 2.8L11.5.2 14 2.8M7 7H4.5 7zm0-2H4.5 7zm0-2H4.5 7zm-2.5 7h-2 2zm0 3.7V1c0-.6-.4-1-1-1s-1 .4-1 1v13.2c-1.2.4-2 1.6-2 2.8 0 1.7 1.3 3 3 3s3-1.3 3-3c0-1.3-.8-2.4-2-2.8v-.5z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol103 || (_symbol103 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-climate-electric-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "climate-electric-large"), /*#__PURE__*/React.createElement("path", {
    d: "M30 15.5h-3.5H30zm0-3h-3.5H30zm0-3h-3.5H30zm-3.5 13h-4 4zm0 7.5V7.5c0-1.1-.9-2-2-2s-2 .9-2 2v23.3c-2.3.8-4 3-4 5.7 0 3.3 2.7 6 6 6s6-2.7 6-6c0-2.6-1.7-4.8-4-5.7V30z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol104 || (_symbol104 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-climate-electric-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "climate-electric-small"), /*#__PURE__*/React.createElement("path", {
    d: "M15 8.5h-2.5H15zm0-2h-2.5H15zm0-2h-2.5H15zm-2.5 7h-2 2zm0 3.7V2.5c0-.6-.4-1-1-1s-1 .4-1 1v13.2c-1.2.4-2 1.6-2 2.8 0 1.7 1.3 3 3 3s3-1.3 3-3c0-1.3-.8-2.4-2-2.8v-.5z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol105 || (_symbol105 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-climate-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "climate-large"), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 20.4s0-2.1-.1-4-.3-4.7-.9-6.5C17 8.1 16.1 6 14.9 5.1c-1.2-1-2.8-1.4-4.7-.5-1.9.9-3.5 3.2-4.3 4.6-.8 1.4-1.5 3.4-1 5.4.5 2.1 2.5 4.2 5 5 2.1.7 3.8.9 5.2 1 1.3 0 3.4-.2 3.4-.2zm2.1 9.1s-.2 6.6-2.6 10.3c-1.8 3-4.6 3.1-5.5 3.1-.8 0-2.4 0-4.4-1.2-2-1.2-2.6-1.9-3.2-2.6-.6-.7-1.6-2.5-1.4-4.1.4-2.3 2.7-3.5 4.5-4.2.9-.3 2.4-.7 4.8-1.1 2.2-.3 5.5-.4 5.9-.4.4.1 1.9.2 1.9.2zm8.9-2s6.4-.9 10.2 1.6c3.6 2.2 3.6 5 3.6 5.7 0 .7-.1 2-1.3 4s-2.1 2.9-2.8 3.6c-.7.7-2.4 1.7-4 1.4-2.3-.4-3.9-2.8-4.5-4.5-.3-.9-.9-2.9-1.1-5.1-.2-2.1-.3-5.2-.3-5.6.2-.5.2-1.1.2-1.1zm-2-9.1s3.1.1 6.4-.2c3.3-.3 5.2-.8 6.6-1.4 1.4-.5 1.8-.8 2.3-1.2.5-.4 1.1-.9 1.4-1.5.2-.4.5-1.1.5-2.1s-.8-2.5-1.7-3.4c-.8-.8-2.5-2.2-4.2-2.9-1.6-.7-3.9-.9-5.3-.4-1.6.6-3.2 2.4-3.8 3.5-.4.8-1.3 3.2-1.7 5.5-.4 2.3-.5 4.1-.5 4.1zM18 23.9c0 3.4 2.6 6 6 6s6-2.6 6-6-2.6-6-6-6-6 2.6-6 6z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol106 || (_symbol106 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-climate-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "climate-small"), /*#__PURE__*/React.createElement("path", {
    d: "M9 10.8l.1-.8C9.2-.1 5.8 1.6 4.5 2.9 3 4.4 1.7 7.4 3.8 9.5c1.4 1.2 3.2 1.7 5 1.5l.2-.2zm1.6 4.1C.5 14.8 1.5 18.8 3 20.3c1.5 1.5 4.3 2.9 6.4.7 1.3-1.5 2-3.5 1.7-5.4l-.2-.7h-.3zm4.1-1.3c.2-.1.7-.3.7-.3s3.2-.7 5.4 1.4c2.2 2.1.6 4.8-.9 6.3s-5.5 3-5.4-7.1c0 0 0-.1.2-.3zM13.4 9c-.2-.9-.4-4.2 1.3-5.9 2.2-2.1 5.2-.8 6.7.7C23.2 5.6 25.2 9 15 9h-1.6zM12 9c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol107 || (_symbol107 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-clothing-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "clothing-large"), /*#__PURE__*/React.createElement("path", {
    d: "M29 12.25a5.25 5.25 0 0 0-10.5 0c0 2.9 2.35 5.25 5 5.25v4L4.435 34.958A2.5 2.5 0 0 0 5.877 39.5h35.62a2.5 2.5 0 0 0 1.423-4.555L23.5 21.5",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol108 || (_symbol108 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-clothing-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "clothing-small"), /*#__PURE__*/React.createElement("path", {
    d: "M14 6.75a2.75 2.75 0 1 0-2.75 2.75h.25V12l-9.813 6.673a1 1 0 0 0 .562 1.827h18.502a1 1 0 0 0 .562-1.827L11.5 12",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol109 || (_symbol109 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-co2-emission-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "co2-emission-large"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.2 31.724c1.378 0 2.405-.208 3.055-.468v-1.118c-.533.195-1.521.455-3.029.455-1.898 0-3.861-.949-3.861-3.731 0-2.496 1.547-3.718 3.9-3.718a7.55 7.55 0 0 1 2.782.52v-1.157c-.819-.351-1.937-.507-2.964-.507C22.21 22 20 23.807 20 26.862c0 3.224 2.21 4.862 5.2 4.862zm8.742 0c-3.302 0-5.018-1.989-5.018-4.862 0-2.769 1.794-4.862 5.018-4.862 3.302 0 5.018 1.989 5.018 4.862 0 2.769-1.794 4.862-5.018 4.862zm0-1.066c2.47 0 3.653-1.69 3.653-3.796s-1.183-3.796-3.653-3.796c-2.47 0-3.653 1.69-3.653 3.796s1.183 3.796 3.653 3.796zm6.19 3.276h5.596v-.914h-3.829l.977-.667c1.193-.837 2.309-1.519 2.309-2.65 0-1.209-.961-1.953-2.65-1.953-.915 0-1.597.186-2.124.387v.962a5.876 5.876 0 0 1 2.061-.388c.977 0 1.442.357 1.442 1.023 0 .62-.574 1.054-1.767 1.922l-2.015 1.457v.822z",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 37.5H8.5l-.225-.004a6 6 0 1 1 1.722-11.808 7.5 7.5 0 0 1 9.654-9.706A11.498 11.498 0 0 1 30 9.5c6.351 0 11.5 5.149 11.5 11.5",
    stroke: "currentColor"
  })))), _symbol110 || (_symbol110 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-co2-emission-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "co2-emission-small"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.095 12.778c.328 0 .61.045.845.135.237.09.416.22.537.39.122.17.183.374.183.614 0 .15-.037.294-.112.432a1.436 1.436 0 0 1-.34.397c-.151.128-.349.257-.592.388l-.388.215H20v.6h-3.028v-.538l1.185-.736c.139-.09.251-.174.337-.253a.96.96 0 0 0 .194-.235.487.487 0 0 0 .063-.238.462.462 0 0 0-.085-.283.507.507 0 0 0-.253-.174 1.246 1.246 0 0 0-.407-.058c-.118 0-.268.017-.448.052-.18.034-.323.074-.428.122v-.647a2.46 2.46 0 0 1 .467-.133 2.61 2.61 0 0 1 .498-.05zM8.13 10.125c.317 0 .626.03.925.09.3.059.582.145.846.259v.836a4.4 4.4 0 0 0-.843-.272 4.11 4.11 0 0 0-.856-.09c-.355 0-.659.066-.912.197-.253.13-.446.322-.58.575-.134.252-.201.55-.201.895 0 .343.067.641.2.896.136.253.33.445.581.575.253.131.557.197.912.197.281 0 .577-.027.887-.08.31-.052.606-.125.884-.218v.81c-.006.003-.172.055-.497.158-.325.102-.773.153-1.346.153-.564 0-1.049-.098-1.454-.296a2.123 2.123 0 0 1-.931-.865c-.216-.38-.324-.823-.324-1.33 0-.492.11-.928.332-1.31a2.2 2.2 0 0 1 .942-.876c.407-.203.885-.304 1.435-.304zm5.23 0c.567 0 1.053.1 1.458.299.406.198.717.487.933.865.215.379.323.82.323 1.326 0 .489-.11.925-.333 1.307-.22.382-.535.675-.942.878-.408.204-.887.306-1.438.306-.567 0-1.053-.099-1.46-.297a2.13 2.13 0 0 1-.932-.867c-.216-.38-.323-.822-.323-1.327 0-.49.11-.926.333-1.308.223-.383.538-.676.945-.878.408-.203.887-.304 1.437-.304zm0 .836c-.341 0-.633.065-.876.195a1.292 1.292 0 0 0-.553.57 1.94 1.94 0 0 0-.192.889c0 .342.064.638.192.89a1.3 1.3 0 0 0 .553.57c.242.129.535.193.877.193.343 0 .635-.065.876-.195.243-.13.427-.32.554-.57.126-.251.19-.547.19-.888 0-.341-.064-.637-.19-.888a1.289 1.289 0 0 0-.554-.571c-.24-.13-.533-.195-.876-.195z",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 18.5H5.5l-.2-.005a4 4 0 0 1-.797-7.87L4.5 10.5a4 4 0 0 1 5.129-3.839A5.5 5.5 0 0 1 19.5 10l-.003.625a4.002 4.002 0 0 1-.797 7.87l-.2.005",
    stroke: "currentColor"
  })))), _symbol111 || (_symbol111 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-code-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "code-large"), /*#__PURE__*/React.createElement("path", {
    d: "M36.5 36.5h6v6h-6v-6zm-10 0h6v6h-6v-6zm10-10h6v6h-6v-6zm-10 0h6v6h-6v-6zm-17 4h8v8h-8v-8zm12 12h-16v-16h13c1.7 0 3 1.3 3 3v13zm9-33h8v8h-8v-8zm12 12h-13c-1.7 0-3-1.3-3-3v-13h16v16zm-33-12h8v8h-8v-8zm9 12h-13v-16h16v13c0 1.7-1.3 3-3 3z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol112 || (_symbol112 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-code-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "code-small"), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 19.5h3v3h-3v-3zm-6 0h3v3h-3v-3zm6-6h3v3h-3v-3zm-6 0h3v3h-3v-3zm-10 2h5v5h-5v-5zm-2-2h9v9h-9v-9zm14-10h5v5h-5v-5zm-2-2h9v9h-9v-9zm-10 2h5v5h-5v-5zm-2-2h9v9h-9v-9z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol113 || (_symbol113 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-collapsed-tabs-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "collapsed-tabs-large"), /*#__PURE__*/React.createElement("path", {
    d: "M45.5 43.5v-27a4 4 0 0 0-4-4H22.414c-.905 0-1.774-.36-2.414-1l-3.828-3.828A4 4 0 0 0 13.343 6.5H2.5v33a4 4 0 0 0 4 4h39zm0 0h.5M14 23l10 10 10-10",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol114 || (_symbol114 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-collapsed-tabs-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "collapsed-tabs-small"), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 6.5v-3h5.172a2 2 0 0 1 1.414.586L10 6c.32.32.754.5 1.207.5H20.5a2 2 0 0 1 2 2v13M7 12l5 5 5-5m6 9.5H3.5a2 2 0 0 1-2-2V6",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol115 || (_symbol115 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-commute-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "commute-large"), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 30.5h-7v7h-6v-31h19v19m-8-6h4v4h-4v-4zm0-9h4v4h-4v-4zm-7 0h4v4h-4v-4zm0 9h4v4h-4v-4zm30 10v13h-18c-1.5 0-3-1.5-3-3v-9l11-9 14 11",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol116 || (_symbol116 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-commute-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "commute-small"), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 14.5h-4v4h-3v-16h9.999l.001 9.25m-4-2.25h2v2h-2v-2zm-4 0h2v2h-2v-2zm4-5h2v2h-2v-2zm-4 0h2v2h-2v-2zm16 9.5v7.5h-9c-1 0-2-1-2-2v-5l5.5-5 7.5 6",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol117 || (_symbol117 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-compare-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "compare-large"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M24.5 9v29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.822 17.5c2.842 0 4.326.98 4.326 2.828 0 1.162-.616 1.806-1.638 2.142 1.358.35 2.142 1.064 2.142 2.338 0 1.848-1.484 2.828-4.326 2.828H29V17.5h3.822zm-16.518 0l5.068 10.136h-1.61l-1.26-2.506h-6.104l-1.246 2.506H9.57L14.638 17.5h1.666zm16.714 5.628h-2.576v3.346h2.576c2.058 0 3.15-.364 3.15-1.666s-1.092-1.68-3.15-1.68zM15.45 18.83l-2.534 5.124h5.068L15.45 18.83zm17.064-.168h-2.072v3.346h2.072c2.058 0 3.15-.378 3.15-1.68s-1.092-1.666-3.15-1.666z",
    fill: "currentColor",
    fillRule: "nonzero"
  })))), _symbol118 || (_symbol118 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-compare-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "compare-small"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M12.5 4v15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.262 8.5c1.683 0 2.561.58 2.561 1.674 0 .688-.364 1.07-.97 1.268.804.207 1.269.63 1.269 1.384 0 1.094-.879 1.674-2.561 1.674H15v-6h2.262zm-9.276 0l3 6h-.953l-.746-1.483H5.674L4.936 14.5H4l3-6h.986zm9.392 3.331h-1.524v1.981h1.524c1.219 0 1.865-.215 1.865-.986 0-.77-.646-.995-1.865-.995zM7.481 9.287l-1.5 3.033h3l-1.5-3.033zm9.6-.1h-1.227v1.982h1.226c1.218 0 1.865-.224 1.865-.995 0-.77-.647-.986-1.865-.986z",
    fill: "currentColor",
    fillRule: "nonzero"
  })))), _symbol119 || (_symbol119 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-compass-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "compass-large"), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.43 23.58L31.496 4 17.944 18.132a8.54 8.54 0 0 0-1.754 2.712l14.618 5.906a8.54 8.54 0 0 0 .621-3.17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 43.595l-.502-.002-.005 1.256.87-.907-.363-.347zM31.497 4l.503.002.004-1.256-.87.906.363.348zm-15.93 20.014l-.502-.002.503.002zm13.486 5.449l-.363-.348.363.348zm2.376-5.883l-.502-.001.502.002zm-13.485-5.448l-.362-.348.362.348zM29.416 29.81a9.043 9.043 0 0 0 2.516-6.228l-1.005-.003a8.039 8.039 0 0 1-2.237 5.536l.726.695zM16.07 24.016a8.038 8.038 0 0 1 2.237-5.536l-.725-.695a9.043 9.043 0 0 0-2.517 6.227l1.005.004zm-.184-2.752l14.849 5.999.376-.932-14.848-5.999-.377.932zm.116 22.332l.068-19.58-1.005-.003-.067 19.58 1.004.003zM28.69 29.115L15.137 43.247l.726.695L29.416 29.81l-.726-.695zm2.305-25.117l-.068 19.58 1.005.004L32 4.002l-1.005-.004zM18.307 18.48L31.86 4.348l-.725-.696-13.553 14.133.725.695z"
  })))), _symbol120 || (_symbol120 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-compass-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "compass-small"), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.457 11.837l.034-9.745-6.745 7.033a4.25 4.25 0 0 0-.873 1.35l7.275 2.94a4.25 4.25 0 0 0 .31-1.578z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.53 21.797l-.5-.001-.005 1.25.866-.903-.361-.346zM15.49 2.092l.5.002.005-1.25-.866.902.361.346zm-7.927 9.96l-.5-.001.5.002zm6.71 2.712l-.36-.346.36.346zm1.183-2.927l-.5-.002.5.002zm-6.71-2.712l-.362-.346.361.346zm5.889 5.985a4.751 4.751 0 0 0 1.321-3.271l-1-.004a3.75 3.75 0 0 1-1.043 2.583l.722.692zm-6.572-3.055a3.75 3.75 0 0 1 1.043-2.583l-.722-.693a4.75 4.75 0 0 0-1.321 3.272l1 .004zm-.436-1.14l7.39 2.986.374-.927-7.389-2.986-.375.928zM8.03 21.8l.034-9.744-1-.004-.034 9.745 1 .003zm5.884-7.38L7.169 21.45l.722.692 6.745-7.033-.722-.692zM14.99 2.09l-.034 9.744 1 .004.034-9.745-1-.003zM9.107 9.47l6.745-7.033-.722-.692L8.385 8.78l.722.693z"
  })))), _symbol121 || (_symbol121 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-connect-key-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "connect-key-large"), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 33.5l2 2 2-2-1-3 1-2-1-2 1-2-1-2v-2c2-.75 3-2 3-4.5s-2.001-4.5-4.501-4.5c-2.5 0-4.499 2-4.499 4.5s1 3.75 3 4.5v13zm1.5-18a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zm16 13c1.1-1.2 1.5-3 1.5-4.5s-.4-3.3-1.5-4.5m2.8 14c2.4-2.6 3.7-6 3.7-9.5s-1.2-7-3.7-9.5M9.5 3.5h19c1.1 0 2 .9 2 2v37c0 1.1-.9 2-2 2h-19c-1.1 0-2-.9-2-2v-37c0-1.1.9-2 2-2zm-2 35h23M19 42.4a.9.9 0 1 0 0-1.8.9.9 0 0 0 0 1.8zM16 7.5h6",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol122 || (_symbol122 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-connect-key-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "connect-key-small"), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 14.7c.7-.7 1-1.7 1-2.7 0-1-.3-2-1-2.8m2 8.3c1.4-1.5 2-3.5 2-5.5s-.6-4-2-5.5m-18 13h14-14zm6.5 2h1-1zM3.5.5h12c.6 0 1 .4 1 1v21c0 .6-.4 1-1 1h-12c-.6 0-1-.4-1-1v-21c0-.6.4-1 1-1zm9 5c0-1.7-1.3-3-3-3s-3 1.3-3 3c0 1.3.8 2.4 2 2.8v8.2l1 1 2-2.5-1-1.5 1-1.5-1-1.5V8.3c1.2-.4 2-1.5 2-2.8z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol123 || (_symbol123 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-consumption-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "consumption-large"), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 41.5c6.6 0 12-5.9 12-12.4s-12-23.6-12-23.6-12 17-12 23.6c0 6.6 5.4 12.4 12 12.4zm14.1-7.9c3.7-.7 6.3-3.9 6.4-7.7 0-4.3-7.8-15.4-7.8-15.4s-1.5 2.2-3.2 5",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol124 || (_symbol124 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-consumption-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "consumption-small"), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 15.4c.1 3.8-2.8 6.9-6.6 7.1h-.4c-3.9-.1-7-3.2-7-7.1 0-3.9 7-13.9 7-13.9s7 10.1 7 13.9z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol125 || (_symbol125 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-content-activities-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "content-activities-large"), /*#__PURE__*/React.createElement("path", {
    d: "M45.5 38.5h-34c-1.7 0-3-1.3-3-3v-9l-6-6 6-6v-5h34c1.7 0 3 1.3 3 3v26zM16 28.5h23-23zm0-10h23-23z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol126 || (_symbol126 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-content-activities-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "content-activities-small"), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 19.5h-17c-1.1 0-2-.9-2-2v-4l-2.75-3 2.75-3v-3h17c1.1 0 2 .9 2 2v13zM7 14.5h12H7zm0-5h12H7z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol127 || (_symbol127 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-copy-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "copy-large"), /*#__PURE__*/React.createElement("path", {
    d: "M28 4.5H4.5v43h34V15L28 4.5zm-.5 0v11h11M8.5 3V.5h23l11 11v32H40",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol128 || (_symbol128 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-copy-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "copy-small"), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 3.5v5h5M5.5 2V.5H17L21.5 5v15.5H20M18.5 8v15.5h-16v-20H14L18.5 8z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol129 || (_symbol129 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-country-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "country-large"), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 25.5V35m0-9.5h-5l5-14 5 14h-5zm7.5-16c8.421 6 7.316 15.429-7 36h32c-4.21-21.429-10.947-31.714-21.053-36H15zm0 0c-3-2-8-6-13-6m38.5 12a5 5 0 1 0 0-10 5 5 0 0 0 0 10zm0 0V25M19 9.5c4-3 7-6 15-6",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol130 || (_symbol130 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-country-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "country-small"), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 12.5V17m0-4.5H1l2.5-7 2.5 7H3.5zm4-8c4.21 3 3.658 7.714-3.5 18h16c-2.105-10.714-5.474-15.857-10.526-18H7.5zm0 0c-1.5-1-4-3-6.5-3m19.5 6a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zm0 0V12m-11-7.5c2-1.5 3.5-3 7.5-3",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol131 || (_symbol131 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-credit-card-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "credit-card-large"), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 9.5h35a2 2 0 0 1 2 2v25a2 2 0 0 1-2 2h-35a2 2 0 0 1-2-2v-25a2 2 0 0 1 2-2zm18.5 24h14m-34.5-16h39",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol132 || (_symbol132 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-credit-card-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "credit-card-small"), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 4.5h19a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-19a1 1 0 0 1-1-1v-13a1 1 0 0 1 1-1zm9.5 12h8m-18.5-7h21",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol133 || (_symbol133 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-cross-traffic-assist-rear-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "cross-traffic-assist-rear-large"), /*#__PURE__*/React.createElement("path", {
    d: "M28 39l-4.5 4.5L19 39m4.5 4.5V32m-9.382-6a9.473 9.473 0 0 0 2.567 5.118m14.005-.409A9.464 9.464 0 0 0 32.882 26m-17.469 8.032A12.479 12.479 0 0 1 11.09 26m24.822 0a12.47 12.47 0 0 1-3.85 7.609m-17.89 3.27A15.483 15.483 0 0 1 8.07 26m30.857 0a15.473 15.473 0 0 1-5.533 10.431M19.778 6.011c.715-.278 1.289-.446 1.722-.506 1-.14 3.106-.127 4 0 .395.055.968.228 1.718.516A2 2 0 0 1 28.5 7.888V25.5a2 2 0 0 1-2 2h-6a2 2 0 0 1-2-2V7.875a2 2 0 0 1 1.278-1.865zM20.5 21.5h5.955v2a1 1 0 0 1-1 1H21.53a1 1 0 0 1-1-.985L20.5 21.5zm0-7h5.955v-2a1 1 0 0 0-1-1H21.53a1 1 0 0 0-1 .985L20.5 14.5z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol134 || (_symbol134 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-cross-traffic-assist-rear-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "cross-traffic-assist-rear-small"), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 19.5l-3 3-3-3m3 3V16m4.84-.771A7.513 7.513 0 0 0 18.574 12M4.427 12a7.513 7.513 0 0 0 2.232 3.229m-1.537 2.613A10.507 10.507 0 0 1 1.3 12m20.402 0a10.507 10.507 0 0 1-3.823 5.842M8.855 1.938l1.161-.352a2 2 0 0 1 .58-.086h1.54a2 2 0 0 1 .5.064l1.49.384a.5.5 0 0 1 .374.484v10.103a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V2.416a.5.5 0 0 1 .355-.478zM9.75 11.5h3.5m-3.5-5h3.5",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol135 || (_symbol135 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-cubic-capacity-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "cubic-capacity-large"), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 38.5c0 2.8-2.2 5-5 5-2.7 0-5-2.2-5-5s2.3-5 5-5c2.8 0 5 2.2 5 5zM22.1 35l5.3-12.5L22.1 35zm.9-12.5l-4.6 11 4.6-11zm-6.5-12h18-18zm18 12h-18v-15c0-1.7 1.3-3 3-3h12c1.7 0 3 1.3 3 3v15z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol136 || (_symbol136 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-cubic-capacity-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "cubic-capacity-small"), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 20c0 1.4-1.1 2.5-2.5 2.5S5.5 21.4 5.5 20s1.2-2.5 2.5-2.5c1.4 0 2.5 1.1 2.5 2.5zM9 17.7l2.4-5.2L9 17.7zM6.5 5.5h11-11zm11 7h-11v-9c0-1.1.9-2 2-2h7c1.1 0 2 .9 2 2v9z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol137 || (_symbol137 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-dashboard-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "dashboard-large"), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 3.5h9v9h-9v-9zm16 0h9v9h-9v-9zm16 0h9v9h-9v-9zm-32 16h9v9h-9v-9zm16 0h9v9h-9v-9zm16 0h9v9h-9v-9zm-32 16h9v9h-9v-9zm16 0h9v9h-9v-9zm16 0h9v9h-9v-9z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol138 || (_symbol138 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-dashboard-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "dashboard-small"), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 18.5h5v5h-5v-5zm-9 0h5v5h-5v-5zm-9 0h5v5h-5v-5zm18-9h5v5h-5v-5zm-9 0h5v5h-5v-5zm-9 0h5v5h-5v-5zm18-9h5v5h-5v-5zm-9 0h5v5h-5v-5zm-9 0h5v5h-5v-5z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol139 || (_symbol139 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-dealer-request-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "dealer-request-large"), /*#__PURE__*/React.createElement("path", {
    d: "M10 28.5H3.5m6.5 11H6.5c-1.7 0-3-1.3-3-3v-34h15.9V19m-6.9 2.5h28c1.7 0 3 1.3 3 3v20h-28c-1.7 0-3-1.3-3-3v-20zm5.2 7.5l10.4 7.9 10.5-8",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol140 || (_symbol140 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-dealer-request-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "dealer-request-small"), /*#__PURE__*/React.createElement("path", {
    d: "M4 15.5H.5m3.5 6H1.5c-.6 0-1-.4-1-1V.5h9V9m-4 1.5h16c1.1 0 2 .9 2 2v11h-16c-1.1 0-2-.9-2-2v-11zm3 4.4l6 4.6 6-4.6",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol141 || (_symbol141 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-dealer-search-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "dealer-search-large"), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 33.5h-16M20 7.5h3.5v14.4m8 .3L40.8 35M24.9 24.5c5.799 0 10.5-4.701 10.5-10.5S30.699 3.5 24.9 3.5 14.4 8.201 14.4 14s4.701 10.5 10.5 10.5zm-1.4 2.6v17.4h-13c-1.7 0-3-1.3-3-3v-34h6.4",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol142 || (_symbol142 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-dealer-search-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "dealer-search-small"), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 14v8.5h-8c-.6 0-1-.4-1-1v-20h4.4m4.6 15h-9m9-14.5v9m4.8.2l5.3 7.3m-9.1-6a6 6 0 1 0 0-12 6 6 0 0 0 0 12z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol143 || (_symbol143 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-diagnostics-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "diagnostics-large"), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 26.5v6a4 4 0 0 1-4 4h-4a4 4 0 0 0 0 8h23a4 4 0 0 0 4-4v-10m-19-4c-4 0-5.667-3.333-6-5L9.078 6.958A2 2 0 0 1 11.025 4.5H14.5m4 22c4 0 5.667-3.333 6-5l3.422-14.542A2 2 0 0 0 25.975 4.5H22.5m15 26a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM14.5 2v5m8-5v5",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol144 || (_symbol144 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-diagnostics-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "diagnostics-small"), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 13.5v3a2 2 0 0 1-2 2h-2a2 2 0 1 0 0 4h11a2 2 0 0 0 2-2v-5m-9-2c-2 0-2.833-1.667-3-2.5L4.79 3.729A1 1 0 0 1 5.762 2.5H8m1.5 11c2 0 2.833-1.667 3-2.5l1.71-7.271a1 1 0 0 0-.973-1.229H11m7.5 13a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM7.5 1v3m4-3v3",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol145 || (_symbol145 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-direct-mail-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "direct-mail-large"), /*#__PURE__*/React.createElement("path", {
    d: "M45.5 39.5h-41c-1.1 0-2-.9-2-2v-29h41c1.1 0 2 .9 2 2v29zM7 17l17 13 17-13",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol146 || (_symbol146 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-direct-mail-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "direct-mail-small"), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 19.5h-19c-1.1 0-2-.9-2-2v-13h19c1.1 0 2 .9 2 2v13zM5 9.5l7 5.5 7-5.5",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol147 || (_symbol147 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-discussion-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "discussion-large"), /*#__PURE__*/React.createElement("path", {
    d: "M40.5 33.5h-27l-11 11v-35c0-2.8 2.2-5 5-5h38v24c0 2.8-2.2 5-5 5z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol148 || (_symbol148 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-discussion-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "discussion-small"), /*#__PURE__*/React.createElement("path", {
    d: "M21 17.5H6.5L.5 23V4.5c0-1.7 1.3-3 3-3h20V15c.1 1.3-.9 2.4-2.3 2.5H21z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol149 || (_symbol149 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-display-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "display-large"), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 5.5h43v26a4 4 0 0 1-4 4H.5v-26a4 4 0 0 1 4-4zm-4 24h47m-38 14h29m-10-8v8m-9-8v8",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol150 || (_symbol150 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-display-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "display-small"), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 2.5h21v13a2 2 0 0 1-2 2H.5v-13a2 2 0 0 1 2-2zm7 15v4m5-4v4m-9 0h13m-18-7h23",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol151 || (_symbol151 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-distance-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "distance-large"), /*#__PURE__*/React.createElement("path", {
    d: "M31.4 27.7c.058-3.898 3.2-7.2 7-7.1 3.9 0 7.1 3.2 7.2 7.1 0 3.9-7.1 13.3-7.1 13.3s-7.158-9.402-7.1-13.3zm7.1-3.3c1.7 0 3.1 1.3 3.1 3s-1.3 3.1-3 3.1h-.1c-1.7 0-3.1-1.4-3.1-3.1 0-1.6 1.4-3 3.1-3zM31.4 37l-4.9-2.5V7l12 5.5V18m-12-11l-12 5.5m12 22l-12 6.5m-12-6.5V7l12 5.5V41l-12-6.5z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol152 || (_symbol152 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-distance-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "distance-small"), /*#__PURE__*/React.createElement("path", {
    d: "M11.7 19.6l-3.2 1.7V4.8l7-3.8 7 4.2v16l-3-1.7m-4-14.3V1m-7 20.3L.5 17V1l8 3.8v16.5zm3-9.7c0-2.1 1.7-3.9 3.8-3.9h.2c2.2 0 4 1.8 4 4s-4 8.1-4 8.1-3.9-5.7-4-8v-.2z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol153 || (_symbol153 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-document-pdf-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "document-pdf-large"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5 2.5v11h11m0 0v32h-34v-43h23l11 11z",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.896 32.036c2.453 0 3.333 1.023 3.333 2.475 0 1.452-.935 2.519-3.388 2.519h-1.958V40H12.75v-7.964h3.146zm8.882 0c2.794 0 4.356 1.551 4.356 3.982 0 2.343-1.628 3.982-4.356 3.982H21.61v-7.964h3.168zm12.864 0v.924h-4.829v2.728h4.136v.924h-4.136V40H31.68v-7.964h5.962zm-12.787.924h-2.112v6.116h2.112c2.09 0 3.124-1.276 3.124-3.058 0-1.782-1.034-3.058-3.124-3.058zm-9.201 0h-1.771v3.146h1.771c1.837 0 2.42-.572 2.42-1.595 0-1.023-.583-1.551-2.42-1.551z",
    fill: "currentColor",
    fillRule: "nonzero"
  })))), _symbol154 || (_symbol154 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-document-pdf-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "document-pdf-small"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 20v2.5h-16v-20H15L19.5 7v3m-5-7.5v5h5",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.028 18v-5.792h2.288c1.784 0 2.424.744 2.424 1.8s-.68 1.832-2.464 1.832H6.852V18h-.824zm2.112-5.12H6.852v2.288H8.14c1.336 0 1.76-.416 1.76-1.16s-.424-1.128-1.76-1.128zM12.164 18v-5.792h2.304c2.032 0 3.168 1.128 3.168 2.896 0 1.704-1.184 2.896-3.168 2.896h-2.304zm2.36-5.12h-1.536v4.448h1.536c1.52 0 2.272-.928 2.272-2.224 0-1.296-.752-2.224-2.272-2.224zM19.18 18h.824v-2.464h3.008v-.672h-3.008V12.88h3.512v-.672H19.18V18z",
    fill: "currentColor",
    fillRule: "nonzero"
  })))), _symbol155 || (_symbol155 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-document-pricelist-dollar-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "document-pricelist-dollar-large"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.5 13.5v32h-34v-43h23l11 11zm-11-11v11h11M17 37.5h12m-16 0h2m2-6h18m-22 0h2",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.149 22.35v-1.785c-1.545-.03-2.79-.27-3.585-.54V18.87c.78.24 2.4.525 3.72.525 2.16 0 3.45-.63 3.45-1.485 0-.9-.885-1.35-2.97-1.86-2.97-.735-4.065-1.485-4.065-3.06 0-1.305 1.11-2.325 3.45-2.55V8.7h1.215v1.68c1.38.015 2.55.24 3.315.555v1.17c-.825-.3-2.07-.555-3.435-.555-1.98 0-3.015.585-3.015 1.425 0 .9.84 1.35 2.97 1.86 2.82.675 4.065 1.485 4.065 3.06 0 1.32-1.41 2.415-3.9 2.64v1.815h-1.215z",
    fill: "currentColor",
    fillRule: "nonzero"
  })))), _symbol156 || (_symbol156 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-document-pricelist-dollar-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "document-pricelist-dollar-small"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 7v15.5h-16v-20H15L19.5 7zm-5-4.5v5h5",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.727 19.21v-1.309c-1.133-.022-2.046-.198-2.629-.396v-.847c.572.176 1.76.385 2.728.385 1.584 0 2.53-.462 2.53-1.089 0-.66-.649-.99-2.178-1.364-2.178-.539-2.98-1.089-2.98-2.244 0-.957.813-1.705 2.53-1.87V9.2h.89v1.232c1.012.011 1.87.176 2.431.407v.858c-.605-.22-1.518-.407-2.519-.407-1.452 0-2.21.429-2.21 1.045 0 .66.615.99 2.177 1.364 2.068.495 2.981 1.089 2.981 2.244 0 .968-1.034 1.771-2.86 1.936v1.331h-.89z",
    fill: "currentColor",
    fillRule: "nonzero"
  })))), _symbol157 || (_symbol157 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-document-pricelist-euro-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "document-pricelist-euro-large"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.5 13.5v32h-34v-43h23l11 11zm-11-11v11h11M17 37.5h12m-16 0h2m2-6h18m-22 0h2",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.619 14.33v-1.215h1.5c.78-2.295 2.91-3.615 5.55-3.615 1.185 0 2.43.165 3.375.57v1.305c-1.08-.435-2.175-.585-3.165-.585-2.13 0-3.645.81-4.26 2.325h5.49v1.215h-5.76c-.045.255-.045.51-.045.78 0 .285.015.57.045.825h5.76v1.215h-5.445c.675 1.65 2.385 2.295 4.17 2.295 1.74 0 2.685-.27 3.3-.495v1.26c-.75.3-1.74.51-3.33.51-2.76 0-4.935-1.2-5.7-3.57h-1.485v-1.215h1.23a7.205 7.205 0 0 1 0-1.605h-1.23z",
    fill: "currentColor",
    fillRule: "nonzero"
  })))), _symbol158 || (_symbol158 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-document-pricelist-euro-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "document-pricelist-euro-small"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 7v15.5h-16v-20H15L19.5 7zm-5-4.5v5h5",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.405 13.742v-.891h1.1c.572-1.683 2.134-2.651 4.07-2.651.87 0 1.782.121 2.475.418v.957a6.203 6.203 0 0 0-2.32-.429c-1.563 0-2.674.594-3.125 1.705h4.026v.891H8.407c-.033.187-.033.374-.033.572 0 .209.011.418.033.605h4.224v.891H8.638c.495 1.21 1.75 1.683 3.058 1.683 1.276 0 1.97-.198 2.42-.363v.924c-.55.22-1.276.374-2.442.374-2.024 0-3.619-.88-4.18-2.618H6.405v-.891h.902a5.283 5.283 0 0 1 0-1.177h-.902z",
    fill: "currentColor",
    fillRule: "nonzero"
  })))), _symbol159 || (_symbol159 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-document-taxation-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "document-taxation-large"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.5 13.5v32h-34v-43h23l11 11zm-11-11v11h11M13 33.5h22m-22 4h16",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.75 20.024V19.1h7.579v.924h-3.223v7.04h-1.133v-7.04H10.75zm7.584 7.04l3.982-7.964h1.31l3.981 7.964h-1.265l-.99-1.969h-4.796l-.979 1.969h-1.243zm4.62-6.919l-1.99 4.026h3.981l-1.99-4.026zm5.263 6.919l3.531-4.114-3.278-3.85h1.43l2.541 3.08 2.563-3.08h1.353l-3.256 3.806 3.575 4.158h-1.43l-2.838-3.388-2.838 3.388h-1.353z",
    fill: "currentColor",
    fillRule: "nonzero"
  })))), _symbol160 || (_symbol160 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-document-taxation-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "document-taxation-small"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 20v2.5h-16v-20H15L19.5 7v3m-5-7.5v5h5",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.9 12.672V12h5.512v.672H8.068v5.12h-.824v-5.12H4.9zm5.816 5.12L13.612 12h.952l2.896 5.792h-.92l-.72-1.432h-3.488l-.712 1.432h-.904zm3.36-5.032l-1.448 2.928h2.896l-1.448-2.928zm3.52 5.032l2.568-2.992L17.78 12h1.04l1.848 2.24L22.532 12h.984l-2.368 2.768 2.6 3.024h-1.04l-2.064-2.464-2.064 2.464h-.984z",
    fill: "currentColor",
    fillRule: "nonzero"
  })))), _symbol161 || (_symbol161 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-documents-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "documents-large"), /*#__PURE__*/React.createElement("path", {
    d: "M12 38.5h23m-23-6h23m-23-6h23m-5.5-24v11h11m0 0v32h-34v-43h23l11 11z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol162 || (_symbol162 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-documents-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "documents-small"), /*#__PURE__*/React.createElement("path", {
    d: "M7 18.5h10m-10-3h10m-10-3h10m-2.5-10v5h5m0 0v14h-15v-19h10l5 5z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol163 || (_symbol163 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-door-open-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "door-open-large"), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 26.5l7-7V9.899a3.6 3.6 0 0 1 2.357-3.379c1.26-.464 2.275-.747 3.043-.849 1.8-.239 5.59-.217 7.2 0 .702.095 1.714.385 3.037.869A3.6 3.6 0 0 1 32.5 9.92v9.58l7 7m-7 4v9.4a3.6 3.6 0 0 1-3.6 3.6H18.1a3.6 3.6 0 0 1-3.6-3.6v-9.4m3-9h12l-.339-3.399a1.8 1.8 0 0 0-1.79-1.622H19.63a1.8 1.8 0 0 0-1.791 1.622L17.5 21.5zm0 11h12l-.338 3.38a1.8 1.8 0 0 1-1.791 1.62h-7.742a1.8 1.8 0 0 1-1.791-1.62L17.5 32.5z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol164 || (_symbol164 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-door-open-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "door-open-small"), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 13.5l3-4V4.053a.9.9 0 0 1 .614-.853l1.529-.513a3.6 3.6 0 0 1 1.145-.187h2.043a3.6 3.6 0 0 1 .99.14l2.027.58a.9.9 0 0 1 .652.865V9.5l3 4m-3 2v5.2a1.8 1.8 0 0 1-1.8 1.8H9.3a1.8 1.8 0 0 1-1.8-1.8v-5.2m1.75-6h5.5m-5.5 9h5.5",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol165 || (_symbol165 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-download-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "download-large"), /*#__PURE__*/React.createElement("path", {
    d: "M11 38.5h27M24.5 9v22.5m9-9l-9 9-9-9",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol166 || (_symbol166 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-download-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "download-small"), /*#__PURE__*/React.createElement("path", {
    d: "M6 19.5h13M17 11l-4.5 4.5L8 11m4.5-7v11.5",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol167 || (_symbol167 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-drive-belt-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "drive-belt-large"), /*#__PURE__*/React.createElement("path", {
    d: "M39.5 13.5c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM16 44.5c6.903 0 12.5-5.597 12.5-12.5S22.903 19.5 16 19.5 3.5 25.097 3.5 32 9.097 44.5 16 44.5zm0-4c4.69 0 8.5-3.81 8.5-8.5 0-4.69-3.81-8.5-8.5-8.5-4.69 0-8.5 3.81-8.5 8.5 0 4.69 3.81 8.5 8.5 8.5zM47.5 8.67c0 1.72-.53 3.31-1.45 4.64L28.7 40.47l-.12.18a15.291 15.291 0 0 1-12.75 6.85C7.37 47.5.5 40.63.5 32.17c0-5.31 2.72-10.01 6.85-12.75l.18-.12L34.69 1.95A8.166 8.166 0 0 1 47.5 8.67z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol168 || (_symbol168 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-drive-belt-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "drive-belt-small"), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 4.5a4 4 0 1 1-4-4m4 4a4 4 0 0 0-4-4m4 4c0 .84-.26 1.62-.71 2.27L14.3 20.06l-.06.09A7.482 7.482 0 0 1 8 23.5C3.86 23.5.5 20.14.5 16c0-2.6 1.33-4.9 3.35-6.24l.09-.06 13.29-8.49C17.88.76 18.66.5 19.5.5M13 16a5 5 0 1 1-10 0 5 5 0 0 1 10 0z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol169 || (_symbol169 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-eco-cycle-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "eco-cycle-large"), /*#__PURE__*/React.createElement("path", {
    d: "M40.663 31.656l-4.796-8.308 7.748-4.473c2.824 3.168 3.702 6.522 2.635 10.06m-11.595 17.26l-.068-4.26c2.796-.132 10.045-5.732 11.653-13.006-2.715 2.361-6.645 3.287-11.79 2.777l-.054-4.24-10.523 9.514 10.782 9.215zm-23.65-12.898h9.593v8.947c-4.156.862-7.5-.054-10.03-2.748m-9.15-18.67l3.724 2.07c-1.285 2.487-.06 11.565 5.436 16.594-.687-3.531.476-7.398 3.49-11.599l3.699 2.073-2.978-13.869-13.37 4.73zM25.046 7.21l-4.796 8.307-7.748-4.473c1.332-4.03 3.797-6.467 7.395-7.312M40.64 5.144l-3.655 2.19C35.475 4.977 27 1.5 19.896 3.743c3.403 1.17 6.17 4.112 8.3 8.823l-3.644 2.166 13.5 4.356 2.59-13.945z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol170 || (_symbol170 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-eco-cycle-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "eco-cycle-small"), /*#__PURE__*/React.createElement("path", {
    d: "M6.357 19.047c-.433-.25-.299-2.482 1.634-4.83l1.732 1-1.147-7.014-6.647 2.514 1.732 1c-1.508 3.15-.442 5.305 2.696 7.33 1.155.666 2.56.9 4.214.7m-.97-17.4c.409-.287 2.375.778 3.686 3.522L11.65 7.016 18.49 8.94l.532-7.086L17.383 3C15.165.303 12.763.358 9.6 2.347 8.508 3.11 7.703 4.286 7.184 5.87M22.5 14.5c0 .5-2 1.5-5 1v-2L12 18l5.5 4.5v-2c3.482-.27 4.816-2.27 5-6 0-1.333-.5-2.667-1.5-4",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol171 || (_symbol171 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-edit-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "edit-large"), /*#__PURE__*/React.createElement("path", {
    d: "M26.3 9l9.4 4.7-6.5 13M12.5 36.8l5.4 2.7m-5.4-2.7v6.7l5.4-4 16-32.3c.2-.5 0-1.1-.4-1.3l-3.6-1.8c-.5-.2-1.1 0-1.3.4L12.5 36.8z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol172 || (_symbol172 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-edit-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "edit-small"), /*#__PURE__*/React.createElement("path", {
    d: "M11.8 4.2l6.6 3.1-2.6 5.5m-10.3 5l3.6 1.7m-3.6-1.7v4.7l3.6-3 7.5-16c.2-.3 0-.7-.3-.9l-2.4-1.1c-.3-.2-.7 0-.9.3l-7.5 16z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol173 || (_symbol173 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-editorial-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "editorial-large"), /*#__PURE__*/React.createElement("path", {
    d: "M11 32.5h26-26zm0-4h26-26zm0-4h26-26zm12-4h14-14zm0-4h14-14zm0-3.9h14-14zm-11.5-.1h9v8h-9v-8zm30-6c0-1.7-1.3-3-3-3h-32v37c0 1.7 1.3 3 3 3h32v-37z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol174 || (_symbol174 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-editorial-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "editorial-small"), /*#__PURE__*/React.createElement("path", {
    d: "M5 15.5h14H5zm0-3h14H5zm8-3h6-6zm0-3h6-6zm-7.5 0h5v3h-5v-3zm16 17h-18c-.5 0-1-.4-1-1V.5h18c.5 0 1 .4 1 1v22z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol175 || (_symbol175 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-electric-range-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "electric-range-large"), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 39v9m27-4.5h-27m27-4.5v9M16 44.5H3M26.5 38V6.5a3 3 0 0 0-3-3h-15a3 3 0 0 0-3 3v38m18.5-24H8m32.5 1v14a4 4 0 1 1-8 0v-11a4 4 0 0 0-4-4h-2m20-11v6a6 6 0 1 1-12 0v-6h12zm-9 0v-5m6 5v-5",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol176 || (_symbol176 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-electric-range-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "electric-range-small"), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 21.5h-14 14zM9.5 19v5-5zm14 0v5-5zM7 22.5H1M12.5 18V3.5a2 2 0 0 0-2-2h-6a2 2 0 0 0-2 2v19m8.5-12H4m15.5 0v7a2 2 0 1 1-4 0v-5a2 2 0 0 0-2-2h-1m10-6v3a3 3 0 0 1-6 0v-3h6zm-5 0V1m4 3.5V1",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol177 || (_symbol177 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-energy-green-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "energy-green-large"), /*#__PURE__*/React.createElement("path", {
    d: "M39.5 21.5a6 6 0 0 0 6-6v-6h-12v6a6 6 0 0 0 6 6zm0 0v20a4 4 0 0 1-4 4h-29a4 4 0 0 1 0-8h1a4 4 0 0 0 4-4v-4m25-20V5m6 4.5V5m-31 24.882c-4.206-2.657-7-7.348-7-12.691 0-5.343 2.794-10.034 7-12.691a15.034 15.034 0 0 1 6.382 8.416M11.5 29.882c4.206-2.657 7-7.348 7-12.691a15.026 15.026 0 0 0-.618-4.275M11.5 29.882V14.5m0 15.382s4.919-.211 7-.87c2.081-.66 4.016-1.78 5.874-3.639 3.778-3.778 5.12-9.07 4.024-13.923a15.033 15.033 0 0 0-10.516 1.466",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol178 || (_symbol178 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-energy-green-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "energy-green-small"), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 10.5a3 3 0 0 0 3-3v-3h-6v3a3 3 0 0 0 3 3zm0 0v10a2 2 0 0 1-2 2H3a2 2 0 1 1 0-4h.5a2 2 0 0 0 2-2v-2m12-10V1m4 3.5V1m-16 13.69A7.495 7.495 0 0 1 2 8.346 7.495 7.495 0 0 1 5.5 2a7.517 7.517 0 0 1 3.191 4.208M5.5 14.691A7.495 7.495 0 0 0 9 8.345a7.513 7.513 0 0 0-.309-2.137M5.5 14.691V7m3.191-.792a7.517 7.517 0 0 1 5.258-.733 7.495 7.495 0 0 1-2.012 6.962c-.929.929-1.896 1.489-2.937 1.819",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol179 || (_symbol179 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-engine-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "engine-large"), /*#__PURE__*/React.createElement("path", {
    d: "M18 9.5h11-11zm5.5 0v4-4zm-15 15h-5 5zm-5-5.5v12-12zm36 11.5h-3v3.3c0 2.7-2.2 2.7-2.2 2.7h-14l-4.8-6h-7V18.4l6-4.9h15.1l6.9 6v2.9h3v-3.9h2c1.7 0 3 1.2 3 2.9v9.1c0 1.7-1.3 3-3 3h-2v-3z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol180 || (_symbol180 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-engine-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "engine-small"), /*#__PURE__*/React.createElement("path", {
    d: "M8 3.5h7-7zm3.5.5v3-3zM3 12.5H0h3zM.5 9v7-7zm18 6.5v1.6c0 1.4-1.2 1.4-1.2 1.4H10l-2.6-3H3.5V9.1L7 6.5h7.8l3.7 4h2v-2h1c1.1 0 2 .9 2 2v5c0 1.1-.9 2-2 2h-1v-2h-2z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol181 || (_symbol181 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-erase-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "erase-large"), /*#__PURE__*/React.createElement("path", {
    d: "M37.5 16v25c0 1.4-1.1 2.5-2.5 2.5H12c-1.4 0-2.5-1.1-2.5-2.5V16m14-8.6v-3m-2.5.1h5m-21 8h37l-3.4-5H8.4l-3.4 5z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol182 || (_symbol182 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-erase-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "erase-small"), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 9v10.5c0 .5.4 1 1 1h10c.5 0 1-.5 1-1V9m-6-3.5v-2m-1.5 0h3m-9.5 4h16l-1.4-2H4.9l-1.4 2z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol183 || (_symbol183 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-external-link-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "external-link-large"), /*#__PURE__*/React.createElement("path", {
    d: "M38.5 23v19.5h-33v-33H24m6.5-4h12v12m-17 5l17-17-17 17z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol184 || (_symbol184 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-external-link-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "external-link-small"), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 11.594V20.5h-15v-15h7.969m4.031-3h6v6m-9 3l9-9-9 9z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol185 || (_symbol185 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-eye-crossed-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "eye-crossed-large"), /*#__PURE__*/React.createElement("path", {
    d: "M35.718 14.899c.044.045.201.156.228.174C41.538 18.886 45 24.001 45 24.001s-8.8 13-21 13c-2.949 0-5.7-.76-8.175-1.911-.009-.005-.058-.005-.182-.117M12.857 33.5c-.072-.07-.123-.122-.15-.14C6.732 29.515 3 24.001 3 24.001s8.8-13 21-13c2.002 0 4.68.646 8.036 1.938l.452.177c.068.027.384.207.477.3m-4.91 4.91c-.035-.035-.072-.082-.078-.086a7 7 0 0 0-9.747 9.725c.003.004.054.072.084.102m2.246 1.996c.095.095.103.093.113.098a7 7 0 0 0 9.488-9.487.869.869 0 0 0-.098-.121M7.499 41l34-34",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol186 || (_symbol186 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-eye-crossed-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "eye-crossed-small"), /*#__PURE__*/React.createElement("path", {
    d: "M18.355 7.982c.035.034.112.095.12.101 2.5 1.853 4.025 4.107 4.025 4.107s-4.4 6.5-10.5 6.5a9.357 9.357 0 0 1-3.347-.642 1.074 1.074 0 0 1-.183-.117m-2.755-1.476a1.739 1.739 0 0 0-.137-.119C3.048 14.476 1.5 12.19 1.5 12.19s4.4-6.5 10.5-6.5c1.171 0 2.28.24 3.307.627.049.018.234.117.3.183m-2.465 2.465a.983.983 0 0 0-.284-.17 3.5 3.5 0 0 0-4.246 4.274c.01.044.163.235.195.267m2.13 2.113c.07.06.251.146.276.152a3.5 3.5 0 0 0 4.203-4.177 1.066 1.066 0 0 0-.182-.306M3.5 20.815L21 3.19",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol187 || (_symbol187 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-eye-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "eye-large"), /*#__PURE__*/React.createElement("path", {
    d: "M45 24s-8.8 13-21 13S3 24 3 24s8.8-13 21-13 21 13 21 13zm-21 7a7 7 0 1 0 0-14 7 7 0 0 0 0 14z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol188 || (_symbol188 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-eye-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "eye-small"), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 12s-4.4 6.5-10.5 6.5S1.5 12 1.5 12 5.9 5.5 12 5.5 22.5 12 22.5 12zM12 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol189 || (_symbol189 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-facebook-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "facebook-large"), /*#__PURE__*/React.createElement("path", {
    d: "M20.1 20.4h-5v4.4h5V38H26V24.8h5.9v-4.4H26v-1.8c0-1.3 1.4-4.1 3.4-4.1h2.4v-4.4h-5.1c-7.2 1.1-6.6 10.3-6.6 10.3z",
    fill: "currentColor"
  }))), _symbol190 || (_symbol190 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-facebook-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "facebook-small"), /*#__PURE__*/React.createElement("path", {
    d: "M10.1 10.2H7.6v2.2h2.5V19H13v-6.6h3v-2.2h-2.9v-.9c0-.7.7-2.1 1.7-2.1H16V5h-2.6c-3.6.5-3.3 5.2-3.3 5.2z",
    fill: "currentColor"
  }))), _symbol191 || (_symbol191 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-factory-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "factory-large"), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 41.5h28v-26l-10 7v-7l-10 7V16L15 22.5m1.5 19l-3-35h-7l-3 35h13zm7-14h5v5h-5v-5zm9 0h5v5h-5v-5z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol192 || (_symbol192 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-factory-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "factory-small"), /*#__PURE__*/React.createElement("path", {
    d: "M7.871 21.5H22.5V7.521L17.5 11V7.5l-5 3.5V7.5l-5.392 3.428M7.871 21.5H1l1.5-19h4l.608 8.428M7.871 21.5l-.763-10.572",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol193 || (_symbol193 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-favorite-filled-50-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "favorite-filled-50-large"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M24.568 37.703l-13.961 7.348 2.625-15.539L2 18.491l15.635-2.309L24.568 2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M24.568 3.138l6.6 13.5 14.9 2.2-10.7 10.5 2.5 14.8-13.3-7-13.3 7 2.5-14.8-10.7-10.5 14.9-2.2z"
  })))), _symbol194 || (_symbol194 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-favorite-filled-50-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "favorite-filled-50-small"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M12.275 18.911l-6.961 3.647 1.324-7.837L1 9.194 8.837 8.09 12.16 1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M12.175 2.147l3.2 6.4 7.1 1-5.1 5 1.2 7.1-6.3-3.3-6.3 3.3 1.2-7.1-5.1-5 7.1-1z"
  })))), _symbol195 || (_symbol195 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-favorite-filled-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "favorite-filled-large"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.568 2l6.934 14.182 15.634 2.309-11.231 11.021 2.625 15.54-13.962-7.349-13.961 7.349 2.625-15.54L1 18.492l15.635-2.309z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M23.568 3.138l6.6 13.5 14.9 2.2-10.7 10.5 2.5 14.8-13.3-7-13.3 7 2.5-14.8-10.7-10.5 14.9-2.2z"
  })))), _symbol196 || (_symbol196 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-favorite-filled-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "favorite-filled-small"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.16 1l3.545 7.089 7.845 1.105-5.639 5.527 1.325 7.837-6.961-3.647-6.961 3.647 1.324-7.837L1 9.194 8.837 8.09z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M12.175 2.147l3.2 6.4 7.1 1-5.1 5 1.2 7.1-6.3-3.3-6.3 3.3 1.2-7.1-5.1-5 7.1-1z"
  })))), _symbol197 || (_symbol197 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-favorite-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "favorite-large"), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 3l6.6 13.5L45 18.7 34.3 29.2 36.8 44l-13.3-7-13.3 7 2.5-14.8L2 18.7l14.9-2.2z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol198 || (_symbol198 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-favorite-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "favorite-small"), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 1.9l3.2 6.4 7.1 1-5.1 5 1.2 7.1-6.3-3.3-6.3 3.3 1.2-7.1-5.1-5 7.1-1z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol199 || (_symbol199 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-feature-on-demand-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "feature-on-demand-large"), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 29.5h16v16h-16v-16zm-21 0h16v16h-16v-16zm21-27h22v22h-22v-22zm-21 6h16v16h-16v-16zm26.5 5h11M34.5 8v11",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol200 || (_symbol200 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-feature-on-demand-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "feature-on-demand-small"), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 13.5h8v8h-8v-8zm-11 0h8v8h-8v-8zm11-13h10v10h-10V.5zm-11 2h8v8h-8v-8zm13.5 3h5M18.5 3v5",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol201 || (_symbol201 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-feed-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "feed-large"), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 35.9c0-3.6-2.9-6.5-6.5-6.5M27.5 36c0-8.6-6.9-15.5-15.5-15.5M36.5 36c0-13.5-11-24.5-24.5-24.5m-7.5 24v-32h36c1.7 0 3 1.3 3 3v37h-31c0-4.4-3.6-8-8-8z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol202 || (_symbol202 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-feed-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "feed-small"), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 17c0-1.9-1.6-3.5-3.5-3.5m7.5 3.5c0-4.1-3.4-7.5-7.5-7.5M18.5 17c0-6.4-5.1-11.5-11.5-11.5m-.5 16c0-2.2-1.8-4-4-4v-16h19c.5 0 1 .4 1 1v19h-16z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol203 || (_symbol203 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-filter-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "filter-large"), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 8.5h37L28.4 23.6c-.6.6-.9 1.3-.9 2.1v10.8l-7 5V25.7c0-.8-.3-1.6-.9-2.1L5.5 8.5z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol204 || (_symbol204 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-filter-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "filter-small"), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 4.5h17l-6.4 7.4c-.4.4-.6.9-.6 1.4v5.2l-3 2v-7.2c0-.5-.2-1-.6-1.4L3.5 4.5z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol205 || (_symbol205 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-financial-services-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "financial-services-large"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.09 30.5H15m15.589-2.524l11.505-3.47s5.406-1.214 5.406 1.786c0 2.541-2.424 3.53-4.091 4.293-5.978 2.735-15.038 7.013-15.038 7.013S23.833 39.5 19 39.5H.5v-9c5 0 3.64-.752 8-3 2.595-1.338 5.881-2 8.917-2H28.09a2.5 2.5 0 1 1 0 5M36 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.842 14.227c.112.053.241.101.386.145.145.044.3.082.465.113a5.977 5.977 0 0 0 1.062.103 2.4 2.4 0 0 0 .622-.07 1.2 1.2 0 0 0 .425-.2.771.771 0 0 0 .243-.307 1 1 0 0 0 .077-.399.67.67 0 0 0-.093-.353.914.914 0 0 0-.254-.27 1.682 1.682 0 0 0-.376-.199 3.249 3.249 0 0 0-.458-.138 5.308 5.308 0 0 0-.502-.088 9.088 9.088 0 0 0-.986-.074l-.4-.01.12-3.48h4.078v1.048h-2.823l-.053 1.371c.164.012.333.03.508.052.174.023.349.053.524.091.175.038.348.085.518.14.171.054.333.121.485.2.152.08.294.172.424.277a1.7 1.7 0 0 1 .556.825c.053.171.079.362.079.573 0 .19-.02.375-.062.553a1.78 1.78 0 0 1-.537.92 1.955 1.955 0 0 1-.497.326c-.194.091-.416.162-.667.211-.252.05-.534.075-.847.075-.229 0-.443-.009-.643-.027a5.386 5.386 0 0 1-.555-.078 3.622 3.622 0 0 1-.461-.121 2.115 2.115 0 0 1-.358-.156v-1.053z",
    fill: "currentColor",
    fillRule: "nonzero"
  })))), _symbol206 || (_symbol206 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-financial-services-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "financial-services-small"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 16.5H7m7.993-1.572l5.861-1.765s2.646-.595 2.646.873c0 1.244-1.186 1.728-2.002 2.101-2.925 1.339-7.359 3.432-7.359 3.432s-2.22.931-4.586.931H.5v-5c2.447 0 1.781.228 3.915-.872 1.27-.655 2.878-1.128 4.363-1.128H13.5a1.5 1.5 0 0 1 0 3m4-4.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11z",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.655 8.066c.087.04.188.078.3.112.113.035.234.064.362.088a4.649 4.649 0 0 0 .826.08c.188 0 .35-.018.484-.055a.933.933 0 0 0 .33-.154.6.6 0 0 0 .19-.24.778.778 0 0 0 .06-.31.52.52 0 0 0-.074-.274.711.711 0 0 0-.197-.21 1.308 1.308 0 0 0-.292-.155 2.527 2.527 0 0 0-.357-.108 4.128 4.128 0 0 0-.39-.068 7.068 7.068 0 0 0-.767-.057l-.311-.008L15.913 4h3.171v.815h-2.196l-.04 1.067c.127.009.259.022.394.04a4.883 4.883 0 0 1 .811.18c.133.042.258.094.377.156.118.061.228.133.33.215a1.324 1.324 0 0 1 .494 1.087c0 .148-.016.291-.048.43a1.385 1.385 0 0 1-.418.715 1.52 1.52 0 0 1-.387.254c-.15.071-.323.126-.519.165a3.403 3.403 0 0 1-.659.058c-.177 0-.344-.007-.5-.022a4.19 4.19 0 0 1-.431-.06 2.817 2.817 0 0 1-.359-.094 1.645 1.645 0 0 1-.278-.122v-.818z",
    fill: "currentColor",
    fillRule: "nonzero"
  })))), _symbol207 || (_symbol207 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-first-aid-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "first-aid-large"), /*#__PURE__*/React.createElement("path", {
    d: "M28.5 18.5v-12h-10v12h-12v10h12v12h10v-12h12v-10z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol208 || (_symbol208 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-first-aid-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "first-aid-small"), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 9.5v-6h-5v6h-6v5h6v6h5v-6h6v-5z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol209 || (_symbol209 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-flashlight-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "flashlight-large"), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 34v9.5c.012 1.333.679 2 2 2h7.002c1.332 0 1.998-.686 1.998-2.058V20.5l6-9.5V2.5h-23V11l6 9.5V34zm4-8.5v5h3v-5h-3zm-4-5h11-11zm-6.5-10h24-24z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol210 || (_symbol210 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-flashlight-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "flashlight-small"), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 10.5v11c0 .686.348 1.03 1.044 1.03.695 0 2.347-.01 4.956-.03.667.02 1-.314 1-1v-11l3-5v-4h-13v4l3 5zm0 0h7m-10-5h13M12 13v3",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol211 || (_symbol211 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-forward-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "forward-large"), /*#__PURE__*/React.createElement("path", {
    d: "M19.4 32.6l9.1-9.1-9.1-9.1",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol212 || (_symbol212 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-forward-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "forward-small"), /*#__PURE__*/React.createElement("path", {
    d: "M10 16.9l5.5-5.4L10 6.1",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol213 || (_symbol213 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-fuel-range-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "fuel-range-large"), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 39v9m27-4.5h-27m27-4.5v9M16 44.5H3M26.5 38V6.5a3 3 0 0 0-3-3h-15a3 3 0 0 0-3 3v38m18.5-24H8M34.5 4c4 5.157 6 9.324 6 12.5v19a4 4 0 1 1-8 0v-11a4 4 0 0 0-4-4h-2",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol214 || (_symbol214 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-fuel-range-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "fuel-range-small"), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 21.5h-14 14zM9.5 19v5-5zm14 0v5-5zm-7-17c1.333 1.667 2.333 3.667 3 6v9.5a2 2 0 1 1-4 0v-5a2 2 0 0 0-2-2h-1M7 22.5H1M12.5 18V3.5a2 2 0 0 0-2-2h-6a2 2 0 0 0-2 2v19m8.5-12H4",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol215 || (_symbol215 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-fuel-station-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "fuel-station-large"), /*#__PURE__*/React.createElement("path", {
    d: "M31 44.5H5m23.5 0v-38a3 3 0 0 0-3-3h-15a3 3 0 0 0-3 3v38m18.5-24H10M36.5 4c4 5.157 6 9.324 6 12.5v19a4 4 0 1 1-8 0v-11a4 4 0 0 0-4-4h-2",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol216 || (_symbol216 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-fuel-station-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "fuel-station-small"), /*#__PURE__*/React.createElement("path", {
    d: "M16 22.5H3m11.5 0v-19a2 2 0 0 0-2-2h-6a2 2 0 0 0-2 2v19m8.5-12H6M18.5 2c1.333 1.667 2.333 3.667 3 6v9.5a2 2 0 1 1-4 0v-5a2 2 0 0 0-2-2h-1",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol217 || (_symbol217 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-gas-station-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "gas-station-large"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.943 45.156c-3.302 0-5.343-1.729-5.343-4.862 0-3.029 2.054-4.862 5.408-4.862 1.118 0 2.548.156 3.367.507v1.157c-.936-.377-2.236-.52-3.172-.52-2.73 0-4.238 1.222-4.238 3.718 0 2.704 1.703 3.731 4.173 3.731 1.313 0 2.262-.221 2.691-.351v-3.211h1.326v4.095c-1.053.377-2.47.598-4.212.598zM18.75 45v-9.412h1.456l6.591 7.748v-7.748h1.313V45h-1.456l-6.591-7.735V45H18.75zm-5.601.156c-2.99 0-5.2-1.638-5.2-4.862 0-3.055 2.21-4.862 5.083-4.862 1.027 0 2.145.156 2.964.507v1.157a7.55 7.55 0 0 0-2.782-.52c-2.353 0-3.9 1.222-3.9 3.718 0 2.782 1.963 3.731 3.861 3.731 1.508 0 2.496-.26 3.029-.455v1.118c-.65.26-1.677.468-3.055.468z",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 31.5H12m16.5 0v-26a3 3 0 0 0-3-3h-8a3 3 0 0 0-3 3v26m12.5-17H16M34 3c1.797 2.246 3.297 4.913 4.5 8v14.5a2 2 0 0 1-2 2h-1.957a2 2 0 0 1-2-2v-9a2 2 0 0 0-2-2H28.5",
    stroke: "currentColor"
  })))), _symbol218 || (_symbol218 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-gas-station-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "gas-station-small"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.93 23.673c-1.842 0-2.98-.964-2.98-2.711 0-1.69 1.145-2.712 3.016-2.712.623 0 1.421.087 1.878.283v.645c-.522-.21-1.247-.29-1.77-.29-1.522 0-2.363.681-2.363 2.073 0 1.509.95 2.081 2.327 2.081a5.34 5.34 0 0 0 1.501-.196v-1.79h.74v2.284c-.588.21-1.378.333-2.35.333zM9 23.586v-5.249h.812l3.676 4.321v-4.321h.732v5.249h-.812l-3.676-4.314v4.314H9zm-3.3.087c-1.668 0-2.9-.913-2.9-2.711 0-1.704 1.232-2.712 2.835-2.712.572 0 1.196.087 1.653.283v.645a4.21 4.21 0 0 0-1.552-.29c-1.312 0-2.175.681-2.175 2.073 0 1.552 1.095 2.081 2.153 2.081.841 0 1.392-.145 1.69-.254v.624c-.363.145-.936.261-1.704.261z",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 16.5H5m9.5 0v-13a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v13m6.5-9H8m9.5-6c.928 1.16 1.594 2.493 2 4v6.543c0 .805-.652 1.457-1.457 1.457a1.478 1.478 0 0 1-1.477-1.456l-.052-3.558a1 1 0 0 0-1-.986H14.5",
    stroke: "currentColor"
  })))), _symbol219 || (_symbol219 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-geofence-alert-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "geofence-alert-large"), /*#__PURE__*/React.createElement("path", {
    d: "M35.5 8v6m0 2v2m10 2.5h-20l10-18 10 18zM26.4 9.6c-5.4-2.7-12-.5-14.8 4.9-.8 1.5-1.2 3.2-1.2 5 0 6.1 11 21.3 11 21.3s6.8-9.3 9.7-16.3m-7.5-10.1c-2.8-1.2-6 .1-7.2 2.9-1.2 2.8.1 6 2.9 7.2 1.6.7 3.5.5 5-.3m3.2 12.3c7.5.6 12.9 2.4 12.9 4.4 0 2.5-8.5 4.6-18.9 4.6-10.4 0-18.9-2-18.9-4.6 0-2 5.4-3.8 12.9-4.4",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol220 || (_symbol220 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-geofence-alert-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "geofence-alert-small"), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 5v3m0 1v2m5.7 1.5H11.8l5.7-11.4 5.7 11.4zM12.4 2.6c-3.2-.5-6.2 1.7-6.7 4.9 0 .3-.1.6-.1.9 0 3.3 5.9 11.8 5.9 11.8s2-2.9 3.7-6m-2.6-8c-1.2-.7-2.8-.2-3.4 1-.5 1-.3 2.2.4 3m5.9 8.3c3.5.4 6 1.5 6 2.5 0 1.4-4.6 2.5-10.1 2.5s-10-1.1-10-2.5c0-1 2.5-2.1 6.2-2.5",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol221 || (_symbol221 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-geofence-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "geofence-large"), /*#__PURE__*/React.createElement("path", {
    d: "M34.52 15.5c0-6.1-4.9-11-11-11s-11 4.9-11 11 11 21.3 11 21.3 11-15.2 11-21.3zm-11 5.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zm6 12.5c7.5.6 12.9 2.4 12.9 4.4 0 2.5-8.5 4.6-18.9 4.6-10.4 0-18.9-2-18.9-4.6 0-2 5.4-3.8 12.9-4.4",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol222 || (_symbol222 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-geofence-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "geofence-small"), /*#__PURE__*/React.createElement("path", {
    d: "M15.4 18.5c3.5.4 6 1.5 6 2.5 0 1.4-4.6 2.5-10.1 2.5s-10-1.1-10-2.5c0-1 2.5-2.1 6.2-2.5m4 1.5S5.7 11.7 5.7 8.5c-.1-3.3 2.6-6.1 5.8-6.2 3.3.1 6 3 5.8 6.2 0 3.2-5.8 11.5-5.8 11.5zm0-14C12.9 6 14 7.1 14 8.5S12.9 11 11.5 11 9 9.9 9 8.5 10.1 6 11.5 6z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol223 || (_symbol223 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-gift-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "gift-large"), /*#__PURE__*/React.createElement("path", {
    d: "M3 25h42M24 45V3m8.5 30.5L24 25m0 0l-8.5 8.5M24 25l4.469-1.117A6.302 6.302 0 0 0 33 19.5a2.023 2.023 0 0 0-2.5-2.5 7.656 7.656 0 0 0-4.934 4.346L24 25zm0 0l-1.566-3.654A7.656 7.656 0 0 0 17.5 17a2.023 2.023 0 0 0-2.5 2.5 6.302 6.302 0 0 0 4.531 4.383L24 25zM2.5 2.5h41a2 2 0 0 1 2 2v41h-41a2 2 0 0 1-2-2v-41z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol224 || (_symbol224 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-gift-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "gift-small"), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 2.5h17a1 1 0 0 1 1 1v17h-17a1 1 0 0 1-1-1v-17zm0 9h18m-9 9v-18M16 16l-4.5-4.5L7 16m-.75-7.5a1.187 1.187 0 0 1 1.345-1.581L8 7a4.029 4.029 0 0 1 3.118 2.973L11.5 11.5l-2.415-.537A3.941 3.941 0 0 1 6.25 8.5zm8.783-1.702l.218-.026a1.251 1.251 0 0 1 1.282 1.776l-.094.199a4.32 4.32 0 0 1-2.859 2.346l-2.015.504.461-2.074a3.512 3.512 0 0 1 3.007-2.725z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol225 || (_symbol225 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-google-plus-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "google-plus-large"), /*#__PURE__*/React.createElement("path", {
    d: "M33.6 19.4h2.7v2.7H39v2.7h-2.7v2.7h-2.7v-2.7h-2.7v-2.7h2.7v-2.7zM9.1 23c.1-4.9 4.6-9.2 9.5-9 2.3-.1 4.5.9 6.3 2.3-.8.9-1.6 1.7-2.4 2.5-2.2-1.5-5.2-1.9-7.4-.2-3.1 2.1-3.2 7.2-.3 9.5 2.9 2.6 8.3 1.3 9.1-2.7-1.8 0-3.6 0-5.4-.1v-3.2h9.1c.2 2.5-.2 5.2-1.7 7.3-2.4 3.3-7.1 4.3-10.8 2.9-3.7-1.4-6.3-5.3-6-9.3z",
    fill: "currentColor"
  }))), _symbol226 || (_symbol226 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-google-plus-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "google-plus-small"), /*#__PURE__*/React.createElement("path", {
    d: "M17.4 9.7h1.5v1.5h1.5v1.5h-1.5v1.5h-1.5v-1.5h-1.5v-1.5h1.5V9.7zm-13.9 2c0-2.8 2.6-5.2 5.4-5.1 1.3-.1 2.6.5 3.6 1.3-.4.5-.9 1-1.4 1.4-1.2-.8-3-1.1-4.2-.1-1.8 1.2-1.8 4.1-.1 5.4 1.6 1.5 4.7.8 5.2-1.5H8.9v-1.8h5.2c.1 1.4-.1 3-1 4.2-1.3 1.9-4 2.4-6.1 1.6-2.2-.9-3.7-3.1-3.5-5.4z",
    fill: "currentColor"
  }))), _symbol227 || (_symbol227 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-gps-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "gps-large"), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 35v10m0-43v10M45 23.5H35m-23 0H2m21.5 17c9.389 0 17-7.611 17-17s-7.611-17-17-17-17 7.611-17 17 7.611 17 17 17z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol228 || (_symbol228 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-gps-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "gps-small"), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 17v6-6zm0-17v6-6zM23 11.5h-6 6zm-17 0H0h6zm14.5 0c0 5-4 9-9 9s-9-4-9-9 4-9 9-9 9 4 9 9z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol229 || (_symbol229 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-grab-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "grab-large"), /*#__PURE__*/React.createElement("path", {
    d: "M13 20.5h22m-22 6h22",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol230 || (_symbol230 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-grab-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "grab-small"), /*#__PURE__*/React.createElement("path", {
    d: "M3 9.5h18m-18 4h18",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol231 || (_symbol231 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-group-discussion-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "group-discussion-large"), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 20.5h-6l-6 6v-22h24v8m19 24h-22l-9 8.5V12.5h35v20c0 2.2-1.7 4-3.9 4h-.1z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol232 || (_symbol232 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-group-discussion-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "group-discussion-small"), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 10.5h-3l-3 3v-11h12v4m9 12h-11l-4 4v-16h17v10c0 1.1-.9 2-2 2z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol233 || (_symbol233 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-groups-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "groups-large"), /*#__PURE__*/React.createElement("path", {
    d: "M30.1 37.5h13.4v-12c0-1.7-1.3-3-3-3H24m4.5-16h6c1.7 0 3 1.3 3 3v6c0 1.7-1.3 3-3 3h-6c-1.7 0-3-1.3-3-3v-6c0-1.7 1.3-3 3-3zm-25 34v-12c0-1.7 1.3-3 3-3h18c1.7 0 3 1.3 3 3v12h-24zm9-31h6c1.7 0 3 1.3 3 3v6c0 1.7-1.3 3-3 3h-6c-1.7 0-3-1.3-3-3v-6c0-1.7 1.3-3 3-3z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol234 || (_symbol234 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-groups-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "groups-small"), /*#__PURE__*/React.createElement("path", {
    d: "M15 18.5h7.5v-6c0-.6-.4-1-1-1H12m3.5-9h2c1.1 0 2 .9 2 2v2c0 1.1-.9 2-2 2h-2c-1.1 0-2-.9-2-2v-2c0-1.1.9-2 2-2zm-14 18v-6c0-.6.4-1 1-1h10c.6 0 1 .4 1 1v6h-12zm5-16h2c1.1 0 2 .9 2 2v2c0 1.1-.9 2-2 2h-2c-1.1 0-2-.9-2-2v-2c0-1.1.9-2 2-2z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol235 || (_symbol235 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-handshake-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "handshake-large"), /*#__PURE__*/React.createElement("path", {
    d: "M38.282 29.379l2.45-2.426a4.14 4.14 0 0 0 .936-4.414l-3.294-8.565a4.14 4.14 0 0 0-3.452-2.634l-6.339-.634a4.14 4.14 0 0 0-2.709.675l-.319.213m0 0l-8.596 5.73a2.584 2.584 0 0 0 2.867 4.3l4.35-2.9a4.14 4.14 0 0 1 5.33.628l8.035 8.652a3.105 3.105 0 0 1-.508 4.666l-7.744 5.361a4.14 4.14 0 0 1-4.465.16l-1.618-.958m2.35-25.64H13.39a4.14 4.14 0 0 0-3.864 2.655l-3.19 8.29a4.14 4.14 0 0 0 .938 4.415l2.654 2.53m2.931-17.855L8.142 8.83A2.07 2.07 0 0 0 5.089 9.94L1.5 20.748l4.415 2.943M35.667 11.42l4.191-2.59a2.07 2.07 0 0 1 3.053 1.109L46.5 20.748l-4.415 2.943m-30.022 2.838c.92-.856 2.32-.93 3.325-.176l8.319 6.239a2.564 2.564 0 0 1 .274 3.864l-1.597 1.598c-.865.865-2.22.999-3.238.32l-8.11-6.262a2.638 2.638 0 0 1-.306-4.107l1.333-1.476z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol236 || (_symbol236 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-handshake-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "handshake-small"), /*#__PURE__*/React.createElement("path", {
    d: "M18.898 14.591l1.183-1.172a2 2 0 0 0 .452-2.132l-1.59-4.137a2 2 0 0 0-1.669-1.273l-3.061-.306a2 2 0 0 0-1.309.326L12.75 6m0 0L8.598 8.768a1.248 1.248 0 0 0 1.384 2.077l2.102-1.4a2 2 0 0 1 2.575.303l3.88 4.179a1.5 1.5 0 0 1-.245 2.254l-3.74 2.59a2 2 0 0 1-2.157.076l-.782-.462M12.75 6H6.874a2 2 0 0 0-1.867 1.282l-1.54 4.005a2 2 0 0 0 .452 2.132l1.282 1.223m1.162-8.726L4.339 4.665a1 1 0 0 0-1.475.535L1.13 10.422l2.133 1.421m14.372-5.927l2.024-1.251a1 1 0 0 1 1.475.535l1.733 5.222-2.132 1.421M6.233 13.215a1.253 1.253 0 0 1 1.606-.086l4.018 3.014c.603.452.666 1.334.133 1.867l-.772.771a1.24 1.24 0 0 1-1.564.155l-3.917-3.025a1.274 1.274 0 0 1-.148-1.983l.644-.713z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol237 || (_symbol237 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-history-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "history-large"), /*#__PURE__*/React.createElement("path", {
    d: "M3 20l4.5 4.5L12 20M25 5.5C15.1 5.8 7.2 14.1 7.5 24v.5m18 17c9.9 0 18-8.1 18-18s-8.1-18-18-18H25m.5 21a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0-6V9v11.5zm3 3H36",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol238 || (_symbol238 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-history-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "history-small"), /*#__PURE__*/React.createElement("path", {
    d: "M12.9 21.6c5.3 0 9.6-4.3 9.6-9.6s-4.3-9.6-9.6-9.6c-2.691 0-5.163 1.18-6.9 3.063-1.058 1.148-1.743 2.556-2.138 4.118-.233.92-.43 1.895-.367 2.9M1.3 10.4l2.2 2.1L6 10.8m7-5.3v7m3.5 0h-4",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol239 || (_symbol239 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-home-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "home-large"), /*#__PURE__*/React.createElement("path", {
    d: "M39.5 19.7v19.8H10.6c-1.7 0-3-1.3-3.1-3V19.7m37 3.8l-21-16.1-21 16.1",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol240 || (_symbol240 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-home-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "home-small"), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 10.1v6.4c0 1.1.9 2 2 2h12v-8.4m2.3 1.7l-9.3-7.2-9.3 7.2",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol241 || (_symbol241 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-honk-and-flash-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "honk-and-flash-large"), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 16.5v-6h-7v-6l-9 9 9 9v-6h7zm4-6v6h7v6l9-9-9-9v6h-7zm5.5 23h6.2s10.3 0 10.3 10h2v-24h-2s-.7 10-10.3 10H17s-6.1-.4-7.5-2.5v9s3-2.4 7.5-2.5h6m-.4 0c-4 .5-6.9 2.1-7.1 4.5-.2 3.1 4.1 6 10 6.5s10.8-1.9 11-5c.2-2.9-3.4-5.2-8.6-6m-8.4 5c-.1 1.6 2.8 2.7 6.5 3 3.7.3 6.4-.9 6.5-2.5.1-1.6-2.3-2.2-6-2.5-3.7-.3-6.9.4-7 2z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol242 || (_symbol242 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-honk-and-flash-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "honk-and-flash-small"), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 18.5h3s5 0 5 5h2v-13h-2s0 5.1-4.9 5.1H6s-2.7.1-3.5-1.1v5s.9-1 3.5-1h6.8m-3.3 0c-2 .3-2.9.8-3 2-.1 1.5 1.6 2.8 4.5 3 2.9.2 5.4-1 5.5-2.5.1-1.5-1.9-2.1-4.5-2.5m-3.5-10v-4h-3v-3l-4.8 5 4.8 5v-3h3zm3 0v-4h3v-3l5 5-5 5v-3h-3z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol243 || (_symbol243 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-honk-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "honk-large"), /*#__PURE__*/React.createElement("path", {
    d: "M24 25.5h6.5s11 .1 11 12h3v-28h-3s-.1 12-11 12H12S5.1 20.4 3.5 18v11s3.1-3.5 8.5-3.5h7m-.5 0c-4.5.6-7.8 2.8-8 5.5-.3 3.6 4.8 7 11.5 7.5s12.2-1.9 12.5-5.5c.3-3.3-4-6.6-10-7.5m-10.3 5.8c-.1 2 3.2 3.9 7.8 4.2 4.6.3 8.7-.9 8.8-2.9.1-2-3.2-3.8-7.8-4.1-4.6-.3-8.7.8-8.8 2.8z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol244 || (_symbol244 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-honk-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "honk-small"), /*#__PURE__*/React.createElement("path", {
    d: "M12 13.5h3.6s6.1-.6 6.1 6h1.8v-15h-1.8s0 6-6.1 6H7C6 10.5 2 10 .5 8v7.5s1.5-2 6.5-2h6m-4.5 0c-2.2.3-3.8 1.1-3.9 2.5-.1 1.8 2.4 3.3 5.7 3.6 3.3.3 6.1-.8 6.2-2.6.1-1.8-2.1-3.1-5.1-3.5",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol245 || (_symbol245 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-hotline-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "hotline-large"), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 17.5h3c1.1 0 2 .9 2 2v13.1c0 1.1-.9 1.9-2 1.9H10m30.5-17h-3c-1.1 0-2 .9-2 2v13.1c0 1.1.9 1.9 2 1.9h3v-19c0-5.5-4.5-10-10-10h-11c-5.5 0-10 4.5-10 10v16c0 5.5 4.5 10 10 10h1m0-2h10v4h-10v-4zm-11-7c-2.3-.3-4-3.1-4-6.5s1.7-6.1 4-6.5m31 13c2.3-.3 4-3.1 4-6.5s-1.7-6.1-4-6.5",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol246 || (_symbol246 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-hotline-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "hotline-small"), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 8.5h-.3c-1.5 0-2.7 1.9-2.7 4s1.2 4 2.7 4h.3m17-9h-2.1c-.7 0-.9.5-.9 1.1v7.7c0 .7.2 1.2.9 1.2h2.1V6.2c0-3.3-2.2-5.7-5.5-5.7H9C5.7.5 3.5 3 3.5 6.2v10.5c0 3.3 2 5.8 5.3 5.8h.7m0-1h6v2h-6v-2zm-6-14h2.1c.7 0 .9.5.9 1.1v7.7c0 .7-.2 1.2-.9 1.2H3.5m17-9h.4c1.5 0 2.6 1.9 2.6 4s-1.1 4-2.6 4h-.4",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol247 || (_symbol247 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-idea-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "idea-large"), /*#__PURE__*/React.createElement("path", {
    d: "M21 43.5h6m-8-4h10m-10-4h10M20.011 32l-2.24-3.125A12.517 12.517 0 0 1 11.5 18.02C11.5 11.105 17.096 5.5 24 5.5s12.5 5.605 12.5 12.519c0 4.643-2.524 8.695-6.272 10.856L27.988 32",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol248 || (_symbol248 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-idea-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "idea-small"), /*#__PURE__*/React.createElement("path", {
    d: "M10 21.5h4m-5-3h6M10 16l-1.239-1.345A6.509 6.509 0 0 1 5.5 9.01C5.5 5.415 8.41 2.5 12 2.5s6.5 2.915 6.5 6.51a6.509 6.509 0 0 1-3.261 5.645L14 16",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol249 || (_symbol249 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-indicators-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "indicators-large"), /*#__PURE__*/React.createElement("path", {
    d: "M26.5 19.5v8h9v8l11.8-12-11.8-12v8h-9zm-5 8v-8h-9v-8L.7 23.5l11.8 12v-8h9z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol250 || (_symbol250 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-indicators-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "indicators-small"), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 13.5v-4h4v-4l5.8 6-5.8 6v-4h-4zm-3 0v-4h-4v-4l-5.8 6 5.8 6v-4h4z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol251 || (_symbol251 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-inspection-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "inspection-large"), /*#__PURE__*/React.createElement("path", {
    d: "M39.5 29v-2.5h-9V29l1 2v5.5l-1 2v5c0 1.1.9 2 2 2h5c1.1 0 2-.9 2-2v-5l-1-2V31l1-2zm-3.1-2.6l.1-11.9 3-3V7L37 2.5h-4L30.5 7v4.5l3 3v11.9m-21 16.1v-25l-5-5v-6l4-4 1 1v4l1 1h5l1-1v-4l1-1 4 4v6l-5 5v25c0 1.7-1.3 3-3 3h-1c-1.7 0-3-1.3-3-3z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol252 || (_symbol252 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-inspection-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "inspection-small"), /*#__PURE__*/React.createElement("path", {
    d: "M19.5.5l1 3v3l-1 1v7h1v7c0 1.1-.9 2-2 2h-1c-1.1 0-2-.9-2-2v-7h1v-7l-1-1v-3l1-3h3zm-15 0v3l1 1h3l1-1v-3h1l2 2v4l-3 3V21c0 1.1-1 2.5-2.2 2.5h-.6c-1.2 0-2.2-1.3-2.2-2.5V9.5l-3-3v-4l2-2h1z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol253 || (_symbol253 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-instagram-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "instagram-large"), /*#__PURE__*/React.createElement("path", {
    d: "M25.16 12c2.223.004 2.678.022 3.788.072 1.277.058 2.15.261 2.912.558.79.307 1.459.717 2.126 1.384a5.883 5.883 0 0 1 1.384 2.126c.297.763.5 1.635.558 2.912.058 1.28.072 1.689.072 4.948 0 3.259-.014 3.668-.072 4.948-.058 1.277-.261 2.15-.558 2.912a5.883 5.883 0 0 1-1.384 2.126 5.883 5.883 0 0 1-2.126 1.384c-.763.297-1.635.5-2.912.558-1.28.058-1.689.072-4.948.072-3.259 0-3.668-.014-4.948-.072-1.277-.058-2.15-.261-2.912-.558a5.883 5.883 0 0 1-2.126-1.384 5.882 5.882 0 0 1-1.384-2.126c-.297-.763-.5-1.635-.558-2.912-.05-1.11-.068-1.565-.071-3.788v-2.32c.003-2.223.02-2.678.071-3.788.058-1.277.261-2.15.558-2.912a5.882 5.882 0 0 1 1.384-2.126 5.882 5.882 0 0 1 2.126-1.384c.763-.297 1.635-.5 2.912-.558 1.11-.05 1.565-.068 3.788-.071zm-.02 2.163h-2.28c-2.181.003-2.612.02-3.709.07-1.17.052-1.805.248-2.228.412-.56.218-.96.478-1.38.898-.42.42-.68.82-.898 1.38-.164.423-.36 1.058-.413 2.228-.05 1.097-.066 1.528-.07 3.71v2.279c.004 2.181.02 2.612.07 3.709.053 1.17.249 1.805.413 2.228.218.56.478.96.898 1.38.42.42.82.68 1.38.898.423.164 1.058.36 2.228.413 1.096.05 1.528.066 3.71.07h2.279c2.181-.004 2.613-.02 3.709-.07 1.17-.053 1.805-.249 2.228-.413.56-.218.96-.478 1.38-.898.42-.42.68-.82.898-1.38.164-.423.36-1.058.413-2.228.05-1.097.066-1.528.07-3.71V22.86c-.004-2.181-.02-2.612-.07-3.709-.053-1.17-.249-1.805-.413-2.228a3.717 3.717 0 0 0-.898-1.38c-.42-.42-.82-.68-1.38-.898-.423-.164-1.058-.36-2.228-.413-1.097-.05-1.528-.066-3.71-.07zM24 17.838a6.162 6.162 0 1 1 0 12.324 6.162 6.162 0 0 1 0-12.324zM24 20a4 4 0 1 0 0 8 4 4 0 0 0 0-8zm6.406-3.846a1.44 1.44 0 1 1 0 2.88 1.44 1.44 0 0 1 0-2.88z",
    fill: "currentColor"
  }))), _symbol254 || (_symbol254 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-instagram-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "instagram-small"), /*#__PURE__*/React.createElement("path", {
    d: "M12.673 6c1.032.003 1.262.012 1.8.036.64.03 1.076.13 1.457.279.395.153.73.358 1.063.692.334.334.539.668.692 1.063.148.381.25.818.279 1.456.03.64.036.844.036 2.474 0 1.63-.007 1.834-.036 2.474-.03.638-.13 1.075-.279 1.456-.153.395-.358.73-.692 1.063a2.941 2.941 0 0 1-1.063.692c-.381.148-.818.25-1.456.279-.64.03-.844.036-2.474.036-1.63 0-1.834-.007-2.474-.036-.638-.03-1.075-.13-1.456-.279a2.941 2.941 0 0 1-1.063-.692 2.94 2.94 0 0 1-.692-1.063c-.148-.381-.25-.818-.279-1.456a32.235 32.235 0 0 1-.035-1.801v-1.346c.002-1.032.01-1.262.035-1.8.03-.64.13-1.076.279-1.457a2.94 2.94 0 0 1 .692-1.063 2.94 2.94 0 0 1 1.063-.692c.381-.148.818-.25 1.456-.279.54-.024.77-.033 1.801-.035zm-.012 1.082h-1.322c-1.012.002-1.23.01-1.764.034-.585.027-.902.124-1.114.207-.28.108-.48.239-.69.448-.21.21-.34.41-.448.69-.083.212-.18.53-.207 1.114-.024.533-.032.752-.034 1.764v1.322c.002 1.012.01 1.23.034 1.764.027.585.124.902.207 1.114.108.28.239.48.448.69.21.21.41.34.69.448.212.083.53.18 1.114.207.533.024.752.032 1.764.034h1.322a31.376 31.376 0 0 0 1.764-.034c.585-.027.902-.124 1.114-.207.28-.108.48-.239.69-.448.21-.21.34-.41.448-.69.083-.212.18-.53.207-1.114.024-.533.032-.752.034-1.764v-1.322a31.382 31.382 0 0 0-.034-1.764c-.027-.585-.124-.902-.207-1.114a1.859 1.859 0 0 0-.448-.69c-.21-.21-.41-.34-.69-.448-.212-.083-.53-.18-1.114-.207a31.382 31.382 0 0 0-1.764-.034zM12 8.919a3.081 3.081 0 1 1 0 6.162 3.081 3.081 0 0 1 0-6.162zM12 10a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm3.203-1.923a.72.72 0 1 1 0 1.44.72.72 0 0 1 0-1.44z",
    fill: "currentColor"
  }))), _symbol255 || (_symbol255 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-interior-configuration-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "interior-configuration-large"), /*#__PURE__*/React.createElement("path", {
    d: "M24.2 39l4.9 6.3-4.9-6.3zm16-24s1.8.6 0 4-10 26-10 26c-.039.045-.62.6-6.1.6L4.5 43v-4s-.5-4.6 4.7-4.6 15 4.6 15 4.6c0-5.8 7-28.3 16-24zm.3-12.5c1.1 0 2 .9 2 2v5c0 1.1-.9 2-2 2h-3c-1.1 0-2-.9-2-2v-5c0-1.1.9-2 2-2h3z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol256 || (_symbol256 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-interior-configuration-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "interior-configuration-small"), /*#__PURE__*/React.createElement("path", {
    d: "M12.3 19.5l2.3 3-2.3-3zm-9.8 2v-2c-.1-1.2.8-2.2 2-2.3h.4c2.5 0 7.5 2.3 7.5 2.3.1-1.2.4-2.5.9-3.6 1.2-3 4.2-7.8 7.1-6.3.2.6.3 1.3 0 2-.8 1.7-5 10.9-5 10.9h-3.1l-9.8-1zm16-19c0-.5.4-1 1-1h1.1c.5 0 1 .5 1 1v4c0 .5-.4 1-1 1h-1.1c-.5 0-1-.5-1-1v-4z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol257 || (_symbol257 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-languages-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "languages-large"), /*#__PURE__*/React.createElement("path", {
    d: "M32.5 23.9c0 11.9-3.8 21.6-8.5 21.6s-8.5-9.6-8.5-21.5S19.3 2.5 24 2.5s8.5 9.6 8.5 21.4zM5.3 34.5h37.4H5.3zm-2.8-10h43-43zm2.3-10h38.5H4.8zm40.7 9.4c0 11.9-9.6 21.5-21.4 21.6-11.9 0-21.5-9.6-21.6-21.4 0-11.9 9.6-21.5 21.4-21.6h.1c11.8 0 21.4 9.6 21.5 21.4z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol258 || (_symbol258 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-languages-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "languages-small"), /*#__PURE__*/React.createElement("path", {
    d: "M1.7 16.5h19.6m-20.8-5h22m-20.8-5h19.6m-9.8 16c2.761 0 5-4.925 5-11s-2.239-11-5-11-5 4.925-5 11 2.239 11 5 11zm0 0c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.925-11 11 4.925 11 11 11z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol259 || (_symbol259 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-laptop-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "laptop-large"), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 9.5h35v26h-39v-22a4 4 0 0 1 4-4zm-8 30h47",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol260 || (_symbol260 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-laptop-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "laptop-small"), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 4.5h17v11a2 2 0 0 1-2 2h-17v-11a2 2 0 0 1 2-2zm-4 16h23",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol261 || (_symbol261 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-lights-crossed-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "lights-crossed-large"), /*#__PURE__*/React.createElement("path", {
    d: "M3.501 34.001h8-8zm0-5h13-13zm0-5h13-13zm0-5h13-13zm0-5h13-13zm28.327.05c-.103-.101-.228-.152-.272-.175-2.753-1.414-5.585-2.626-7.855-3.575-2.4-1-4.7.2-4.7 2.7v13.5m0 5v3.4c0 2.5 2.3 3.7 4.7 2.7 6.7-2.7 18.3-7.8 18.3-13.6 0-3.037-3.181-5.883-7.174-8.306a3.364 3.364 0 0 1-.24-.194M3 45L45 3",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol262 || (_symbol262 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-lights-crossed-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "lights-crossed-small"), /*#__PURE__*/React.createElement("path", {
    d: "M0 15.69h6-6zm0-4h7-7zm0-4h7-7zm16.494-2.214a.997.997 0 0 0-.217-.15A67.031 67.031 0 0 0 12.4 3.69c-1.5-.6-2.9.1-2.9 1.6v6.9m0 5v1c0 1.5 1.4 2.2 2.9 1.6 4.1-1.7 11.1-4.7 11.1-8.1 0-1.66-1.669-3.225-3.854-4.578a2.624 2.624 0 0 1-.324-.225M1.375 22.815l21.5-21.625",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol263 || (_symbol263 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-lights-day-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "lights-day-large"), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 23.5c0-3.3-5.5-6.2-8.8-7.8-.7-.4-1.6-.2-2.1.6-.2.3-.2.7-.2 1v12.5c-.1.8.4 1.6 1.2 1.7.3.1.7 0 1-.2 3.4-1.6 8.9-4.5 8.9-7.8zm-20.3 7l7.5-3-7.5 3zm-.2-7h8-8zm7.7-4l-7.5-3 7.5 3zm16.8 4c0-3.3 5.5-6.2 8.8-7.8.7-.4 1.6-.2 2.1.6.2.3.2.7.2 1v12.5c.1.8-.4 1.6-1.2 1.7-.3.1-.7 0-1-.2-3.4-1.6-8.9-4.5-8.9-7.8zm21.3 7l-7.5-3 7.5 3zm.2-7h-8 8zm-7.7-4l7.5-3-7.5 3z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol264 || (_symbol264 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-lights-day-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "lights-day-small"), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 11.5c0-1.9-2.2-3.5-3.7-4.6-.3-.3-.8-.2-1.1.1-.2.2-.2.5-.2.7v7.6c-.1.4.2.9.6.9.2 0 .5 0 .7-.2 1.5-1 3.7-2.6 3.7-4.5zM.3 16.6l3.5-2.2-3.5 2.2zM0 11.5h4-4zm.3-5.1l3.5 2.2L.3 6.4zm13.2 5.1c0-1.9 2.2-3.5 3.7-4.6.3-.3.8-.2 1.1.1.2.2.2.4.2.7v7.6c.1.4-.2.9-.6.9-.2 0-.5 0-.7-.2-1.5-1-3.7-2.6-3.7-4.5zM24 16.6l-3.5-2.2 3.5 2.2zm0-5.1h-4 4zm0-5.1l-3.5 2.2L24 6.4z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol265 || (_symbol265 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-lights-dim-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "lights-dim-large"), /*#__PURE__*/React.createElement("path", {
    d: "M16.8 33.5L4.2 37.9l12.6-4.4zm0-5L4.2 32.9l12.6-4.4zm0-5L4.2 27.9l12.6-4.4zm0-5L4.2 22.9l12.6-4.4zm0-5L4.2 17.9l12.6-4.4zm25.7 10c0-5.8-11.6-10.9-18.3-13.7-2.4-1-4.7.2-4.7 2.7v21.9c0 2.5 2.3 3.7 4.7 2.7 6.7-2.7 18.3-7.8 18.3-13.6z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol266 || (_symbol266 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-lights-dim-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "lights-dim-small"), /*#__PURE__*/React.createElement("path", {
    d: "M7.1 16.5L.2 18.9l6.9-2.4zm0-4.8L.2 14.1l6.9-2.4zm0-4.7L.2 9.4 7.1 7zm16.4 4.5c0-3.4-7-6.4-11.1-8-1.5-.6-2.9.1-2.9 1.6V18c0 1.5 1.4 2.2 2.9 1.6 4.1-1.7 11.1-4.7 11.1-8.1z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol267 || (_symbol267 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-lights-full-beam-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "lights-full-beam-large"), /*#__PURE__*/React.createElement("path", {
    d: "M4 33.5h13H4zm0-5h13H4zm0-5h13H4zm0-5h13H4zm0-5h13H4zm38.5 10c0-5.8-11.6-10.9-18.3-13.7-2.4-1-4.7.2-4.7 2.7v21.9c0 2.5 2.3 3.7 4.7 2.7 6.7-2.7 18.3-7.8 18.3-13.6z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol268 || (_symbol268 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-lights-full-beam-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "lights-full-beam-small"), /*#__PURE__*/React.createElement("path", {
    d: "M0 15.5h7-7zm0-4h7-7zm0-4h7-7zm23.5 4c0-3.4-7-6.4-11.1-8-1.5-.6-2.9.1-2.9 1.6V18c0 1.5 1.4 2.2 2.9 1.6 4.1-1.7 11.1-4.7 11.1-8.1z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol269 || (_symbol269 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-lights-led-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "lights-led-large"), /*#__PURE__*/React.createElement("path", {
    d: "M13 27.5h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1-1h1m1-1h1m0-2h1m-1-2h1m-1-2h1m-1-2h1m-15.6 1.8s.8 3.3 6.4 3.3c6 0 4.7-7.2 4.7-7.2M21.9 36.1s-8.6 3.3-19.5-10l43.1-14.6-2 16.7s-.4 3.2-2.3 3.6l-19.3 4.3z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol270 || (_symbol270 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-lights-led-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "lights-led-small"), /*#__PURE__*/React.createElement("path", {
    d: "M7 13.5h1m1 0h1m1 0h1m1 0h1m1 0h1m1-1h1m1-1h1m-1-2h1m-8.1-.2s.3 1.3 3.1 1.3c3.1 0 1.8-3.3 1.8-3.3m-6 10.3S6.4 19.3.9 12.5L23 5.3l-1.1 8.3s-.2 1.6-1.2 1.8l-9.9 2.2z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol271 || (_symbol271 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-lights-xenon-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "lights-xenon-large"), /*#__PURE__*/React.createElement("path", {
    d: "M39.6 19l-1.1 7.5L20 31.9s-3.3.7-8.3-4.2l8.7-2.7m3-5.7s.8 3.3 6.4 3.3c6 0 4.7-7.2 4.7-7.2M21.9 36.1s-8.6 3.3-19.5-10l43.1-14.6-2 16.7s-.4 3.2-2.3 3.6l-19.3 4.3z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol272 || (_symbol272 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-lights-xenon-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "lights-xenon-small"), /*#__PURE__*/React.createElement("path", {
    d: "M19.9 9.1l-.5 3.5-9.5 2.8s-1.8.3-4.2-2l4.3-1.3m1.9-2.8s.3 1.3 3.1 1.3c3.1 0 1.8-3.3 1.8-3.3m-6 10.3S6.4 19.3.9 12.5L23 5.3l-1.1 8.3s-.2 1.6-1.2 1.8l-9.9 2.2z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol273 || (_symbol273 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-line-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "line-large"), /*#__PURE__*/React.createElement("path", {
    d: "M15 23.5h19",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol274 || (_symbol274 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-line-me-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "line-me-large"), /*#__PURE__*/React.createElement("path", {
    d: "M34.983 19.782c0 .17-.14.307-.311.307h-3.05v1.16h3.05a.31.31 0 0 1 .31.306v1.104c0 .17-.138.307-.31.307h-3.05v1.16h3.05c.172 0 .31.137.31.306v1.105a.31.31 0 0 1-.31.306h-4.484a.313.313 0 0 1-.22-.09l-.004-.004a.302.302 0 0 1-.088-.212v-6.859c0-.082.034-.156.087-.211l.005-.006.003-.003a.313.313 0 0 1 .217-.087h4.484a.31.31 0 0 1 .31.307v1.104zm-6.198 5.755c0 .169-.139.306-.311.306h-1.122a.31.31 0 0 1-.08-.01l-.005-.001-.02-.007-.01-.004-.015-.006a.118.118 0 0 1-.015-.007.154.154 0 0 1-.01-.005l-.018-.011-.004-.003a.303.303 0 0 1-.079-.075l-3.199-4.251v4.074c0 .169-.14.306-.311.306h-1.122a.309.309 0 0 1-.312-.306v-6.86a.31.31 0 0 1 .312-.306H23.596l.017.002c.005 0 .01 0 .016.002a.188.188 0 0 1 .031.006l.01.002a.235.235 0 0 1 .02.006l.01.004a.194.194 0 0 1 .027.012l.017.009a.255.255 0 0 1 .025.017l.009.006a.218.218 0 0 1 .016.013l.006.006a.268.268 0 0 1 .019.019l.002.002.024.03 3.195 4.246v-4.075a.31.31 0 0 1 .312-.307h1.122c.172 0 .311.138.311.307v6.859zm-7.724 0c0 .169-.14.306-.312.306h-1.122a.309.309 0 0 1-.312-.306v-6.86a.31.31 0 0 1 .312-.306h1.122a.31.31 0 0 1 .312.307v6.859zm-2.706 0c0 .169-.14.306-.311.306H13.56a.312.312 0 0 1-.215-.085l-.005-.005a.302.302 0 0 1-.091-.217v-6.858c0-.17.14-.307.311-.307h1.123a.31.31 0 0 1 .311.307v5.448h3.05c.172 0 .311.137.311.306v1.104zM40 21.775C40 14.73 32.823 9 24 9 15.178 9 8 14.731 8 21.776 8 28.09 13.692 33.38 21.381 34.38c.521.11 1.23.338 1.41.776.16.398.105 1.022.052 1.424l-.229 1.347c-.07.398-.321 1.557 1.386.849 1.708-.708 9.214-5.339 12.571-9.14C38.888 27.134 40 24.595 40 21.776z",
    fill: "currentColor"
  }))), _symbol275 || (_symbol275 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-line-me-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "line-me-small"), /*#__PURE__*/React.createElement("path", {
    d: "M17.756 9.897a.169.169 0 0 1-.17.167h-1.668v.634h1.668c.094 0 .17.075.17.168v.604a.169.169 0 0 1-.17.168h-1.668v.634h1.668c.094 0 .17.075.17.167v.604a.169.169 0 0 1-.17.168h-2.452a.171.171 0 0 1-.118-.047l-.002-.002-.003-.003a.165.165 0 0 1-.047-.115V9.292c0-.045.018-.086.047-.116l.003-.003.002-.002a.171.171 0 0 1 .118-.047h2.452c.094 0 .17.075.17.168v.604zm-3.389 3.147a.169.169 0 0 1-.17.167h-.614a.17.17 0 0 1-.044-.006h-.002l-.012-.004-.005-.002-.008-.003a.064.064 0 0 1-.008-.004.084.084 0 0 1-.005-.003l-.01-.006-.003-.001a.166.166 0 0 1-.043-.042l-1.75-2.324v2.228a.169.169 0 0 1-.17.167h-.613a.169.169 0 0 1-.17-.167V9.292a.17.17 0 0 1 .17-.167h.629l.008.002a.103.103 0 0 1 .017.003l.006.001a.128.128 0 0 1 .01.004l.006.002a.106.106 0 0 1 .015.006l.009.005a.14.14 0 0 1 .014.009l.004.004a.12.12 0 0 1 .01.007l.003.003a.147.147 0 0 1 .01.01l.001.001a.16.16 0 0 1 .013.017l1.748 2.322V9.292c0-.092.076-.167.17-.167h.614c.094 0 .17.075.17.167v3.752zm-4.224 0a.169.169 0 0 1-.171.167h-.614a.169.169 0 0 1-.17-.167V9.292a.17.17 0 0 1 .17-.167h.614c.094 0 .17.075.17.167v3.752zm-1.48 0a.169.169 0 0 1-.17.167H6.04a.17.17 0 0 1-.118-.047l-.003-.002a.165.165 0 0 1-.05-.118V9.292a.17.17 0 0 1 .17-.168h.615c.094 0 .17.075.17.168v2.979h1.668c.094 0 .17.075.17.167v.604zM20.5 10.986C20.5 7.134 16.575 4 11.75 4 6.926 4 3 7.134 3 10.987c0 3.453 3.113 6.346 7.318 6.892.285.061.673.185.77.425.089.218.058.559.029.779l-.125.736c-.038.218-.176.852.758.465.934-.388 5.04-2.92 6.875-4.999 1.268-1.368 1.875-2.757 1.875-4.298z",
    fill: "currentColor"
  }))), _symbol276 || (_symbol276 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-line-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "line-small"), /*#__PURE__*/React.createElement("path", {
    d: "M7 11.5h11",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol277 || (_symbol277 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-linkedin-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "linkedin-large"), /*#__PURE__*/React.createElement("path", {
    d: "M34.2 12H13.8c-1 0-1.8.8-1.8 1.7v20.5c0 1 .8 1.7 1.8 1.7h20.5c1 0 1.8-.8 1.8-1.7V13.7c-.1-.9-.9-1.7-1.9-1.7zM19.1 32.5h-3.6V21h3.6v11.5zm-1.8-13.1c-1.1 0-2.1-.9-2.1-2.1 0-1.1.9-2.1 2.1-2.1 1.2 0 2.1.9 2.1 2.1 0 1.2-.9 2.1-2.1 2.1zm15.2 13.1h-3.6v-5.6c0-1.3 0-3-1.9-3s-2.1 1.4-2.1 2.9v5.7h-3.6V21h3.4v1.6c.5-.9 1.6-1.9 3.4-1.9 3.6 0 4.3 2.4 4.3 5.5l.1 6.3z",
    fill: "currentColor"
  }))), _symbol278 || (_symbol278 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-linkedin-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "linkedin-small"), /*#__PURE__*/React.createElement("path", {
    d: "M17.1 6H6.9c-.5 0-.9.4-.9.9v10.3c0 .4.4.8.9.8h10.2c.5 0 .9-.4.9-.9V6.9c0-.5-.4-.9-.9-.9zM9.6 16.2H7.8v-5.7h1.8v5.7zm-.9-6.5c-.6 0-1-.5-1-1 0-.6.5-1 1-1s1 .5 1 1c0 .6-.5 1-1 1zm7.5 6.5h-1.8v-2.8c0-.7 0-1.5-.9-1.5s-1.1.7-1.1 1.5v2.8h-1.8v-5.7h1.7v.8c.2-.4.8-.9 1.7-.9 1.8 0 2.1 1.2 2.1 2.7v3.1h.1z",
    fill: "currentColor"
  }))), _symbol279 || (_symbol279 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-list-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "list-large"), /*#__PURE__*/React.createElement("path", {
    d: "M16 30.5h5m-9 0h2m2-6h12m-16 0h2m2-6h18m-22 0h2",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol280 || (_symbol280 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-list-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "list-small"), /*#__PURE__*/React.createElement("path", {
    d: "M7 15.5h5m-9 0h2m2-4h9m-13 0h2m2-4h14m-18 0h2",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol281 || (_symbol281 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-lock-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "lock-large"), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 37.5v-5.3c-1.4-.7-2.3-2.3-1.9-4 .3-1.3 1.3-2.3 2.6-2.6 2.3-.5 4.3 1.2 4.3 3.4 0 1.4-1 2.6-2 3.2v5.3h-3zm-13-17v-4c0-7.18 5.445-13 12.161-13h4.678c6.716 0 12.161 5.82 12.161 13v4m-32 0h35v23h-35v-23z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol282 || (_symbol282 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-lock-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "lock-small"), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 14v4-4zm8 7.5v-10h-16v10h16zm-14-10v-3c0-2.761 1.919-5 4.286-5h3.428c2.367 0 4.286 2.239 4.286 5v3",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol283 || (_symbol283 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-lock-unlock-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "lock-unlock-large"), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 37.5v-5.3c-1.4-.7-2.3-2.3-1.9-4 .3-1.3 1.3-2.3 2.6-2.6 2.3-.5 4.3 1.2 4.3 3.4 0 1.4-1 2.6-2 3.2v5.3h-3zM10.038 11.663C11.57 6.356 16.194 2.5 21.661 2.5h4.678c6.716 0 12.161 5.82 12.161 13v5m-32 0h35v23h-35v-23z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol284 || (_symbol284 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-lock-unlock-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "lock-unlock-small"), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 14v4-4zm8 7.5v-10h-16v10h16zm-14-14c0-2.761 1.919-5 4.286-5h3.428c2.367 0 4.286 2.239 4.286 5v4",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol285 || (_symbol285 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-logbook-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "logbook-large"), /*#__PURE__*/React.createElement("path", {
    d: "M5 39.5h4.9H5zm0-31h4.9H5zm2.5 37v-43h30a3 3 0 0 1 3 3v37a3 3 0 0 1-3 3h-30zm16.5-12c5.799 0 10.5-4.701 10.5-10.5S29.799 12.5 24 12.5 13.5 17.201 13.5 23 18.201 33.5 24 33.5zm-6.927-2.573l4.15-4.15m9.71 4.156l-4.16-4.16 4.16 4.16zm3.491-9.433h-7.33m-6.194 0h-7.312M24 28c2.21 0 3.5-1.5 3.5-3.75 0-1.25 0-2.75-1-3.4-.801-.52-4.2-.52-5 0-1 .65-1 2.15-1 3.4C20.5 26.5 21.79 28 24 28z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol286 || (_symbol286 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-logbook-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "logbook-small"), /*#__PURE__*/React.createElement("path", {
    d: "M1 18.5h5-5zm0-13h5-5zm19.5 17h-17v-21h17a2 2 0 0 1 2 2v17a2 2 0 0 1-2 2zm-3.04-6.486l-2.357-2.36 2.358 2.36zm-7.924-.002l2.38-2.377M13.5 17.5a6 6 0 1 0 0-12 6 6 0 0 0 0 12zm0-3.191c1.262 0 2-.857 2-2.143 0-.714 0-1.572-.571-1.943-.458-.298-2.4-.297-2.858 0-.571.371-.571 1.229-.571 1.943 0 1.286.738 2.143 2 2.143zm-1.804-3.636H7.519m11.938 0h-4.145",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol287 || (_symbol287 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-login-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "login-large"), /*#__PURE__*/React.createElement("path", {
    d: "M27.1 26.5c1.7 5.3 7.3 8.2 12.5 6.5 5.3-1.7 8.2-7.3 6.5-12.5-1.7-5.3-7.3-8.2-12.5-6.5-3.1 1-5.5 3.4-6.5 6.5H4.6l-4 4 3.7 4h2.1l3.1-2 4.1 2 4-2 4.5 2 3.6-2h1.4zm13.4-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol288 || (_symbol288 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-login-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "login-small"), /*#__PURE__*/React.createElement("path", {
    d: "M14.8 10.5c.8-2.3 3.4-3.6 5.7-2.7 1.8.6 3 2.3 3 4.2 0 2.5-2 4.5-4.5 4.5-1.9 0-3.6-1.2-4.2-3h-1.3l-1.9 1.1-1.9-1.3-2 1.3-2.1-1.3-1.9 1.3h-.9l-2-2.1 2.1-1.9h11.9v-.1z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol289 || (_symbol289 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-logout-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "logout-large"), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 23.58h23M24.5 14V6.5h-16a4 4 0 0 0-4 4v26a4 4 0 0 0 4 4h16V33m6.92-20.5L42.5 23.58 31.42 34.66",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol290 || (_symbol290 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-logout-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "logout-small"), /*#__PURE__*/React.createElement("path", {
    d: "M10 12.54h11.5M12.5 6V3.5h-8a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h8V18m3.46-11l5.54 5.54-5.54 5.54",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol291 || (_symbol291 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-loose-wheel-indicator-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "loose-wheel-indicator-large"), /*#__PURE__*/React.createElement("path", {
    d: "M22.41 13.5c5.02 0 9.09 6.94 9.09 15.5 0 8.56-4.07 15.5-9.09 15.5h-6.82c-5.02 0-9.09-6.94-9.09-15.5 0-8.56 4.07-15.5 9.09-15.5h6.82zm.59 28c3.59 0 6.5-5.596 6.5-12.5S26.59 16.5 23 16.5s-6.5 5.596-6.5 12.5 2.91 12.5 6.5 12.5zM20.1 21l.8 2.25m4-2.25l-.8 2.25m-1.2 13.5L22.866 39m1.634-5.85l1.6 1.35m-5.2-1.35l-1.6 1.35m1.2-6.525l-2-.45m6.4.675l1.6-.9m10-7.8V23l2.5 2.5h3l.5-.5-1.5-1.5-.5-1 2-2 1 .5 1.5 1.5.5-.5v-3L43 16.5h-3.5l-8-8V5L29 2.5h-3l-.5.5 1.8 1.7.2.8-2 2-.8-.2L23 5.5l-.5.5v3l2.5 2.5h3.5l8 8z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol292 || (_symbol292 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-loose-wheel-indicator-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "loose-wheel-indicator-small"), /*#__PURE__*/React.createElement("path", {
    d: "M12.136 6.5c2.41 0 4.364 3.358 4.364 7.5 0 4.142-1.954 7.5-4.364 7.5H8.864C6.454 21.5 4.5 18.142 4.5 14c0-4.142 1.954-7.5 4.364-7.5h3.272zm.364 15c2.21 0 4-3.358 4-7.5 0-4.142-1.79-7.5-4-7.5s-4 3.358-4 7.5c0 4.142 1.79 7.5 4 7.5zm0-12.5v1.5m0 7V19m1.398-3.5L15 16m-1.102-3.5L15 12m-3.5 3.5L10 16m1.464-3.5L10 12m5-9l5 5m1 2.5l-1.5-1L20 8l1.5-.5 1 1.5m-10-7l1 1.5L15 3l.5-1.5-1.5-1",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol293 || (_symbol293 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-main-user-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "main-user-large"), /*#__PURE__*/React.createElement("path", {
    d: "M38.5 20s-3 3.8-7 3.8c0 13.2 7 17.2 7 17.2s7-4.7 7-17.2c-3.9 0-7-3.8-7-3.8zm-11 .5h-7c-1.6 0-3-1.4-3-3v-7c0-1.6 1.4-3 3-3h7c1.6 0 3 1.4 3 3v7c0 1.6-1.4 3-3 3zm5.5 20H11.5V27.2s.2-2.8 3.5-2.8h12",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol294 || (_symbol294 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-main-user-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "main-user-small"), /*#__PURE__*/React.createElement("path", {
    d: "M19.1 11s-1.8 2.1-4.1 2.1c0 7.5 4 9.8 4 9.8s3.9-2.7 3.9-9.8c-2.1 0-3.8-2.1-3.8-2.1zm-5.6-.5h-3c-1.1 0-2-.9-2-2v-3c0-1.1.9-2 2-2h3c1.1 0 2 .9 2 2v3c0 1.1-.9 2-2 2zm1.5 11H5.5V15s-.1-1.5 1.2-1.5H12",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol295 || (_symbol295 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-maintenance-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "maintenance-large"), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 26v-8.5l5-5v-6l-4-4-1 1v4l-1 1h-5l-1-1v-4l-1-1-4 4v6l5 5v25c0 1.7 1.3 3 3 3h1c1.347 0 2.442-.816 2.84-2M34.5 40v-7m0-2v-2m0 16.5c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.925-11 11 4.925 11 11 11z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol296 || (_symbol296 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-maintenance-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "maintenance-small"), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 9.5l3-3v-4l-2-2h-1v3l-1 1h-3l-1-1v-3h-1l-2 2v4l3 3V21c0 1.2 1 2.5 2.2 2.5h.6c.574 0 1.102-.32 1.497-.775M15.5 21v-5.5m0-1.5v-2m0 11.5a7 7 0 1 0 0-14 7 7 0 0 0 0 14z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol297 || (_symbol297 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-maneuvering-assist-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "maneuvering-assist-large"), /*#__PURE__*/React.createElement("path", {
    d: "M27.366 23a1 1 0 0 1-.866.5h-2a1 1 0 0 1-1-1v-1l-15-.045V22.5a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-8l2-2c.66-1.212 1.19-2.136 1.59-2.773.4-.636.87-1.363 1.41-2.182a79.296 79.296 0 0 1 6.512-.272c2.134 0 4.297.09 6.488.272.54.819 1.01 1.546 1.41 2.182.4.637.93 1.56 1.59 2.773l2 2V16m-17 .5l1-1h9l1 1c-.636 2-1.136 3-1.5 3h-8c-.364 0-.864-1-1.5-3zm-4-4h19m-21 3H9m14 0h4.5m4.5 24h10.981m-9.481-2h8l-4-14.5-4 14.5zm-.493-13.636l-2.83 3.636v-5.09l-5.713-3.637 6.578-.728 1.965-6.545 2.124 5.09 6.369-.726-2.83 3.636",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol298 || (_symbol298 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-maneuvering-assist-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "maneuvering-assist-small"), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 13.5H12a.75.75 0 0 1-.75-.75v-.25h-6.5v.25a.75.75 0 0 1-.75.75H2.25a.75.75 0 0 1-.75-.75V8.358l3-3.858h7l1.245 1.6M1.5 9.5h3m15 1.5l2 7.5h-4l2-7.5zm-3 1l-2 2.5V11l-4.036-2.5 4.647-.5L16.5 3.5 18 7l4.5-.5-2 2.5",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol299 || (_symbol299 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-map-layer-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "map-layer-large"), /*#__PURE__*/React.createElement("path", {
    d: "M5 24.146l18.451 11.36a2.001 2.001 0 0 0 2.098 0L44 24.146m-39 4l18.451 11.36a2.001 2.001 0 0 0 2.098 0L44 28.146m0-8l-18.451 11.36a2.001 2.001 0 0 1-2.098 0L5 20.146l18.452-11.35a2.002 2.002 0 0 1 2.096 0L44 20.146z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol300 || (_symbol300 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-map-layer-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "map-layer-small"), /*#__PURE__*/React.createElement("path", {
    d: "M3 13.314l8.966 5.665a1 1 0 0 0 1.068 0L22 13.314m0-3l-8.966 5.665a1 1 0 0 1-1.068 0L3 10.314l8.966-5.66a1 1 0 0 1 1.068 0L22 10.314z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol301 || (_symbol301 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-merchandise-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "merchandise-large"), /*#__PURE__*/React.createElement("path", {
    d: "M11.91 8.41c2.833-.606 5.363-.91 7.59-.91h9c2.247 0 4.804.31 7.67.928a6 6 0 0 1 .632.173l8.694 2.899-1.994 10-6.002-2v23h-27v-23l-5.996 2L2.5 11.75l8.628-3.116a6 6 0 0 1 .781-.223zm18.565-.836a6.5 6.5 0 0 1-12.95 0M17.565 24c1.692 0 3.064-1.343 3.064-3s-1.372-3-3.064-3c-1.693 0-3.065 1.343-3.065 3s1.372 3 3.065 3zm12.87 0c1.693 0 3.065-1.343 3.065-3s-1.372-3-3.065-3c-1.692 0-3.064 1.343-3.064 3s1.372 3 3.064 3zm-4.29 0c1.693 0 3.065-1.343 3.065-3s-1.372-3-3.065-3c-1.692 0-3.064 1.343-3.064 3s1.372 3 3.064 3zm-4.29 0c1.692 0 3.064-1.343 3.064-3s-1.372-3-3.064-3c-1.693 0-3.065 1.343-3.065 3s1.372 3 3.065 3z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol302 || (_symbol302 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-merchandise-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "merchandise-small"), /*#__PURE__*/React.createElement("path", {
    d: "M6.894 2.689A18.165 18.165 0 0 1 9.5 2.5h5c.868 0 1.737.063 2.605.189a3 3 0 0 1 .732.203l5.16 2.166L22 10l-3.502-1.329V20.5H5.502V8.671L2 10 1 5.058l5.163-2.167a3 3 0 0 1 .731-.202zm8.606-.161a3.5 3.5 0 0 1-7 0",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol303 || (_symbol303 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-microphone-off-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "microphone-off-large"), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 47.5v-9m0 9h-8m8 0h8m-8-9c6.627 0 12-5.373 12-12V22m-12 16.5c-3.321 0-6.327-1.35-8.5-3.53M12.5 22v4.5c0 1.784.39 3.478 1.088 5M32.5 18v8.5A8 8 0 0 1 18.69 32M32.5 13V8.5a8 8 0 1 0-16 0v18c0 .637.074 1.256.215 1.85M3.499 44.499l42-42",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol304 || (_symbol304 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-microphone-off-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "microphone-off-small"), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 11v1.857A6.5 6.5 0 0 1 8.024 18M5.5 11v1.857c0 .941.2 1.836.56 2.643M12 23v-3.5m-4 4h8M8.5 13V4a3.5 3.5 0 1 1 7 0v2m-5.304 10a3.5 3.5 0 0 0 5.304-3v-2M1.375 22.625L22.875 1",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol305 || (_symbol305 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-microphone-on-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "microphone-on-large"), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 38.5v9m0-9c-6.627 0-12-5.373-12-12V22m12 16.5c6.627 0 12-5.373 12-12V22m-12 25.5h-8m8 0h8m-8-13a8 8 0 0 1-8-8v-18a8 8 0 1 1 16 0v18a8 8 0 0 1-8 8z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol306 || (_symbol306 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-microphone-on-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "microphone-on-small"), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 11v1.857a6.5 6.5 0 1 1-13 0V11M12 23v-3.5m-4 4h8m-4-7A3.5 3.5 0 0 1 8.5 13V4a3.5 3.5 0 1 1 7 0v9a3.5 3.5 0 0 1-3.5 3.5z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol307 || (_symbol307 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-mileage-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "mileage-large"), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 11.5h12v25h-12v-25zm16 0h12v25h-12v-25zm16 0h12v25h-12v-25zm12.5-4H1h45zm-45 33h45H1zm3-21h6.5l-5 9.5M27 19.5h-5.5v4s5-.1 5 3-6 2-6 2m21 7.5v-9.5l-5 7H43m-6.5-15c.8.7 1.9 1.1 3 1 2 0 2-2.5 2-2.5s0-2.5-3-2.5c1.6.1 2.9-1.1 3-2.7v-.3",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol308 || (_symbol308 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-mileage-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "mileage-small"), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 19.5h-7v-15h7v15zm0-15h7v15h-7v-15zm7 0h7v15h-7v-15zm7.5-3H1h22zm-22 21h22H1zm2-13h3.2l-2.6 5.2M14 9.5h-3.5v2.6s2.9 0 2.9 1.7-3.2.9-3.2.9m7.3 1.3c.5-.4 1.1-.6 1.7-.6 1.1.1 1.3 1.2 1.1 1.8-.4 1-1.1 2.3-2.8 2.3m2-15V9",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol309 || (_symbol309 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-mmi-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "mmi-large"), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 30.5v-16a2 2 0 0 1 2-2h26.973a2 2 0 0 1 2 2v16M8.5 15.5h30.973M22 26.5h4M2.926 31A139.58 139.58 0 0 1 23.5 29.495c6.972 0 14.163.501 21.574 1.505M2.926 28c2.484-.343 4.35-.582 5.6-.715m30.967.05c1.23.126 3.091.348 5.58.665",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol310 || (_symbol310 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-mmi-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "mmi-small"), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 16.5V9A1.5 1.5 0 0 1 6 7.5h12A1.5 1.5 0 0 1 19.5 9v7.5m-15-7h15M1.423 17c3.52-1 7.046-1.5 10.577-1.5 3.532 0 7.057.5 10.577 1.5M1.423 15c1.375-.362 2.407-.612 3.095-.75m15.006.008c.678.137 1.696.384 3.053.742",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol311 || (_symbol311 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-mobile-phone-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "mobile-phone-large"), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 3.5h19c1.1 0 2 .9 2 2v37c0 1.1-.9 2-2 2h-19c-1.1 0-2-.9-2-2v-37c0-1.1.9-2 2-2zm-2 35h23M24 42.4a.9.9 0 1 0 0-1.8.9.9 0 0 0 0 1.8zM21 7.5h6",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol312 || (_symbol312 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-mobile-phone-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "mobile-phone-small"), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 18.5h13m-7.5 2h2m-6.5-19h11c.6 0 1 .4 1 1v19c0 .6-.4 1-1 1h-11c-.6 0-1-.4-1-1v-19c0-.6.4-1 1-1zm7.5 2h-4",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol313 || (_symbol313 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-more-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "more-large"), /*#__PURE__*/React.createElement("path", {
    d: "M38.5 27a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zm-15 0a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zm-15 0a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol314 || (_symbol314 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-more-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "more-small"), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 12.6a1.1 1.1 0 1 0 0-2.2 1.1 1.1 0 0 0 0 2.2zm-7 0a1.1 1.1 0 1 0 0-2.2 1.1 1.1 0 0 0 0 2.2zm-7 0a1.1 1.1 0 1 0 0-2.2 1.1 1.1 0 0 0 0 2.2z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol315 || (_symbol315 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-motorway-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "motorway-large"), /*#__PURE__*/React.createElement("path", {
    d: "M45.5 45.5v.5h.75l-.288-.692-.462.192zm-42 0l-.462-.192L2.75 46h.75v-.5zm18-42V3h-.323l-.133.295.456.205zm6 0l.456-.205L27.823 3H27.5v.5zm-24 10V13H3v.5h.5zm42 0h.5V13h-.5v.5zm0 8v.5h.5v-.5h-.5zm-42 0H3v.5h.5v-.5zm3 0H7V21h-.5v.5zm36 0V21H42v.5h.5zm-34 0V21H8v.5h.5zm32 0h.5V21h-.5v.5zm5 23.5h-42v1h42v-1zm-24-41h6V3h-6v1zm-.456-.705l-4.5 10 .912.41 4.5-10-.912-.41zm6 .41l4.5 10 .912-.41-4.5-10-.912.41zm7.994 17.987l10 24 .924-.384-10-24-.924.384zm-31.076 24l10-24-.923-.384-10 24 .923.384zM24 34v11.5h1V34h-1zm0-10v6h1v-6h-1zm0-16v4h1V8h-1zm0-4.5V6h1V3.5h-1zM3.5 14h42v-1h-42v1zm41.5-.5v8h1v-8h-1zm-41 8v-8H3v8h1zm-.5.5h3v-1h-3v1zm42-1h-3v1h3v-1zm-10 0h-22v1h22v-1zM6 21.5V27h1v-5.5H6zm36 0V27h1v-5.5h-1zm-34 0V27h1v-5.5H8zm.5.5h5v-1h-5v1zM41 27v-5.5h-1V27h1zm-.5-6h-5v1h5v-1z",
    fill: "currentColor"
  }))), _symbol316 || (_symbol316 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-motorway-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "motorway-small"), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 22.5v.5h.75l-.288-.692-.462.192zm-21 0l-.462-.192L.75 23h.75v-.5zm9-21V1h-.338l-.126.314.464.186zm3 0l.464-.186L13.838 1H13.5v.5zm4 9l.462-.192-.129-.308H17.5v.5zm-11 0V10h-.333l-.129.308.462.192zm-5-4V6H1v.5h.5zm21 0h.5V6h-.5v.5zm0 4v.5h.5v-.5h-.5zm-21 0H1v.5h.5v-.5zm2 0H4V10h-.5v.5zm17 0V10H20v.5h.5zm2 11.5h-21v1h21v-1zm-12-20h3V1h-3v1zm-.464-.686l-2 5 .928.372 2-5-.928-.372zm3 .372l2 5 .928-.372-2-5-.928.372zm4.002 9.006l5 12 .924-.384-5-12-.924.384zm-15.076 12l5-12-.924-.384-5 12 .924.384zM11.5 17v5h1v-5h-1zm0-5v3h1v-3h-1zm0-8v2h1V4h-1zm0-2v1h1V2h-1zm-10 5h21V6h-21v1zM22 6.5v4h1v-4h-1zm-20 4v-4H1v4h1zm-.5.5h2v-1h-2v1zm21-1h-2v1h2v-1zm-5 0h-11v1h11v-1zM3 10.5V13h1v-2.5H3zm17 0V13h1v-2.5h-1z",
    fill: "currentColor"
  }))), _symbol317 || (_symbol317 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-my-dealer-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "my-dealer-large"), /*#__PURE__*/React.createElement("path", {
    d: "M19 27.5H7.5m5.4 12H9.5c-1.1 0-2-.9-2-2v-35h16v10.4m-8 32.6v-12c0-1.7 1.3-3 3-3h18c1.7 0 3 1.3 3 3v12h-24zm9-30h6c1.7 0 3 1.3 3 3v6c0 1.7-1.3 3-3 3h-6c-1.7 0-3-1.3-3-3v-6c0-1.7 1.3-3 3-3z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol318 || (_symbol318 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-my-dealer-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "my-dealer-small"), /*#__PURE__*/React.createElement("path", {
    d: "M9 15.5H3.5m2.5 6H4.5c-.5 0-1-.4-1-1V.5h9v6.4m-5 16.6v-4.9c0-.6.4-1 1-1.1h11.1c.6 0 1 .5 1 1.1v4.9H7.5zm5-15h3c1.1 0 2 .9 2 2v3c0 1.1-.9 2-2 2h-3c-1.1 0-2-.9-2-2v-3c0-1.1.9-2 2-2z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol319 || (_symbol319 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-myaudi-destinations-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "myaudi-destinations-large"), /*#__PURE__*/React.createElement("path", {
    d: "M38.5 19.6c-3.9 0-7 3-7 6.9 0 3.9 7 14 7 14s7-10.1 7-14c0-3.9-3.1-6.9-7-6.9zm0 3.9c1.7 0 3 1.3 3.1 2.9 0 1.7-1.3 3-2.9 3.1h-.1c-1.7 0-3-1.4-2.9-3.1-.1-1.6 1.2-2.9 2.8-2.9zm-11-3h-7c-1.6 0-3-1.4-3-3v-7c0-1.6 1.4-3 3-3h7c1.6 0 3 1.4 3 3v7c0 1.6-1.4 3-3 3zm5.5 20H11.5V27.2s.2-2.8 3.5-2.8h12",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol320 || (_symbol320 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-myaudi-destinations-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "myaudi-destinations-small"), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 10.5h-3c-1.1 0-2-.9-2-2v-3c0-1.1.9-2 2-2h3c1.1 0 2 .9 2 2v3c0 1.1-.9 2-2 2zm1.5 11H5.5V15s-.1-1.5 1.2-1.5H12m7 9.5s-4-5.8-4-8 1.8-4 4-4 4 1.8 4 4-4 8-4 8z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol321 || (_symbol321 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-napster-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "napster-large"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 17c-2.1-1.9-5-2-5-2v12s2 9 10.5 9S35 27 35 27V15s-3 0-5 2c0 0-2-2-5.5-2S19 17 19 17zm3 15.5h5-5zm1-2h3-3zm-6.5-15s2.7-4.5 8-4.5 8 4.5 8 4.5",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 25h3s3 0 3 3h-3s-3 0-3-3zm13 0h-3s-3 0-3 3h3s3 0 3-3zm-18-7s-3 1.4-3 4 3 3.9 3 3.9V18zm23 0s3 1.4 3 4-3 3.9-3 3.9V18z",
    fill: "currentColor",
    fillRule: "nonzero"
  })))), _symbol322 || (_symbol322 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-napster-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "napster-small"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.5C6 6 4.5 6 4.5 6v8s1.3 5.5 7 5.5 7-5.5 7-5.5V6s-1.5 0-3 1.5c0 0-1.7-1.5-4-1.5s-4 1.5-4 1.5zm3.5 8h1-1zm-1 2h3-3zM6.3 6.6l.2-.3s1.6-2.8 5-2.8 5.4 2.8 5.4 2.8l.1.1",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 7.9s-1.9.9-1.9 2.6c0 1.7 1.9 2.6 1.9 2.6V7.9zm15 0s1.9.9 1.9 2.6c0 1.7-1.9 2.6-1.9 2.6V7.9zM7 12h2s2 .1 2 2H9s-2-.1-2-2zm9 0h-2s-2 .1-2 2h2s2-.1 2-2z",
    fill: "currentColor",
    fillRule: "nonzero"
  })))), _symbol323 || (_symbol323 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-network-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "network-large"), /*#__PURE__*/React.createElement("path", {
    d: "M20.3 18.9a6.99 6.99 0 0 0-2.8 5.6c0 1.933.784 3.683 2.05 4.95m.75-10.55a6.969 6.969 0 0 1 4.2-1.4c2.126 0 4.031.948 5.315 2.444M20.3 18.9l-6-8m5.25 18.55a7.003 7.003 0 0 0 11.742-3.252M19.55 29.45l-8.929 8.929m20.672-12.18A7.015 7.015 0 0 0 31.5 24.5c0-1.74-.635-3.331-1.685-4.556m1.478 6.254l6.296 1.574m-7.774-7.828l6.407-5.492m0 0A3 3 0 1 0 35.5 12.5c0 .746.272 1.428.722 1.952zM14.3 10.9a3 3 0 1 0-1.8.6c.675 0 1.299-.223 1.8-.6zM10.621 38.38a3 3 0 1 0-4.243 4.243 3 3 0 0 0 4.243-4.243zM37.59 27.772A3.005 3.005 0 0 0 40.5 31.5a3 3 0 1 0-2.911-3.728z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol324 || (_symbol324 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-network-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "network-small"), /*#__PURE__*/React.createElement("path", {
    d: "M9.9 9.2A3.495 3.495 0 0 0 8.5 12a3.49 3.49 0 0 0 1.025 2.475M9.9 9.2c.585-.44 1.312-.7 2.1-.7 1.063 0 2.015.474 2.657 1.222M9.9 9.2l-3-4m2.625 9.275a3.501 3.501 0 0 0 5.871-1.626m-5.87 1.626L5.06 18.939m10.335-6.09a3.51 3.51 0 0 0-.739-3.127m.74 3.127l3.147.787m-3.887-3.914l3.204-2.746m0 0A1.5 1.5 0 1 0 17.5 6c0 .373.136.714.361.976zM6.901 5.2a1.5 1.5 0 1 0-.9.3c.337 0 .648-.112.9-.3zM5.06 18.94A1.5 1.5 0 1 0 2.94 21.06a1.5 1.5 0 0 0 2.12-2.122zm13.483-5.304a1.5 1.5 0 1 0 0 0z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol325 || (_symbol325 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-news-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "news-large"), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 17.5v20h32v-28h-24l-8 8zm36.7 1h5.9l-10.6 19m0-23h5.7l-5.7 23m-24-28v8h-8m4.5 13h23m-23-6h23",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol326 || (_symbol326 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-news-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "news-small"), /*#__PURE__*/React.createElement("path", {
    d: "M.5 9.5h5v-5M3 15.5h10m-10-3h10m6.7-3h3.4l-5.9 10m-.2-12h3.2l-3 12M.5 9.5v10h15v-15h-10l-5 5z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol327 || (_symbol327 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-nfc-inactive-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "nfc-inactive-large"), /*#__PURE__*/React.createElement("path", {
    d: "M32.185 12.247l.133.643-.026.022c-.341-2.367-1.086-4.41-2.372-6.522m.15 18.47a17.892 17.892 0 0 0 2.314-6.732l.031-.03-.218 1.175m5.858-12.754l.253.705-.017.018A28.293 28.293 0 0 0 35.88 1.72m.21 27.7a28.331 28.331 0 0 0 3.134-18.17l.037-.037.143 1.315M22.355 8.715a18.003 18.003 0 0 1 .05 13.76l-12.75-10.44a20.725 20.725 0 0 0 1 10.5m1.062 15.784L18.5 45v-9m-8 10v-5.922l.035-.033-.035.817M22.5 46v-9.5H29m-1 5h-5m15.45 2.86a4.16 4.16 0 0 1-2.72 1 4.3 4.3 0 0 1 0-8.6 4.133 4.133 0 0 1 2 .5M3.499 44.499l42-42",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol328 || (_symbol328 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-nfc-inactive-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "nfc-inactive-small"), /*#__PURE__*/React.createElement("path", {
    d: "M3.527 23.277l-.027.025.02.648.007-.673zm17.123-.427c-.455.394-1.038.651-1.64.65-1.428-.089-2.513-1.148-2.424-2.576A2.59 2.59 0 0 1 19.01 18.5c.415-.001.825.102 1.19.3M10.5 24v-5.5H14m0 3h-3.467M7.5 18.796v4.054L5.51 21m8.73-17.93c.619 1.097.695 1.21 1 2.371l.039-.033-.256-.735m-.431 8.647c.49-.545.776-1.208.92-1.82l-.02.018-.112.438M18.21 1.9l.269.655-.022.02c-.29-.883-.505-1.242-.957-2.075m0 15c1.342-2.473 1.998-4.885 1.921-7.613l-.021.028-.013 1.49M8.9 4.3c1 2.3 1 4.9 0 7.3L2.6 6c-.4 1.8-.2 3.7.4 5.5M1.375 22.625L22.875 1",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol329 || (_symbol329 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-nfc-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "nfc-large"), /*#__PURE__*/React.createElement("path", {
    d: "M30.1 24.9c3.4-5.7 3.3-12.8-.1-18.5m6.1 23c4.7-8.6 4.7-19.1-.2-27.7m-12.7 7c1.8 4.4 1.9 9.3 0 13.8L10.5 12c-.6 3.5-.2 7.1 1 10.5m11 23.5v-9.5H29m-1 5h-5M10.5 46v-9l8 8v-9m20 8.4c-.8.6-1.7 1-2.7 1-2.4 0-4.3-1.9-4.3-4.3s1.9-4.3 4.3-4.3c.7 0 1.4.2 2 .5",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol330 || (_symbol330 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-nfc-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "nfc-small"), /*#__PURE__*/React.createElement("path", {
    d: "M14.3 12.8c1.8-3 1.7-6.8-.1-9.8m3.3 12.5c2.5-4.7 2.5-10.3 0-15m-6.6 3.8c1 2.3 1 4.9 0 7.3L4.6 6c-.4 1.8-.2 3.7.4 5.5M10.5 24v-5.5H14m0 3h-3.5m-7 2.5v-5l4 3.8V18m13.1 4.9c-.5.4-1 .7-1.6.6-1.4-.1-2.5-1.1-2.4-2.6.1-1.3 1.1-2.3 2.4-2.4.4 0 .8.1 1.2.3",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol331 || (_symbol331 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-notepad-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "notepad-large"), /*#__PURE__*/React.createElement("path", {
    d: "M16 26.5h17-17zm8.5-8.5v17-17zm17-5v32.5h-34v-43H31L41.5 13zm-11-10.5v11h11",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol332 || (_symbol332 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-notepad-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "notepad-small"), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 7v15.5h-16v-20H15L19.5 7zm-5-4.5v5h5",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol333 || (_symbol333 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-off-canvas-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "off-canvas-large"), /*#__PURE__*/React.createElement("path", {
    d: "M13 30.5h22m-22-6h22m-22-6h22",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol334 || (_symbol334 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-off-canvas-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "off-canvas-small"), /*#__PURE__*/React.createElement("path", {
    d: "M3 15.5h18m-18-4h18m-18-4h18",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol335 || (_symbol335 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-offline-maps-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "offline-maps-large"), /*#__PURE__*/React.createElement("path", {
    d: "M30.5 29v11.5M36 35l-5.5 5.5L25 35m-6.5-23l12-5.5 12 5.5v28m-36-6V6.5l12 5.5v28.6L6.5 34zM24 43.5h13M30.5 21V6.5",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol336 || (_symbol336 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-offline-maps-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "offline-maps-small"), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 13v7.4M20 17l-3.5 3.4L13 17m-3.5 4.8l-8-4.3v-16l8 3.8v16.5zm0 0V5.2l7-3.8 7 4.2V22m-7-13V1.5m-3.5 21h7",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol337 || (_symbol337 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-oil-change-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "oil-change-large"), /*#__PURE__*/React.createElement("path", {
    d: "M27.5 24.5L44 19l3 1.5-1.5 2-2-1-10 4-6 9h-18v-10l-3.5-3H1.5V19H7l3.5 2.5h13l4 3zm18 5c.828 0 1.5-.796 1.5-1.778 0-.981-1.5-3.222-1.5-3.222S44 26.74 44 27.722c0 .982.672 1.778 1.5 1.778zM14 16.5c0-.552.438-1 1.003-1h4.994a.999.999 0 0 1 1.003 1c0 .552-.438 1-1.003 1h-4.994a.999.999 0 0 1-1.003-1zm3.5 1v4",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol338 || (_symbol338 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-oil-change-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "oil-change-small"), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 11.5l-2-2-8 2.5-1-1.5h-8v6H15l5-6.5m-10.5.5v-3m-2 0h4M0 8.5h3l2 2",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol339 || (_symbol339 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-options-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "options-large"), /*#__PURE__*/React.createElement("path", {
    d: "M3 11.5h4.5m0 0a4 4 0 1 0 8 0 4 4 0 0 0-8 0zm10.5 0h27m-42 12h31m-31 12h16.5m0 0a4 4 0 1 0 8 0 4 4 0 0 0-8 0zm10.5 0h15m-.5-12a4 4 0 1 1-8 0 4 4 0 0 1 8 0z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol340 || (_symbol340 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-options-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "options-small"), /*#__PURE__*/React.createElement("path", {
    d: "M1 8.5h2.5m0 0a2 2 0 1 0 4 0 2 2 0 0 0-4 0zm6.5 0h13m0 7h-2.5m0 0a2 2 0 1 0-4 0 2 2 0 0 0 4 0zm-6.5 0H1",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol341 || (_symbol341 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-order-reverse-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "order-reverse-large"), /*#__PURE__*/React.createElement("path", {
    d: "M32.5 42V8m-8.78 8.22l8.78-8.78 8.78 8.78m-18 15.56l-8.78 8.78-8.78-8.78M14.5 6v34",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol342 || (_symbol342 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-order-reverse-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "order-reverse-small"), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 21V4m-4.39 4.11l4.39-4.39 4.39 4.39m-9 7.78L7.5 20.28l-4.39-4.39M7.5 3v17",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol343 || (_symbol343 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-over-the-air-car-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "over-the-air-car-large"), /*#__PURE__*/React.createElement("path", {
    d: "M45.5 24.5V18L41 13.5c-.933-1.833-1.767-3.333-2.5-4.5-.733-1.167-1.733-2.5-3-4-3.74-.333-7.565-.5-11.478-.5-3.913 0-7.754.167-11.522.5-1.267 1.5-2.267 2.833-3 4-.733 1.167-1.567 2.667-2.5 4.5L2.5 18v14A1.5 1.5 0 0 0 4 33.5h5a1.5 1.5 0 0 0 1.5-1.5v-1.5H24m9-8.5l-2-2.5H17L15 22c1.333 3.667 2.333 5.5 3 5.5h6m-17.25-14h34.5m3.605 23a9.44 9.44 0 0 1-.755 2.184c-1.5 3.1-4.6 5-8.1 5-4.3 0-7.4-3.5-8.3-7m4.849-.1h-4.904v5.992m0-8.892c.157-.74.407-1.473.755-2.184 1.5-3.1 4.6-5 8.1-5 4.3 0 7.4 3.5 8.3 7m-4.849.1H45.5v-5.992m-2-9.033c0 .97-.083 1.63-.25 1.978-.25.522-.75 1.022-1.25 1.022h-2c-.5 0-4.25-1-4.75-1.5a3.917 3.917 0 0 1-.75-1c1.768-.233 3.268-.4 4.5-.5 1.232-.1 2.732-.1 4.5 0zm-39 0c1.768-.1 3.268-.1 4.5 0 1.232.1 2.732.267 4.5.5a3.917 3.917 0 0 1-.75 1c-.5.5-4.25 1.5-4.75 1.5H6c-.5 0-1-.5-1.25-1.022-.167-.348-.25-1.007-.25-1.978z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol344 || (_symbol344 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-over-the-air-car-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "over-the-air-car-small"), /*#__PURE__*/React.createElement("path", {
    d: "M.5 10.5v-1l2-2m-2 3v7a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1H12m-11.5-6H5m18.5.5v-.5m0 0v-1l-2-2m2 3H19m2.5-3c-.66-1.212-1.19-2.136-1.59-2.773-.4-.636-.87-1.363-1.41-2.182a78.436 78.436 0 0 0-6.488-.272c-2.135 0-4.305.09-6.512.272-.54.819-1.01 1.546-1.41 2.182-.4.637-.93 1.56-1.59 2.773m19 0h-19m14.5 3H7.5l-1 1c.636 2 1.136 3 1.5 3h4m2.768 1.452c.06-.17.13-.337.21-.502.75-1.55 2.3-2.5 4.05-2.5 2.15 0 3.7 1.75 4.15 3.5m-3.15.05h3.5V13m-.267 6.048c-.06.169-.13.337-.211.502-.75 1.55-2.3 2.5-4.05 2.5-2.15 0-3.7-1.75-4.15-3.5M18 18.5h-3.5V22",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol345 || (_symbol345 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-over-the-air-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "over-the-air-large"), /*#__PURE__*/React.createElement("path", {
    d: "M24.996 36.5H8.5l-.225-.004a6 6 0 1 1 1.722-11.808 7.5 7.5 0 0 1 9.654-9.706A11.498 11.498 0 0 1 30 8.5c6.351 0 11.5 5.149 11.5 11.5m4.355 12.5a9.438 9.438 0 0 1-.755 2.184c-1.5 3.1-4.6 5-8.1 5-4.3 0-7.4-3.5-8.3-7m4.849-.1H28v5.992m.645-8.892c.157-.74.407-1.473.755-2.184 1.5-3.1 4.6-5 8.1-5 4.3 0 7.4 3.5 8.3 7m-4.849.1H46.5v-5.992",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol346 || (_symbol346 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-over-the-air-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "over-the-air-small"), /*#__PURE__*/React.createElement("path", {
    d: "M11.005 17.5H5.5l-.2-.005a4 4 0 0 1-.797-7.87L4.5 9.5a4 4 0 0 1 5.129-3.839A5.5 5.5 0 0 1 19.5 9m-5.733 4.952c.06-.17.13-.337.212-.502.75-1.55 2.3-2.5 4.05-2.5 2.15 0 3.7 1.75 4.15 3.5m-3.15.05h3.5V11m-.268 6.048c-.06.17-.13.337-.211.502-.75 1.55-2.3 2.5-4.05 2.5-2.15 0-3.7-1.75-4.15-3.5M17 16.5h-3.5V20",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol347 || (_symbol347 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-parking-in-left-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "parking-in-left-large"), /*#__PURE__*/React.createElement("path", {
    d: "M45 10.5h-8.5v31c0 2.2-1.8 4-4 4h-16c-2.2 0-4-1.8-4-4v-31H4m12.5-9s8 5.9 8 14v22M30 32l-5.5 5.5L19 32",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol348 || (_symbol348 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-parking-in-left-long-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "parking-in-left-long-large"), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 2v4.5H40c2.2 0 3.5 1.3 3.5 3.5v27c0 2.2-1.3 4.5-3.5 4.5H24.5V46m9-9.5v-9c0-5-4-9-9-9h-1c-5 0-9-4-9-9V2M39 31l-5.5 5.5L28 31",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol349 || (_symbol349 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-parking-in-left-long-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "parking-in-left-long-small"), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 0v2.5h8c1.1 0 2 .9 2 2v15c0 1.1-.9 2-2 2h-8V24m3-6.5v-5c0-2.8-2.2-5-5-5h-1c-2.8 0-5-2.2-5-5V0M18 14l-3.5 3.5L11 14",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol350 || (_symbol350 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-parking-in-left-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "parking-in-left-small"), /*#__PURE__*/React.createElement("path", {
    d: "M23 6.5h-4.5v14.9c0 1.2-1 2.1-2.2 2.1H6.7c-1.2 0-2.2-1-2.2-2.1V6.5H0M15 15l-3.5 3.5L8 15M7.2.9s4.3 3.1 4.3 7.5v10.1",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol351 || (_symbol351 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-parking-in-right-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "parking-in-right-large"), /*#__PURE__*/React.createElement("path", {
    d: "M45 10.5h-8.5v31c0 2.2-1.8 4-4 4h-16c-2.2 0-4-1.8-4-4v-31H4m20.5 27v-22c0-8.1 8-14 8-14M30 32l-5.5 5.5L19 32",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol352 || (_symbol352 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-parking-in-right-long-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "parking-in-right-long-large"), /*#__PURE__*/React.createElement("path", {
    d: "M27.5 46v-4.5h-15c-2.2 0-4-2.3-4-4.5V10c0-2.2 1.8-3.5 4-3.5h15V2m10 0v7.5c0 5-3.5 9-8.5 9h-1c-5 0-9.5 4-9.5 9v9M24 31l-5.5 5.5L13 31",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol353 || (_symbol353 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-parking-in-right-long-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "parking-in-right-long-small"), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 24v-2.5h-8c-1.1 0-2-.9-2-2v-15c0-1.1.9-2 2-2h8V0m8 0v2.5c0 2.8-2.2 5-5 5h-1c-2.8 0-5 2.2-5 5v5M13 14l-3.5 3.5L6 14",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol354 || (_symbol354 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-parking-in-right-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "parking-in-right-small"), /*#__PURE__*/React.createElement("path", {
    d: "M23 4.5h-4.5v16.9c0 1.2-1 2.1-2.2 2.1H6.7c-1.2 0-2.2-1-2.2-2.1V4.5H0M15 15l-3.5 3.5L8 15m3.5 3.5V8.4C11.5 4 15.8.9 15.8.9",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol355 || (_symbol355 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-parking-in-straight-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "parking-in-straight-large"), /*#__PURE__*/React.createElement("path", {
    d: "M45 10.5h-8.5v31c0 2.2-1.8 4-4 4h-16c-2.2 0-4-1.8-4-4v-31H4m20.5 27V2M30 32l-5.5 5.5L19 32",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol356 || (_symbol356 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-parking-in-straight-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "parking-in-straight-small"), /*#__PURE__*/React.createElement("path", {
    d: "M15 15l-3.5 3.5L8 15m3.5-15v18.5M23 4.5h-4.5v16.9c0 1.2-1 2.1-2.2 2.1H6.7c-1.2 0-2.2-1-2.2-2.1V4.5H0",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol357 || (_symbol357 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-parking-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "parking-large"), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 33V15.5H27c3 0 5.5.5 5.5 5.5S30 26.5 27 26.5h-9.5m28-24H6.41A3.91 3.91 0 0 0 2.5 6.41V45.5h39.09a3.91 3.91 0 0 0 3.91-3.91V2.5z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol358 || (_symbol358 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-parking-out-left-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "parking-out-left-large"), /*#__PURE__*/React.createElement("path", {
    d: "M45 10.5h-8.5v31c0 2.2-1.8 4-4 4h-16c-2.2 0-4-1.8-4-4v-31H4m12.5-9s8 5.9 8 14V37m-8-28V1.5H25",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol359 || (_symbol359 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-parking-out-left-long-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "parking-out-left-long-large"), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 2v4.5H40c2.2 0 3.5 1.3 3.5 3.5v27c0 2.2-1.3 4.5-3.5 4.5H24.5V46M9 7l5.5-5.5L20 7m13.5 29v-8.5c0-5-4-9-9-9h-1c-5 0-9-4-9-9v-8",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol360 || (_symbol360 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-parking-out-left-long-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "parking-out-left-long-small"), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 0v2.5h8c1.1 0 2 .9 2 2v15c0 1.1-.9 2-2 2h-8V24m4-6v-3.5c0-2.8-2.2-5-5-5h-1c-2.8 0-5-2.2-5-5v-3M1 5l3.5-3.5L8 5",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol361 || (_symbol361 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-parking-out-left-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "parking-out-left-small"), /*#__PURE__*/React.createElement("path", {
    d: "M23 6.5h-4.5v14.9c0 1.2-1 2.1-2.2 2.1H6.7c-1.2 0-2.2-1-2.2-2.1V6.5H0M7.5 5V.5H12M7.5.5c1.2 1 4 3.5 4 6.9V17",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol362 || (_symbol362 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-parking-out-right-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "parking-out-right-large"), /*#__PURE__*/React.createElement("path", {
    d: "M45 10.5h-8.5v31c0 2.2-1.8 4-4 4h-16c-2.2 0-4-1.8-4-4v-31H4m21-9h7.5V9m-8 28V15.5c0-8.1 8-14 8-14",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol363 || (_symbol363 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-parking-out-right-long-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "parking-out-right-long-large"), /*#__PURE__*/React.createElement("path", {
    d: "M27.5 46v-4.5h-15c-2.2 0-4-2.3-4-4.5V10c0-2.2 1.8-3.5 4-3.5h15V2M32 7l5.5-5.5L43 7m-5.5-5.5v8c0 5-3.5 9-8.5 9h-1c-5 0-9.5 4-9.5 9V36",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol364 || (_symbol364 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-parking-out-right-long-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "parking-out-right-long-small"), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 24v-2.5h-8c-1.1 0-2-.9-2-2v-15c0-1.1.9-2 2-2h8V0m7 1.5v3c0 2.8-2.2 5-5 5h-1c-2.8 0-5 2.2-5 5V18M16 5l3.5-3.5L23 5",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol365 || (_symbol365 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-parking-out-right-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "parking-out-right-small"), /*#__PURE__*/React.createElement("path", {
    d: "M23 6.5h-4.5v14.9c0 1.2-1 2.1-2.2 2.1H6.7c-1.2 0-2.2-1-2.2-2.1V6.5H0M11.5 17V7.4c0-3.5 2.9-5.9 4-6.9M11 .5h4.5V5",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol366 || (_symbol366 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-parking-out-straight-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "parking-out-straight-large"), /*#__PURE__*/React.createElement("path", {
    d: "M45 10.5h-8.5v31c0 2.2-1.8 4-4 4h-16c-2.2 0-4-1.8-4-4v-31H4M19 7l5.5-5.5L30 7m-5.5 30V1.5",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol367 || (_symbol367 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-parking-out-straight-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "parking-out-straight-small"), /*#__PURE__*/React.createElement("path", {
    d: "M23 6.5h-4.5v14.9c0 1.2-1 2.1-2.2 2.1H6.7c-1.2 0-2.2-1-2.2-2.1V6.5H0M8 4L11.5.7 15 4M11.5.7V18",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol368 || (_symbol368 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-parking-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "parking-small"), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 17V6.5h5c1 0 3 0 3 3.5s-2 3.5-3 3.5h-5m15-13h-20a2 2 0 0 0-2 2v20h20a2 2 0 0 0 2-2V.5z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol369 || (_symbol369 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-pause-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "pause-large"), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 9v29m12-29v29",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol370 || (_symbol370 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-pause-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "pause-small"), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 3v17m8-17v17",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol371 || (_symbol371 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-photo-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "photo-large"), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 6.5h45v34h-45v-34zm0 34l18-18 9 9 9-9 9 9M11 20.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol372 || (_symbol372 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-photo-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "photo-small"), /*#__PURE__*/React.createElement("path", {
    d: "M.5 2.5h23v19H.5v-19zm0 19l9-9 4.9 4.9 5-4.9 4.1 3.9m-18-5.9a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol373 || (_symbol373 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-piloted-parking-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "piloted-parking-large"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 42.5c6.904 0 12.5-5.596 12.5-12.5S36.904 17.5 30 17.5 17.5 23.096 17.5 30 23.096 42.5 30 42.5zm-8.334-3.166l4.665-4.665m12.012 4.674l-4.662-4.662 4.662 4.662zm4.1-10.843H34.3m-8.6 0h-8.134M30 36.374c2.883 0 4.568-1.958 4.568-4.894 0-1.632 0-3.59-1.305-4.438-1.046-.68-5.483-.678-6.526 0-1.305.848-1.305 2.806-1.305 4.438 0 2.936 1.685 4.894 4.568 4.894z",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 23.094V5h7.148c5.573 0 7.572 2.324 7.572 5.623 0 3.299-2.124 5.723-7.697 5.723H8.574v6.748H6zm6.598-15.995H8.574v7.148h4.024c4.173 0 5.498-1.3 5.498-3.624S16.77 7.1 12.598 7.1z",
    fill: "currentColor",
    fillRule: "nonzero"
  })))), _symbol374 || (_symbol374 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-piloted-parking-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "piloted-parking-small"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.87 20.766l2.69-2.688m6.577 2.693l-2.701-2.7 2.7 2.7zM15.5 22.5a7 7 0 1 0 0-14 7 7 0 0 0 0 14zm0-3.614c1.578 0 2.5-1.072 2.5-2.679 0-.893 0-1.964-.714-2.428-.573-.372-3-.371-3.572 0C13 14.243 13 15.314 13 16.207c0 1.607.922 2.679 2.5 2.679zm-2.313-4.34H8.534m13.918 0H17.84",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 12.86V2h4.29c3.345 0 4.545 1.395 4.545 3.375S9.56 8.81 6.215 8.81h-2.67v4.05H2zm3.96-9.6H3.545v4.29H5.96c2.505 0 3.3-.78 3.3-2.175 0-1.395-.795-2.115-3.3-2.115z",
    fill: "currentColor",
    fillRule: "nonzero"
  })))), _symbol375 || (_symbol375 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-pinterest-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "pinterest-large"), /*#__PURE__*/React.createElement("path", {
    d: "M24.7 9c-8.2 0-12.3 5.9-12.3 10.8 0 3 1.1 5.6 3.5 6.6.4.2.7 0 .9-.4.1-.3.3-1.1.4-1.4.1-.4.1-.6-.2-1-.7-.8-1.1-1.9-1.1-3.4 0-4.4 3.3-8.3 8.5-8.3 4.6 0 7.2 2.8 7.2 6.6 0 5-2.2 9.2-5.5 9.2-1.8 0-3.2-1.5-2.7-3.3.5-2.2 1.5-4.5 1.5-6.1 0-1.4-.8-2.6-2.3-2.6-1.8 0-3.3 1.9-3.3 4.5 0 1.6.5 2.7.5 2.7l-2.2 9.4c-.7 2.8-.1 6.2-.1 6.5 0 .2.3.3.4.1.2-.2 2.4-2.9 3.1-5.6.2-.8 1.2-4.7 1.2-4.7.6 1.1 2.3 2.1 4.2 2.1 5.5 0 9.3-5.1 9.3-11.8-.1-5.1-4.4-9.9-11-9.9z",
    fill: "currentColor"
  }))), _symbol376 || (_symbol376 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-pinterest-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "pinterest-small"), /*#__PURE__*/React.createElement("path", {
    d: "M12.3 5c-3.8 0-5.7 2.7-5.7 5 0 1.4.5 2.6 1.6 3.1.2.1.3 0 .4-.2 0-.1.1-.5.2-.6.1-.2 0-.3-.1-.4-.3-.4-.5-.9-.5-1.6 0-2 1.5-3.9 4-3.9 2.2 0 3.3 1.3 3.3 3.1 0 2.3-1 4.3-2.6 4.3-.8 0-1.5-.7-1.3-1.6.2-1 .7-2.1.7-2.9 0-.7-.4-1.2-1.1-1.2-.9 0-1.6.9-1.6 2.1 0 .8.3 1.3.3 1.3l-1 4.4c-.3 1.3 0 2.9 0 3.1h.2c.1-.1 1.1-1.4 1.5-2.6.1-.4.6-2.2.6-2.2.3.5 1.1 1 2 1 2.6 0 4.3-2.4 4.3-5.5-.1-2.5-2.1-4.7-5.2-4.7z",
    fill: "currentColor"
  }))), _symbol377 || (_symbol377 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-plan-route-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "plan-route-large"), /*#__PURE__*/React.createElement("path", {
    d: "M38.5 14.5h-20a4 4 0 0 0-4 4V41m15-17.5l9-9-9-9",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol378 || (_symbol378 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-plan-route-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "plan-route-small"), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 7.5h-10a2 2 0 0 0-2 2V21M15 3l4.5 4.5L15 12",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol379 || (_symbol379 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-play-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "play-large"), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 9.3l20.9 14-20.9 14.4V9.3z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol380 || (_symbol380 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-play-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "play-small"), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 3.3l12 8.1-12 8.3z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol381 || (_symbol381 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-plug-ccs-dc-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "plug-ccs-dc-large"), /*#__PURE__*/React.createElement("path", {
    d: "M33.909 3.741c4.704 4.047 6.915 10.929 3.963 18.005a13.87 13.87 0 0 1-7.45 7.432c-11.06 4.587-21.65-3.419-21.65-13.896 0-4.617 2.058-8.753 5.3-11.541a.999.999 0 0 1 .656-.241h18.524a1 1 0 0 1 .657.241zM18.5 16a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0zm8 0a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0zm8 0a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0zm-14 21.5a4 4 0 1 1-8 0 4 4 0 0 1 8 0zm15 0a4 4 0 1 1-8 0 4 4 0 0 1 8 0zm1 7h-25a4 4 0 0 1-4-4v-6a4 4 0 0 1 4-4h25a4 4 0 0 1 4 4v6a4 4 0 0 1-4 4zm-6-21.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0zm-8 0a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0zm-1-13a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 21.5 10zm8 0a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 29.5 10z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol382 || (_symbol382 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-plug-ccs-dc-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "plug-ccs-dc-small"), /*#__PURE__*/React.createElement("path", {
    d: "M16.251 2.5c.245 0 .488.084.67.249a7.317 7.317 0 0 1 2.34 6.379c-.416 3.293-3.12 5.954-6.418 6.324A7.329 7.329 0 0 1 7.068 2.749.998.998 0 0 1 7.74 2.5h8.512zm1.249 19h-11a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2zm-8-3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-2-6.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm-6-3a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm4 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm4 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm-7-4v2m5-2v2m-4 5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol383 || (_symbol383 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-plug-ccs1-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "plug-ccs1-large"), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 37.51a4 4 0 1 1-8 0 4 4 0 0 1 8 0zm15 0a4 4 0 1 1-8 0 4 4 0 0 1 8 0zm1 7h-25a4 4 0 0 1-4-4v-6a4 4 0 0 1 4-4h25a4 4 0 0 1 4 4v6a4 4 0 0 1-4 4zm-15-20.49a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0zm-5-11a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0zm10 0a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0zm-11 7a1.5 1.5 0 1 1 3.001.001 1.5 1.5 0 0 1-3.001-.001zm14 0a1.5 1.5 0 1 1 3.001.001 1.5 1.5 0 0 1-3.001-.001zm8.01-3.01C37.51 9.549 31.46 3.5 24 3.5c-7.461 0-13.51 6.049-13.51 13.51 0 7.461 6.049 13.51 13.51 13.51 7.46 0 13.51-6.049 13.51-13.51z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol384 || (_symbol384 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-plug-ccs1-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "plug-ccs1-small"), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 21.514h-11a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2zm-8-3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM9.5 7a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0zm2 5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0zm4-1V9m-7 2V9m5-2a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0zm5.01 2.014a6.514 6.514 0 1 0-13.029 0 6.514 6.514 0 0 0 13.028 0z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol385 || (_symbol385 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-plug-cee3-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "plug-cee3-large"), /*#__PURE__*/React.createElement("path", {
    d: "M43.5 24c0-10.77-8.73-19.5-19.5-19.5S4.5 13.23 4.5 24 13.23 43.5 24 43.5 43.5 34.77 43.5 24zm-16 6.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0zM33 18a2 2 0 1 1-3.999.001A2 2 0 0 1 33 18zm-14 0a2 2 0 1 1-3.999.001A2 2 0 0 1 19 18z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol386 || (_symbol386 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-plug-cee3-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "plug-cee3-small"), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 12a8.5 8.5 0 1 0-17.001.001A8.5 8.5 0 0 0 20.5 12zm-8.995 3a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0zM9.5 10V8m5.005 2V8",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol387 || (_symbol387 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-plug-cee5-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "plug-cee5-large"), /*#__PURE__*/React.createElement("path", {
    d: "M27.5 33a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0zm4-16.5a2 2 0 1 1-3.999.001A2 2 0 0 1 31.5 16.5zm-11 0a2 2 0 1 1-3.999.001A2 2 0 0 1 20.5 16.5zm16 9a2 2 0 1 1-3.999.001A2 2 0 0 1 36.5 25.5zm-21 0a2 2 0 1 1-3.999.001A2 2 0 0 1 15.5 25.5zm28-1.5c0-10.77-8.73-19.5-19.5-19.5S4.5 13.23 4.5 24 13.23 43.5 24 43.5 43.5 34.77 43.5 24z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol388 || (_symbol388 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-plug-cee5-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "plug-cee5-small"), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 12a8.5 8.5 0 1 0-17.001.001A8.5 8.5 0 0 0 20.5 12zm-8.995 4a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0zm5-2v-2m-9 2v-2m2-2V8m4.995 2V8",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol389 || (_symbol389 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-plug-chademo-dc-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "plug-chademo-dc-large"), /*#__PURE__*/React.createElement("path", {
    d: "M43.5 24c0-10.77-8.73-19.5-19.5-19.5S4.5 13.23 4.5 24 13.23 43.5 24 43.5 43.5 34.77 43.5 24zm-25 0a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0zm-3 0a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 15.5 24zm5.32 6.82L24 34l3.18 3.18m-6.36 0L24 34l3.18-3.18M28.5 34a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0zm-7.68-23.18L24 14l3.18 3.18m-6.36 0L24 14l3.18-3.18M28.5 14a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0zm10 10a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0zm-3 0a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 35.5 24zM8.35 12.35l-1.57-1.69 5.12-4.77 1.58 1.7m21.04 0l1.58-1.7 5.12 4.77-1.57 1.69",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol390 || (_symbol390 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-plug-chademo-dc-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "plug-chademo-dc-small"), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0zm4 4a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0zm0-8a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0zm4 4a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0zm5 0a8.5 8.5 0 1 0-17.001.001A8.5 8.5 0 0 0 20.5 12zm-16-4.5L3 6l3-3 1.5 1.5m9 0L18 3l3 3-1.5 1.5",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol391 || (_symbol391 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-plug-schuko-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "plug-schuko-large"), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 23.84a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0zm16 0a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0zm-3-19.34c5.557.707 10.385 3.762 13.46 8.136 1.033 1.469 1.54 3.245 1.54 5.041v3.663h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-2v3.663c0 1.796-.507 3.572-1.54 5.041-3.075 4.374-7.903 7.429-13.46 8.136v-1.84a1 1 0 0 0-1-1h-3a1 1 0 0 0-1 1v1.84c-5.557-.707-10.385-3.762-13.46-8.136-1.033-1.469-1.54-3.245-1.54-5.041V26.34h-2a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h2v-3.663c0-1.796.507-3.572 1.54-5.041C11.115 8.262 15.943 5.207 21.5 4.5v1.84a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V4.5z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol392 || (_symbol392 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-plug-schuko-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "plug-schuko-small"), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 11.88a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm-8 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm2 9.38A9.479 9.479 0 0 1 3.99 17c-.32-.49-.49-1.07-.49-1.66v-1.96h-1c-.55 0-1-.45-1-1v-1c0-.55.45-1 1-1h1V8.42c0-.59.17-1.17.49-1.66A9.479 9.479 0 0 1 10.5 2.5v.88a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V2.5c2.74.43 5.07 2.02 6.51 4.26.32.49.49 1.07.49 1.66v1.96h1c.55 0 1 .45 1 1v1c0 .55-.45 1-1 1h-1v1.96c0 .59-.17 1.17-.49 1.66a9.479 9.479 0 0 1-6.51 4.26v-.88a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v.88z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol393 || (_symbol393 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-plug-type1-ac-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "plug-type1-ac-large"), /*#__PURE__*/React.createElement("path", {
    d: "M43.5 22c0-10.77-8.73-19.5-19.5-19.5S4.5 11.23 4.5 22 13.23 41.5 24 41.5 43.5 32.77 43.5 22zm-7 4.5a2 2 0 1 1-3.999.001A2 2 0 0 1 36.5 26.5zm-21 0a2 2 0 1 1-3.999.001A2 2 0 0 1 15.5 26.5zm5-10.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0zm7 16a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0zm7-16a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0zm-14 25v4.5h7V41",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol394 || (_symbol394 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-plug-type1-ac-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "plug-type1-ac-small"), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 11a8.5 8.5 0 1 0-17.001.001A8.5 8.5 0 0 0 20.5 11zM8.505 8a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0zm3 7a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0zm5-2v-2m-9 2v-2m7-3a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0zm-4 11.5v2h3v-2",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol395 || (_symbol395 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-plug-type2-ac-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "plug-type2-ac-large"), /*#__PURE__*/React.createElement("path", {
    d: "M27.477 23a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0zm-11 0a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0zm22 0a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0zm-17 9a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0zm12 0a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0zm-14-17.5a2 2 0 1 1-3.999.002 2 2 0 0 1 3.999-.002zm13.013 0a2 2 0 1 1-3.999.002 2 2 0 0 1 3.999-.002zm4.258-7.761c6.113 5.198 9.026 14.068 5.306 23.213-1.801 4.427-5.325 8.003-9.74 9.834C17.977 45.733 4.25 35.355 4.25 21.773c0-6.026 2.704-11.419 6.956-15.034.183-.155.412-.238.652-.238L36.096 6.5c.24 0 .469.083.652.239z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol396 || (_symbol396 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-plug-type2-ac-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "plug-type2-ac-small"), /*#__PURE__*/React.createElement("path", {
    d: "M16.924 4.5c.245 0 .488.084.67.248a8.446 8.446 0 0 1 2.745 7.4c-.481 3.799-3.6 6.869-7.406 7.297A8.457 8.457 0 0 1 6.314 4.748c.183-.164.425-.248.671-.248h9.939zM8.422 12a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm2.032 3a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm4 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm-2-3a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm4.005 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zM9.454 8v2m5-2v2",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol397 || (_symbol397 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-poi-calendar-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "poi-calendar-large"), /*#__PURE__*/React.createElement("path", {
    d: "M16 10.5h13M16.5 12v10c0 .3.2.6.6.6H25l3.5-3.2V12m0 7.5h-4v3m-5 .1v1.3c0 .3.2.6.6.6h9.7c.4 0 .7-.3.7-.6V14m7 3.5c0-7.7-6.3-14-14-14s-14 6.3-14 14 14 27 14 27 14-19.3 14-27z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol398 || (_symbol398 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-poi-calendar-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "poi-calendar-small"), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 9.5h-3v3M7 5.5h9m2.7 3.1c0-4-3.3-7.3-7.2-7.3-3.9 0-7.2 3.3-7.2 7.3s7.2 14.1 7.2 14.1 7.2-10.1 7.2-14.1zM7.5 7v5.2c0 .2.3.3.5.3h5l2.5-2.5V7",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol399 || (_symbol399 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-poi-car-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "poi-car-large"), /*#__PURE__*/React.createElement("path", {
    d: "M37.5 17.5c0-7.7-6.3-14-14-14s-14 6.3-14 14 14 27 14 27 14-19.3 14-27zm-24-3v7a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1h12v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-7l-1.75-2-1.33-2.114C30.07 9.83 29.597 9.201 29 8.5a56.708 56.708 0 0 0-5.49-.261c-1.867 0-3.704.08-5.51.238-.597.716-1.07 1.353-1.42 1.91L15.25 12.5l-1.75 2zm5 2l1-1h8l1 1c-.682 1.467-1.182 2.2-1.5 2.2h-7c-.318 0-.818-.733-1.5-2.2zm-3.25-4h16.5m-18.25 3H17m13 0h3.5",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol400 || (_symbol400 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-poi-car-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "poi-car-small"), /*#__PURE__*/React.createElement("path", {
    d: "M18.7 8.6c0-4-3.3-7.3-7.2-7.3-3.9 0-7.2 3.3-7.2 7.3s7.2 14.1 7.2 14.1 7.2-10.1 7.2-14.1zM6.5 7.5V11a.5.5 0 0 0 .5.5h1.5A.5.5 0 0 0 9 11v-.5h5v.5a.5.5 0 0 0 .5.5H16a.5.5 0 0 0 .5-.5V7.531L14 4.5H9l-2.5 3zm0 1H9m5 0h2.5",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol401 || (_symbol401 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-poi-contact-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "poi-contact-large"), /*#__PURE__*/React.createElement("path", {
    d: "M25 14.5h-3c-1.1 0-2-.9-2-2v-3c0-1.1.9-2 2-2h3c1.1 0 2 .9 2 2v3c0 1.1-.9 2-2 2zm5.5 4.5s.1-1.5-1.2-1.5H17.8c-1.3 0-1.2 1.5-1.2 1.5v6.5h14V19h-.1zm7-1.5c0-7.7-6.3-14-14-14s-14 6.3-14 14 14 27 14 27 14-19.3 14-27z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol402 || (_symbol402 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-poi-contact-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "poi-contact-small"), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 7.5h-2c-.6 0-1-.4-1-1v-2c0-.5.4-1 1-1h2c.6 0 1 .5 1 1v2c0 .6-.4 1-1 1zm2 2.7s0-.7-.5-.7H9c-.6 0-.5.7-.5.7v3.3h6v-3.3zm4.1-1.5c0-3.9-3.1-7.2-6.9-7.2-3.8 0-6.9 3.3-6.9 7.2 0 3.9 6.9 13.8 6.9 13.8s6.9-9.8 6.9-13.8z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol403 || (_symbol403 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-poi-favorite-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "poi-favorite-large"), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 8.5l2.8 5.6 6.2.9-4.5 4.4 1.1 6.2-5.6-2.9-5.6 2.9 1.1-6.2-4.5-4.4 6.2-.9 2.8-5.6zm14 9c0-7.7-6.3-14-14-14s-14 6.3-14 14 14 27 14 27 14-19.3 14-27z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol404 || (_symbol404 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-poi-favorite-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "poi-favorite-small"), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 3.8l1.5 3 3.3.5-2.4 2.3.6 3.3-2.9-1.5-2.9 1.5.6-3.3-2.5-2.4 3.2-.5 1.5-2.9zm7 4.7c0-3.9-3.1-7-7-7s-7 3.1-7 7 7 14 7 14 7-10.1 7-14z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol405 || (_symbol405 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-poi-home-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "poi-home-large"), /*#__PURE__*/React.createElement("path", {
    d: "M37.5 17.5c0-7.7-6.3-14-14-14s-14 6.3-14 14 14 27 14 27 14-19.3 14-27zm-21-3.5v6.5c0 1.1.9 2 2 2h12V14m2.5 2l-9.5-7.5L14 16",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol406 || (_symbol406 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-poi-home-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "poi-home-small"), /*#__PURE__*/React.createElement("path", {
    d: "M18.7 8.6c0-4-3.3-7.3-7.2-7.3-3.9 0-7.2 3.3-7.2 7.3s7.2 14.1 7.2 14.1 7.2-10.1 7.2-14.1zM7.5 7v3.5c0 .6.4 1 .9 1h7.1V7M17 8l-5.5-4L6 8",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol407 || (_symbol407 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-poi-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "poi-large"), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 24.5a7 7 0 1 0 0-14 7 7 0 0 0 0 14zm14-7c0-7.7-6.3-14-14-14s-14 6.3-14 14 14 27 14 27 14-19.3 14-27z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol408 || (_symbol408 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-poi-last-destination-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "poi-last-destination-large"), /*#__PURE__*/React.createElement("path", {
    d: "M37.5 17.5c0-7.7-6.3-14-14-14s-14 6.3-14 14 14 27 14 27 14-19.3 14-27zM17.4 21c1.2 2.1 3.5 3.5 6.1 3.5 3.9 0 7-3.1 7-7s-3.1-7-7-7c-2.6 0-4.6 1.1-6.5 3.3-.3.4-.5.7-.5.7m4.5 0h-4.5V10m7 4v4.5H27",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol409 || (_symbol409 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-poi-last-destination-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "poi-last-destination-small"), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 8.5c0-3.9-3.1-7-7-7s-7 3.1-7 7 7 14 7 14 7-10.1 7-14zm-7 3c1.7 0 3-1.3 3-3s-1.3-3-3-3-3 1.2-3 3v2M10.9 8l-2.4 2.5L6 8",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol410 || (_symbol410 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-poi-on-map-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "poi-on-map-large"), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 3.5c7.7 0 14 6.3 14 14s-14 27-14 27-14-19.3-14-27c0-7.7 6.3-14 14-14zm0 7a7 7 0 1 0 0 14 7 7 0 0 0 0-14z",
    fill: "currentColor"
  }))), _symbol411 || (_symbol411 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-poi-on-map-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "poi-on-map-small"), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 1.5c3.9 0 7 3.1 7 7s-7 14-7 14-7-10.1-7-14c0-3.9 3.1-7 7-7zm0 4a3 3 0 1 0 0 6 3 3 0 0 0 0-6z",
    fill: "currentColor"
  }))), _symbol412 || (_symbol412 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-poi-search-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "poi-search-large"), /*#__PURE__*/React.createElement("path", {
    d: "M39.5 32.5L28.6 22.3m-5.1 2.2a7 7 0 1 0 0-14 7 7 0 0 0 0 14zm13.2-2.9c.5-1.3.8-2.7.8-4.1 0-7.7-6.3-14-14-14s-14 6.3-14 14 14 27 14 27 3.9-5.4 7.6-11.6",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol413 || (_symbol413 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-poi-search-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "poi-search-small"), /*#__PURE__*/React.createElement("path", {
    d: "M18.8 15.8l-5.1-5.1m-.1-.1c1.2-1.2 1.2-3.1 0-4.2s-3.1-1.2-4.2 0-1.2 3.1 0 4.2c.6.6 1.3.9 2.1.9s1.6-.3 2.1-.9m4 1.2c.5-1 .8-2.2.9-3.3 0-3.9-3.1-7-7-7s-7 3.1-7 7 7 14 7 14 2.3-3.3 4.3-6.9",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol414 || (_symbol414 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-poi-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "poi-small"), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 11.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm7-3c0-3.9-3.1-7-7-7s-7 3.1-7 7 7 14 7 14 7-10.1 7-14z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol415 || (_symbol415 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-poi-work-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "poi-work-large"), /*#__PURE__*/React.createElement("path", {
    d: "M37.5 17.5c0-7.7-6.3-14-14-14s-14 6.3-14 14 14 27 14 27 14-19.3 14-27zm-13-6h2v2h-2v-2zm-5 0h2v2h-2v-2zm5 6h2v2h-2v-2zm-5 0h2v2h-2v-2zm10 10h-5v-5h-3v5h-5v-19h13v19z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol416 || (_symbol416 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-poi-work-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "poi-work-small"), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 8.5c0-3.9-3.1-7-7-7s-7 3.1-7 7 7 14 7 14 7-10.1 7-14zm-10-4h6v9h-2v-3h-2v3h-2v-9zm3.5 4h1-1zm-2 0h1-1zm2-2h1-1zm-2 0h1-1z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol417 || (_symbol417 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-pois-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "pois-large"), /*#__PURE__*/React.createElement("path", {
    d: "M39.6 31.2a3.1 3.1 0 1 0 0-6.2 3.1 3.1 0 0 0 0 6.2zm-6.5 1.4c1.9 3.2 6.3 9.4 6.3 9.4s7.1-9.8 7.1-13.6c.2-3.8-2.8-7-6.6-7.1h-.5m-16.9 3.2a7 7 0 1 0 0-14 7 7 0 0 0 0 14zm14-7c0-7.7-6.3-14-14-14s-14 6.3-14 14 14 27 14 27 14-19.3 14-27z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol418 || (_symbol418 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-pois-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "pois-small"), /*#__PURE__*/React.createElement("path", {
    d: "M20.1 11.2c1.9.1 3.4 1.6 3.4 3.5 0 1.8-3.2 5.9-3.2 5.9s-2.2-2.9-3-4.2m-5.8-4.9a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm7-3c0-3.9-3.1-7-7-7s-7 3.1-7 7 7 14 7 14 7-10.1 7-14z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol419 || (_symbol419 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-polls-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "polls-large"), /*#__PURE__*/React.createElement("path", {
    d: "M5 44.5h38H5zm28.5-32h9v27h-9v-27zm-14-9h9v36h-9v-36zm-14 16h9v20h-9v-20z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol420 || (_symbol420 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-polls-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "polls-small"), /*#__PURE__*/React.createElement("path", {
    d: "M1 23.5h22H1zm16.5-18h5v15h-5v-15zm-8-5h5v20h-5V.5zm-8 9h5v11h-5v-11z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol421 || (_symbol421 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-power-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "power-large"), /*#__PURE__*/React.createElement("path", {
    d: "M37 25.5h4.5M33 16l3.2-3.2M23.5 12V7.5M14 16l-3.2-3.2M5.5 25.5H10m4 9.5l-3.2 3.2c-3.4-3.4-5.3-8-5.3-12.7 0-9.9 8.1-18 18-18s18 8.1 18 18c0 5-2 9.5-5.3 12.7L33 35m-6.7-8.5l8.5 3.1m-11.3-1.1a3 3 0 1 0 0-6 3 3 0 0 0 0 6z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol422 || (_symbol422 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-power-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "power-small"), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 13.5l6.5 2m4.5-2H20m-.7-7.8l-1.8 1.8m-6-5V5m-6 2.5L3.7 5.7M3 13.5H.5m5 6l-1.8 1.8C1.6 19.2.5 16.4.5 13.5c0-6.1 4.9-11 11-11s11 4.9 11 11c0 3-1.2 5.8-3.2 7.8l-1.8-1.8",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol423 || (_symbol423 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-pre-heating-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "pre-heating-large"), /*#__PURE__*/React.createElement("path", {
    d: "M19.1 10l4.5-5.5 4.5 5.5m-4.6 7V5M6 44.5h36H6zM36.5 17V5m-4.4 5l4.5-5.5 4.5 5.5M10.6 5v7.6s-.3 3.7 1.7 7.3C14.3 23.5 16 26 16 30s-1.6 10.5-7.9 10.5M6.1 10l4.5-5.5 4.5 5.5m15 17.5c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3zm2.5 4.9c-.1 10.1 3.9 8.6 5.4 7.1 1.5-1.5 3.1-4.2.9-6.3-2.2-2.1-5.4-1.4-5.4-1.4l-.7.2-.2.4zm-3.9 1c-10.1-.1-9.1 3.9-7.6 5.4 1.5 1.5 4.3 2.9 6.4.7 1.3-1.5 2-3.5 1.7-5.4l-.2-.7h-.3zm2.8-5.9c-.2-.9-.4-4.2 1.3-5.9 2.2-2.1 5.2-.8 6.7.7 1.8 1.8 3.8 5.2-6.4 5.2h-1.6zm-4.6 2c-1.8.2-3.6-.3-5-1.5-2.1-2.1-.8-5.1.7-6.6 1.3-1.3 4.7-3 4.6 7.1l-.2 1.2-.1-.2z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol424 || (_symbol424 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-pre-heating-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "pre-heating-small"), /*#__PURE__*/React.createElement("path", {
    d: "M9.1 3.5L11.6 1l2.5 2.5M2 20.7c2 0 4.5-1.9 4.5-5.5 0-3.5-3-5-3-8V.9M0 23.5h24m-14-2.8c2 0 4.5-1.9 4.5-5.5 0-3.5-3-5-3-8V.9M.4 4.4L3.5 1 7 4.4m11 16.3c2 0 4.5-1.9 4.5-5.5 0-3.5-3-5-3-8V.9m-3.1 3.5L19.5 1 23 4.4",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol425 || (_symbol425 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-print-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "print-large"), /*#__PURE__*/React.createElement("path", {
    d: "M28.5 3.5v10h10M16 27.5h16m-16-7h16m6.5 7h5c1.1 0 2 .9 2 2v15h-43v-15c0-1.1.9-2 2-2h5m29-14v22h-29v-32h19l10 10z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol426 || (_symbol426 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-print-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "print-small"), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 1.5v5h5M8 14.5h8m-8-4h8m3.5-4v12h-15v-17h10l5 5zm.1 8h2.9c.5 0 1 .4 1 1v8H.5v-8c0-.5.5-1 1-1h3",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol427 || (_symbol427 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-privacy-mode-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "privacy-mode-large"), /*#__PURE__*/React.createElement("path", {
    d: "M24 24.5v4m4.5-7.042V18.75a3.25 3.25 0 0 0-3.25-3.25h-2.5a3.25 3.25 0 0 0-3.25 3.25v2.708m0 .042h11v10h-13v-10h2zm-15-12c0 31 19.5 37 19.5 37s19.5-6 19.5-37c0 0-13 0-19-8h-1c-6 8-19 8-19 8z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol428 || (_symbol428 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-privacy-mode-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "privacy-mode-small"), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 12v2m3-3.5v-2a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v2m-7-6c0 15.5 10 18.9 10 18.9s10-3.4 10-18.9c0 0-6.5 0-9.5-4h-1c-3 4-9.5 4-9.5 4zm6 6h8v5h-8v-5z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol429 || (_symbol429 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-private-customer-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "private-customer-large"), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 20.5h-7c-1.6 0-3-1.4-3-3v-7c0-1.6 1.4-3 3-3h7c1.6 0 3 1.4 3 3v7c0 1.6-1.4 3-3 3zm1.5 20H7.5V27.3s.2-2.8 3.5-2.8h18c2.202 0 3.303.933 3.303 2.8M27.5 34.058V40.5a2 2 0 0 0 2 2h12v-8.432m2.328 1.745l-9.268-7.23-9.268 7.229",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol430 || (_symbol430 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-private-customer-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "private-customer-small"), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 9.5h-3c-1.1 0-2-.9-2-2v-3c0-1.1.9-2 2-2h3c1.1 0 2 .9 2 2v3c0 1.1-.9 2-2 2zm-1.5 11H3.5V14s-.1-1.5 1.2-1.5H15M12.5 17v3.53c0 .536.512.97 1.143.97H20.5V17m1.5 1l-5.5-4-5.5 4",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol431 || (_symbol431 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-profile-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "profile-large"), /*#__PURE__*/React.createElement("path", {
    d: "M20.8 39.6c3.7-.9 7.1-2.9 9.7-5.7 4.2-4.8 4.1-6.8 7.9-7.3m-26.8 12c4.9-.7 9.6-2.8 13.3-6 6-5.3 7-9.7 13.1-10m-27.9 3.2c2.8-.9 5.3-2.4 7.6-4.2 4.2-3.3 5.1-5.3 6.8-3.4 4 4.3-11.2 11.9-14.4 12.8m5.5 10.3c2.1 1.4 4.5 2.2 7 2.2 6.5 0 12-4.9 14.4-12.8m-27.4-10s4.3-1 8.5-6.1c4.6-5.7 8.8-2.6 10.2 2.1 1 3.2 2.6 10.5-17.8 18.5m.3-19.8S16.1 7.5 23 7.5c6.9 0 9.9 7 9.9 12.8m4.5-.5C36.1 9.5 30.1 3.5 22.6 3.5c-4 .1-7.7 2-10.2 5.1",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol432 || (_symbol432 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-profile-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "profile-small"), /*#__PURE__*/React.createElement("path", {
    d: "M4.2 9.8c2-.8 3.7-2.2 5-3.9 2.9-3.8 5.6-1.7 6.5 1.4.6 2.1 1.7 7-10.4 12.1M4.5 6.6l2.4-2.2m12.8 12.1c-1.7 4.1-4.3 5.9-7.2 6.8-1.7.5-3.6.2-5-.9l-1.2-1.1m13.5-8.5c-2.2.3-2 1.4-4.5 4.3-1.7 2-3.9 3.1-4.9 3.1H9.1M4.3 13c1.6-.6 3-1.5 4.3-2.6 2.6-2.2 3.3-3.5 4.3-2.2 1 1.3-.7 3.7-3.1 5.2-1.7 1.2-3.6 2.2-5.5 3.1M6.4 2.8C7.9 1.3 9.9.5 12 .5c4.5 0 7.5 4.5 7.5 9.3v.6",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol433 || (_symbol433 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-projects-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "projects-large"), /*#__PURE__*/React.createElement("path", {
    d: "M40.5 43.5h-31c-1.7 0-3-1.3-3-3v-21h31c1.7 0 3 1.3 3 3v21zm-11.5-7h7-7zm-9 0h7-7zm-9 0h7-7zm18-5h7-7zm-9 0h7-7zm-9 0h7-7zm18-5h7-7zm-9 0h7-7zm-9 0h7-7zm24.3-7L23.9 7.1l11.4 12.4zm-25.3 0L21.2 7.1 10 19.5zM22.6 7.6a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol434 || (_symbol434 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-projects-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "projects-small"), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 9.5h18c.6 0 1 .4 1 1v13h-18c-.6 0-1-.4-1-1v-13zm12.5 10h4-4zm-5 0h4-4zm-5 0h4-4zm10-3h4-4zm-5 0h4-4zm-5 0h4-4zm10-3h4-4zm-5 0h4-4zm-5 0h4-4zm13.6-4l-5.2-6.3m-3.8 0L4.4 9.5m7.1-5a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol435 || (_symbol435 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-public-transport-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "public-transport-large"), /*#__PURE__*/React.createElement("path", {
    d: "M42.5 29.5h-37 37zm-10 14v-2h-17v2c0 1.1-.9 2-2 2h-3c-1.1 0-2-.9-2-2v-2h-3v-19h-1c-1.1 0-2-.9-2-2v-11h43v11c0 1.1-.9 2-2 2h-1v19h-3v2c0 1.1-.9 2-2 2h-3c-1.1 0-2-.9-2-2zM12 32.5c1.4 0 2.5 1.1 2.5 2.5s-1.1 2.5-2.5 2.5-2.5-1.1-2.5-2.5 1.1-2.5 2.5-2.5zm24 0c1.4 0 2.5 1.1 2.5 2.5s-1.1 2.5-2.5 2.5-2.5-1.1-2.5-2.5 1.1-2.5 2.5-2.5zM5.5 23V6.5c0-1.6 1.3-3 3-3h31c1.7 0 3 1.3 3 3V23",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol436 || (_symbol436 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-public-transport-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "public-transport-small"), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 9.5v-6h19v6M6 16c1 0 2 1 2 2s-1 2-2 2-2-1-2-2 1-2 2-2m12 0c1 0 2 1 2 2s-1 2-2 2-2-1-2-2 1-2 2-2m-1.5 6.5v-1h-9v1c0 .6-.4 1-1 1h-2c-.6 0-1-.4-1-1v-1h-1v-12h-1c-.6 0-1-.4-1-1v-5h2V2.2c0-.9.7-1.7 1.6-1.7h15.8c.9 0 1.6.7 1.6 1.6v1.4h2v5c0 .6-.4 1-1 1h-1v12h-1v1c0 .6-.4 1-1 1h-2c-.6 0-1-.4-1-1zm5-9h-19 19z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol437 || (_symbol437 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-quattro-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "quattro-large"), /*#__PURE__*/React.createElement("path", {
    d: "M37.5 18.5h4v10h-4v-10zm0 5H24h13.5zm-25-2l11.5 2-11.5 2v3h-8v-10h8v3zm27 7v4m-6 0h12c.6 0 1 .4 1 1v3c0 .6-.4 1-1 1h-12c-.6 0-1-.4-1-1v-3c0-.6.4-1 1-1zm-25-4v4m-6 0h12c.6 0 1 .4 1 1v3c0 .6-.4 1-1 1h-12c-.6 0-1-.4-1-1v-3c0-.6.4-1 1-1zm37-18v4m-6-9h12c.6 0 1 .4 1 1v3c0 .6-.4 1-1 1h-12c-.6 0-1-.4-1-1v-3c0-.6.4-1 1-1zm-25 5v4m-6-9h12c.6 0 1 .4 1 1v3c0 .6-.4 1-1 1h-12c-.6 0-1-.4-1-1v-3c0-.6.4-1 1-1z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol438 || (_symbol438 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-quattro-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "quattro-small"), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 8.5h4v6h-4v-6zm-4.9 3h4.9-4.9zM6.5 10l6.1 1.5L6.5 13v1.5h-4v-6h4V10zm13 4.5v3m-3 0h6c.6 0 1 .4 1 1v1c0 .6-.4 1-1 1h-6c-.6 0-1-.4-1-1v-1c0-.6.4-1 1-1zm-12-3v3m-3 0h6c.6 0 1 .4 1 1v1c0 .6-.4 1-1 1h-6c-.6 0-1-.4-1-1v-1c0-.6.4-1 1-1zm18-12v3m-3-6h6c.6 0 1 .4 1 1v1c0 .6-.4 1-1 1h-6c-.6 0-1-.4-1-1v-1c0-.6.4-1 1-1zm-12 3v3m-3-6h6c.6 0 1 .4 1 1v1c0 .6-.4 1-1 1h-6c-.6 0-1-.4-1-1v-1c0-.6.4-1 1-1z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol439 || (_symbol439 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-receive-e-mail-notification-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "receive-e-mail-notification-large"), /*#__PURE__*/React.createElement("path", {
    d: "M7 22l17 13 17-13m4-4L24 3.5 3 18m-.5 3v21.5c0 1.1.9 2 2 2h41V21",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol440 || (_symbol440 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-receive-e-mail-notification-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "receive-e-mail-notification-small"), /*#__PURE__*/React.createElement("path", {
    d: "M5 13l7 5.5 7-5.5m3-4L12 2 2 9m-.5 2v10.5c0 1.1.9 2 2 2h19V11",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol441 || (_symbol441 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-recommended-destination-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "recommended-destination-large"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 22h10v8H6v-8zM6 3h10v9H6V3zm10 9h11v10H16V12zm11-7h10v7H27V5z",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 3v44m18-15.5l-2-2h-13v-26h16l2 2h12V15m-3 22l-.8-2.4c-2.3-1.4-4.2-4.2-4.2-7.1 0-4.4 3.5-8 8.5-8s8.5 3.6 8.5 8c0 2.9-2 5.6-4.2 7l-.8 2.5M34 41.5h6m-6-2h6m-5 4h4",
    stroke: "currentColor"
  })))), _symbol442 || (_symbol442 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-recommended-destination-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "recommended-destination-small"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 11v4H3v-4h5zm6-5v5H8V6h6zM8 1v5H3V1h5zm11 1v4h-5V2h5z",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 1v22m9-7.5l-1-1h-6v-13h8l1 1h6V8M17 18l-.5-1.5c-1.2-.7-2-1.5-2-3 0-2.2 1.8-4 4-4s4 1.8 4 4c0 1.4-.9 2.3-2 3L20 18m0 1.5h-3m3 2h-3m1 2h1",
    stroke: "currentColor"
  })))), _symbol443 || (_symbol443 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-refresh-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "refresh-large"), /*#__PURE__*/React.createElement("path", {
    d: "M38.692 30.8c-4 7.9-13.7 11-21.5 6.9-7.8-4.1-11-13.7-6.9-21.5 2.7-5.3 8.2-8.7 14.2-8.7 6.4 0 12.1 4 14.4 10m-8.9 0h9.5V8",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol444 || (_symbol444 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-refresh-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "refresh-small"), /*#__PURE__*/React.createElement("path", {
    d: "M19.557 15.5c-2.2 4.4-7.6 6.2-12.1 4s-6.2-7.6-4-12.1c1.5-3.1 4.6-5 8.1-5 4.3 0 7.4 3.5 8.3 7m-6.3.1h7v-7",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol445 || (_symbol445 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-replay-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "replay-large"), /*#__PURE__*/React.createElement("path", {
    d: "M9.3 30.8c4 7.9 13.7 11 21.5 6.9 7.8-4.1 11-13.7 6.9-21.5-2.7-5.3-8.2-8.7-14.2-8.7-6.4 0-12.1 4-14.4 10m8.9 0H8.5V8",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol446 || (_symbol446 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-replay-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "replay-small"), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 15.5c2.2 4.4 7.6 6.2 12.1 4s6.2-7.6 4-12.1c-1.5-3.1-4.6-5-8.1-5-4.3 0-7.4 3.5-8.3 7m6.3.1h-7v-7",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol447 || (_symbol447 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-resize-decrease-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "resize-decrease-large"), /*#__PURE__*/React.createElement("path", {
    d: "M8 26.5l13.5.02V40m-16 2.5l16-16M26.494 8v13.5H40m2.5-16l-16 15.994",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol448 || (_symbol448 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-resize-decrease-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "resize-decrease-small"), /*#__PURE__*/React.createElement("path", {
    d: "M20 10.5h-6.492V4M21.5 2.5l-8 8m-11 11l8-8m0 6.5v-6.5H4.008",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol449 || (_symbol449 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-resize-increase-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "resize-increase-large"), /*#__PURE__*/React.createElement("path", {
    d: "M19 42.494H5.5V29m16-2.5l-15.996 16M42.5 19V5.5H29m-2.506 15.994L42.5 5.5",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol450 || (_symbol450 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-resize-increase-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "resize-increase-small"), /*#__PURE__*/React.createElement("path", {
    d: "M15 2.5h6.492V9M13.5 10.5l8-8m-11 11l-8 8m0-6.5v6.5h6.492",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol451 || (_symbol451 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-restaurant-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "restaurant-large"), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 23.5V46m0-22.5a4 4 0 0 0 4-4V1.828m-4 21.672a4 4 0 0 1-4-4V1.828m4 .172v16m19 5.5h-6v-17a4 4 0 0 1 4-4h2m0-.5v44",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol452 || (_symbol452 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-restaurant-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "restaurant-small"), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 1.5h.5m-.5 0a4 4 0 0 0-4 4v7m4-11V23m.5-10.5h-5m-6.5 0V23m0-10.5a3 3 0 0 1-3-3V1m3 11.5a3 3 0 0 0 3-3V1m-3 9V1",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol453 || (_symbol453 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-restroom-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "restroom-large"), /*#__PURE__*/React.createElement("path", {
    d: "M40.917 14c.863 0 1.738.098 2.626.295.889.197 1.619.447 2.19.749v1.51a12.91 12.91 0 0 0-2.385-.815 10.675 10.675 0 0 0-2.463-.288c-1.365 0-2.507.337-3.425 1.01-.915.67-1.597 1.641-2.047 2.915-.451 1.269-.676 2.81-.676 4.62 0 1.782.22 3.309.663 4.582.446 1.274 1.128 2.254 2.047 2.94.918.688 2.075 1.031 3.47 1.031.871 0 1.747-.091 2.626-.275A13.47 13.47 0 0 0 46 31.525v1.425c-.672.289-1.471.536-2.398.741-.927.206-1.842.309-2.743.309-1.764 0-3.232-.403-4.407-1.208-1.174-.81-2.047-1.958-2.619-3.446-.567-1.488-.851-3.262-.851-5.323 0-2.057.294-3.833.884-5.33.593-1.5 1.481-2.658 2.664-3.472C37.718 14.407 39.18 14 40.917 14zm-36.104.263l4.894 15.03c.321.963.561 1.77.722 2.423.195-.819.424-1.626.689-2.422l4.796-15.031h1.625l4.894 15.03c.32.963.561 1.77.722 2.423a29.11 29.11 0 0 1 .689-2.422l4.9-15.031h1.729L24.006 33.73h-1.787L17.214 18.7c-.26-.797-.455-1.52-.585-2.173-.156.796-.342 1.52-.559 2.173l-4.79 15.03H9.467L3 14.264h1.813z",
    fill: "currentColor"
  }))), _symbol454 || (_symbol454 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-restroom-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "restroom-small"), /*#__PURE__*/React.createElement("path", {
    d: "M20.655 6.63c.263 0 .523.013.78.038s.502.062.736.11c.234.048.452.108.654.179.205.069.385.147.542.234v1.152a4.141 4.141 0 0 0-.552-.223 5.499 5.499 0 0 0-.637-.169 6.453 6.453 0 0 0-.699-.11 7.157 7.157 0 0 0-.739-.038c-.35 0-.67.041-.96.124-.292.08-.553.2-.785.361-.229.158-.43.355-.603.589-.17.231-.312.498-.426.801a5.05 5.05 0 0 0-.255 1.012c-.057.369-.085.77-.085 1.2 0 .484.035.922.105 1.315.073.392.175.742.307 1.049.134.305.295.569.484.791.188.223.4.408.634.554.236.145.491.252.766.324.277.069.57.103.876.103.295 0 .569-.012.821-.034.255-.024.492-.056.712-.097.22-.041.426-.092.617-.151.193-.06.377-.126.552-.2v1.122c-.175.078-.36.149-.555.213a5.306 5.306 0 0 1-.638.158c-.229.044-.48.077-.753.1a10.9 10.9 0 0 1-.91.035c-.451 0-.873-.05-1.264-.152a3.975 3.975 0 0 1-1.07-.447 3.587 3.587 0 0 1-.862-.74 4.25 4.25 0 0 1-.633-1.028 6 6 0 0 1-.396-1.318 8.924 8.924 0 0 1-.133-1.597c0-.525.042-1.02.127-1.482.084-.466.207-.893.371-1.28.166-.39.371-.74.617-1.05.245-.31.529-.57.852-.784a3.95 3.95 0 0 1 1.087-.492 4.78 4.78 0 0 1 1.315-.172zm-18.751.168L4.2 14.213l.096.303a11.97 11.97 0 0 1 .18.612c.03.103.057.209.082.316.02-.107.043-.213.068-.316a12.025 12.025 0 0 1 .263-.915l2.31-7.415h1.298l2.314 7.425.05.154.045.152c.032.101.062.203.089.306.03.101.056.205.078.31.025.103.049.208.072.313a10.285 10.285 0 0 1 .16-.623c.032-.103.065-.205.099-.306l.102-.306 2.3-7.425h1.387l-3.346 10.205h-1.373l-2.219-6.857c-.034-.1-.07-.214-.109-.34a12.968 12.968 0 0 1-.3-1.335 17.058 17.058 0 0 1-.2.922 8.955 8.955 0 0 1-.209.753l-2.21 6.857H3.848L.5 6.798h1.404z",
    fill: "currentColor"
  }))), _symbol455 || (_symbol455 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-results-list-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "results-list-large"), /*#__PURE__*/React.createElement("path", {
    d: "M16 11.5h18m-18 6h12m-12 6h5m-9 0h2m-2-6h2m-2-6h2m22.5 11.9c1.7 0 3.1 1.3 3.1 3s-1.3 3.1-3 3.1h-.1c-1.7 0-3.1-1.4-3-3.1 0-1.6 1.3-2.9 3-3zm-7.1 3.3c-.2-3.8 2.8-7 6.6-7.1h.4c3.9 0 7.1 3.2 7.2 7.1 0 3.9-7.1 13.8-7.1 13.8s-7.1-9.9-7.1-13.8z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol456 || (_symbol456 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-results-list-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "results-list-small"), /*#__PURE__*/React.createElement("path", {
    d: "M5 12.5h3-3zm-3 0h2-2zm3-3h5-5zm-3 0h2-2zm3-3h9-9zm-3 0h2-2zm3-3h9-9zm-3 0h2-2zm9.5 8.9c-.1-2.1 1.6-3.9 3.7-4h.3c2.2 0 4 1.8 4 4s-4 8.1-4 8.1-4-5.9-4-8.1z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol457 || (_symbol457 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-roof-open-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "roof-open-large"), /*#__PURE__*/React.createElement("path", {
    d: "M13.022 19.125c19.98-.28 30.219-.357 30.717-.23 1.176.3 1.788 1.457 2.11 2.531.322 1.074.721 3.415.647 4.574-.075 1.16-1.008 2.216-2.167 2.3l-2.829.2a4 4 0 0 1-4 4H37a4 4 0 0 1-4-4H15a4 4 0 0 1-4 4h-.5a4 4 0 0 1-4-4H3.258c-.971 0-1.758-.787-1.758-1.758v-.351c0-1.406.039-1.993.273-2.696.351-1.055 1.758-2.46 3.867-3.164 1.406-.468 3.867-.937 7.382-1.406 2.948-2.837 4.94-4.477 5.976-4.921m19.005 4.524l3.842-3.76a1 1 0 0 0-.791-1.71L33 14",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol458 || (_symbol458 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-roof-open-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "roof-open-small"), /*#__PURE__*/React.createElement("path", {
    d: "M6.361 10.273c9.091-.364 14-.485 14.728-.364.387.065.674.147 1.061.245.608.156 1.107.683 1.15 1.31l.2 2.633c.042.6-.387 1.12-.987 1.164L21 15.52a2.23 2.23 0 0 1-2.23 2.229h-.04a2.23 2.23 0 0 1-2.23-2.23l-9-.02a2.25 2.25 0 0 1-2.25 2.25h-.02A2.23 2.23 0 0 1 3 15.52l-1.5-.02c-.502 0-1-.543-1-1.045v-.182c0-.727-.021-1.273.1-1.636.182-.546.96-1.273 2.05-1.637.727-.242 1.893-.484 3.711-.727 1.525-1.467 2.556-2.316 3.091-2.545m9.32 2.005l2.016-1.866a.5.5 0 0 0-.422-.86L16 7.733",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol459 || (_symbol459 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-rotate-image-left-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "rotate-image-left-large"), /*#__PURE__*/React.createElement("path", {
    d: "M27.5 4.5l-5 5 5 5m16 13.5v-1.4c0-4.5-1.7-9-5-12.4-3.2-3.2-7.6-4.7-11.9-4.7h-4.1m-17 13h24c1.7 0 3 1.3 3 3v16h-24c-1.7 0-3-1.3-3-3v-16z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol460 || (_symbol460 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-rotate-image-left-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "rotate-image-left-small"), /*#__PURE__*/React.createElement("path", {
    d: "M14.1 1.3L11 4.5l3.1 3.3m8.4 6.2c-.3-2.4-1.3-5-3.2-6.9-2.1-2.1-4.6-2.6-7.4-2.6H11m-8.5 8h12c1.1 0 2 .9 2 2v7h-12c-1.1 0-2-.9-2-2v-7z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol461 || (_symbol461 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-rotate-image-right-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "rotate-image-right-large"), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 4.5l5 5-5 5M5.5 28v-1.4c0-4.5 1.7-9 5-12.4 3.2-3.2 7.6-4.7 11.9-4.7h4.1m14 13h-24v16c0 1.7 1.3 3 3 3h24v-16c0-1.7-1.3-3-3-3z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol462 || (_symbol462 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-rotate-image-right-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "rotate-image-right-small"), /*#__PURE__*/React.createElement("path", {
    d: "M11.1 1.3l3.4 3.2-3.4 3.3M2.5 14c.3-2.4 1.5-5 3.4-6.9C8 5 10.6 4.5 13.4 4.5h1.1m6 8h-12v7c0 1.1.9 2 2 2h12v-7c0-1.1-.9-2-2-2z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol463 || (_symbol463 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-rotate-left-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "rotate-left-large"), /*#__PURE__*/React.createElement("path", {
    d: "M15.7 22l4.4 5.7-6 4.4m5.6-4.1c-6.5-.7-11.2-3-11.2-5.7 0-3.3 6.9-5.9 15.5-5.9s15.5 2.6 15.5 5.9c0 2.4-3.9 4.5-9.4 5.4",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol464 || (_symbol464 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-rotate-left-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "rotate-left-small"), /*#__PURE__*/React.createElement("path", {
    d: "M6.4 11.5l3 3.9-4.1 3m3.8-3.1c-4.4-.5-7.6-2-7.6-3.8 0-2.2 4.7-4 10.5-4s10.5 1.8 10.5 4c0 1.6-2.6 3.1-6.4 3.7",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol465 || (_symbol465 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-rotate-right-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "rotate-right-large"), /*#__PURE__*/React.createElement("path", {
    d: "M32.3 22l-4.4 5.7 6 4.4M28.3 28c6.5-.7 11.2-3 11.2-5.7 0-3.3-6.9-5.9-15.5-5.9s-15.5 2.7-15.5 6c0 2.4 3.9 4.5 9.4 5.4",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol466 || (_symbol466 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-rotate-right-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "rotate-right-small"), /*#__PURE__*/React.createElement("path", {
    d: "M17.6 11.5l-3 3.9 4.1 3m-3.8-3.1c4.4-.5 7.6-2 7.6-3.8 0-2.2-4.7-4-10.5-4s-10.5 1.8-10.5 4c0 1.6 2.6 3.1 6.4 3.7",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol467 || (_symbol467 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-roundabout-left-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "roundabout-left-large"), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 19L3 24.5 8.5 30M3 24.5h9.5m12 20.5v-8.5m0 0c6.627 0 12-5.373 12-12s-5.373-12-12-12-12 5.373-12 12 5.373 12 12 12z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol468 || (_symbol468 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-roundabout-left-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "roundabout-left-small"), /*#__PURE__*/React.createElement("path", {
    d: "M6.8 11.8c0 3.2 2.6 5.8 5.8 5.8 3.2 0 5.8-2.6 5.8-5.8 0-3.2-2.7-5.8-5.9-5.8-2.1 0-4.2 1.4-5 2.9-.8 1.5-.7 2.9-.7 2.9zM2 11.5h4.8H2zM12.5 23v-5.5V23zM4.8 8.5l-2.8 3 2.8 3",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol469 || (_symbol469 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-roundabout-long-left-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "roundabout-long-left-large"), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 16V8.5H17m-7.5 0l7.1 7.1M24.5 45v-8.5m0 0c-6.627 0-12-5.373-12-12s5.373-12 12-12 12 5.373 12 12-5.373 12-12 12z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol470 || (_symbol470 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-roundabout-long-left-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "roundabout-long-left-small"), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 4.5l3.6 3.6-3.6-3.6zm2.3 7.3c0 3.2 2.6 5.8 5.8 5.8 3.2 0 5.8-2.6 5.8-5.8 0-3.2-2.7-5.8-5.9-5.8-2.1 0-4.2 1.4-5 2.9-.8 1.5-.7 2.9-.7 2.9zM12.5 23v-5.5V23zm-8-15V4.5H8",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol471 || (_symbol471 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-roundabout-long-right-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "roundabout-long-right-large"), /*#__PURE__*/React.createElement("path", {
    d: "M39.5 16V8.5H32m7.5 0l-7.1 7.1M24.5 45v-8.5m0 0c6.627 0 12-5.373 12-12s-5.373-12-12-12-12 5.373-12 12 5.373 12 12 12z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol472 || (_symbol472 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-roundabout-long-right-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "roundabout-long-right-small"), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 4.5l-3.6 3.6 3.6-3.6zM6.8 11.8c0 3.2 2.6 5.8 5.8 5.8 3.2 0 5.8-2.6 5.8-5.8 0-3.2-2.7-5.8-5.9-5.8-2.1 0-4.2 1.4-5 2.9-.8 1.5-.7 2.9-.7 2.9zM12.5 23v-5.5V23zm8-15V4.5H17",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol473 || (_symbol473 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-roundabout-right-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "roundabout-right-large"), /*#__PURE__*/React.createElement("path", {
    d: "M39.5 19l5.5 5.5-5.5 5.5m5.5-5.5h-8.5M24.5 45v-8.5m0 0c6.627 0 12-5.373 12-12s-5.373-12-12-12-12 5.373-12 12 5.373 12 12 12z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol474 || (_symbol474 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-roundabout-right-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "roundabout-right-small"), /*#__PURE__*/React.createElement("path", {
    d: "M6.8 11.8c0 3.2 2.6 5.8 5.8 5.8 3.2 0 5.8-2.6 5.8-5.8 0-3.2-2.7-5.8-5.9-5.8-2.1 0-4.2 1.4-5 2.9-.8 1.5-.7 2.9-.7 2.9zm16.2-.3h-4.8H23zM12.5 23v-5.5V23zm7.7-14.5l2.8 3-2.8 3",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol475 || (_symbol475 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-roundabout-sharp-left-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "roundabout-sharp-left-large"), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 32v7.5H16m-7.5 0l7-7m9 12.5v-8.5m0 0c6.627 0 12-5.373 12-12s-5.373-12-12-12-12 5.373-12 12 5.373 12 12 12z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol476 || (_symbol476 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-roundabout-sharp-left-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "roundabout-sharp-left-small"), /*#__PURE__*/React.createElement("path", {
    d: "M6.8 11.8c0 3.2 2.6 5.8 5.8 5.8 3.2 0 5.8-2.6 5.8-5.8 0-3.2-2.7-5.8-5.9-5.8-2.1 0-4.2 1.4-5 2.9-.8 1.5-.7 2.9-.7 2.9zM12.5 23v-5.5V23zm-7-3.5l3.3-3.3-3.3 3.3zm0-3.5v3.5H9",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol477 || (_symbol477 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-roundabout-sharp-right-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "roundabout-sharp-right-large"), /*#__PURE__*/React.createElement("path", {
    d: "M40.5 32v7.5H33m7.5 0l-7-7m-9 4c6.627 0 12-5.373 12-12s-5.373-12-12-12-12 5.373-12 12 5.373 12 12 12zm0 8.5v-8.5",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol478 || (_symbol478 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-roundabout-sharp-right-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "roundabout-sharp-right-small"), /*#__PURE__*/React.createElement("path", {
    d: "M6.8 11.8c0 3.2 2.6 5.8 5.8 5.8 3.2 0 5.8-2.6 5.8-5.8 0-3.2-2.7-5.8-5.9-5.8-2.1 0-4.2 1.4-5 2.9-.8 1.5-.7 2.9-.7 2.9zM12.5 23v-5.5V23zm7-3.5l-3.3-3.3 3.3 3.3zm0-3.5v3.5H16",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol479 || (_symbol479 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-roundabout-straight-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "roundabout-straight-large"), /*#__PURE__*/React.createElement("path", {
    d: "M19 8.5L24.5 3 30 8.5m-5.5 4V3m0 33.5c6.627 0 12-5.373 12-12s-5.373-12-12-12-12 5.373-12 12 5.373 12 12 12zm0 8.5v-8.5",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol480 || (_symbol480 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-roundabout-straight-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "roundabout-straight-small"), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 6V1.5 6zm-5.7 5.8c0 3.2 2.6 5.8 5.8 5.8 3.2 0 5.8-2.6 5.8-5.8 0-3.2-2.7-5.8-5.9-5.8-2.1 0-4.2 1.4-5 2.9-.8 1.5-.7 2.9-.7 2.9zM12.5 23v-5.5V23zM9.8 4.3l2.8-2.8 2.7 2.8",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol481 || (_symbol481 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-search-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "search-large"), /*#__PURE__*/React.createElement("path", {
    d: "M42 42L29 29l13 13zm-9.5-22c0 7.6-5.7 12.5-12.5 12.5-6.9 0-12.5-5.6-12.5-12.5S13.1 7.5 20 7.5 32.5 13.1 32.5 20z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol482 || (_symbol482 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-search-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "search-small"), /*#__PURE__*/React.createElement("path", {
    d: "M22 22l-8.3-8.3L22 22zM15.5 9c.1 3.5-2.6 6.4-6.1 6.5H9c-3.6 0-6.5-2.9-6.5-6.5S5.4 2.5 9 2.5s6.5 2.9 6.5 6.5z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol483 || (_symbol483 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-select-all-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "select-all-large"), /*#__PURE__*/React.createElement("path", {
    d: "M22 7.5h5m-13 0h5m11 0h5m-13 34h5m-13 0h5m11 0h5M41.5 27v-5m0 13v-5m0-11v-5m-34 13v-5m0 13v-5m0-11v-5M11 7.5H8s-.5 0-.5.5v3M38 7.5h3s.5 0 .5.5v3M11 41.5H8s-.5 0-.5-.5v-3M38 41.5h3s.5 0 .5-.5v-3m-27-23.5h20v20h-20v-20z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol484 || (_symbol484 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-select-all-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "select-all-small"), /*#__PURE__*/React.createElement("path", {
    d: "M7 2.5h2m2 0h2m2 0h2m-12 0H2.8s-.3 0-.3.3V5M19 2.5h2.2s.3 0 .3.3V5M7 21.5h2m2 0h2m2 0h2m-12 0H2.8s-.3 0-.3-.3V19M19 21.5h2.2s.3 0 .3-.3V19m-19-2v-2m0-2v-2m0-2V7m19 10v-2m0-2v-2m0-2V7m-15-.5h11v11h-11v-11z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol485 || (_symbol485 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-select-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "select-large"), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 25.5l8.2 8.2 14.5-19.3",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol486 || (_symbol486 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-select-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "select-small"), /*#__PURE__*/React.createElement("path", {
    d: "M6 12.2l4.3 4.2 8.1-10.3",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol487 || (_symbol487 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-send-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "send-large"), /*#__PURE__*/React.createElement("path", {
    d: "M17.798 36.562l-.014-13.202-11.31-8.86a1.993 1.993 0 0 1-.55-2.205A2.004 2.004 0 0 1 7.795 11h36.32L21.323 37.854c-1.204 1.419-3.523.569-3.525-1.292zM17.794 23l10.451-4.33m-14.753 6.112l-7.775 3.221m8.127 1.5l-6.404 2.65m1.001-10.15L4 23.843",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol488 || (_symbol488 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-send-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "send-small"), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 18.281l-.006-6.601-5.655-4.43a1.002 1.002 0 0 1 .66-1.75h18.16L10.263 18.927c-.602.709-1.761.284-1.762-.646zm-.001-6.78l5.226-2.166",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol489 || (_symbol489 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-send-to-vehicle-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "send-to-vehicle-large"), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 16.5v8a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1.045l15 .045v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-8l-2-2c-.66-1.212-1.19-2.136-1.59-2.773-.4-.636-.87-1.363-1.41-2.182a78.437 78.437 0 0 0-6.488-.272c-2.135 0-4.305.09-6.512.272-.54.819-1.01 1.546-1.41 2.182-.4.637-.93 1.56-1.59 2.773l-2 2zm6 2l1-1h9l1 1c-.636 2-1.136 3-1.5 3h-8c-.364 0-.864-1-1.5-3zm-4-4h19m-21 3H26m14 0h4.5M11.5 43v-1.1c0-3.5-2.9-6.4-6.4-6.4H4M19.5 43c0-8.6-6.6-15.5-15.5-15.5m13-5.3c-3.6-2.4-8.2-3.9-13-3.7M29.5 43c0-4.8-1.2-9.7-4-13.3",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol490 || (_symbol490 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-send-to-vehicle-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "send-to-vehicle-small"), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7.358v4.392c0 .414.336.75.75.75H13a.75.75 0 0 0 .75-.75v-.25h6.5v.25c0 .414.336.75.75.75h1.75a.75.75 0 0 0 .75-.75V7.358l-3-3.858h-7l-3 3.858zm0 1.142h3m7 0h3M3.5 21c0-2-1.6-3.5-3.5-3.5m8.5-8c-1.8-1.3-4-2-6.4-2H0M13.5 21v-2c0-1.6-.3-3.1-.9-4.5M8.5 21v-1c0-4.1-3.4-7.5-7.5-7.5H0",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol491 || (_symbol491 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-settings-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "settings-large"), /*#__PURE__*/React.createElement("path", {
    d: "M27.4 5.5V11c1.2.3 2.4.8 3.5 1.4l3.9-3.9 4.8 4.8-3.9 3.9c.6 1.1 1.1 2.2 1.4 3.5h5.5v6.7H37c-.3 1.2-.8 2.4-1.4 3.5l3.9 3.9-4.8 4.8-3.9-3.9c-1.1.6-2.2 1.1-3.5 1.4v5.5h-6.7V37c-1.2-.3-2.4-.8-3.5-1.4l-3.9 3.9-4.8-4.8 3.9-3.9c-.6-1.1-1.1-2.2-1.4-3.5H5.5v-6.7H11c.3-1.2.8-2.4 1.4-3.5l-3.9-3.9 4.8-4.8 3.9 3.9c1.1-.6 2.2-1.1 3.5-1.4V5.5h6.7zm-3.4 12c-3.6 0-6.5 2.9-6.5 6.5s2.9 6.5 6.5 6.5 6.5-2.9 6.5-6.5-2.9-6.5-6.5-6.5z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol492 || (_symbol492 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-settings-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "settings-small"), /*#__PURE__*/React.createElement("path", {
    d: "M13.1 2.5v2.7c.6.2 1.2.4 1.7.7L16.7 4 19 6.3l-1.9 1.9c.3.5.5 1.1.7 1.7h2.7v3.3h-2.7c-.2.6-.4 1.2-.7 1.7l1.9 1.9-2.3 2.2-1.9-1.9c-.5.3-1.1.5-1.7.7v2.7H9.9v-2.7c-.6-.2-1.2-.4-1.7-.7L6.3 19 4 16.7l1.9-1.9c-.3-.5-.5-1.1-.7-1.7H2.5V9.9h2.7c.2-.6.4-1.2.7-1.7L4 6.3 6.3 4l1.9 1.9c.5-.3 1.1-.5 1.7-.7V2.5h3.2zM11.5 8C9.6 8 8 9.6 8 11.5S9.6 15 11.5 15s3.5-1.6 3.5-3.5S13.4 8 11.5 8z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol493 || (_symbol493 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-share-android-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "share-android-large"), /*#__PURE__*/React.createElement("path", {
    d: "M31.884 34.17L13.11 25.828m-.005-3.652l18.768-8.34M36 40.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9zm0-24a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9zm-27 12a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol494 || (_symbol494 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-share-android-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "share-android-small"), /*#__PURE__*/React.createElement("path", {
    d: "M15.729 16.952l-8.457-3.903m-.012-2.092l8.473-3.91M18 8.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zm0 12a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zm-13-6a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol495 || (_symbol495 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-share-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "share-large"), /*#__PURE__*/React.createElement("path", {
    d: "M28 16.5h7.5v24h-24v-24H19M23.5 29V4.503M17 11l6.5-6.5L30 11",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol496 || (_symbol496 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-share-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "share-small"), /*#__PURE__*/React.createElement("path", {
    d: "M13.982 8.5H17.5v12h-12v-12H9m2.5 6.5V2.501M8 6l3.5-3.5L15 6",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol497 || (_symbol497 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-shopping-basket-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "shopping-basket-large"), /*#__PURE__*/React.createElement("path", {
    d: "M13.8 19.5h30m-33.2-8h35.9l-5.5 16H16.9m21.6 17a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM1 3.5h6.5l12.5 32",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol498 || (_symbol498 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-shopping-basket-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "shopping-basket-small"), /*#__PURE__*/React.createElement("path", {
    d: "M6.4 9.5h15.3M5 5.5h18l-2.5 8H7.9m11.6 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm-9 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM0 1.5h3.5l5.5 15",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol499 || (_symbol499 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-shuffle-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "shuffle-large"), /*#__PURE__*/React.createElement("path", {
    d: "M25.8 20.2s2.3-3.1 3.2-4.1c2.3-2.4 5.5-3.7 8.8-3.7h5.6M4 34.5h4.8c3.3 0 6.5-1.4 8.8-3.8.8-.9 3.1-4 3.1-4M38.2 7.3l5.2 5.2-5.2 5.2M4 12.5h5.1c3.4-.1 6.6 1.3 8.9 3.7 3 3.4 8.1 11 11.1 14.4 2.3 2.5 5.5 3.9 8.9 3.9h5.6m-5.3-5.2l5.2 5.1-5.2 5.2",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol500 || (_symbol500 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-shuffle-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "shuffle-small"), /*#__PURE__*/React.createElement("path", {
    d: "M13.3 9.7s1.3-1.6 1.8-2.1c1.4-1.4 3.3-2.2 5.3-2.1h2.9M0 18.5h2.8c2 .1 3.9-.7 5.2-2.1.4-.5 1.6-2.1 1.6-2.1M20.2 2.4l3.1 3.1-3.1 3.1M0 5.5h3.1c2-.1 3.9.7 5.3 2.2 1.8 2.1 4.8 6.6 6.6 8.6 1.4 1.5 3.3 2.3 5.3 2.2h3m-3.1-3.1l3.1 3.1-3.1 3.1",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol501 || (_symbol501 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-side-assist-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "side-assist-large"), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 44V31.848a2 2 0 0 1 1.31-1.877c.7-.257 1.263-.414 1.69-.471 1-.133 3.106-.12 4 0 .39.053.952.213 1.687.482A2 2 0 0 1 18.5 31.86V44m-8-5.5h5.955v-2a1 1 0 0 0-1-1H11.53a1 1 0 0 0-1 .985L10.5 38.5zm19.463-8.28A7.503 7.503 0 0 1 24.566 22m3.614 11.85C23.707 32.276 20.5 28.012 20.5 23c0-.337.014-.67.043-1M30.81 4.971c.7-.257 1.263-.414 1.69-.471 1-.133 3.106-.12 4 0 .39.053.952.213 1.687.482A2 2 0 0 1 39.5 6.86V23.5a2 2 0 0 1-2 2h-6a2 2 0 0 1-2-2V6.848a2 2 0 0 1 1.31-1.877zm.69 8.529h5.955v-2a1 1 0 0 0-1-1H32.53a1 1 0 0 0-1 .985L31.5 13.5zm0 6h5.955v2a1 1 0 0 1-1 1H32.53a1 1 0 0 1-1-.985L31.5 19.5z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol502 || (_symbol502 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-side-assist-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "side-assist-small"), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 23v-5.64a.5.5 0 0 1 .342-.474l.85-.283a2 2 0 0 1 .633-.103h1.138a2 2 0 0 1 .547.076l1.127.32a.5.5 0 0 1 .363.482V23m-4-2.5h3m7.87-4.781a9.024 9.024 0 0 1-3.949-4.99m2.595 7.675a12.022 12.022 0 0 1-5.679-7.567m7.505-8.951l.85-.283a2 2 0 0 1 .633-.103h1.138a2 2 0 0 1 .547.076l1.127.32a.5.5 0 0 1 .363.482v9.157a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1V2.36a.5.5 0 0 1 .342-.474zM16.5 5.5h3m-3 5h3",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol503 || (_symbol503 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-signal-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "signal-large"), /*#__PURE__*/React.createElement("path", {
    d: "M6 25.5c9.113 0 16.5 7.387 16.5 16.5M6 15.5c14.636 0 26.5 11.864 26.5 26.5M6 5.5c20.158 0 36.5 16.342 36.5 36.5m-30-2.5a4 4 0 1 1-8 0 4 4 0 0 1 8 0z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol504 || (_symbol504 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-signal-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "signal-small"), /*#__PURE__*/React.createElement("path", {
    d: "M4 11.5a8.5 8.5 0 0 1 8.5 8.5M4 6.5c7.456 0 13.5 6.044 13.5 13.5M4 1.5c10.217 0 18.5 8.283 18.5 18.5m-16-.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol505 || (_symbol505 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-skip-next-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "skip-next-large"), /*#__PURE__*/React.createElement("path", {
    d: "M38.5 39.5v-31 31zM9.5 9.2v29.5L31.1 24 9.5 9.2z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol506 || (_symbol506 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-skip-next-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "skip-next-small"), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 19V4v15zM5.5 4.4v14.2l10.4-7.2-10.4-7z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol507 || (_symbol507 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-skip-previous-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "skip-previous-large"), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 39.5v-31 31zm29-30.3L16.9 24l21.6 14.8V9.2z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol508 || (_symbol508 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-skip-previous-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "skip-previous-small"), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 19V4v15zm14-14.6l-10.4 7 10.4 7.2V4.4z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol509 || (_symbol509 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-slider-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "slider-large"), /*#__PURE__*/React.createElement("path", {
    d: "M19 35L8 24l11-11m10 0l11 11-11 11",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol510 || (_symbol510 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-slider-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "slider-small"), /*#__PURE__*/React.createElement("path", {
    d: "M9.485 17.439L4 11.996l5.48-5.435m5.035 0L20 12.004l-5.48 5.435",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol511 || (_symbol511 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-smartwatch-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "smartwatch-large"), /*#__PURE__*/React.createElement("path", {
    d: "M21.5.5h8v10h-11v-7a3 3 0 0 1 3-3zm5 47h-8v-10h11v7a3 3 0 0 1-3 3zm-9-37h13a4 4 0 0 1 4 4v19a4 4 0 0 1-4 4h-13a4 4 0 0 1-4-4v-19a4 4 0 0 1 4-4zm17 10h3V28h-3v-7.5z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol512 || (_symbol512 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-smartwatch-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "smartwatch-small"), /*#__PURE__*/React.createElement("path", {
    d: "M10.5.5h5v5h-7v-3a2 2 0 0 1 2-2zm3 23h-5v-5h7v3a2 2 0 0 1-2 2zm-5-18h7a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2zm11 5v3",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol513 || (_symbol513 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-smiley-happy-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "smiley-happy-large"), /*#__PURE__*/React.createElement("path", {
    d: "M34.4 30.4c-5.468 5.467-14.332 5.467-19.8 0m3.9-11.9a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm15 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zM24 2.5h-.1c-11.8.1-21.4 9.7-21.4 21.6.1 11.8 9.7 21.4 21.6 21.4 11.8-.1 21.4-9.7 21.4-21.6C45.4 12.1 35.8 2.5 24 2.5z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol514 || (_symbol514 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-smiley-happy-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "smiley-happy-small"), /*#__PURE__*/React.createElement("path", {
    d: "M16.45 14.45a7 7 0 0 1-9.9 0m4.95 8.05c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.925-11 11 4.925 11 11 11zM8 8.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm8 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol515 || (_symbol515 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-smiley-neutral-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "smiley-neutral-large"), /*#__PURE__*/React.createElement("path", {
    d: "M13 31.5h23m-17.5-13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm15 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zM24 2.5h-.1c-11.8.1-21.4 9.7-21.4 21.6.1 11.8 9.7 21.4 21.6 21.4 11.8-.1 21.4-9.7 21.4-21.6C45.4 12.1 35.8 2.5 24 2.5z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol516 || (_symbol516 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-smiley-neutral-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "smiley-neutral-small"), /*#__PURE__*/React.createElement("path", {
    d: "M6 14.5h11m-9-6a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm8 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm-4.5 14c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.925-11 11 4.925 11 11 11z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol517 || (_symbol517 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-smiley-unhappy-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "smiley-unhappy-large"), /*#__PURE__*/React.createElement("path", {
    d: "M34.4 34.6c-5.468-5.467-14.332-5.467-19.8 0m3.9-16.1a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm15 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zM24 2.5h-.1c-11.8.1-21.4 9.7-21.4 21.6.1 11.8 9.7 21.4 21.6 21.4 11.8-.1 21.4-9.7 21.4-21.6C45.4 12.1 35.8 2.5 24 2.5z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol518 || (_symbol518 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-smiley-unhappy-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "smiley-unhappy-small"), /*#__PURE__*/React.createElement("path", {
    d: "M6.55 16.5a7 7 0 0 1 9.9 0M8 8.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm8 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm-4.5 14c6.075 0 11-4.925 11-11s-4.925-11-11-11C5.423.5.5 5.425.5 11.5s4.924 11 11 11z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol519 || (_symbol519 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-snapchat-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "snapchat-large"), /*#__PURE__*/React.createElement("path", {
    d: "M39.97 32.051c-.098-.372-.413-.463-.74-.536-3.166-.708-5.052-2.85-6.306-5.676-.255-.575-.08-.978.45-1.326.41-.27.874-.417 1.339-.561.58-.181 1.14-.41 1.6-.819.665-.592.585-1.42-.182-1.875-.564-.335-1.156-.424-1.771-.13-.388.185-.793.324-1.224.34-.333.01-.558-.032-.521-.515.076-1 .18-2.004.129-2.849v-1.138c.004-2.913-1.352-5.077-3.729-6.633-1.73-1.133-3.683-1.42-5.715-1.311-1.874.1-3.598.643-5.057 1.842-1.589 1.306-2.685 2.923-2.904 5.035-.176 1.7-.058 3.397.053 5.092.026.398-.134.458-.425.478-.514.036-.993-.104-1.449-.324-.556-.27-1.088-.194-1.604.09-.807.446-.882 1.328-.179 1.928.448.38.974.603 1.523.779.393.126.784.25 1.152.442.771.403.967.87.594 1.666-1.303 2.772-3.227 4.84-6.358 5.513-.627.135-.817.622-.485 1.17.209.342.539.541.885.71.842.407 1.744.642 2.661.75.54.064.7.316.8.78.32 1.504.426 1.548 1.927 1.26 1.718-.328 3.349-.195 4.767.984.327.272.693.502 1.055.729 2.492 1.558 4.993 1.564 7.486.006.624-.39 1.22-.827 1.835-1.235.605-.402 1.28-.57 2.002-.613.908-.053 1.794.072 2.681.235.599.11.929-.102 1.09-.684.093-.34.16-.687.242-1.03.052-.215.15-.344.406-.384.595-.093 1.189-.21 1.77-.365.669-.177 1.33-.397 1.858-.877.273-.249.446-.56.344-.948",
    fill: "currentColor"
  }))), _symbol520 || (_symbol520 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-snapchat-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "snapchat-small"), /*#__PURE__*/React.createElement("path", {
    d: "M19.853 15.86c-1.632-.366-2.605-1.47-3.252-2.927-.131-.297-.04-.505.232-.684.211-.14.451-.215.69-.29.3-.093.588-.21.826-.421.343-.306.302-.733-.094-.967-.29-.173-.596-.22-.913-.068-.2.096-.409.168-.631.175-.172.006-.288-.016-.27-.265.04-.516.094-1.033.068-1.469v-.587c.002-1.501-.698-2.617-1.923-3.42-.892-.584-1.9-.732-2.947-.676-.966.052-1.855.332-2.608.95-.819.673-1.384 1.507-1.497 2.596-.09.877-.03 1.752.028 2.626.013.205-.07.236-.22.246a1.466 1.466 0 0 1-.747-.167c-.286-.139-.56-.1-.827.047-.416.23-.455.685-.092.994.23.196.502.31.785.401.203.066.405.13.594.228.398.208.499.45.306.86-.671 1.429-1.663 2.495-3.278 2.842-.323.07-.421.32-.25.603.108.177.278.28.457.366.433.21.899.331 1.371.387.278.033.362.163.413.403.165.775.22.797.993.65.886-.17 1.727-.102 2.458.506.17.14.358.26.544.376 1.286.804 2.575.807 3.86.003.322-.201.63-.426.946-.636.313-.208.66-.295 1.033-.316.468-.028.925.037 1.383.12.308.058.478-.052.561-.352.048-.175.083-.354.125-.531.027-.11.078-.177.21-.198.306-.048.612-.108.912-.188.345-.092.686-.205.958-.453.141-.128.23-.288.178-.488-.05-.192-.213-.24-.382-.277z",
    fill: "currentColor"
  }))), _symbol521 || (_symbol521 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-social-reader-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "social-reader-large"), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 17.5h13.682m15.636 6H45.5m-29.318 10h15.636m-15.636 12v-43m15.636 43v-43M2.5 2.5h43v43h-43v-43z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol522 || (_symbol522 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-social-reader-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "social-reader-small"), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 4.5h15v15h-15v-15zm0 5.77h4.615H4.5zm10.385 2.307H19.5h-4.615zm-5.77 3.461h5.77-5.77zm0 3.462v-15 15zm5.77 0v-15 15z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol523 || (_symbol523 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-spark-plug-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "spark-plug-large"), /*#__PURE__*/React.createElement("path", {
    d: "M25.5 43.5h-4a2 2 0 0 1-2-2v-7m6 9a2 2 0 0 0 2-2v-7m-2 9v3a1 1 0 0 1-1 1h-2m-3-24.5V9.5c0-2 1-4 2-4h4c1 0 2 2 2 4V23m-9 .5v6m10-6v6m-1 8h-8m8 3h-8m-2-11v5h12v-5m-7-24v-5h2v5m-9 24v-6h16v6h-16z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol524 || (_symbol524 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-spark-plug-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "spark-plug-small"), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 21.5h-2a1 1 0 0 1-1-1v-3m3 4a1 1 0 0 0 1-1v-3m-1 4v1a1 1 0 0 1-1 1H11m-1.5-12v-7c0-1 .5-2 1-2h2c.5 0 1 1 1 2v7m-5 3v3h6v-3M11.5 0v2.5m-4 12v-3h8v3h-8z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol525 || (_symbol525 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-split-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "split-large"), /*#__PURE__*/React.createElement("path", {
    d: "M10 24h9.5m0 0l7.807-11.277A3.991 3.991 0 0 1 30.591 11H45.5m-26 13l7.807 11.277A4 4 0 0 0 30.596 37H45.5M5 26.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zM40.25 5.75L45.5 11l-5.25 5.25m0 15.5L45.5 37l-5.25 5.25",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol526 || (_symbol526 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-split-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "split-small"), /*#__PURE__*/React.createElement("path", {
    d: "M6 12h4m0 0l3.307-4.777A4 4 0 0 1 16.596 5.5H22.5M10 12l3.307 4.777a4 4 0 0 0 3.289 1.723H22.5M19.5 2L23 5.5 19.5 9m0 6l3.5 3.5-3.5 3.5M3 13.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol527 || (_symbol527 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-status-update-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "status-update-large"), /*#__PURE__*/React.createElement("path", {
    d: "M39.5 33.5h-11v11m2.5-29h8.5v18l-11 11h-20v-29H23M30.7 9l-7 12m8.8-11.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol528 || (_symbol528 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-status-update-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "status-update-small"), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 17.5h-6v6m1.5-16h4.5v10l-6 6h-11v-16H11m4.5-3.3l-3 5.2m4-4.9a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol529 || (_symbol529 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-sync-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "sync-large"), /*#__PURE__*/React.createElement("path", {
    d: "M7 32.5h26c6.4 0 11.5-5.1 11.5-11.5v-1M11.8 37.1L7 32.5l4.8-4.6M41 14.5H15C8.6 14.5 3.5 19.6 3.5 26v1M36.2 9.9l4.8 4.6-4.8 4.6",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol530 || (_symbol530 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-sync-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "sync-small"), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 17.5h13.3c3.2 0 5.8-2.7 5.7-5.9V11M5.7 15.3l-2.2 2.2 2.2 2.2M20.5 7.5H7.2c-3.2 0-5.8 2.7-5.7 5.9v.6m16.8-4.3l2.2-2.2-2.2-2.2",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol531 || (_symbol531 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-system-add-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-add-large"), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 17v13m6.5-6.5H17m6.5 22c12.15 0 22-9.85 22-22s-9.85-22-22-22-22 9.85-22 22 9.85 22 22 22z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol532 || (_symbol532 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-system-add-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-add-small"), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 7v9m4.5-4.6H7m4.5 11.1c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.925-11 11 4.925 11 11 11z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol533 || (_symbol533 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-system-audio-off-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-audio-off-large"), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 20.5h4v6h-4v-6zm4 6l4 2.9V17.6l-4 2.9m7.5-.6c1.9 2 1.9 5.1 0 7.1m2.5-9.7s6.7 5.9 0 12.3M14 32.1L27.9 14 14 32.1zm9.5 13.4c12.15 0 22-9.85 22-22s-9.85-22-22-22-22 9.85-22 22 9.85 22 22 22z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol534 || (_symbol534 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-system-audio-off-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-audio-off-small"), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 22.5c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.925-11 11 4.925 11 11 11zm-6-13h3v4h-3v-4zm3 4l3 1.9V7.5l-3 2m5.6.5c.5.8.8 2.2-.9 3.9m2.7-6.1c1 1.1 3.2 4.4-.4 7.8m2.3-13.1L3.7 19.3 17.8 2.5z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol535 || (_symbol535 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-system-audio-on-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-audio-on-large"), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 20.5h4v6h-4v-6zm4 6l4 2.9V17.6l-4 2.9m7.5-.6c1.9 2 1.9 5.1 0 7.1m2.5-9.7s6.7 5.9 0 12.3m-5 15.9c12.15 0 22-9.85 22-22s-9.85-22-22-22-22 9.85-22 22 9.85 22 22 22z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol536 || (_symbol536 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-system-audio-on-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-audio-on-small"), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 9.5h3v4h-3v-4zm3 4l3 1.9V7.5l-3 2m4.7-.4s3 1.8 0 4.8m2.3-6.5s4.5 3.9 0 8.3m-4 6.8c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.925-11 11 4.925 11 11 11z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol537 || (_symbol537 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-system-cancel-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-cancel-large"), /*#__PURE__*/React.createElement("path", {
    d: "M28.7 18.2L18.2 28.7m10.6.1L18.3 18.2m5.2 27.3c12.15 0 22-9.85 22-22s-9.85-22-22-22-22 9.85-22 22 9.85 22 22 22z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol538 || (_symbol538 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-system-cancel-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-cancel-small"), /*#__PURE__*/React.createElement("path", {
    d: "M14.7 8.2l-6.5 6.5m6.5 0L8.2 8.2m3.3 14.3c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.925-11 11 4.925 11 11 11z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol539 || (_symbol539 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-system-code-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-code-large"), /*#__PURE__*/React.createElement("path", {
    d: "M31.5 31.5h3v3h-3v-3zm-6 0h3v3h-3v-3zm6-6h3v3h-3v-3zm-6 0h3v3h-3v-3zm-10 2h5v5h-5v-5zm-2-2h9v9h-9v-9zm14-10h5v5h-5v-5zm-2-2h9v9h-9v-9zm-10 2h5v5h-5v-5zm-2-2h9v9h-9v-9zm10 32c12.15 0 22-9.85 22-22s-9.85-22-22-22-22 9.85-22 22 9.85 22 22 22z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol540 || (_symbol540 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-system-code-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-code-small"), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 15.5h1v1h-1v-1zm-3 0h1v1h-1v-1zm3-3h1v1h-1v-1zm-3 0h1v1h-1v-1zm-6 0h4v4h-4v-4zm6-6h4v4h-4v-4zm-6 0h4v4h-4v-4zm5 16c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.925-11 11 4.925 11 11 11z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol541 || (_symbol541 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-system-compare-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-compare-large"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5 45.5c12.15 0 22-9.85 22-22s-9.85-22-22-22-22 9.85-22 22 9.85 22 22 22zm0-36.5v29",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.822 17.5c2.842 0 4.326.98 4.326 2.828 0 1.162-.616 1.806-1.638 2.142 1.358.35 2.142 1.064 2.142 2.338 0 1.848-1.484 2.828-4.326 2.828H28V17.5h3.822zm-16.518 0l5.068 10.136h-1.61l-1.26-2.506h-6.104l-1.246 2.506H8.57L13.638 17.5h1.666zm16.714 5.628h-2.576v3.346h2.576c2.058 0 3.15-.364 3.15-1.666s-1.092-1.68-3.15-1.68zM14.45 18.83l-2.534 5.124h5.068L14.45 18.83zm17.064-.168h-2.072v3.346h2.072c2.058 0 3.15-.378 3.15-1.68s-1.092-1.666-3.15-1.666z",
    fill: "currentColor",
    fillRule: "nonzero"
  })))), _symbol542 || (_symbol542 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-system-compare-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-compare-small"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 22.5c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.925-11 11 4.925 11 11 11zm0-18.5v15",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.262 8.5c1.683 0 2.561.58 2.561 1.674 0 .688-.364 1.07-.97 1.268.804.207 1.269.63 1.269 1.384 0 1.094-.879 1.674-2.561 1.674H14v-6h2.262zm-9.276 0l3 6h-.953l-.746-1.483H4.674L3.936 14.5H3l3-6h.986zm9.392 3.331h-1.524v1.981h1.524c1.219 0 1.865-.215 1.865-.986 0-.77-.646-.995-1.865-.995zM6.481 9.287l-1.5 3.033h3l-1.5-3.033zm9.6-.1h-1.227v1.982h1.226c1.218 0 1.865-.224 1.865-.995 0-.77-.647-.986-1.865-.986z",
    fill: "currentColor",
    fillRule: "nonzero"
  })))), _symbol543 || (_symbol543 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-system-download-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-download-large"), /*#__PURE__*/React.createElement("path", {
    d: "M17 30.5h13M23.5 16v11m4.4-4.4L23.5 27l-4.4-4.4m4.4 22.9c12.15 0 22-9.85 22-22s-9.85-22-22-22-22 9.85-22 22 9.85 22 22 22z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol544 || (_symbol544 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-system-download-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-download-small"), /*#__PURE__*/React.createElement("path", {
    d: "M15 15.5H8M11.5 7v6.4m-3.2-3.2l3.2 3.2 3.2-3.2m-3.2 12.3c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.925-11 11 4.925 11 11 11z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol545 || (_symbol545 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-system-facebook-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-facebook-large"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1 20.6h-4.9V25h4.9v13h5.8V25h5.8v-4.3h-5.8V19c0-1.3 1.4-4 3.4-4h2.4v-4.3h-5.1c-7.1.8-6.5 9.9-6.5 9.9z",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    cx: 23.5,
    cy: 23.5,
    r: 22
  })))), _symbol546 || (_symbol546 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-system-facebook-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-facebook-small"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.2 10.1H7v2h2.2V18h2.6v-5.9h2.6v-2h-2.6v-.8c0-.6.6-1.8 1.5-1.8h1.1v-2h-2.3c-3.1.4-2.9 4.6-2.9 4.6z",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    cx: 11.5,
    cy: 11.5,
    r: 11
  })))), _symbol547 || (_symbol547 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-system-favorites-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-favorites-large"), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 15.3l2.3 4.7 5.2.8-3.8 3.7.9 5.2-4.7-2.5-4.7 2.5.9-5.2-3.8-3.7L21 20l2.5-4.7zm0 30.2c12.15 0 22-9.85 22-22s-9.85-22-22-22-22 9.85-22 22 9.85 22 22 22z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol548 || (_symbol548 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-system-favorites-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-favorites-small"), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 5.7l1.7 3.5 3.9.6-2.8 2.7.7 3.8-3.4-1.8-3.4 1.8.7-3.8-3-2.8 3.9-.6 1.7-3.4zm0 16.8c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.925-11 11 4.925 11 11 11z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol549 || (_symbol549 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-system-follow-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-follow-large"), /*#__PURE__*/React.createElement("path", {
    d: "M21.4 25.6L16 31l5.4-5.4zm9.9-4.2l-.7.7-2.5-.3-1.4 1.4-.9 3.7-1.5 1.5-5.7-5.7 1.5-1.5 3.7-.9 1.4-1.4-.3-2.5.7-.7 5.7 5.7zm-7.8 24.1c12.15 0 22-9.85 22-22s-9.85-22-22-22-22 9.85-22 22 9.85 22 22 22z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol550 || (_symbol550 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-system-follow-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-follow-small"), /*#__PURE__*/React.createElement("path", {
    d: "M10.3 12.7l-3.1 3.1 3.1-3.1zm-2.5-2.5l.8-.7h2.3L13.4 7 16 9.6l-2.5 2.5v2.3l-.7.8-5-5zm3.7 12.3c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.925-11 11 4.925 11 11 11z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol551 || (_symbol551 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-system-google-plus-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-google-plus-large"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.6 19.4h2.7v2.7H39v2.7h-2.7v2.7h-2.7v-2.7h-2.7v-2.7h2.7v-2.7zM9.1 23c.1-4.9 4.6-9.2 9.5-9 2.3-.1 4.5.9 6.3 2.3-.8.9-1.6 1.7-2.4 2.5-2.2-1.5-5.2-1.9-7.4-.2-3.1 2.1-3.2 7.2-.3 9.5 2.9 2.6 8.3 1.3 9.1-2.7-1.8 0-3.6 0-5.4-.1v-3.2h9.1c.2 2.5-.2 5.2-1.7 7.3-2.4 3.3-7.1 4.3-10.8 2.9-3.7-1.4-6.3-5.3-6-9.3z",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    cx: 23.5,
    cy: 23.5,
    r: 22
  })))), _symbol552 || (_symbol552 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-system-google-plus-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-google-plus-small"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1 9.6h1.3v1.3h1.3v1.3h-1.3v1.3h-1.3v-1.3h-1.3v-1.3h1.3V9.6zM4.5 11.3C4.6 9 6.7 6.9 9 7c1.1-.1 2.2.4 3 1.1-.4.4-.7.8-1.1 1.2-1-.7-2.5-.9-3.5-.1-1.5 1-1.5 3.4-.1 4.5 1.4 1.2 4 .6 4.3-1.3H9v-1.5h4.3c.1 1.2-.1 2.5-.8 3.5-1.1 1.6-3.4 2-5.1 1.4-1.8-.8-3-2.6-2.9-4.5z",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    cx: 11.5,
    cy: 11.5,
    r: 11
  })))), _symbol553 || (_symbol553 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-system-help-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-help-large"), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 29v2M20 17.4s5.9-2.4 6.7 1.5c.5 2.7-4.2 6.1-4.2 6.1v2m1 18.5c12.15 0 22-9.85 22-22s-9.85-22-22-22-22 9.85-22 22 9.85 22 22 22z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol554 || (_symbol554 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-system-help-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-help-small"), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 15v1M9.9 7.5s4.1-1.6 4.6 1c.4 1.9-3 4.2-3 4.2V14m0 8.5c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.925-11 11 4.925 11 11 11z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol555 || (_symbol555 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-system-info-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-info-large"), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 20v12m0-14v-3m0 30.5c12.15 0 22-9.85 22-22s-9.85-22-22-22-22 9.85-22 22 9.85 22 22 22z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol556 || (_symbol556 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-system-info-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-info-small"), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 17v-7m0-2V6m0 16.5c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.925-11 11 4.925 11 11 11z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol557 || (_symbol557 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-system-instagram-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-instagram-large"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.646 12c2.101.004 2.538.021 3.595.07 1.224.055 2.06.25 2.792.534a5.637 5.637 0 0 1 2.037 1.326c.64.64 1.032 1.28 1.326 2.037.285.732.479 1.568.535 2.792.056 1.226.069 1.618.069 4.741 0 3.123-.013 3.515-.07 4.741-.055 1.224-.25 2.06-.534 2.792a5.638 5.638 0 0 1-1.326 2.037 5.638 5.638 0 0 1-2.037 1.326c-.732.285-1.568.479-2.792.535-1.226.056-1.618.069-4.741.069-3.123 0-3.515-.013-4.741-.07-1.224-.055-2.06-.25-2.792-.534a5.638 5.638 0 0 1-2.037-1.326 5.637 5.637 0 0 1-1.326-2.037c-.285-.732-.479-1.568-.535-2.792-.048-1.057-.065-1.494-.068-3.595v-2.292c.003-2.101.02-2.538.068-3.595.056-1.224.25-2.06.535-2.792a5.637 5.637 0 0 1 1.326-2.037 5.637 5.637 0 0 1 2.037-1.326c.732-.285 1.568-.479 2.792-.535 1.057-.048 1.494-.065 3.595-.068zm-.02 2.073h-2.251c-2.062.003-2.477.018-3.522.066-1.121.051-1.73.239-2.135.396-.537.209-.92.458-1.323.86a3.563 3.563 0 0 0-.86 1.323c-.157.405-.345 1.014-.396 2.135-.048 1.045-.063 1.46-.066 3.522v2.25c.003 2.062.018 2.477.066 3.522.051 1.121.239 1.73.396 2.135.209.537.458.92.86 1.323.403.402.786.651 1.323.86.405.157 1.014.345 2.135.396 1.045.048 1.46.063 3.521.066h2.252c2.061-.003 2.476-.018 3.521-.066 1.121-.051 1.73-.239 2.135-.396.537-.209.92-.458 1.323-.86.402-.403.651-.786.86-1.323.157-.405.345-1.014.396-2.135.048-1.045.063-1.46.066-3.522v-2.25c-.003-2.062-.018-2.477-.066-3.522-.051-1.121-.239-1.73-.396-2.135a3.563 3.563 0 0 0-.86-1.323 3.563 3.563 0 0 0-1.323-.86c-.405-.157-1.014-.345-2.135-.396-1.045-.048-1.46-.063-3.522-.066zM23.5 17.595a5.905 5.905 0 1 1 0 11.81 5.905 5.905 0 0 1 0-11.81zm0 2.072a3.833 3.833 0 1 0 0 7.666 3.833 3.833 0 0 0 0-7.666zm6.139-3.686a1.38 1.38 0 1 1 0 2.76 1.38 1.38 0 0 1 0-2.76z",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    cx: 23.5,
    cy: 23.5,
    r: 22
  })))), _symbol558 || (_symbol558 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-system-instagram-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-instagram-small"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.146 6c.921.003 1.133.01 1.622.033.585.027.985.12 1.335.256.361.14.668.328.974.634.306.306.494.613.634.974.136.35.23.75.256 1.335.027.587.033.774.033 2.268 0 1.494-.006 1.681-.033 2.268-.027.585-.12.985-.256 1.335-.14.361-.328.668-.634.974a2.696 2.696 0 0 1-.974.634c-.35.136-.75.23-1.335.256-.587.027-.774.033-2.268.033-1.494 0-1.681-.006-2.268-.033-.585-.027-.985-.12-1.335-.256a2.696 2.696 0 0 1-.974-.634 2.696 2.696 0 0 1-.634-.974c-.136-.35-.23-.75-.256-1.335-.022-.49-.03-.7-.032-1.622v-1.292c.002-.921.01-1.133.032-1.622.027-.585.12-.985.256-1.335.14-.361.328-.668.634-.974.306-.306.613-.494.974-.634.35-.136.75-.23 1.335-.256.49-.022.7-.03 1.622-.032zm-.646.991c-1.469 0-1.643.006-2.222.032-.537.025-.828.114-1.022.19-.256.1-.44.218-.632.41a1.704 1.704 0 0 0-.412.633c-.075.194-.164.485-.189 1.022-.026.58-.032.753-.032 2.222 0 1.469.006 1.643.032 2.222.025.537.114.828.19 1.022.1.256.218.44.41.632.193.193.377.312.633.412.194.075.485.164 1.022.189.58.026.753.032 2.222.032 1.469 0 1.643-.006 2.222-.032.537-.025.828-.114 1.022-.19.256-.1.44-.218.632-.41.193-.193.312-.377.412-.633.075-.194.164-.485.189-1.022.026-.58.032-.753.032-2.222 0-1.469-.006-1.643-.032-2.222-.025-.537-.114-.828-.19-1.022-.1-.256-.218-.44-.41-.632a1.704 1.704 0 0 0-.633-.412c-.194-.075-.485-.164-1.022-.189-.58-.026-.753-.032-2.222-.032zm0 1.685a2.824 2.824 0 1 1 0 5.648 2.824 2.824 0 0 1 0-5.648zm0 .99a1.833 1.833 0 1 0 0 3.667 1.833 1.833 0 0 0 0-3.666zm2.936-1.762a.66.66 0 1 1 0 1.32.66.66 0 0 1 0-1.32z",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    cx: 11.5,
    cy: 11.5,
    r: 11
  })))), _symbol559 || (_symbol559 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-system-line-me-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-line-me-large"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    cx: 23.5,
    cy: 23.5,
    r: 22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.247 19.87c0 .15-.123.272-.276.272h-2.706v1.028h2.706c.153 0 .276.122.276.273v.98c0 .15-.123.272-.276.272h-2.706v1.029h2.706c.153 0 .276.122.276.272v.98c0 .15-.123.272-.276.272h-3.979a.275.275 0 0 1-.277-.272V18.89c0-.073.03-.139.077-.187a.283.283 0 0 1 .2-.085h3.979c.153 0 .276.122.276.272v.98zm-5.5 5.107c0 .15-.124.271-.276.271h-.996a.276.276 0 0 1-.071-.01l-.023-.006-.022-.009a.35.35 0 0 1-.02-.01l-.018-.01a.277.277 0 0 1-.073-.07l-2.839-3.772v3.616c0 .15-.124.271-.277.271h-.996a.274.274 0 0 1-.276-.271v-6.088c0-.15.124-.272.276-.272h.996l.024.001.026.004.026.006.025.008a.313.313 0 0 1 .048.024l.022.015a.194.194 0 0 1 .036.034c.01.01.017.02.024.029l2.835 3.768v-3.617c0-.15.124-.272.277-.272h.996c.152 0 .276.122.276.272v6.088zm-6.856 0c0 .15-.124.271-.276.271h-.996a.274.274 0 0 1-.277-.271v-6.088c0-.15.124-.272.277-.272h.996c.152 0 .276.122.276.272v6.088zm-2.4-.001c0 .15-.124.272-.277.272h-3.98a.277.277 0 0 1-.276-.272V18.89c0-.15.124-.272.277-.272h.996c.153 0 .276.122.276.272v4.835h2.707c.153 0 .276.122.276.272v.98zM23.5 10.3c-7.83 0-14.2 5.086-14.2 11.338 0 5.605 5.052 10.299 11.876 11.186.462.099 1.092.3 1.25.69.144.353.094.906.047 1.263l-.203 1.196c-.062.353-.285 1.381 1.23.753 1.516-.628 8.178-4.738 11.157-8.112 2.057-2.22 3.043-4.474 3.043-6.976 0-6.252-6.37-11.338-14.2-11.338z",
    fill: "currentColor",
    fillRule: "nonzero"
  })))), _symbol560 || (_symbol560 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-system-line-me-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-line-me-small"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    cx: 11.5,
    cy: 11.5,
    r: 11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.648 10.054c0 .08-.065.144-.146.144h-1.43v.543h1.43c.08 0 .146.065.146.144v.518c0 .08-.065.144-.146.144h-1.43v.543h1.43c.08 0 .146.064.146.144v.518c0 .079-.065.143-.146.143h-2.101a.147.147 0 0 1-.105-.044.141.141 0 0 1-.041-.1V9.538c0-.039.015-.074.04-.1l.003-.002.001-.002a.147.147 0 0 1 .101-.04h2.102c.08 0 .146.064.146.144v.517zm-2.905 2.698c0 .079-.065.143-.146.143h-.526a.146.146 0 0 1-.037-.005h-.002l-.01-.003-.005-.002-.007-.003a.055.055 0 0 1-.007-.003.072.072 0 0 1-.004-.003l-.009-.005-.002-.001a.142.142 0 0 1-.037-.035l-1.5-1.993v1.91c0 .079-.065.143-.145.143h-.526a.145.145 0 0 1-.146-.143V9.536c0-.079.065-.143.146-.143h.531a.156.156 0 0 1 .03.004l.005.001a.11.11 0 0 1 .009.003l.004.002a.09.09 0 0 1 .013.006c.003 0 .005.002.008.004l.004.002a.12.12 0 0 1 .008.006l.004.002a.102.102 0 0 1 .008.007l.002.002a.126.126 0 0 1 .009.01h.001l.011.015 1.498 1.99v-1.91c0-.08.065-.144.146-.144h.526c.08 0 .146.064.146.143v3.216zm-3.62 0c0 .079-.066.143-.147.143H9.45a.145.145 0 0 1-.146-.143V9.536c0-.079.065-.143.146-.143h.526c.08 0 .146.064.146.143v3.216zm-1.27 0c0 .079-.064.143-.145.143H6.606a.146.146 0 0 1-.1-.04l-.003-.002-.002-.002a.142.142 0 0 1-.04-.1V9.536c0-.079.065-.143.145-.143h.527c.08 0 .146.064.146.143v2.554h1.429c.08 0 .146.064.146.144v.517zM19 10.988C19 7.686 15.636 5 11.5 5 7.365 5 4 7.686 4 10.989c0 2.96 2.668 5.439 6.272 5.908.245.052.577.158.661.364.076.186.05.478.024.667l-.107.632c-.032.186-.15.73.65.397.8-.331 4.32-2.502 5.893-4.284C18.478 13.5 19 12.31 19 10.989z",
    fill: "currentColor",
    fillRule: "nonzero"
  })))), _symbol561 || (_symbol561 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-system-linkedin-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-linkedin-large"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.3 12H13.7c-.9 0-1.7.7-1.7 1.7v19.7c0 .9.8 1.7 1.7 1.7h19.6c.9 0 1.7-.7 1.7-1.7V13.7c0-1-.8-1.7-1.7-1.7zM18.8 31.6h-3.4v-11h3.4v11zm-1.7-12.5c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm14.5 12.5h-3.4v-5.3c0-1.3 0-2.9-1.8-2.9s-2 1.4-2 2.8v5.4H21v-11h3.3v1.5c.5-.9 1.6-1.8 3.2-1.8 3.5 0 4.1 2.3 4.1 5.2v6.1z",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    cx: 23.5,
    cy: 23.5,
    r: 22
  })))), _symbol562 || (_symbol562 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-system-linkedin-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-linkedin-small"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2 6H6.8c-.4 0-.8.3-.8.8v9.4c0 .4.4.8.8.8h9.4c.4 0 .8-.4.8-.8V6.8c0-.5-.4-.8-.8-.8zm-6.9 9.4H7.6v-5.2h1.6l.1 5.2zm-.9-6c-.5 0-.9-.4-.9-.9s.4-.9.9-.9.9.4.9.9-.3.9-.9.9zm7 6h-1.6v-2.6c0-.6 0-1.4-.8-1.4s-1 .7-1 1.3v2.6h-1.6v-5.2H12v.7c.2-.4.8-.8 1.5-.8 1.7 0 2 1.1 2 2.5-.1 0-.1 2.9-.1 2.9z",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    cx: 11.5,
    cy: 11.5,
    r: 11
  })))), _symbol563 || (_symbol563 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-system-paragraph-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-paragraph-large"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    cx: 23.5,
    cy: 23.5,
    r: 22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.273 30a7.072 7.072 0 0 1-1.642-.192 5.46 5.46 0 0 1-1.384-.512v-.91a6.654 6.654 0 0 0 3.057.75c.618 0 1.119-.053 1.503-.16.385-.107.663-.258.835-.452.172-.194.258-.428.258-.702 0-.279-.066-.51-.2-.692-.132-.182-.388-.361-.766-.537-.378-.176-.952-.38-1.724-.612-.972-.29-1.705-.567-2.197-.831-.493-.265-.826-.546-1.001-.845-.175-.298-.262-.673-.262-1.124 0-.464.148-.904.444-1.321.296-.417.612-.73.948-.938a2.245 2.245 0 0 1-.686-.69c-.16-.263-.24-.598-.24-1.007 0-.438.125-.824.377-1.158.251-.333.634-.595 1.149-.784.515-.189 1.153-.283 1.914-.283.506 0 1.024.059 1.554.176.53.117.995.266 1.394.446v.915a9.175 9.175 0 0 0-1.453-.485 6.32 6.32 0 0 0-1.51-.188c-.556 0-1.012.054-1.37.162-.356.108-.618.26-.783.454a1.04 1.04 0 0 0-.248.698c0 .279.066.51.199.692.133.182.389.362.768.54.38.177.954.38 1.723.61.972.289 1.704.566 2.197.83.492.265.826.546 1 .845.175.298.263.673.263 1.124 0 .464-.148.904-.444 1.321-.296.417-.612.73-.948.938.307.204.539.438.694.704.155.266.232.597.232.993 0 .44-.129.828-.387 1.162-.258.333-.66.594-1.204.781-.545.188-1.231.282-2.06.282zm3.092-6.146c0-.308-.069-.559-.207-.753-.138-.194-.394-.378-.768-.551-.374-.173-.946-.375-1.715-.604-.43-.13-.79-.246-1.083-.348a6.721 6.721 0 0 1-.696-.278 3.18 3.18 0 0 0-.826.91c-.197.334-.296.64-.296.916 0 .308.07.559.208.753.138.194.394.378.768.551.374.173.945.375 1.714.604.402.12.749.231 1.042.334.293.103.54.2.737.292a3.18 3.18 0 0 0 .827-.91c.197-.334.295-.64.295-.916z",
    fill: "currentColor",
    fillRule: "nonzero"
  })))), _symbol564 || (_symbol564 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-system-paragraph-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-paragraph-small"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    cx: 11.5,
    cy: 11.5,
    r: 11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.278 17.8a6.881 6.881 0 0 1-1.598-.186 5.313 5.313 0 0 1-1.347-.499v-.886a6.474 6.474 0 0 0 2.975.73c.601 0 1.089-.052 1.463-.156.374-.104.645-.25.812-.44a.994.994 0 0 0 .251-.682c0-.272-.064-.496-.194-.674-.129-.177-.377-.351-.745-.523-.368-.17-.927-.37-1.678-.595-.946-.282-1.659-.551-2.138-.808-.48-.258-.804-.532-.974-.822-.17-.29-.255-.655-.255-1.094 0-.452.144-.88.432-1.286.288-.406.595-.71.922-.913a2.185 2.185 0 0 1-.667-.672c-.156-.254-.234-.581-.234-.98 0-.425.122-.8.367-1.125.245-.325.617-.58 1.118-.763.501-.184 1.122-.276 1.863-.276.492 0 .996.057 1.512.171.516.114.968.259 1.356.434v.89a8.928 8.928 0 0 0-1.413-.472 6.15 6.15 0 0 0-1.47-.182c-.54 0-.985.052-1.332.158-.348.105-.602.252-.763.441a1.012 1.012 0 0 0-.241.68c0 .27.064.495.194.673.129.177.378.352.747.525.37.172.928.37 1.676.593.946.282 1.659.551 2.138.808.48.258.804.532.974.822.17.29.255.655.255 1.094 0 .452-.144.88-.432 1.286-.288.406-.595.71-.922.913.299.198.524.426.675.685.15.259.226.58.226.966 0 .429-.125.806-.376 1.13-.251.325-.642.578-1.172.761-.53.183-1.199.274-2.005.274zm3.01-5.98c0-.3-.068-.544-.202-.733-.135-.189-.384-.368-.748-.536-.364-.17-.92-.365-1.668-.588-.419-.127-.77-.24-1.054-.339a6.54 6.54 0 0 1-.677-.27 3.094 3.094 0 0 0-.805.885c-.191.325-.287.623-.287.892 0 .299.067.543.201.732.135.189.384.368.748.536.364.17.92.365 1.668.588.39.117.729.225 1.014.326.286.1.525.194.717.283.345-.264.613-.559.805-.885.191-.325.287-.623.287-.892z",
    fill: "currentColor",
    fillRule: "nonzero"
  })))), _symbol565 || (_symbol565 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-system-pause-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-pause-large"), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 16v15m6-15v15m-3 14.5c12.15 0 22-9.85 22-22s-9.85-22-22-22-22 9.85-22 22 9.85 22 22 22z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol566 || (_symbol566 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-system-pause-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-pause-small"), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 7v9m4-9v9m-2 6.5c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.925-11 11 4.925 11 11 11z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol567 || (_symbol567 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-system-pinterest-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-pinterest-large"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.2 9c-7.9 0-11.9 5.7-11.9 10.4 0 2.9 1.1 5.4 3.4 6.4.4.2.7 0 .8-.4.1-.3.3-1 .3-1.3.1-.4.1-.6-.2-.9-.7-.8-1.1-1.8-1.1-3.3 0-4.2 3.2-8 8.2-8 4.5 0 6.9 2.7 6.9 6.4 0 4.8-2.1 8.9-5.3 8.9-1.7 0-3-1.4-2.6-3.2.5-2.1 1.5-4.4 1.5-5.9 0-1.4-.7-2.5-2.2-2.5-1.8 0-3.2 1.8-3.2 4.3 0 1.6.5 2.6.5 2.6l-2.1 9.1c-.6 2.7-.1 6 0 6.3 0 .2.3.2.4.1.2-.2 2.3-2.8 3-5.5.2-.7 1.2-4.6 1.2-4.6.6 1.1 2.3 2.1 4.1 2.1 5.4 0 9-4.9 9-11.4-.2-5-4.4-9.6-10.7-9.6z",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    cx: 23.5,
    cy: 23.5,
    r: 22
  })))), _symbol568 || (_symbol568 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-system-pinterest-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-pinterest-small"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8 5C8.3 5 6.5 7.5 6.5 9.7c0 1.3.5 2.4 1.5 2.9.2.1.3 0 .4-.2 0-.1.1-.5.2-.6.1-.2 0-.3-.1-.4-.4-.4-.6-.9-.6-1.5 0-1.9 1.4-3.6 3.7-3.6 2 0 3.1 1.2 3.1 2.9 0 2.2-1 4-2.4 4-.8 0-1.4-.6-1.2-1.4.2-.9.7-2 .7-2.7 0-.6-.3-1.1-1-1.1-.8 0-1.4.8-1.4 1.9 0 .7.2 1.2.2 1.2l-1 4.1c-.3 1.2 0 2.7 0 2.8 0 .1.1.1.2 0s1-1.3 1.3-2.4c.1-.3.5-2.1.5-2.1.3.5 1 .9 1.8.9 2.4 0 4-2.2 4-5.1.1-2.2-1.7-4.3-4.6-4.3z",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    cx: 11.5,
    cy: 11.5,
    r: 11
  })))), _symbol569 || (_symbol569 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-system-play-backwards-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-play-backwards-large"), /*#__PURE__*/React.createElement("path", {
    d: "M26.5 16.4l-10.4 7 10.4 7.2V16.4zm-3 29.1c12.15 0 22-9.85 22-22s-9.85-22-22-22-22 9.85-22 22 9.85 22 22 22z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol570 || (_symbol570 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-system-play-backwards-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-play-backwards-small"), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 7.4l-6 4.1 6 4.2V7.4zm-2 15.1c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.925-11 11 4.925 11 11 11z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol571 || (_symbol571 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-system-play-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-play-large"), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 16.4l10.4 7-10.4 7.2V16.4zm4 29.1c12.15 0 22-9.85 22-22s-9.85-22-22-22-22 9.85-22 22 9.85 22 22 22z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol572 || (_symbol572 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-system-play-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-play-small"), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 7.4l6 4.1-6 4.2V7.4zm2 15.1c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.925-11 11 4.925 11 11 11z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol573 || (_symbol573 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-system-print-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-print-large"), /*#__PURE__*/React.createElement("path", {
    d: "M31.6 24.5H34a1.5 1.5 0 0 1 1.5 1.5v7.5h-23V26a1.5 1.5 0 0 1 1.5-1.5h2.5m15-8v12h-15v-17h10l5 5zm-5-5v5h5m-11.5 8h8m-8-4h8m-4.5 25c12.15 0 22-9.85 22-22s-9.85-22-22-22-22 9.85-22 22 9.85 22 22 22z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol574 || (_symbol574 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-system-print-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-print-small"), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 12.5h1a1 1 0 0 1 1 1v4h-12v-4a1 1 0 0 1 1-1h1m8-4.5v6.5h-8v-9H13L15.5 8zm-3-2.5v3h3m-6.5 4h5m-5-2h5m-2.5 12c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.925-11 11 4.925 11 11 11z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol575 || (_symbol575 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-system-remove-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-remove-large"), /*#__PURE__*/React.createElement("path", {
    d: "M29 23.5H18m5.5 22c12.15 0 22-9.85 22-22s-9.85-22-22-22-22 9.85-22 22 9.85 22 22 22z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol576 || (_symbol576 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-system-remove-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-remove-small"), /*#__PURE__*/React.createElement("path", {
    d: "M15 11.4H8m3.5 11.1c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.925-11 11 4.925 11 11 11z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol577 || (_symbol577 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-system-replay-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-replay-large"), /*#__PURE__*/React.createElement("path", {
    d: "M16.4 27.2c2 3.9 6.8 5.5 10.8 3.5 4-2 5.5-6.8 3.5-10.8-2-4-6.8-5.5-10.8-3.5-1.7.9-3.1 2.3-3.8 4.1m3.9 0h-4.5V16m8 29.5c12.15 0 22-9.85 22-22s-9.85-22-22-22-22 9.85-22 22 9.85 22 22 22z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol578 || (_symbol578 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-system-replay-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-replay-small"), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13.5c1.1 2.2 3.8 3.1 6 2s3.1-3.8 2-6-3.8-3.1-6-2c-1.2.6-2.1 1.7-2.4 3m2.9 0H6.5V7m5 15.5c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.925-11 11 4.925 11 11 11z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol579 || (_symbol579 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-system-resize-decrease-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-resize-decrease-large"), /*#__PURE__*/React.createElement("path", {
    d: "M31.992 21.5H25.5V15m0 6.5L33 14l-7.5 7.5zM14 33l7.5-7.5L14 33zm7.492-1v-6.5H15m8.5-24c-12.15 0-22 9.85-22 22s9.85 22 22 22 22-9.85 22-22a22 22 0 0 0-22-22z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol580 || (_symbol580 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-system-resize-decrease-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-resize-decrease-small"), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 11.5c0 6.075-4.925 11-11 11s-11-4.925-11-11 4.925-11 11-11a11 11 0 0 1 11 11zM12.5 6v4.5H17m-4.5 0l4.132-4.132L12.5 10.5zm-2 2l-4.132 4.132L10.5 12.5zm-4.5 0h4.5V17",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol581 || (_symbol581 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-system-resize-increase-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-resize-increase-large"), /*#__PURE__*/React.createElement("path", {
    d: "M26 14.5h6.492V21M25 22l7.5-7.5L25 22zm-3 3l-7.5 7.5L22 25zm-7.5 1v6.5h6.492m2.508-31c-12.15 0-22 9.85-22 22s9.85 22 22 22 22-9.85 22-22a22 22 0 0 0-22-22z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol582 || (_symbol582 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-system-resize-increase-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-resize-increase-small"), /*#__PURE__*/React.createElement("path", {
    d: "M12 6.5h4.5V11m-4.132-.368L16.5 6.5l-4.132 4.132zm-1.736 1.736L6.5 16.5l4.132-4.132zM6.5 12v4.5H11m.5-16C5.425.5.5 5.425.5 11.5s4.925 11 11 11 11-4.925 11-11a11 11 0 0 0-11-11z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol583 || (_symbol583 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-system-save-as-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-save-as-large"), /*#__PURE__*/React.createElement("path", {
    d: "M32.5 20v10.5h-18V20m9-4v11m4.4-4.4L23.5 27l-4.4-4.4m4.4 22.9c12.15 0 22-9.85 22-22s-9.85-22-22-22-22 9.85-22 22 9.85 22 22 22z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol584 || (_symbol584 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-system-save-as-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-save-as-small"), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 9v6.5h12V9m-6-2v6.4m-3.2-3.2l3.2 3.2 3.2-3.2m-3.2 12.3c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.925-11 11 4.925 11 11 11z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol585 || (_symbol585 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-system-search-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-search-large"), /*#__PURE__*/React.createElement("path", {
    d: "M30.7 30.9L24 24.2l6.7 6.7zM25.3 21c.1 2.4-1.8 4.4-4.2 4.5h-.3c-2.5 0-4.5-2-4.5-4.5s2.1-4.5 4.5-4.5c2.5 0 4.5 2 4.5 4.5zm-1.8 24.5c12.15 0 22-9.85 22-22s-9.85-22-22-22-22 9.85-22 22 9.85 22 22 22z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol586 || (_symbol586 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-system-search-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-search-small"), /*#__PURE__*/React.createElement("path", {
    d: "M15.8 15.8l-4-4 4 4zM12.5 10c.1 1.3-1 2.5-2.3 2.5H10c-1.4 0-2.5-1.1-2.5-2.5S8.6 7.5 10 7.5s2.5 1.1 2.5 2.5zm-1 12.5c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.925-11 11 4.925 11 11 11z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol587 || (_symbol587 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-system-select-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-select-large"), /*#__PURE__*/React.createElement("path", {
    d: "M17.2 24.2l5.2 5.2 8-11.5m-6.9 27.6c12.15 0 22-9.85 22-22s-9.85-22-22-22-22 9.85-22 22 9.85 22 22 22z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol588 || (_symbol588 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-system-select-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-select-small"), /*#__PURE__*/React.createElement("path", {
    d: "M7.3 11.3l3.3 3.3 5.1-7.2m-4.2 15.1c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.925-11 11 4.925 11 11 11z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol589 || (_symbol589 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-system-settings-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-settings-large"), /*#__PURE__*/React.createElement("path", {
    d: "M25.1 14.5v2.7c.6.2 1.2.4 1.7.7l1.9-1.9 2.3 2.3-1.9 1.9c.3.5.5 1.1.7 1.7h2.7v3.3h-2.7c-.2.6-.4 1.2-.7 1.7l1.9 1.9-2.3 2.2-1.9-1.9c-.5.3-1.1.5-1.7.7v2.7h-3.3v-2.7c-.6-.2-1.2-.4-1.7-.7L18.3 31 16 28.7l1.9-1.9c-.3-.5-.5-1.1-.7-1.7h-2.7v-3.3h2.7c.2-.6.4-1.2.7-1.7L16 18.3l2.3-2.3 1.9 1.9c.5-.3 1.1-.5 1.7-.7v-2.7h3.2zM23.5 20c1.9 0 3.5 1.6 3.5 3.5S25.4 27 23.5 27 20 25.4 20 23.5s1.6-3.5 3.5-3.5m0 25.5c12.15 0 22-9.85 22-22s-9.85-22-22-22-22 9.85-22 22 9.85 22 22 22z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol590 || (_symbol590 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-system-settings-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-settings-small"), /*#__PURE__*/React.createElement("path", {
    d: "M12.7 6.7c.9.2 1.7.7 2.3 1.3l1.9-1 1.3 2.1-1.9 1.2c.2.8.2 1.7 0 2.5l2 1.2-1.3 2.1-2-1.2c-.6.6-1.4 1.1-2.3 1.3v2.3h-2.5v-2.3c-.8-.2-1.6-.6-2.2-1.3L6.1 16l-1.3-2 2-1.2c-.2-.9-.2-1.8 0-2.6l-2-1.1L6.2 7 8 8c.6-.6 1.4-1 2.2-1.2V4.5h2.5v2.2zm-1.2 6.9a2.1 2.1 0 1 0 0-4.2 2.1 2.1 0 0 0 0 4.2zm0 8.9c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.925-11 11 4.925 11 11 11z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol591 || (_symbol591 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-system-share-android-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-share-android-large"), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 45.5c12.15 0 22-9.85 22-22s-9.85-22-22-22-22 9.85-22 22 9.85 22 22 22zm3.06-16.72l-8.11-4.055m-.014-2.443l8.114-4.057M29 32.75a2.75 2.75 0 1 0 0-5.5 2.75 2.75 0 0 0 0 5.5zm0-13a2.75 2.75 0 1 0 0-5.5 2.75 2.75 0 0 0 0 5.5zm-13 6.5a2.75 2.75 0 1 0 0-5.5 2.75 2.75 0 0 0 0 5.5z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol592 || (_symbol592 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-system-share-android-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-share-android-small"), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 22.5c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.925-11 11 4.925 11 11 11zm1.224-7.861l-4.482-2.173m-.002-1.93l4.468-2.167M14.5 17.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm0-8a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm-8 4a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol593 || (_symbol593 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-system-share-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-share-large"), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 45.5c12.15 0 22-9.85 22-22s-9.85-22-22-22-22 9.85-22 22 9.85 22 22 22zm2.482-26H29.5v12h-12v-12H21m2.5 6.5V13.501M20 17l3.5-3.5L27 17",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol594 || (_symbol594 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-system-share-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-share-small"), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 22.5c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.925-11 11 4.925 11 11 11zm1.5-13h2.5v8l-8 .001V9.5H10m1.5 4.5V4.5M9 7l2.5-2.5L14 7",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol595 || (_symbol595 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-system-skip-next-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-skip-next-large"), /*#__PURE__*/React.createElement("path", {
    d: "M30.5 31V16m-14 .4l10.4 7-10.4 7.2V16.4zm7 29.1c12.15 0 22-9.85 22-22s-9.85-22-22-22-22 9.85-22 22 9.85 22 22 22z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol596 || (_symbol596 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-system-skip-next-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-skip-next-small"), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 16V7m-8 8.6l6-4.1-6-4.2v8.3zm4 6.9c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.925-11 11 4.925 11 11 11z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol597 || (_symbol597 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-system-skip-previous-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-skip-previous-large"), /*#__PURE__*/React.createElement("path", {
    d: "M30.5 16.4l-10.4 7 10.4 7.2V16.4zM16.5 31V16m7 29.5c12.15 0 22-9.85 22-22s-9.85-22-22-22-22 9.85-22 22 9.85 22 22 22z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol598 || (_symbol598 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-system-skip-previous-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-skip-previous-small"), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 15.6l-6-4.1 6-4.2v8.3zm-8 .4V7m4 15.5c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.925-11 11 4.925 11 11 11z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol599 || (_symbol599 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-system-snapchat-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-snapchat-large"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    cx: 23.5,
    cy: 23.5,
    r: 22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.691 30.485c-.087-.33-.367-.412-.657-.477-2.814-.628-4.49-2.532-5.605-5.044-.226-.51-.07-.87.4-1.178.364-.24.777-.37 1.19-.499.516-.16 1.012-.363 1.421-.727.592-.527.521-1.262-.161-1.667-.501-.297-1.027-.377-1.574-.116-.344.165-.704.29-1.087.302-.296.01-.497-.027-.464-.457.068-.889.161-1.78.115-2.531v-1.012c.004-2.588-1.201-4.512-3.313-5.894-1.538-1.007-3.274-1.263-5.08-1.166-1.664.09-3.197.572-4.494 1.637-1.411 1.16-2.386 2.598-2.58 4.475-.157 1.51-.051 3.019.047 4.525.023.354-.12.407-.378.425-.456.032-.882-.093-1.287-.288-.494-.24-.967-.173-1.425.08-.718.396-.785 1.18-.16 1.713.398.338.866.536 1.354.692.349.113.697.223 1.023.394.686.357.86.773.528 1.48-1.158 2.463-2.867 4.3-5.65 4.9-.557.119-.726.551-.43 1.038.184.305.478.482.786.631.748.363 1.55.571 2.364.667.48.057.623.28.711.694.285 1.336.379 1.375 1.713 1.12 1.526-.293 2.976-.174 4.236.874a8.5 8.5 0 0 0 .937.647c2.215 1.385 4.438 1.39 6.653.006.555-.348 1.085-.735 1.63-1.098.539-.357 1.138-.507 1.78-.544.807-.048 1.594.064 2.383.209.532.098.825-.091.968-.608.083-.302.143-.61.216-.916.045-.19.133-.305.36-.341a15.456 15.456 0 0 0 1.573-.324c.594-.158 1.183-.353 1.651-.78.243-.22.397-.497.306-.842",
    fill: "currentColor",
    fillRule: "nonzero"
  })))), _symbol600 || (_symbol600 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-system-snapchat-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-snapchat-small"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    cx: 11.5,
    cy: 11.5,
    r: 11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.07 14.718c-1.366-.305-2.18-1.23-2.722-2.45-.11-.248-.034-.422.194-.572.177-.116.378-.18.578-.242.25-.078.492-.177.69-.353.288-.256.254-.613-.078-.81-.243-.144-.498-.183-.764-.056-.167.08-.342.14-.528.146-.144.005-.241-.013-.225-.222.033-.431.078-.864.056-1.23v-.49c.001-1.258-.584-2.192-1.61-2.864-.747-.489-1.59-.613-2.467-.566-.809.044-1.553.278-2.183.796-.686.563-1.159 1.261-1.253 2.173-.076.734-.025 1.466.023 2.198.011.172-.058.197-.184.206a1.227 1.227 0 0 1-.625-.14c-.24-.116-.47-.084-.692.04-.349.192-.381.572-.078.831.193.164.42.26.658.337.17.054.338.108.497.19.333.174.417.376.256.72-.562 1.196-1.393 2.089-2.744 2.38-.27.057-.353.267-.21.504.09.148.233.234.383.306.363.176.752.278 1.148.324.233.028.303.137.345.337.139.65.184.668.832.544.742-.142 1.446-.084 2.058.425.141.117.299.216.455.314 1.076.673 2.155.675 3.231.003.27-.169.527-.357.792-.533.262-.174.553-.247.865-.265.391-.023.774.031 1.157.102.258.047.4-.044.47-.296.04-.146.07-.296.105-.444.022-.093.065-.149.175-.166.257-.04.513-.09.764-.157.289-.077.574-.172.802-.38.118-.106.193-.24.149-.408-.043-.16-.179-.2-.32-.232z",
    fill: "currentColor",
    fillRule: "nonzero"
  })))), _symbol601 || (_symbol601 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-system-sync-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-sync-large"), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 45.5c12.15 0 22-9.85 22-22s-9.85-22-22-22-22 9.85-22 22 9.85 22 22 22zm-5.8-19.2l-2.2 2.2 2.2 2.2m-2.2-2.2h13.3c3.2 0 5.8-2.7 5.7-5.9V22m-4.2-1.3l2.2-2.2-2.2-2.2m2.2 2.2H19.2c-3.2 0-5.8 2.7-5.7 5.9v.6",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol602 || (_symbol602 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-system-sync-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-sync-small"), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 22.5c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.925-11 11 4.925 11 11 11zM8.7 12.3l-2.2 2.2 2.2 2.2m-2.2-2.2h7.15c1.6 0 2.9-1.35 2.85-2.95v-.3m0-2.75H9.35c-1.6 0-2.9 1.35-2.85 2.95v.3m7.8-1.05l2.2-2.2-2.2-2.2",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol603 || (_symbol603 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-system-twitter-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-twitter-large"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.1 16.9s3.2.4 4.1-.2c-1.5.8-3 1.8-4.2 3 0 0 1.2 13.3-12.7 16.5 0 0-7.2.6-12.3-3.3 0 0 5.5 1.5 8.5-1.9 0 0-5.1.5-6.4-3.5 1.2 0 2.4-.2 3.6-.5 0 0-4.8-.9-4.7-5.7.8.5 1.7.7 2.7.7 0 0-4-3.6-1.5-7.8 0 0 5.3 6.5 11.9 6.1-.8-3 1-6.1 4.1-6.9 2-.5 4 .1 5.4 1.5 1.4-.3 2.7-.9 3.9-1.9-.1.2 0 2-2.4 3.9z",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    cx: 23.5,
    cy: 23.5,
    r: 22
  })))), _symbol604 || (_symbol604 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-system-twitter-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-twitter-small"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8 8.2c.6.1 1.2.1 1.8-.1-.7.4-1.3.8-1.9 1.4.3 3.6-2.2 6.8-5.7 7.4-2 .1-3.9-.4-5.5-1.5 0 0 2.5.7 3.8-.8 0 0-2.3.2-2.9-1.6.6 0 1.1-.1 1.6-.2-1.2-.2-2.1-1.3-2.1-2.6.4.2.8.3 1.2.3 0 0-1.8-1.6-.7-3.5 0 0 2.4 2.9 5.4 2.8-.4-1.4.5-2.8 1.8-3.1.9-.2 1.8 0 2.5.7.6-.1 1.2-.4 1.7-.8-.1.6-.4 1.2-1 1.6z",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    cx: 11.5,
    cy: 11.5,
    r: 11
  })))), _symbol605 || (_symbol605 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-system-upload-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-upload-large"), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 45.5c12.15 0 22-9.85 22-22s-9.85-22-22-22-22 9.85-22 22 9.85 22 22 22zm0-14.5V20m-4.4 4.4l4.4-4.4 4.4 4.4m2.1-7.9H17",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol606 || (_symbol606 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-system-upload-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-upload-small"), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 22.5c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.925-11 11 4.925 11 11 11zm0-6.5V9.6m-3.2 3.2l3.2-3.2 3.2 3.2m.3-5.3H8",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol607 || (_symbol607 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-system-vimeo-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-vimeo-large"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    cx: 23.5,
    cy: 23.5,
    r: 22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.637 18.321c-.12 2.588-1.956 6.133-5.506 10.63C27.46 33.652 24.354 36 21.813 36c-1.573 0-2.906-1.43-3.993-4.292l-2.18-7.87c-.808-2.86-1.674-4.292-2.6-4.292-.203 0-.91.418-2.12 1.252l-1.27-1.612a341.663 341.663 0 0 0 3.94-3.46c1.778-1.513 3.112-2.308 4-2.388 2.102-.2 3.395 1.215 3.88 4.243.526 3.267.888 5.3 1.093 6.095.605 2.71 1.272 4.064 2 4.064.565 0 1.414-.88 2.546-2.637 1.13-1.759 1.736-3.097 1.818-4.016.16-1.517-.445-2.278-1.818-2.278-.647 0-1.313.147-1.999.436 1.327-4.28 3.862-6.359 7.605-6.24 2.774.08 4.082 1.852 3.922 5.316",
    fill: "currentColor",
    fillRule: "nonzero"
  })))), _symbol608 || (_symbol608 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-system-vimeo-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-vimeo-small"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    cx: 11.5,
    cy: 11.5,
    r: 11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.994 9.413c-.053 1.126-.87 2.667-2.447 4.623-1.632 2.043-3.012 3.064-4.141 3.064-.7 0-1.292-.622-1.775-1.866l-.969-3.422c-.359-1.244-.744-1.866-1.156-1.866-.09 0-.404.182-.941.544L5 9.79c.592-.502 1.176-1.003 1.751-1.505.79-.657 1.383-1.003 1.778-1.038.934-.087 1.509.528 1.725 1.845.233 1.42.394 2.304.485 2.65.27 1.178.565 1.767.889 1.767.251 0 .628-.383 1.131-1.147s.772-1.346.808-1.746c.072-.66-.197-.99-.808-.99a2.32 2.32 0 0 0-.888.19c.59-1.862 1.717-2.765 3.38-2.714 1.233.035 1.814.805 1.743 2.311",
    fill: "currentColor",
    fillRule: "nonzero"
  })))), _symbol609 || (_symbol609 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-system-wechat-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-wechat-large"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    cx: 23.5,
    cy: 23.5,
    r: 22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4 22c4.1-3.9 12.3-2.8 14.3 2.9.4 1.3.4 2.7 0 3.9-.3.8-.8 1.5-1.3 2.1-.3.3-.6.7-1 1-.3.2-.8.5-.8.8 0 .4.1.7.3 1.1l.4 1.2c-.8-.4-2.2-1.6-3.1-1.4-3 .9-6.3.2-8.7-1.8-1.8-1.5-2.6-3.9-2.2-6.2.3-1.4 1.1-2.6 2.1-3.6zm-4.7-9.7c4.4-.5 9.7 1.7 11.1 6.2h-.2c-2.6-.1-5.2.9-7.1 2.6-1.2 1.2-2.1 2.7-2.4 4.3-.3 1.2-.2 2.5.3 3.8-1.1 0-2.2-.2-3.3-.4-.4-.1-.7-.1-1 .1l-.6.3-2.5 1.2.8-2.1.2-.5c.1-.4.1-.4-.3-.7-.8-.6-1.5-1.3-2.1-2.1-1.8-2.4-2-5.6-.4-8.2 1.7-2.6 4.5-4.2 7.5-4.5zm8.1 11.3c-1.6 0-1.2 2.6.5 2.1 1.5-.4.9-2.1-.5-2.1zm5.4 0c-1.6 0-1.2 2.6.5 2.1 1.5-.4 1-2.1-.5-2.1zm-8.6-7.2c-.8-.1-1.5.5-1.6 1.3.1.9.8 1.5 1.6 1.4.7 0 1.3-.6 1.3-1.3 0-.8-.6-1.4-1.3-1.4zm-6.9 0c-.8-.1-1.5.5-1.6 1.3.1.9.8 1.5 1.6 1.4.7-.1 1.3-.6 1.3-1.3 0-.8-.6-1.4-1.3-1.4z",
    fill: "currentColor",
    fillRule: "nonzero"
  })))), _symbol610 || (_symbol610 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-system-wechat-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-wechat-small"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    cx: 11.5,
    cy: 11.5,
    r: 11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1 10.9c2.1-2 6.2-1.4 7.2 1.4.3.7.3 1.4 0 2-.1.3-.3.7-.6 1l-.5.5c-.2.1-.4.2-.4.4s.7 1.5.8 1.7c-.4-.2-1.6-1.3-2-1.2-1.6.5-3.2.1-4.4-.9-.9-.8-1.3-1.9-1.1-3.1.1-.7.5-1.3 1-1.8zM8.8 6c2.2-.2 4.8.9 5.5 3.2h-.1c-1.3 0-2.5.4-3.5 1.3-.6.5-1.1 1.3-1.3 2.1-.1.6 0 1.2.3 1.9-.5 0-1.1-.1-1.6-.2-.2-.1-.4-.1-.5 0-.1 0-1.7 1.2-2.1 1.4.1-.4 1-2.2.8-2.3-.4-.3-.8-.6-1.1-1-.9-1.2-1-2.8-.2-4.1C5.9 7 7.3 6.2 8.8 6zm3.7 5.6c-1.1 0-.8 1.8.3 1.5 1-.3.6-1.5-.3-1.5zm3.1 0c-1.1 0-.8 1.8.3 1.5 1-.3.7-1.5-.3-1.5zm-4.2-3.7c-.5 0-.9.3-.9.8s.4.8.9.8.8-.4.8-.8c0-.5-.4-.8-.8-.8zM7.8 8c-.5-.1-.9.3-.9.7 0 .5.4.8.9.8.4 0 .7-.3.7-.7.1-.4-.3-.8-.7-.8z",
    fill: "currentColor",
    fillRule: "nonzero"
  })))), _symbol611 || (_symbol611 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-system-weibo-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-weibo-large"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    cx: 23.5,
    cy: 23.5,
    r: 22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2 24c-2.2-.6-4.6.5-5.7 2.5-.9 1.7-.2 3.8 1.5 4.6.2.1.5.2.7.3 2.3.7 4.9-.3 6-2.5.8-1.7 0-3.8-1.7-4.6-.2-.2-.5-.2-.8-.3zm-1.7 5.1c-.4.7-1.3 1-2.1.7-.6-.3-.9-1-.6-1.6 0-.1.1-.2.1-.2.4-.7 1.3-1 2.1-.7.6.3.9 1 .7 1.6-.1 0-.1.1-.2.2zm1.5-1.9c-.2.3-.5.4-.8.3-.2-.1-.4-.4-.3-.6v-.1c.2-.3.5-.4.8-.3.3.1.5.3.3.7.1-.1 0-.1 0 0zm9-4.6c-.4-.1-.7-.2-.5-.7.5-.9.5-1.9 0-2.8-.9-1.3-3.4-1.2-6.2 0 0 0-.9.4-.7-.3.4-1.4.4-2.6-.3-3.3-1.5-1.5-5.7.1-9.2 3.6-2.6 2.6-4.1 5.4-4.1 7.8 0 4.6 5.9 7.4 11.7 7.4 7.6 0 12.7-4.4 12.7-7.9 0-2.1-1.8-3.3-3.4-3.8zm-9.2 10.1c-4.6.5-8.6-1.6-8.9-4.7-.3-3.1 3.2-5.9 7.8-6.3 4.6-.4 8.6 1.6 8.9 4.7.3 3-3.2 5.8-7.8 6.3zm14.3-18.6c-1.8-2-4.5-2.8-7.1-2.3-.6.1-.9.7-.8 1.3.1.6.7.9 1.3.8 2.8-.6 5.6 1.2 6.3 4.1.2.9.1 1.8-.1 2.7-.2.6.2 1.2.7 1.3.5.1 1.1-.1 1.3-.7.8-2.5.2-5.2-1.6-7.2m-2.8 2.6c-.9-1-2.2-1.4-3.4-1.1-.5.1-.8.6-.7 1.1.1.5.6.8 1.1.7 1-.2 1.9.4 2.1 1.4.1.3 0 .6 0 .9-.2.5.1 1 .6 1.2.5.2 1-.1 1.2-.6.2-1.3-.1-2.7-.9-3.6",
    fill: "currentColor",
    fillRule: "nonzero"
  })))), _symbol612 || (_symbol612 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-system-weibo-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-weibo-small"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    cx: 11.5,
    cy: 11.5,
    r: 11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9 11.6c-1.1-.3-2.3.2-2.9 1.3-.4.9-.1 1.9.8 2.3.1.1.2.1.4.1 1.2.4 2.5-.2 3-1.3.4-.9 0-1.9-.9-2.3-.1 0-.2 0-.4-.1zm-.8 2.6c-.2.4-.7.5-1.1.4-.3-.1-.5-.5-.3-.8 0 0 0-.1.1-.1.2-.4.7-.5 1.1-.4.3.1.5.5.3.8-.1 0-.1.1-.1.1zm5.3-3.3c-.2-.1-.3-.1-.2-.4.2-.4.2-1 0-1.4-.5-.7-1.7-.6-3.2 0 0 0-.5.2-.3-.2.3-.5.2-1.2-.2-1.7-.8-.8-2.9 0-4.7 1.8-1.2 1-2 2.5-2.1 4 0 2.4 3 3.8 6 3.8 3.9 0 6.5-2.3 6.5-4.1-.1-.8-.8-1.6-1.8-1.8zm-4.7 5.2c-2.4.2-4.4-.8-4.6-2.4-.2-1.6 1.6-3 4-3.2 2.4-.2 4.4.8 4.6 2.4.2 1.6-1.6 2.9-4 3.2zM18 6.6c-.9-1-2.3-1.4-3.6-1.2-.3.1-.4.4-.4.7.1.3.3.4.6.4 1.5-.3 2.9.6 3.2 2.1.1.5.1.9-.1 1.4-.1.3.1.6.4.7.3.1.6-.1.7-.3.4-1.4.1-2.8-.8-3.8m-1.4 1.3c-.4-.5-1.1-.7-1.8-.6-.3.1-.4.3-.4.6.1.3.3.4.6.4.5-.1 1 .2 1.1.7v.5c-.1.1 0 .4.3.5.2.1.5-.1.6-.3.2-.6 0-1.3-.4-1.8",
    fill: "currentColor",
    fillRule: "nonzero"
  })))), _symbol613 || (_symbol613 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-system-whatsapp-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-whatsapp-large"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    cx: 24,
    cy: 24,
    r: 22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.313 13.123c-4.779-4.711-12.311-5.18-17.641-1.1a13.39 13.39 0 0 0-3.494 17.283L11.25 36.25l7.128-1.866a13.403 13.403 0 0 0 6.428 1.635 13.447 13.447 0 0 0 12.42-8.28c2.08-5.012.931-10.78-2.913-14.616zm-9.507 20.633a11.141 11.141 0 0 1-5.688-1.558l-.405-.237-4.25 1.102 1.132-4.11-.27-.423a11.132 11.132 0 0 1-.303-11.323 11.189 11.189 0 0 1 9.784-5.75c6.172.007 11.172 5 11.172 11.156-.007 6.15-5.005 11.136-11.172 11.143zm6.126-8.335c-.334-.167-1.986-.981-2.295-1.09-.308-.11-.533-.167-.752.167-.218.333-.868 1.09-1.067 1.282-.2.192-.392.25-.726.083a9.1 9.1 0 0 1-2.7-1.66 10.206 10.206 0 0 1-1.858-2.302c-.192-.34 0-.52.148-.686.148-.167.335-.391.502-.584.137-.172.252-.362.34-.564a.64.64 0 0 0-.032-.583c-.083-.167-.752-1.815-1.035-2.488-.283-.673-.546-.564-.752-.577h-.643c-.344.01-.668.163-.893.423a3.733 3.733 0 0 0-1.176 2.796 6.447 6.447 0 0 0 1.375 3.462c.167.224 2.366 3.61 5.734 5.059.63.27 1.273.505 1.928.705a4.633 4.633 0 0 0 2.115.135c.643-.097 1.986-.808 2.269-1.597.217-.5.284-1.053.193-1.59-.116-.154-.34-.237-.675-.404v.013z",
    fill: "currentColor",
    fillRule: "nonzero"
  })))), _symbol614 || (_symbol614 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-system-whatsapp-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-whatsapp-small"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    cx: 12,
    cy: 12,
    r: 11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.854 6.865a6.487 6.487 0 0 0-8.493-.53 6.447 6.447 0 0 0-1.683 8.322L5.75 18l3.432-.898a6.475 6.475 0 0 0 9.075-3.2 6.446 6.446 0 0 0-1.403-7.037zm-4.577 9.934c-.964 0-1.91-.259-2.739-.75l-.195-.114-2.046.53.545-1.978-.13-.204a5.36 5.36 0 0 1-.146-5.452 5.387 5.387 0 0 1 4.711-2.769c2.972.004 5.379 2.408 5.379 5.372a5.378 5.378 0 0 1-5.379 5.365zm2.95-4.013c-.162-.08-.957-.472-1.105-.525-.149-.052-.257-.08-.363.08-.105.161-.417.525-.513.618-.096.092-.19.12-.35.04a4.381 4.381 0 0 1-1.3-.8 4.914 4.914 0 0 1-.894-1.108c-.093-.163 0-.25.07-.33.072-.08.162-.188.242-.281.066-.083.122-.175.164-.272a.308.308 0 0 0-.015-.28c-.04-.08-.362-.874-.498-1.198-.137-.325-.263-.272-.362-.278h-.31a.592.592 0 0 0-.43.204c-.371.348-.577.837-.567 1.345.052.609.283 1.189.663 1.667.08.109 1.139 1.738 2.76 2.436.304.13.613.243.929.34.33.1.678.122 1.018.065.31-.047.956-.39 1.093-.77.104-.24.136-.506.092-.765-.055-.074-.164-.114-.325-.194v.006z",
    fill: "currentColor",
    fillRule: "nonzero"
  })))), _symbol615 || (_symbol615 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-system-xing-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-xing-large"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    cx: 23.5,
    cy: 23.5,
    r: 22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5 10c-.6 0-.8.4-1 .7l-8.7 15.4 5.5 10.2c.2.3.5.7 1.1.7h3.9c.2 0 .4-.1.5-.2.1-.2.1-.4 0-.6l-5.5-10L33.9 11c.1-.2.1-.4 0-.6-.1-.2-.3-.2-.5-.2 0-.2-3.9-.2-3.9-.2zm-16.4 5.3c-.2 0-.4.1-.5.2-.1.2-.1.4 0 .6l2.6 4.6-4.1 7.3c-.1.2-.1.4 0 .6.1.2.3.3.5.3h3.9c.6 0 .9-.4 1.1-.8l4.2-7.4-2.7-4.7c-.2-.3-.5-.7-1.1-.7h-3.9z",
    fill: "currentColor",
    fillRule: "nonzero"
  })))), _symbol616 || (_symbol616 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-system-xing-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-xing-small"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4 5c-.3 0-.4.2-.5.4l-4.2 7.4 2.7 4.9c.1.2.2.4.5.4h1.9c.1 0 .2 0 .2-.1.1-.1 0-.2 0-.3l-2.6-4.8 4.2-7.3c.1-.1.1-.2 0-.3-.2-.3-.2-.3-.4-.3h-1.8zM6.5 7.6c-.1 0-.2 0-.3.1-.1.1 0 .2 0 .3l1.3 2.2-2 3.5c-.1.1-.1.2 0 .3.1.1.1.1.2.1h1.9c.3 0 .4-.2.5-.4l2-3.6-1.2-2.2c-.1-.1-.3-.3-.6-.3H6.5z",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    cx: 11.5,
    cy: 11.5,
    r: 11
  })))), _symbol617 || (_symbol617 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-system-yelp-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-yelp-large"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    cx: 23.5,
    cy: 23.5,
    r: 22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.294 22.142l5.449 2.657c1.048.511.886 2.053-.245 2.335L14.615 28.6a1.251 1.251 0 0 1-1.544-1.074 10.754 10.754 0 0 1 .491-4.663 1.25 1.25 0 0 1 1.732-.721m2.182 11.217l4.055-4.505c.78-.866 2.218-.286 2.177.88l-.212 6.06a1.25 1.25 0 0 1-1.457 1.188 10.854 10.854 0 0 1-4.344-1.757 1.25 1.25 0 0 1-.22-1.866m9.617-5.995l5.765 1.874a1.25 1.25 0 0 1 .742 1.726 10.855 10.855 0 0 1-2.883 3.694c-.583.48-1.456.34-1.857-.302l-3.213-5.142c-.618-.99.336-2.21 1.446-1.85m5.862-3.678l-5.827 1.671c-1.122.322-2.033-.932-1.38-1.899l3.39-5.025a1.25 1.25 0 0 1 1.86-.242 10.755 10.755 0 0 1 2.758 3.793c.3.693-.074 1.494-.8 1.702M19.336 9.546a17.45 17.45 0 0 0-2.995 1.104 1.249 1.249 0 0 0-.54 1.751l5.695 9.865c.639 1.107 2.33.653 2.33-.624V10.25a1.25 1.25 0 0 0-1.344-1.247 17.442 17.442 0 0 0-3.146.542",
    fill: "currentColor",
    fillRule: "nonzero"
  })))), _symbol618 || (_symbol618 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-system-yelp-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-yelp-small"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    cx: 11.5,
    cy: 11.5,
    r: 11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.647 10.57l2.724 1.33a.625.625 0 0 1-.122 1.167l-2.941.733a.626.626 0 0 1-.773-.537 5.377 5.377 0 0 1 .246-2.331.625.625 0 0 1 .866-.361m1.09 5.608l2.029-2.252a.625.625 0 0 1 1.088.44l-.106 3.03a.625.625 0 0 1-.728.594 5.427 5.427 0 0 1-2.172-.878.625.625 0 0 1-.11-.934m4.808-2.997l2.882.937a.625.625 0 0 1 .371.863 5.428 5.428 0 0 1-1.44 1.847.626.626 0 0 1-.93-.15l-1.606-2.572a.624.624 0 0 1 .723-.925m2.931-1.839l-2.914.836a.624.624 0 0 1-.69-.95l1.695-2.513a.625.625 0 0 1 .93-.12 5.377 5.377 0 0 1 1.38 1.896.626.626 0 0 1-.401.851m-6.808-7.07a8.725 8.725 0 0 0-1.498.552.624.624 0 0 0-.27.876l2.847 4.932c.32.554 1.166.327 1.166-.312V4.625a.625.625 0 0 0-.672-.623 8.72 8.72 0 0 0-1.573.271",
    fill: "currentColor",
    fillRule: "nonzero"
  })))), _symbol619 || (_symbol619 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-system-youku-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-youku-large"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    cx: 23.5,
    cy: 23.5,
    r: 22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5 21l-3.9-2.8c-1-.7-2.1-1.8-3.5-1-1 .6-1.3 1.8-.7 2.8 0 .1.1.2.2.2.4.4.8.7 1.2 1 1.2.8 2.5 1.5 3.6 2.4-1 .8-2.2 1.7-3.3 2.4-.4.3-.8.5-1.1.8-.9.7-1.1 2-.4 2.9v.1c1.2 1.5 2.7.4 3.9-.4l3.8-2.7c1-.7 2.6-2 2.6-3 0-1.2-1.5-2.1-2.4-2.7zm9.3-.1c-1.4-7.3-8.6-12.1-15.9-10.6-4.6.9-8.4 4.2-10.1 8.6-2.6 7 1 14.8 8 17.3 3.8 1.4 8.1 1 11.6-1.1 4.9-2.9 7.4-8.6 6.4-14.2zm-4.1 4.5c-1 5.1-6 8.4-11.1 7.4s-8.4-6-7.4-11.1 6-8.4 11.1-7.4c1.1.2 2.1.6 3 1.2 3.5 2 5.2 6 4.4 9.9z",
    fill: "currentColor",
    fillRule: "nonzero"
  })))), _symbol620 || (_symbol620 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-system-youku-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-youku-small"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    cx: 11.5,
    cy: 11.5,
    r: 11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4 10.2l-1.9-1.4c-.5-.3-1-.8-1.7-.4-.5.3-.6.9-.3 1.3 0 0 0 .1.1.1.2.2.4.3.6.5.6.4 1.2.7 1.7 1.1-.5.4-1.1.8-1.6 1.1-.2.1-.4.3-.5.4-.4.3-.5.9-.2 1.4.6.7 1.3.2 1.9-.2l1.8-1.3c.5-.4 1.3-1 1.3-1.4-.1-.4-.8-.8-1.2-1.2zm4.4 0c-.7-3.5-4.1-5.8-7.6-5.1-2.2.4-4 2-4.8 4.1-1.2 3.3.5 7.1 3.8 8.3 1.8.7 3.9.5 5.5-.5 2.4-1.4 3.6-4.1 3.1-6.8zm-1.9 2.1c-.5 2.4-2.9 4-5.3 3.5S6.5 13 7 10.6c.5-2.4 2.9-4 5.3-3.5.5.1 1 .3 1.4.6 1.7.9 2.5 2.8 2.2 4.6z",
    fill: "currentColor",
    fillRule: "nonzero"
  })))), _symbol621 || (_symbol621 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-system-youtube-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-youtube-large"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    cx: 23.5,
    cy: 23.5,
    r: 22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7 17.9s-.3-2-1.2-2.9c-1.1-1.2-2.3-1.2-2.9-1.2-4.1-.3-10.1-.3-10.1-.3s-6.1 0-10.1.3c-.6.1-1.8.1-2.9 1.2-.9.9-1.2 2.9-1.2 2.9S9 20.2 9 22.5v2.2c0 2.3.3 4.7.3 4.7s.3 2 1.2 2.9c1.1 1.2 2.6 1.1 3.2 1.2 2.3.2 9.9.3 9.9.3s6.1 0 10.2-.3c.6-.1 1.8-.1 2.9-1.2.9-.9 1.2-2.9 1.2-2.9s.3-2.3.3-4.7v-2.2c-.2-2.3-.5-4.6-.5-4.6zm-17.2 9.5v-8.1l7.8 4.1-7.8 4z",
    fill: "currentColor",
    fillRule: "nonzero"
  })))), _symbol622 || (_symbol622 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-system-youtube-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-youtube-small"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    cx: 11.5,
    cy: 11.5,
    r: 11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9 8.9s-.1-.9-.5-1.3c-.5-.5-1-.5-1.3-.6-1.8-.1-4.5-.1-4.5-.1s-2.7 0-4.5.1c-.3 0-.8 0-1.3.6-.5.4-.7 1.3-.7 1.3S5 10 5 11v1c0 1.1.1 2.1.1 2.1s.1.9.5 1.3c.5.5 1.1.5 1.4.6 1 .1 4.4.1 4.4.1s2.7 0 4.5-.1c.3 0 .8 0 1.3-.6.4-.4.5-1.3.5-1.3S18 13 18 12v-1c0-1-.1-2.1-.1-2.1zm-7.7 4.3V9.5l3.5 1.8c0 .1-3.5 1.9-3.5 1.9z",
    fill: "currentColor",
    fillRule: "nonzero"
  })))), _symbol623 || (_symbol623 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-system-zhihu-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-zhihu-large"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    cx: 23.5,
    cy: 23.5,
    r: 22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 34.5c1.2.4 2.6.3 3.7-.3 1.8-1.1 3.2-5.8 3.2-5.8l4.3 5.3s.4-2.5-.1-3.2c-.5-.7-3-3.6-3-3.6l-1.1 1 .8-3.1h4.7s0-1.8-.9-1.9c-.9-.1-3.7 0-3.7 0v-5.7H24s0-1.9-.9-1.9h-6.8l1.1-3.1s-1.7.1-2.3 1.2c-.6 1.1-2.6 6.6-2.6 6.6s.7.3 1.8-.5c.7-.6 1.2-1.4 1.5-2.3l2-.1v5.8s-3.5-.1-4.2 0c-.7.1-1.1 1.9-1.1 1.9h5.3c-.3 1.9-.9 3.8-1.8 5.6-1.1 1.6-2.4 3-4 4.1zm15.8-.1l3-2.2H35V15h-9.6v17.2h1.7l.7 2.2zm-.3-17.5h5.6v13.4h-2l-2.5 1.9-.6-1.9h-.5V16.9z",
    fill: "currentColor",
    fillRule: "nonzero"
  })))), _symbol624 || (_symbol624 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-system-zhihu-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "system-zhihu-small"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    cx: 11.5,
    cy: 11.5,
    r: 11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 16.8c.6.2 1.3.2 1.8-.2.9-.5 1.6-2.9 1.6-2.9l2.1 2.6c.1-.5.1-1.1 0-1.6-.2-.3-1.4-1.7-1.4-1.7l-.6.4.4-1.6h2.3s0-.9-.5-1c-.5-.1-1.9 0-1.9 0V8h2.1s0-.9-.4-.9H7.6l.5-1.6s-.9.1-1.2.6c-.3.5-1.2 3.3-1.2 3.3s.3.2.9-.3c.4-.2.6-.6.7-1.1l1-.1v2.9H6.2c-.4 0-.6 1-.6 1h2.7c-.1 1-.5 1.9-.9 2.8-.5.9-1.1 1.6-1.9 2.2zm7.9-.1l1.5-1.1H17V7h-4.8v8.6h.9l.3 1.1zM13.2 8H16v6.7h-1l-1.3 1-.3-1h-.3V8h.1z",
    fill: "currentColor",
    fillRule: "nonzero"
  })))), _symbol625 || (_symbol625 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-tag-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "tag-large"), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 18.5l16 16-16-16zm6-6l16 16-16-16zm8 33l19-19-24-24h-19v19l24 24zM9 11.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol626 || (_symbol626 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-tag-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "tag-small"), /*#__PURE__*/React.createElement("path", {
    d: "M6.1 10.1L14 18l-7.9-7.9zm4-4L18 14l-7.9-7.9zm2.4 16.4l10.1-10.1L10.7.5H.5v10l12 12zm-8-16a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol627 || (_symbol627 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-test-drive-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "test-drive-large"), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 44.5c11.046 0 20-8.954 20-20s-8.954-20-20-20-20 8.954-20 20 8.954 20 20 20zm0-3c4.188 0 8.023-1.514 10.985-4.026A16.963 16.963 0 0 0 40.5 24.5c0-9.389-7.611-17-17-17s-17 7.611-17 17c0 5.212 2.345 9.876 6.038 12.994A16.932 16.932 0 0 0 23.5 41.5zm6.577-12.423L36.5 35.5l-6.423-6.423zm-1.983 3.017L34 38l-5.906-5.906zm-9.183-.005L13 38m3.942-8.938L10.5 35.5m6-11h-10m34 0h-10m-23.246-5H18m21.752 0H29h10.752zM23.5 33.58c4.418 0 7-3 7-7.5 0-2.5 0-5.5-2-6.8-1.603-1.041-8.401-1.039-10 0-2 1.3-2 4.3-2 6.8 0 4.5 2.582 7.5 7 7.5z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol628 || (_symbol628 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-test-drive-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "test-drive-small"), /*#__PURE__*/React.createElement("path", {
    d: "M12 22.5c5.799 0 10.5-4.701 10.5-10.5S17.799 1.5 12 1.5 1.5 6.201 1.5 12 6.201 22.5 12 22.5zm-6.927-2.573l4.15-4.15m9.71 4.156l-4.16-4.16 4.16 4.16zm3.491-9.433h-7.33m-6.194 0H1.588M12 17c2.21 0 3.5-1.5 3.5-3.75 0-1.25 0-2.75-1-3.4-.801-.52-4.2-.52-5 0-1 .65-1 2.15-1 3.4C8.5 15.5 9.79 17 12 17z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol629 || (_symbol629 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-thumbs-down-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "thumbs-down-large"), /*#__PURE__*/React.createElement("path", {
    d: "M34.5 23V5.5m-1 20l-15 18-2-2a4 4 0 0 1-1-4.48l5-11.52H8.16a3 3 0 0 1-2.94-3.58L8.5 5.5h34v20h-9z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol630 || (_symbol630 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-thumbs-down-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "thumbs-down-small"), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 10V2.5m-.5 10l-7.5 9-1-1a2 2 0 0 1-.5-2.24l2.5-5.76H4.33a1.5 1.5 0 0 1-1.47-1.79L4.5 2.5h17v10H17z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol631 || (_symbol631 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-thumbs-up-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "thumbs-up-large"), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 25v17.5m1-20l15-18 2 2a4 4 0 0 1 1 4.48l-5 11.52h12.34a3 3 0 0 1 2.94 3.58L39.5 42.5h-34v-20h9z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol632 || (_symbol632 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-thumbs-up-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "thumbs-up-small"), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 14v7.5m.5-10l7.5-9 1 1a2 2 0 0 1 .5 2.24l-2.5 5.76h6.17a1.5 1.5 0 0 1 1.47 1.79L19.5 21.5h-17v-10H7z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol633 || (_symbol633 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-time-climate1-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "time-climate1-large"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5 20.5c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3zM32 39.4c-2.5 1.4-5.4 2.1-8.5 2.1-9.9 0-18-8.1-18-18s8.1-18 18-18 18 8.1 18 18c0 2.3-.4 4.5-1.2 6.5m-16.8-9.5V9m3 14.5H34",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M37.495 41.914v-8.259L35 34.087V33.08l2.964-.581h.753v9.414z"
  })))), _symbol634 || (_symbol634 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-time-climate1-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "time-climate1-small"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 22.6c-1.4.6-2.9.9-4.5.9-6.1 0-11-4.9-11-11s4.9-11 11-11 11 4.9 11 11c0 1.2-.2 2.4-.6 3.5M16 13.5h-4.5v-8",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M18.97 22.819v-4.143l-1.37.253v-.842l1.72-.337h.662v5.069z"
  })))), _symbol635 || (_symbol635 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-time-climate2-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "time-climate2-large"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5 20.5c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3zM32 39.4c-2.5 1.4-5.4 2.1-8.5 2.1-9.9 0-18-8.1-18-18s8.1-18 18-18 18 8.1 18 18c0 2.3-.4 4.5-1.2 6.5m-16.8-9.5V9m3 14.5H34",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 41.97v-.934l2.422-2.33c.262-.251.504-.488.725-.71.221-.223.422-.435.603-.637.18-.202.34-.396.478-.582.137-.186.253-.368.347-.546.094-.178.165-.354.213-.529.047-.174.071-.351.071-.531 0-.258-.04-.492-.119-.702-.08-.21-.2-.387-.362-.533a1.64 1.64 0 0 0-.615-.336 2.945 2.945 0 0 0-.881-.118c-.267 0-.52.01-.757.032a6.208 6.208 0 0 0-.68.097 5.096 5.096 0 0 0-.61.162 4.123 4.123 0 0 0-.553.23V32.93a3.29 3.29 0 0 1 .508-.228c.184-.066.385-.122.602-.167.217-.046.449-.08.696-.102.248-.022.515-.033.8-.033.381 0 .725.03 1.033.087.308.058.582.142.822.251.24.109.447.243.62.402.172.158.314.338.426.54.112.2.195.422.248.664.053.242.079.502.079.78 0 .27-.034.53-.102.778-.067.249-.163.491-.287.727a4.986 4.986 0 0 1-.444.695 9.332 9.332 0 0 1-.573.683c-.21.227-.435.457-.678.688-.242.232-.492.468-.75.71l-1.635 1.558h4.847v1.006H35z",
    fill: "currentColor",
    fillRule: "nonzero"
  })))), _symbol636 || (_symbol636 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-time-climate2-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "time-climate2-small"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 22.6c-1.4.6-2.9.9-4.5.9-6.1 0-11-4.9-11-11s4.9-11 11-11 11 4.9 11 11c0 1.2-.2 2.4-.6 3.5M16 13.5h-4.5v-8",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 23v-.733l1.174-.954c.162-.133.31-.258.442-.375.133-.117.251-.228.356-.333.105-.106.195-.206.271-.302a1.98 1.98 0 0 0 .189-.282c.05-.092.087-.183.112-.272.024-.09.037-.181.037-.275a.92.92 0 0 0-.058-.33.642.642 0 0 0-.18-.258.86.86 0 0 0-.314-.167c-.127-.04-.279-.06-.457-.06-.13 0-.263.01-.398.03a3.788 3.788 0 0 0-1.046.309v-.82a2.732 2.732 0 0 1 .625-.247c.128-.034.268-.061.42-.081a3.725 3.725 0 0 1 1.125.027c.19.038.357.093.503.163a1.38 1.38 0 0 1 .778.961c.03.137.046.279.046.426 0 .168-.024.33-.07.483a2.068 2.068 0 0 1-.196.445 2.872 2.872 0 0 1-.297.415 4.941 4.941 0 0 1-.371.389 7.51 7.51 0 0 1-.424.369c-.149.12-.299.239-.45.356l-.402.303h2.475V23H18z",
    fill: "currentColor",
    fillRule: "nonzero"
  })))), _symbol637 || (_symbol637 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-time-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "time-large"), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 26.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm18-3c0 9.9-8.1 18-18 18s-18-8.1-18-18 8.1-18 18-18 18 8.1 18 18zm-18-3V9m3 14.5H34",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol638 || (_symbol638 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-time-long-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "time-long-large"), /*#__PURE__*/React.createElement("path", {
    d: "M23 41.5C13.1 41.2 5.2 32.9 5.5 23v-.5m18-17c9.9 0 18 8.1 18 18s-8.1 18-18 18H23M7 14l2 2m5.5-8.5L16 10m7.5 16.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2.1-5.1l5.9-6.9M1 27l4.5-4.5L10 27",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol639 || (_symbol639 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-time-long-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "time-long-small"), /*#__PURE__*/React.createElement("path", {
    d: "M11.9 1.4c5.3 0 9.6 4.3 9.6 9.6s-4.3 9.6-9.6 9.6c-2.7 0-5.2-1.2-6.9-3.1-1.1-1.1-1.7-2.6-2.1-4.1-.2-.9-.4-1.9-.4-2.9M11 12l5-5M3 6.5H2M6.5 3V2M.3 12.6l2.2-2.1L5 12.2",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol640 || (_symbol640 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-time-middle-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "time-middle-large"), /*#__PURE__*/React.createElement("path", {
    d: "M25.6 21.4l5.9-6.9M27 46l-4.5-4.5 4.4-4.4M7 14l2 2m4 24l2-2m-.5-30.5L16 10M6 33l2-1.5m-4-8h3m15.5 18h1c9.9 0 18-8.1 18-18s-8.1-18-18-18H23m.5 21a3 3 0 1 0 0-6 3 3 0 0 0 0 6z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol641 || (_symbol641 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-time-middle-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "time-middle-small"), /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5c5.3 0 9.5 4.2 9.5 9.5 0 4.6-3.2 8.4-7.4 9.4-.7.2-1.8.3-2.6.1m-9.5-4h1m0-10H2M6.5 20v-1m0-16V2M1 11.5h1m9 .5l5-5m-2 16l-2.5-2.5L14 18",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol642 || (_symbol642 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-time-short-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "time-short-large"), /*#__PURE__*/React.createElement("path", {
    d: "M46 20l-4.5 4.5L37 20M23.5 40v3M7 14l2 2m22 22l2 2m-20 0l2-2m-.5-30.5L16 10m22 21.5l2 1.5M6 33l2-1.5m-4-8h3m18.6-2.1l5.9-6.9m10 10v-1c0-9.9-8.1-18-18-18H23m.5 21a3 3 0 1 0 0-6 3 3 0 0 0 0 6z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol643 || (_symbol643 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-time-short-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "time-short-small"), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 20v1m8.5-4.5h1M16.5 19v1M2 16.5h1m0-10H2M6.5 20v-1m0-16V2M1 11.5h1m10-10c5.1 0 9.1 3.9 9.4 9M11 12l5-5m7.6 1.4l-2.2 2.1-2.5-1.7",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol644 || (_symbol644 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-time-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "time-small"), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 12.5c0 6.1-4.9 11-11 11s-11-4.9-11-11 4.9-11 11-11 11 4.9 11 11zm-11 .5V5v8zm4.5-.5h-4.5H16z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol645 || (_symbol645 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-tire-battery-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "tire-battery-large"), /*#__PURE__*/React.createElement("path", {
    d: "M35 11l-2.5 4.49h4.1L34 20M31.5 5.5h-3v18a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-18h-3m-6 0v-3h6v3m-6 0h6M20.1 21l.8 2.25m4-2.25l-.8 2.25m-1.2 13.5L22.866 39m1.634-5.85l1.6 1.35m-5.2-1.35l-1.6 1.35m1.2-6.525l-2-.45m6.4.675l1.6-.9m4.981.7c.013.33.019.664.019 1 0 8.56-4.07 15.5-9.09 15.5h-6.82c-5.02 0-9.09-6.94-9.09-15.5 0-8.56 4.07-15.5 9.09-15.5h6.82c1.313 0 2.562.475 3.69 1.33M29.48 28c.013.33.02.663.02 1 0 6.904-2.91 12.5-6.5 12.5s-6.5-5.596-6.5-12.5 2.91-12.5 6.5-12.5c1.122 0 2.179.547 3.1 1.51",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol646 || (_symbol646 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-tire-battery-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "tire-battery-small"), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 3.502V1.5h4v2.002m-9 2.998H6.864C4.454 6.5 2.5 9.858 2.5 14c0 4.142 1.954 7.5 4.364 7.5H10.5m0 0c-2.21 0-4-3.358-4-7.5 0-4.142 1.79-7.5 4-7.5.345 0 .68.082 1 .236m-1 14.764c1.392 0 2.618-1.333 3.334-3.355M21.5 3.5v11.667a1.334 1.334 0 0 1-1.333 1.333h-5.334a1.334 1.334 0 0 1-1.333-1.333V3.5h8zm-11 13c.552 0 1-1.12 1-2.5s-.448-2.5-1-2.5-1 1.12-1 2.5.448 2.5 1 2.5z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol647 || (_symbol647 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-tire-sealant-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "tire-sealant-large"), /*#__PURE__*/React.createElement("path", {
    d: "M20.1 21l.8 2.25m2 13.5L22.866 39m1.634-5.85l1.6 1.35m-5.2-1.35l-1.6 1.35m1.2-6.525l-2-.45m6.4.675l1.6-.9m2.917-.3c.055.651.083 1.32.083 2 0 6.904-2.91 12.5-6.5 12.5s-6.5-5.596-6.5-12.5 2.91-12.5 6.5-12.5c.34 0 .674.05 1 .147M31.495 28.5c.003.166.005.333.005.5 0 8.56-4.07 15.5-9.09 15.5h-6.82c-5.02 0-9.09-6.94-9.09-15.5 0-8.56 4.07-15.5 9.09-15.5h6.82c.719 0 1.419.143 2.09.412m0 8.213l-.4 1.125m18.897-5.375c.121 4.614-3.4 8.378-8.013 8.62h-.486C29.764 26.374 26 22.61 26 17.875 26 13.141 34.498 1 34.498 1s8.499 12.262 8.499 16.875z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol648 || (_symbol648 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-tire-sealant-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "tire-sealant-small"), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 6.5H6.864C4.454 6.5 2.5 9.858 2.5 14c0 4.142 1.954 7.5 4.364 7.5H10.5m0 0c-2.21 0-4-3.358-4-7.5 0-4.142 1.79-7.5 4-7.5.345 0 .68.082 1 .236m-1 14.764c1.935 0 3.55-2.577 3.92-6m7.078-5.566c.065 2.443-1.8 4.435-4.242 4.564H17c-2.506-.065-4.499-2.057-4.499-4.564S17 1 17 1s4.498 6.492 4.498 8.934zM10.5 16.5c.552 0 1-1.12 1-2.5s-.448-2.5-1-2.5-1 1.12-1 2.5.448 2.5 1 2.5z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol649 || (_symbol649 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-top-speed-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "top-speed-large"), /*#__PURE__*/React.createElement("path", {
    d: "M11 27.5H4m7-3H2m9-3H4m19.003 7a3 3 0 1 1-6 0l-1.959-.141c-.824-.06-1.598-.776-1.541-1.6l.404-3.622a2 2 0 0 1 1.5-1.8 19.223 19.223 0 0 1 1.596-.336c1.5-.25 4.5-2.25 6.5-3 1.025-.385 3.048-.51 5-.5 1.856.009 3.647.134 4.5.5.737.315 2.153 1.482 4.25 3.5 2.5.333 4.25.666 5.25 1 1.5.5 2.5 1.5 2.75 2.25.167.5.25 1.25.25 2.25v.25c0 .69-.56 1.25-1.25 1.25h-2.25a3 3 0 1 1-6 0h-13z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol650 || (_symbol650 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-top-speed-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "top-speed-small"), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 15.5a1.5 1.5 0 0 1-3 0l-1.181-.152c-.438-.032-.85-.41-.819-.848l.216-2.006c.032-.457.353-.842.797-.956.283-.072.565-.131.848-.179.797-.132 2.39-1.195 3.453-1.593.544-.204 1.65-.27 2.686-.266.986.005 1.907.072 2.36.266.391.168 1.144.787 2.258 1.86 1.328.176 2.257.353 2.788.53.797.266 1.328.797 1.461 1.195.089.266.133.664.133 1.196l-.002.212a.664.664 0 0 1-.664.664L21.5 15.5a1.5 1.5 0 0 1-3 0h-7zm-6.5 0H1m4-2H0m5-2H1",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol651 || (_symbol651 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-torque-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "torque-large"), /*#__PURE__*/React.createElement("path", {
    d: "M27.1 15.5v2.7c.6.2 1.2.4 1.7.7l1.9-1.9 2.3 2.3-1.9 1.9c.3.5.5 1.1.7 1.7h2.7v3.3h-2.7c-.2.6-.4 1.2-.7 1.7l1.9 1.9-2.3 2.2-1.9-1.9c-.5.3-1.1.5-1.7.7v2.7h-3.3v-2.7c-.6-.2-1.2-.4-1.7-.7L20.3 32 18 29.7l1.9-1.9c-.3-.5-.5-1.1-.7-1.7h-2.7v-3.3h2.7c.2-.6.4-1.2.7-1.7L18 19.3l2.3-2.3 1.9 1.9c.5-.3 1.1-.5 1.7-.7v-2.7h3.2zM25.5 24v1-1zM16.7 5.7c.9.2 1.7.7 2.3 1.3l1.9-1 1.3 2.1-1.9 1.2c.2.8.2 1.7 0 2.5l2 1.2-1.3 2.1-2-1.2c-.6.6-1.4 1.1-2.3 1.3v2.3h-2.5v-2.3c-.8-.2-1.6-.7-2.2-1.3L10.1 15l-1.3-2 2-1.2c-.2-.8-.2-1.7 0-2.6l-2-1.1L10.2 6 12 7c.6-.6 1.4-1.1 2.2-1.3V3.5h2.5v2.2zM15.5 10v1-1zm-7 12.6v1.9c0 9.4 7.6 17 17 17s17-7.6 17-17-7.6-17-17-17M12.7 26.7l-4.2-4.2-4.2 4.2",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol652 || (_symbol652 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-torque-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "torque-small"), /*#__PURE__*/React.createElement("path", {
    d: "M12.7 6.7c.9.2 1.7.7 2.3 1.3l1.9-1 1.3 2.1-1.9 1.2c.2.8.2 1.7 0 2.5l2 1.2-1.3 2.1-2-1.2c-.6.6-1.4 1.1-2.3 1.3v2.3h-2.5v-2.3c-.8-.2-1.6-.6-2.2-1.3L6.1 16l-1.3-2 2-1.2c-.2-.9-.2-1.8 0-2.6l-2-1.1L6.2 7 8 8c.6-.6 1.4-1 2.2-1.2V4.5h2.5v2.2zM11.5 11v1-1zM2.7 4.9C4.7 2.3 7.9.5 11.5.5c6.1 0 11 4.9 11 11s-4.9 11-11 11c-3.4 0-5.9-1.6-7.9-4m4.4 0H3.5V23",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol653 || (_symbol653 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-tour-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "tour-large"), /*#__PURE__*/React.createElement("path", {
    d: "M38.5 24.5c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3zM7.7 5.5H8c2.2 0 4 1.8 4 4s-4 8.2-4 8.2-4-6.1-4-8.2c-.1-2.1 1.6-3.9 3.7-4zm18 0h.3c2.2 0 4 1.8 4 4s-4 8.2-4 8.2-4-6.1-4-8.2c-.1-2.1 1.6-3.9 3.7-4zm5.8 22c-.2-3.8 2.7-6.8 6.5-7h.4c3.9 0 7 3.1 7.1 7 0 3.9-7 14-7 14s-7-10.1-7-14zM8 21.5h16L10 32l28 14.1",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol654 || (_symbol654 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-tour-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "tour-small"), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 8.5c2.2 0 4 1.8 4 4s-4 8-4 8-4-5.8-4-8c-.1-2.2 1.6-3.9 3.8-4h.2zm-15-6c1.1 0 2 .9 2 2s-2 4-2 4-2-2.9-2-4 .8-2 1.9-2h.1zm9 0c1.1 0 2 .9 2 2s-2 4-2 4-2-2.9-2-4 .8-2 1.9-2h.1zm-9.5 8h8.5l-7 5 14 7.5",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol655 || (_symbol655 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-traffic-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "traffic-large"), /*#__PURE__*/React.createElement("path", {
    d: "M20 14c-.303-.483-.616-.893-1.133-1.5a49.08 49.08 0 0 0-4.758-.25c-1.619 0-3.21.112-4.776.25-.517.62-.927 1.086-1.23 1.568L6.95 15.9 5.5 17.5v6c0 .479.521 1 1 1h2c.479 0 1-.521 1-1H11m-4.62-7h7.12m-8.067 2H8.9m20.52-.114c-.35-.556-.823-1.185-1.42-1.886a56.708 56.708 0 0 0-5.49-.261c-1.867 0-3.704.08-5.51.238-.597.716-1.07 1.353-1.42 1.91L14.25 20.5l-1.75 2v7a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1H19m-4.75-8H22m-9.5 3h4m4 4v8a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1h15v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-8l-2-2c-.66-1.212-1.19-2.136-1.59-2.773-.4-.636-.87-1.363-1.41-2.182a78.437 78.437 0 0 0-6.488-.272c-2.135 0-4.305.09-6.512.272-.54.819-1.01 1.546-1.41 2.182-.4.637-.93 1.56-1.59 2.773l-2 2zm2-2h19m-21 3H25m14 0h4.5",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol656 || (_symbol656 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-traffic-sign-recognition-alert-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "traffic-sign-recognition-alert-large"), /*#__PURE__*/React.createElement("path", {
    d: "M46.5 23.5h-20l10-18 10 18zM36.5 11v6m0 2v2m-.6 6l8.6 15.5h-42l21-38 4.7 8.6m-3.557 10.174a55.8 55.8 0 0 0-2.357-.051c-1.612 0-3.307.075-5.087.225a30.586 30.586 0 0 0-1.11 1.629c-.301.48-.702 1.088-1.202 1.824L13.5 28.566V36m2-4v6.533a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V37.5h11v1.033a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V32L33 30.2a69.56 69.56 0 0 1-1.3-1.973 33.07 33.07 0 0 0-1.2-1.76 65.398 65.398 0 0 0-5.5-.244c-1.743 0-3.576.081-5.5.244a33.07 33.07 0 0 0-1.2 1.76c-.327.52-.76 1.177-1.3 1.973L15.5 32zm1-1.5h17m-18 3H19m12 0h3.5",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol657 || (_symbol657 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-traffic-sign-recognition-alert-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "traffic-sign-recognition-alert-small"), /*#__PURE__*/React.createElement("path", {
    d: "M23.2 12.5H11.6L17.5 1l5.7 11.5zM17.5 5v3m0 1v2m2 4l3.7 7.5H.8L12 1.5 13.5 4M9 12.5l-2.5 3V19m2-2v3a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-.5h5v.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-3l-2-2.5h-5l-2 2.5z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol658 || (_symbol658 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-traffic-sign-recognition-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "traffic-sign-recognition-large"), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 42.5l21-38 21 38h-42zm25.8-17.6c-.302-.48-.49-.847-.927-1.452a60.485 60.485 0 0 0-5.087-.225c-1.612 0-3.307.075-5.087.225a30.586 30.586 0 0 0-1.11 1.629c-.301.48-.702 1.088-1.202 1.824L13.5 28.566V36m2-4v6.533a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V37.5h11v1.033a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V32L33 30.2a69.56 69.56 0 0 1-1.3-1.973 33.07 33.07 0 0 0-1.2-1.76 65.398 65.398 0 0 0-5.5-.244c-1.743 0-3.576.081-5.5.244a33.07 33.07 0 0 0-1.2 1.76c-.327.52-.76 1.177-1.3 1.973L15.5 32zm1-1.5h17m-18 3H19m12 0h3.5",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol659 || (_symbol659 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-traffic-sign-recognition-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "traffic-sign-recognition-small"), /*#__PURE__*/React.createElement("path", {
    d: "M23.2 22.5H.8L12 1.5l11.2 21zm-9.2-10H9l-2.5 3V19m2-2v3a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-.5h5v.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-3l-2-2.5h-5l-2 2.5z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol660 || (_symbol660 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-traffic-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "traffic-small"), /*#__PURE__*/React.createElement("path", {
    d: "M9 5.5H3.5l-3 3v3.25c0 .414.336.75.75.75h.5a.75.75 0 0 0 .75-.75V11m-2-1.5h2m13.25-.75L14.5 7.5h-6l-4.045 4 .038 4.257a.75.75 0 0 0 .75.743H6a.5.5 0 0 0 .5-.5v-1m-2-2.5H7m1.5 2v5a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1h9a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-5l-4-4h-7l-4 4zm0 1H12m8 0h3.5m-14-2h13",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol661 || (_symbol661 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-trailer-maneuver-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "trailer-maneuver-large"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 34.5h11.5l3-3h15l3 3h2a2 2 0 0 0 2-2V19m-30 6v9.5m11 5a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm9 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-9.5-25h2.977m-8.026 5.642l-2.948-2.95 2.948 2.95zm-9.906-.002l2.976-2.971M12 22a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15zm0-3.99c1.578 0 2.5-1.07 2.5-2.678 0-.893 0-1.964-.714-2.428-.573-.372-3-.371-3.572 0-.714.464-.714 1.535-.714 2.428 0 1.607.922 2.679 2.5 2.679zm-2.255-4.544H4.524m14.922 0h-5.18",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.088 8.8c.371 0 .706.042 1.003.126.297.084.56.204.788.361.229.157.425.347.587.569.163.222.297.472.4.75.105.277.181.578.23.902.049.323.073.665.073 1.025 0 .358-.024.7-.074 1.025-.05.326-.127.627-.233.904-.106.276-.241.527-.405.752a2.442 2.442 0 0 1-.591.573c-.23.158-.493.28-.791.365a3.627 3.627 0 0 1-1.001.128c-.371 0-.705-.041-1.001-.125a2.64 2.64 0 0 1-.786-.362 2.412 2.412 0 0 1-.585-.568 3.142 3.142 0 0 1-.4-.749 4.42 4.42 0 0 1-.229-.902A6.903 6.903 0 0 1 27 12.548c0-.359.025-.7.074-1.025.05-.324.127-.625.232-.903.105-.277.24-.528.403-.753.164-.225.36-.416.59-.574a2.7 2.7 0 0 1 .788-.365 3.61 3.61 0 0 1 1.001-.128zm0 .789c-.255 0-.485.033-.688.1a1.714 1.714 0 0 0-.941.737 2.653 2.653 0 0 0-.276.593c-.073.22-.125.458-.158.713a6.398 6.398 0 0 0-.048.808c0 .283.016.553.048.81.033.256.085.494.158.712.072.22.164.417.276.594.111.176.245.326.401.45.157.124.336.22.54.287.203.068.433.101.688.101.256 0 .485-.033.688-.101.202-.068.381-.163.537-.287.155-.124.288-.274.399-.45.11-.177.202-.375.275-.594.072-.218.125-.456.158-.712.034-.257.05-.527.05-.81 0-.283-.016-.552-.05-.808a3.879 3.879 0 0 0-.158-.713 2.687 2.687 0 0 0-.275-.593 1.699 1.699 0 0 0-.938-.737 2.195 2.195 0 0 0-.686-.1zM35 16.24V9h4.329v.776h-3.39v2.544h3.121v.777h-3.12v3.144H35zm6 0V9h4.329v.776h-3.39v2.544h3.121v.777h-3.12v3.144H41z",
    fill: "currentColor",
    fillRule: "nonzero"
  })))), _symbol662 || (_symbol662 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-trailer-maneuver-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "trailer-maneuver-small"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 19.5h6.5l2-2h9l2 2h1a1 1 0 0 0 1-1V9m-18 5v5.5m6.625 3a1.625 1.625 0 1 0 0-3.25 1.625 1.625 0 0 0 0 3.25zm5.75 0a1.625 1.625 0 1 0 0-3.25 1.625 1.625 0 0 0 0 3.25zM8.801 11.261L6.836 9.295 8.8 11.261zm-6.605-.001L4.18 9.28M5.5 12.5a5 5 0 1 0 0-10 5 5 0 0 0 0 10zm0-2.66c1.052 0 1.667-.714 1.667-1.785 0-.595 0-1.31-.477-1.62-.381-.247-2-.247-2.38 0-.477.31-.477 1.025-.477 1.62 0 1.071.615 1.786 1.667 1.786zM3.997 6.81H.516m9.948 0H7.01",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.005 3.25c.258 0 .487.027.687.082.2.055.373.131.521.23.148.099.273.217.375.356.102.139.184.292.246.46.062.168.107.348.134.54a4.255 4.255 0 0 1-.003 1.197c-.03.193-.077.373-.142.541a1.873 1.873 0 0 1-.252.46c-.104.139-.23.258-.38.357-.148.1-.32.177-.516.232-.196.054-.42.082-.67.082-.258 0-.487-.028-.687-.082a1.78 1.78 0 0 1-.521-.231 1.482 1.482 0 0 1-.375-.356 1.87 1.87 0 0 1-.246-.46 2.606 2.606 0 0 1-.135-.541 4.255 4.255 0 0 1 .004-1.197c.03-.192.077-.373.142-.54.065-.169.149-.322.252-.46.104-.14.23-.258.378-.357.149-.1.321-.176.517-.231.197-.055.42-.082.671-.082zm5.737.1v.699h-1.875v1.186h1.669v.698h-1.669v1.762H17V3.35h2.742zm4 0v.699h-1.875v1.186h1.669v.698h-1.669v1.762H21V3.35h2.742zm-9.737.622c-.13 0-.249.017-.355.05a.896.896 0 0 0-.494.368c-.059.09-.107.192-.146.306-.039.114-.067.24-.085.378a3.418 3.418 0 0 0-.027.444c0 .158.009.306.027.443.018.138.046.264.085.38.039.114.087.216.146.305a.895.895 0 0 0 .494.368c.106.033.225.049.355.049.131 0 .25-.016.355-.048a.896.896 0 0 0 .493-.369c.059-.09.108-.191.146-.306.039-.115.067-.24.085-.379.018-.137.027-.285.027-.443 0-.159-.009-.307-.027-.444A1.991 1.991 0 0 0 15 4.696a1.327 1.327 0 0 0-.146-.306.896.896 0 0 0-.493-.369 1.194 1.194 0 0 0-.355-.049z",
    fill: "currentColor",
    fillRule: "nonzero"
  })))), _symbol663 || (_symbol663 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-train-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "train-large"), /*#__PURE__*/React.createElement("path", {
    d: "M28.9 37.1c-.6.3-1.2.4-1.8.4h-4c-.6 0-1.3-.2-1.8-.4l-6-3.1c-1.6-1.1-2.8-3-2.8-5V12.5c0-2.8 2.4-5 5.2-5h15c2.8 0 4.8 2.2 4.8 5V29c0 2-.8 3.8-2.4 5l-6.2 3.1zM9 46l8-8-8 8zm24-8l8 8-8-8zM18 26.5c1.4 0 2.5 1.1 2.5 2.5s-1.1 2.5-2.5 2.5-2.5-1.1-2.5-2.5 1.1-2.5 2.5-2.5zm14 0c1.4 0 2.5 1.1 2.5 2.5s-1.1 2.5-2.5 2.5-2.5-1.1-2.5-2.5 1.1-2.5 2.5-2.5zm-16-23h18-18zm3.4 0l4 4-4-4zm11 0l-4 4 4-4zm-15.7 7h20.6-20.6zm4.5 10h11.3-11.3zM14 9l6.5 14.5H29l7.1-14.6",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol664 || (_symbol664 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-train-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "train-small"), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 23.5L6 21l-2.5 2.5zM17 21l2.5 2.5L17 21zm-7-.5L6 18c-.9-.6-1.5-1.6-1.5-2.7V5.5c0-1.6 1.6-3 3.2-3h7.8c1.6 0 3 1.4 3 3v9.8c0 1.2-.6 2-1.5 2.7l-4 2.5h-3zM8 .5h7-7zm3.5 0v2-2zm-6 2.9l4 8.1h4l4.1-8.1M8.5 13c.8 0 1.5.8 1.5 1.5S9.2 16 8.5 16 7 15.2 7 14.5 7.8 13 8.5 13m6 0c.8 0 1.5.8 1.5 1.5s-.8 1.5-1.5 1.5-1.5-.8-1.5-1.5.8-1.5 1.5-1.5",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol665 || (_symbol665 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-training-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "training-large"), /*#__PURE__*/React.createElement("path", {
    d: "M30.1 37.5h13.4v-12c0-1.7-1.3-3-3-3H24m4-16h6.5c1.7 0 3 1.3 3 3v6c0 1.7-1.3 3-3 3h-6c-1.7 0-3-1.3-3-3V13m-4-1v6.5c0 1.7-1.3 3-3 3h-6c-1.7 0-3-1.3-3-3V12m-6-3v-.5l12-5.5 12 6-12 6-12-6zm0 0v9m0 22.5v-12c0-1.7 1.3-3 3-3h18c1.7 0 3 1.3 3 3v12h-24z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol666 || (_symbol666 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-training-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "training-small"), /*#__PURE__*/React.createElement("path", {
    d: "M15 18.5h7.5v-6c0-.6-.4-1-1-1H12m3-9h2.5c1.1 0 2 .9 2 2v2c0 1.1-.9 2-2 2h-2c-1.1 0-2-.9-2-2m-3-.5v2.5c0 1.1-.9 2-2 2h-2c-1.1 0-2-.9-2-2V6m-3-1.5V4l6-2.5 6 3-6 3-6-3zm0 0V9m0 11.5v-6c0-.6.4-1 1-1h10c.6 0 1 .4 1 1v6h-12z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol667 || (_symbol667 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-transmission-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "transmission-large"), /*#__PURE__*/React.createElement("path", {
    d: "M37.5 13v23m-9-23v23m-9-23v23m-9-23v11.5h27",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol668 || (_symbol668 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-transmission-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "transmission-small"), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 5v15m-7-15v15m-7-15v15m-7-15v7.5h21",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol669 || (_symbol669 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-trunk-open-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "trunk-open-large"), /*#__PURE__*/React.createElement("path", {
    d: "M33 28.5H15a4 4 0 0 1-4 4h-.5a4 4 0 0 1-4-4H3.258c-.971 0-1.758-.787-1.758-1.758v-.351c0-1.406.039-1.993.273-2.696.351-1.055 1.758-2.46 3.867-3.164 1.406-.468 3.867-.937 7.382-1.406 2.948-2.837 4.94-4.477 5.976-4.921 1.2-.514 3.717-.69 6.327-.703 2.745-.014 5.59.162 7.031.703 2.812 1.054 7.03 3.867 9.14 4.218a27.03 27.03 0 0 1 2.243.473c1.176.3 1.788 1.457 2.11 2.531.322 1.074.721 3.415.647 4.574-.075 1.16-1.008 2.216-2.167 2.3l-2.829.2a4 4 0 0 1-4 4H37a4 4 0 0 1-4-4zM35.5 14l.105-.255c.598-.617.943-.976 1.036-1.076C38.81 10.314 40.413 9 41.514 9c1.884 0 2.235.438 2.986 1.25",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol670 || (_symbol670 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-trunk-open-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "trunk-open-small"), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 15.52l-9-.02a2.25 2.25 0 0 1-2.25 2.25h-.02A2.23 2.23 0 0 1 3 15.52l-1.5-.02c-.502 0-1-.543-1-1.045v-.182c0-.727-.021-1.273.1-1.636.182-.546.96-1.273 2.05-1.637.727-.242 1.893-.484 3.711-.727 1.525-1.467 2.556-2.316 3.091-2.545.62-.266 1.923-.357 3.273-.364 1.42-.007 2.89.084 3.636.364 1.455.545 3.637 2 4.728 2.181.387.065.674.147 1.061.245.608.156 1.107.683 1.15 1.31l.2 2.633c.042.6-.387 1.12-.987 1.164L21 15.52a2.23 2.23 0 0 1-2.23 2.229h-.04a2.23 2.23 0 0 1-2.23-2.23zM18 7.226l.054-.138c.306-.337.484-.532.531-.587 1.114-1.284 1.935-2 2.5-2 .966 0 1.146.057 1.531.5",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol671 || (_symbol671 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-tube-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "tube-large"), /*#__PURE__*/React.createElement("path", {
    d: "M7 46l6-6-6 6zm27.1-6.1l6 6.1-6-6.1zM23.5 14.5h9c1.7 0 3 1.4 3 3v6h-12v-9zm0 9h-12v-6c0-1.7 1.3-3 3-3h9v9zm-9.5 6c1.4 0 2.5 1.1 2.5 2.5s-1.1 2.5-2.5 2.5-2.5-1.1-2.5-2.5 1.1-2.5 2.5-2.5zm19 0c1.4 0 2.5 1.1 2.5 2.5s-1.1 2.5-2.5 2.5-2.5-1.1-2.5-2.5 1.1-2.5 2.5-2.5zm-20-24h21-21zm5.4 0l4.1 4.1-4.1-4.1zm10 0l-4 4 4-4zm-1.4 6h6.5c2.8 0 5 2.2 5 5v18c0 1.7-1.3 3-3 3h-24c-1.7 0-3-1.3-3-3v-18c0-2.8 2.2-5 5-5H20s0-2 3.5-2 3.5 2 3.5 2z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol672 || (_symbol672 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-tube-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "tube-small"), /*#__PURE__*/React.createElement("path", {
    d: "M13.6 3.5h3.9c1.7 0 3 1.9 3 3.6v10.7c0 1-.8 1.7-1.9 1.7H4.3c-1 0-1.8-.6-1.8-1.7V7.1c0-1.7 1.3-3.6 3-3.6h3.9s0-1.2 2.1-1.2 2.1 1.2 2.1 1.2zM5 .5h13H5zm6.5-.5v11.5V0zm-8 23.5L6 21l-2.5 2.5zM17 21l2.5 2.5L17 21zm3.5-9.5h-18 18zM18 16c0 1-1 2-2 2s-2-1-2-2 1-2 2-2 2 1 2 2zM7 14c1 0 2 1 2 2s-1 2-2 2-2-1-2-2 1-2 2-2z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol673 || (_symbol673 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-twitter-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "twitter-large"), /*#__PURE__*/React.createElement("path", {
    d: "M34.5 16.2s3.2.4 4.1-.2c-1.5.8-3 1.8-4.2 3 0 0 1.2 13.3-12.7 16.5 0 0-7.2.6-12.3-3.3 0 0 5.5 1.5 8.5-1.9 0 0-5.1.5-6.4-3.5 1.2 0 2.4-.2 3.6-.5 0 0-4.8-.9-4.7-5.7.8.5 1.7.7 2.7.7 0 0-4-3.6-1.5-7.8 0 0 5.3 6.5 11.9 6.1-.8-3 1-6.1 4.1-6.9 2-.5 4 .1 5.4 1.5 1.4-.3 2.7-.9 3.9-1.9-.1.2 0 2-2.4 3.9z",
    fill: "currentColor"
  }))), _symbol674 || (_symbol674 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-twitter-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "twitter-small"), /*#__PURE__*/React.createElement("path", {
    d: "M17 8.2c.7.1 1.3.1 2-.1-.7.4-1.4.9-2 1.5.3 3.8-2.3 7.2-6.1 7.9-2.1.1-4.2-.4-5.9-1.6 0 0 2.6.7 4.1-.9 0 0-2.5.2-3.1-1.7.6 0 1.2-.1 1.7-.2-1.3-.3-2.3-1.4-2.3-2.7.4.2.8.3 1.3.3 0 0-1.9-1.7-.7-3.7 0 0 2.6 3.1 5.7 2.9-.4-1.5.5-2.9 2-3.3.9-.2 1.9 0 2.6.7.7-.1 1.3-.4 1.8-.9 0 .8-.4 1.5-1.1 1.8z",
    fill: "currentColor"
  }))), _symbol675 || (_symbol675 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-upload-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "upload-large"), /*#__PURE__*/React.createElement("path", {
    d: "M38 9.5H11M24.5 39V16.5m-9 9l9-9 9 9",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol676 || (_symbol676 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-upload-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "upload-small"), /*#__PURE__*/React.createElement("path", {
    d: "M19 4.5H6M8 13l4.5-4.5L17 13m-4.5 7V8.5",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol677 || (_symbol677 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-used-car-search-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "used-car-search-large"), /*#__PURE__*/React.createElement("path", {
    d: "M25.987 16.501a57.659 57.659 0 0 0-1.03.003c-2.477.027-4.816.21-5.96.7-.565.242-1.417.842-2.554 1.8a48.13 48.13 0 0 0-1.117.972m-4.816 2.512c-.538.085-1.042.17-1.511.255-1.451.263-2.57.526-3.36.788-2.108.703-3.515 2.11-3.866 3.164-.234.703-.273 1.29-.273 2.696v.351c0 .971.787 1.758 1.758 1.758H6.5a4 4 0 0 0 4 4h.5a4 4 0 0 0 4-4h8m7.01 0H33a4 4 0 0 0 4 4h.5a4 4 0 0 0 4-4l2.829-.2c1.159-.084 2.092-1.14 2.167-2.3.074-1.16-.325-3.5-.647-4.574-.322-1.074-.934-2.23-2.11-2.53a27.03 27.03 0 0 0-2.243-.474c-2.11-.351-6.328-3.164-9.14-4.218a5.143 5.143 0 0 0-.33-.11 9.098 9.098 0 0 0-.973-.227M30.7 40.7l-7.5-16.9 7.5 16.9zm-2.2-25.3c.2 4.8-3.5 8.9-8.3 9.1h-.6c-5-.1-9-4.1-9.1-9.1.1-5 4.1-8.9 9.1-8.9 4.9 0 8.9 4 8.9 8.9z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol678 || (_symbol678 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-used-car-search-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "used-car-search-small"), /*#__PURE__*/React.createElement("path", {
    d: "M4.37 12.584c-.744.139-1.304.278-1.72.416-1.09.364-1.868 1.091-2.05 1.637-.121.363-.1.909-.1 1.636v.182c0 .502.498 1.045 1 1.045l1.5.02a2.23 2.23 0 0 0 2.23 2.23h.02A2.25 2.25 0 0 0 7.5 17.5l3.911.009m4.077.01l1.012.002a2.23 2.23 0 0 0 2.23 2.229h.04A2.23 2.23 0 0 0 21 17.52l1.513-.26c.6-.043 1.029-.563.987-1.163l-.2-2.634c-.043-.626-.542-1.153-1.15-1.309-.387-.098-.674-.18-1.061-.245-1.091-.181-3.273-1.636-4.728-2.181a2.976 2.976 0 0 0-.289-.09m-3.593-.272c-1.26.016-2.444.112-3.027.362-.316.135-.804.486-1.464 1.052M15.4 22.6l-4-9.5 4 9.5zm-.9-14.1c.1 2.7-2 4.9-4.6 5h-.3c-2.8 0-5-2.3-5-5 0-2.8 2.3-5 5-5s4.9 2.2 4.9 5z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol679 || (_symbol679 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-used-cars-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "used-cars-large"), /*#__PURE__*/React.createElement("path", {
    d: "M32.137 17.5h3.86a3 3 0 1 0 6 0l1.959-.141c.824-.06 1.598-.776 1.541-1.6l-.404-3.622a2 2 0 0 0-1.5-1.8 19.224 19.224 0 0 0-1.596-.336c-1.5-.25-4.5-2.25-6.5-3-1.025-.385-3.048-.51-5-.5-1.856.009-3.647.134-4.5.5-.737.315-2.153 1.482-4.25 3.5-2.5.333-4.25.666-5.25 1-1.5.5-2.5 1.5-2.75 2.25-.1.3-.17.69-.21 1.172m20.796 9.364l-.24-2.15a2 2 0 0 0-1.5-1.8 19.224 19.224 0 0 0-1.596-.336c-1.5-.25-4.5-2.25-6.5-3-1.025-.385-3.048-.51-5-.5-1.856.009-3.647.134-4.5.5-.737.315-2.153 1.482-4.25 3.5-2.5.333-4.25.666-5.25 1-1.5.5-2.5 1.5-2.75 2.25-.166.5-.25 1.25-.25 2.25v.25c0 .69.56 1.25 1.25 1.25h2.25a3 3 0 1 0 6 0h6m16 10a3 3 0 1 0 6 0l1.959-.142c.824-.06 1.598-.776 1.541-1.6l-.404-3.622a2 2 0 0 0-1.5-1.8 19.223 19.223 0 0 0-1.596-.336c-1.5-.25-4.5-2.25-6.5-3-1.025-.385-3.048-.51-5-.5-1.856.009-3.647.134-4.5.5-.737.315-2.153 1.482-4.25 3.5-2.5.333-4.25.666-5.25 1-1.5.5-2.5 1.5-2.75 2.25-.167.5-.25 1.25-.25 2.25v.25c0 .69.56 1.25 1.25 1.25h2.25a3 3 0 1 0 6 0h13z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol680 || (_symbol680 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-used-cars-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "used-cars-small"), /*#__PURE__*/React.createElement("path", {
    d: "M16.686 8.5H18.5a1.5 1.5 0 0 0 3 0l1.181-.152c.438-.032.85-.41.819-.848l-.216-2.006a1.062 1.062 0 0 0-.797-.956 10.212 10.212 0 0 0-.848-.179c-.797-.132-2.39-1.195-3.453-1.593-.544-.204-1.65-.27-2.686-.266-.986.005-1.907.072-2.36.266-.391.168-1.144.787-2.258 1.86-1.328.176-2.257.353-2.788.53-.797.266-1.328.797-1.461 1.195a2.694 2.694 0 0 0-.11.604m10.92 6.008l-.16-1.469a1.062 1.062 0 0 0-.796-.956 10.211 10.211 0 0 0-.848-.179c-.797-.132-2.39-1.195-3.453-1.593-.544-.204-1.65-.27-2.686-.266-.986.005-1.907.072-2.36.266-.391.168-1.144.787-2.258 1.86-1.328.176-2.257.353-2.788.53-.797.266-1.328.797-1.461 1.195-.089.266-.133.664-.133 1.196l.002.212c0 .367.297.664.664.664L2.5 14.5a1.5 1.5 0 0 0 3 0h4.49m8.51 6a1.5 1.5 0 0 0 3 0l1.181-.152c.438-.032.85-.41.819-.848l-.216-2.006a1.062 1.062 0 0 0-.797-.956 10.211 10.211 0 0 0-.848-.179c-.797-.132-2.39-1.195-3.453-1.593-.544-.204-1.65-.27-2.686-.266-.986.005-1.907.072-2.36.266-.391.168-1.144.787-2.258 1.86-1.328.176-2.257.353-2.788.53-.797.266-1.328.797-1.461 1.195-.089.266-.133.664-.133 1.196l.002.212c0 .367.297.664.664.664L8.5 20.5a1.5 1.5 0 0 0 3 0h7z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol681 || (_symbol681 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-user-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "user-large"), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 40.5v-13c0-1.7 1.3-3 3-3h19c1.7 0 3 1.3 3 3v13h-25zm9-33h7c1.7 0 3 1.3 3 3v7c0 1.7-1.3 3-3 3h-7c-1.7 0-3-1.3-3-3v-7c0-1.7 1.3-3 3-3z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol682 || (_symbol682 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-user-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "user-small"), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 13.5c.6 0 1 .4 1 1v7h-13v-7c0-.6.4-1 1-1h11zm-4-10c1.1 0 2 .9 2 2v3c0 1.1-.9 2-2 2h-3c-1.1 0-2-.9-2-2v-3c0-1.1.9-2 2-2h3z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol683 || (_symbol683 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-user-whole-body-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "user-whole-body-large"), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 44.5V31m-4-12v8.7l1 16.8h6l1-17V19m-8 8.5h-3V14.4c0-1.1.9-2 2-1.9h10c1.1 0 2 .9 2 1.9v13.1h-3m-5-24h2c1.1 0 2 .9 2 2v2c0 1.1-.9 2-2 2h-2c-1.1 0-2-.9-2-2v-2c0-1.1.9-2 2-2z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol684 || (_symbol684 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-user-whole-body-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "user-whole-body-small"), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 10v13.5h4V10m-4 4.5h-2v-7c0-.5.4-1 .9-1h6.1c.5 0 1 .4 1 .9v7.1h-2m-3-14h2c.6 0 1 .4 1 1v2c0 .6-.4 1-1 1h-2c-.6 0-1-.4-1-1v-2c0-.6.4-1 1-1z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol685 || (_symbol685 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-valet-parking-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "valet-parking-large"), /*#__PURE__*/React.createElement("path", {
    d: "M27 21.5h-1.675c-2.61.014-5.128.19-6.327.704-1.036.444-3.028 2.084-5.976 4.921-3.515.469-5.976.938-7.382 1.406-2.11.703-3.516 2.11-3.867 3.164-.234.703-.273 1.29-.273 2.696v.351c0 .971.787 1.758 1.758 1.758H6.5a4 4 0 0 0 4 4h.5a4 4 0 0 0 4-4h18a4 4 0 0 0 4 4h.5a4 4 0 0 0 4-4l2.829-.2c1.159-.084 2.092-1.14 2.167-2.3.074-1.16-.325-3.5-.647-4.574-.322-1.074-.934-2.23-2.11-2.53-.747-.191-1.495-.271-2.243-.396m4.004-3v-10h-16v10h16zm-8-7.5v4-4zm-6-2.5v-3c0-2.761 1.919-5 4.286-5h3.428c2.367 0 4.286 2.239 4.286 5v3",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol686 || (_symbol686 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-valet-parking-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "valet-parking-small"), /*#__PURE__*/React.createElement("path", {
    d: "M11.973 11.377c-1.064.034-2.017.135-2.52.35-.536.23-1.567 1.079-3.092 2.546-1.818.243-2.984.485-3.711.727-1.09.364-1.868 1.091-2.05 1.637-.121.363-.1.909-.1 1.636v.182c0 .502.498 1.045 1 1.045l1.5.02a2.23 2.23 0 0 0 2.23 2.23h.02A2.25 2.25 0 0 0 7.5 19.5l9 .02a2.23 2.23 0 0 0 2.23 2.23h.04A2.23 2.23 0 0 0 21 19.52l1.513-.26c.6-.043 1.029-.563.987-1.163l-.25-2.947m.25-1.65v-6h-10v6h10zm-5-4.5v2.5V9zm-4-1.5v-2a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v2",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol687 || (_symbol687 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-vehicle-signal-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "vehicle-signal-large"), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 19c-3 1.9-3.9 6-2 9M8 13c-5.5 4.4-6.9 12.6-4 19m35.5-4c1.9-3 1-7.1-2-9M44 32c2.9-6.4 1.5-14.6-4-19M12.5 25.5v8a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1.045l15 .045v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-8l-2-2c-.66-1.212-1.19-2.136-1.59-2.773-.4-.636-.87-1.363-1.41-2.182a78.437 78.437 0 0 0-6.488-.272c-2.135 0-4.305.09-6.512.272-.54.819-1.01 1.546-1.41 2.182-.4.637-.93 1.56-1.59 2.773l-2 2zm6 2l1-1h9l1 1c-.636 2-1.136 3-1.5 3h-8c-.364 0-.864-1-1.5-3zm-4-4h19m-21 3H17m14 0h4.5",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol688 || (_symbol688 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-vehicle-signal-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "vehicle-signal-small"), /*#__PURE__*/React.createElement("path", {
    d: "M5 10c-1.6 1-2.5 3.4-1.5 5m0-8c-3 2.3-3.7 6.4-2.3 9.8M20.5 15c1-1.6.1-4-1.5-5m3.8 6.8c1.5-3.4.7-7.6-2.3-9.8m-15 5.358v4.392c0 .414.336.75.75.75H8a.75.75 0 0 0 .75-.75v-.25h6.5v.25c0 .414.336.75.75.75h1.75a.75.75 0 0 0 .75-.75v-4.392l-3-3.858h-7l-3 3.858zm0 1.142h3m7 0h3",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol689 || (_symbol689 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-vehicle-wi-fi-1-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "vehicle-wi-fi-1-large"), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 34.5v8a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1.045l15 .045v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-8l-2-2c-.66-1.212-1.19-2.136-1.59-2.773-.4-.636-.87-1.363-1.41-2.182a78.437 78.437 0 0 0-6.488-.272c-2.135 0-4.305.09-6.512.272-.54.819-1.01 1.546-1.41 2.182-.4.637-.93 1.56-1.59 2.773l-2 2zm6 2l1-1h9l1 1c-.636 2-1.136 3-1.5 3h-8c-.364 0-.864-1-1.5-3zm-4-4h19m-21 3H17m14 0h4.5",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol690 || (_symbol690 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-vehicle-wi-fi-1-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "vehicle-wi-fi-1-small"), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 17.5v5a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1h8a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-5l-4-4h-8l-4 4zm0 1H8m9 0h3.5",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol691 || (_symbol691 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-vehicle-wi-fi-2-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "vehicle-wi-fi-2-large"), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 34.5v8a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1.045l15 .045v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-8l-2-2c-.66-1.212-1.19-2.136-1.59-2.773-.4-.636-.87-1.363-1.41-2.182a78.437 78.437 0 0 0-6.488-.272c-2.135 0-4.305.09-6.512.272-.54.819-1.01 1.546-1.41 2.182-.4.637-.93 1.56-1.59 2.773l-2 2zm6 2l1-1h9l1 1c-.636 2-1.136 3-1.5 3h-8c-.364 0-.864-1-1.5-3zm-4-4h19m-21 3H17m14 0h4.5M29 23.4c-1.2-1.2-3.1-1.9-5-1.9s-3.8.6-5 1.9",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol692 || (_symbol692 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-vehicle-wi-fi-2-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "vehicle-wi-fi-2-small"), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 17.5v5a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1h8a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-5l-4-4h-8l-4 4zm0 1H8m9 0h3.5m-5.3-9.1C13.9 8 11 8 9.7 9.4",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol693 || (_symbol693 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-vehicle-wi-fi-3-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "vehicle-wi-fi-3-large"), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 34.5v8a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1.045l15 .045v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-8l-2-2c-.66-1.212-1.19-2.136-1.59-2.773-.4-.636-.87-1.363-1.41-2.182a78.437 78.437 0 0 0-6.488-.272c-2.135 0-4.305.09-6.512.272-.54.819-1.01 1.546-1.41 2.182-.4.637-.93 1.56-1.59 2.773l-2 2zm6 2l1-1h9l1 1c-.636 2-1.136 3-1.5 3h-8c-.364 0-.864-1-1.5-3zm-4-4h19m-21 3H17m14 0h4.5m0-17.5c-3-3.1-7.3-4.5-11.5-4.5s-8.5 1.4-11.5 4.5M29 23.4c-1.2-1.2-3.1-1.9-5-1.9s-3.8.6-5 1.9",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol694 || (_symbol694 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-vehicle-wi-fi-3-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "vehicle-wi-fi-3-small"), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 17.5v5a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1h8a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-5l-4-4h-8l-4 4zm0 1H8m9 0h3.5M18 6.6c-1.5-1.5-3.6-2.1-5.5-2.1S8.4 5.1 7 6.6m8.2 2.8C13.9 8 11 8 9.7 9.4",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol695 || (_symbol695 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-vehicle-wi-fi-4-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "vehicle-wi-fi-4-large"), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 34.5v8a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1.045l15 .045v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-8l-2-2c-.66-1.212-1.19-2.136-1.59-2.773-.4-.636-.87-1.363-1.41-2.182a78.437 78.437 0 0 0-6.488-.272c-2.135 0-4.305.09-6.512.272-.54.819-1.01 1.546-1.41 2.182-.4.637-.93 1.56-1.59 2.773l-2 2zm6 2l1-1h9l1 1c-.636 2-1.136 3-1.5 3h-8c-.364 0-.864-1-1.5-3zm-4-4h19m-21 3H17m14 0h4.5m6-22.5C36.7 8.2 30.4 5.5 24 5.5S11.2 8.2 6.5 13M29 23.4c-1.2-1.2-3.1-1.9-5-1.9s-3.8.6-5 1.9M35.5 18c-3-3.1-7.3-4.5-11.5-4.5s-8.5 1.4-11.5 4.5",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol696 || (_symbol696 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-vehicle-wi-fi-4-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "vehicle-wi-fi-4-small"), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 17.5v5a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1h8a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-5l-4-4h-8l-4 4zm0 1H8m9 0h3.5m.1-14.7C18.4 1.6 15.4.5 12.5.5c-2.9 0-5.9 1-8.1 3.3m10.8 5.6C13.9 8 11 8 9.7 9.4M18 6.6c-1.5-1.5-3.6-2.1-5.5-2.1S8.4 5.1 7 6.6",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol697 || (_symbol697 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-velocity-alert-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "velocity-alert-large"), /*#__PURE__*/React.createElement("path", {
    d: "M45.5 21.5h-20l10-18 10 18zm-19-11c-9.4-3.3-19.7 1.6-23 11-3.3 9.4 1.6 19.7 11 23 9.4 3.3 19.7-1.6 23-11 1-2.8 1.3-5.9.8-8.9m-15 3.9l8.5 3.1m-13.3-22V7m4 2.6V7m13 2v6m0 2v2m-15 11.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-7-27h14v3h-14v-3zm-4.2 9.9l-2.9-2.9-2.8 2.8 2.9 2.9",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol698 || (_symbol698 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-velocity-alert-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "velocity-alert-small"), /*#__PURE__*/React.createElement("path", {
    d: "M23.2 12.5H11.6L17.5 1l5.7 11.5zM5.5 1.5h8v2h-8v-2zm4 4V4v1.5zm0 9l5.5 2-5.5-2zm8-9.5v3m0 1v2m-6.1-5.3C6.5 4.6 1.7 7.7.7 12.6s2 9.7 6.9 10.7 9.7-2 10.7-6.9c.1-.6.2-1.3.2-1.9M4.8 6.8L3 4.7l-2.3 2 1.8 2.1",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol699 || (_symbol699 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-velocity-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "velocity-large"), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 7.6V4.5v3.1zm4 0V4.5v3.1zm-9-6.1h14v3h-14v-3zm21.1 12.8l2.9-2.9-2.8-2.8-2.9 2.9m-22.5-.1L9.4 8.5l-2.8 2.8 2.9 2.9m14 14.3a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2.8-2l8.5 3.1M23.5 43.5c9.941 0 18-8.059 18-18s-8.059-18-18-18-18 8.059-18 18 8.059 18 18 18z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol700 || (_symbol700 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-velocity-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "velocity-small"), /*#__PURE__*/React.createElement("path", {
    d: "M16.7 6.2l1.9-1.9 2.1 2.1-1.9 1.9M6.3 6.2L4.4 4.3 2.3 6.4l1.9 1.9m7.3 14.2a9 9 0 1 0 0-18 9 9 0 0 0 0 18zm0-18v-2 2zm-4-4h8v2h-8v-2zm4 13l5.5 2-5.5-2z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol701 || (_symbol701 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-video-call-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "video-call-large"), /*#__PURE__*/React.createElement("path", {
    d: "M36.5 20.283L46.478 15v17L36.5 26.152m0 4.348v-20h-29a6 6 0 0 0-6 6v20h29a6 6 0 0 0 6-6z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol702 || (_symbol702 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-video-call-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "video-call-small"), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 10.5l5-3v9l-5-3m0 2v-10H3.567A3.067 3.067 0 0 0 .5 8.567v10h14.933A3.067 3.067 0 0 0 18.5 15.5z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol703 || (_symbol703 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-video-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "video-large"), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 9.5h40c1.7 0 3 1.3 3 3v25h-40c-1.7 0-3-1.3-3-3v-25zm17 5.9l11.9 8-11.9 8.2V15.4z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol704 || (_symbol704 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-video-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "video-small"), /*#__PURE__*/React.createElement("path", {
    d: "M.5 4.5h22c.6 0 1 .4 1 1v14h-22c-.6 0-1-.4-1-1v-14zm9 2.5l6.6 4.4L9.5 16V7z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol705 || (_symbol705 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-view-360-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "view-360-large"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9 28.5l3.5 4.9-5 3.4m4.4-3.7c-6.4-.7-11.1-3-11.1-5.7 0-1.7 1.8-3.2 4.8-4.3m21.9.1c2.9 1.1 4.7 2.6 4.7 4.2 0 3.1-6.2 5.6-14.2 5.9",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.33 19.8c2.012 0 3.251-.853 3.251-2.093 0-.854-.579-1.555-1.554-1.87.752-.335 1.199-.924 1.199-1.676 0-1.25-1.128-1.961-2.896-1.961-.884 0-1.758.152-2.398.427v.863c.732-.294 1.646-.416 2.398-.416.976 0 1.829.355 1.829 1.128 0 .863-.732 1.25-1.9 1.25h-.884v.843h.884c1.473 0 2.256.548 2.256 1.371 0 .833-.966 1.24-2.165 1.24a8.516 8.516 0 0 1-2.56-.396v.884c.63.233 1.433.406 2.54.406zm8.616 0c-2.184 0-3.393-1.168-3.393-3.465 0-2.672 1.422-4.135 4.145-4.135.894 0 1.463.102 1.94.244v.904a6.988 6.988 0 0 0-1.9-.254c-1.89 0-2.946.793-3.098 2.601.6-.477 1.443-.762 2.418-.762 1.971 0 3.068.955 3.068 2.439 0 1.25-.995 2.428-3.18 2.428zm0-4.003c-.924 0-1.697.254-2.337.68.061 1.972 1.057 2.51 2.337 2.51 1.31 0 2.114-.569 2.114-1.615 0-1.067-.752-1.575-2.114-1.575zm8.007 4.003c-2.571 0-3.414-1.656-3.414-3.81 0-2.103.894-3.79 3.414-3.79 2.57 0 3.413 1.656 3.413 3.81 0 2.103-.894 3.79-3.413 3.79zm0-.803c1.767 0 2.357-1.33 2.357-2.997 0-1.656-.59-2.997-2.357-2.997-1.768 0-2.358 1.33-2.358 2.997 0 1.656.59 2.997 2.358 2.997zm6.695-3.22c-1.026 0-1.839-.813-1.839-1.789 0-.975.813-1.788 1.84-1.788 1.025 0 1.838.813 1.838 1.788 0 .976-.813 1.788-1.839 1.788zm0-.732c.57 0 1.057-.488 1.057-1.057s-.488-1.056-1.057-1.056-1.056.487-1.056 1.056c0 .57.487 1.057 1.056 1.057z",
    fill: "currentColor",
    fillRule: "nonzero"
  })))), _symbol706 || (_symbol706 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-view-360-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "view-360-small"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.9 19.1c-4.3-.5-7.4-2-7.4-3.8 0-1.1 1.2-2.1 3.2-2.8m14.7 0c1.9.7 3.1 1.7 3.1 2.8 0 2.1-4.2 3.8-9.5 3.9m-6.1-3.1l2.3 3.2-3.4 2.3",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 10.984c1.584 0 2.56-.672 2.56-1.648 0-.672-.456-1.224-1.224-1.472.592-.264.944-.728.944-1.32C7.28 5.56 6.392 5 5 5c-.696 0-1.384.12-1.888.336v.68c.576-.232 1.296-.328 1.888-.328.768 0 1.44.28 1.44.888 0 .68-.576.984-1.496.984h-.696v.664h.696c1.16 0 1.776.432 1.776 1.08 0 .656-.76.976-1.704.976-.84 0-1.488-.152-2.016-.312v.696c.496.184 1.128.32 2 .32zm6.784 0c-1.72 0-2.672-.92-2.672-2.728C9.112 6.152 10.232 5 12.376 5c.704 0 1.152.08 1.528.192v.712a5.502 5.502 0 0 0-1.496-.2c-1.488 0-2.32.624-2.44 2.048.472-.376 1.136-.6 1.904-.6 1.552 0 2.416.752 2.416 1.92 0 .984-.784 1.912-2.504 1.912zm0-3.152c-.728 0-1.336.2-1.84.536.048 1.552.832 1.976 1.84 1.976 1.032 0 1.664-.448 1.664-1.272 0-.84-.592-1.24-1.664-1.24zM18.488 5c2.024 0 2.688 1.304 2.688 3 0 1.656-.704 2.984-2.688 2.984-2.024 0-2.688-1.304-2.688-3C15.8 6.328 16.504 5 18.488 5zm0 .632c-1.392 0-1.856 1.048-1.856 2.36 0 1.304.464 2.36 1.856 2.36 1.392 0 1.856-1.048 1.856-2.36 0-1.304-.464-2.36-1.856-2.36z",
    fill: "currentColor",
    fillRule: "nonzero"
  })))), _symbol707 || (_symbol707 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-vimeo-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "vimeo-large"), /*#__PURE__*/React.createElement("path", {
    d: "M36.6 17.313c-.1 2.6-1.9 6.1-5.4 10.6-3.6 4.7-6.7 7-9.2 7-1.6 0-2.9-1.4-3.9-4.3l-2.1-7.9c-.8-2.9-1.6-4.3-2.6-4.3-.8.3-1.5.7-2.1 1.3l-1.3-1.5c1.3-1.2 2.6-2.3 3.9-3.5 1.7-1.5 3.1-2.3 3.9-2.4 2.1-.2 3.3 1.2 3.8 4.2.5 3.3.9 5.3 1.1 6.1.6 2.7 1.3 4.1 2 4.1.6 0 1.4-.9 2.5-2.6.9-1.2 1.5-2.6 1.8-4 .2-1.5-.4-2.3-1.8-2.3-.7 0-1.3.2-2 .4 1.3-4.3 3.8-6.4 7.5-6.2 2.7.1 4 1.9 3.9 5.3z",
    fill: "currentColor"
  }))), _symbol708 || (_symbol708 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-vimeo-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "vimeo-small"), /*#__PURE__*/React.createElement("path", {
    d: "M17.997 8.85c-.048 1.249-.928 2.93-2.638 5.09-1.76 2.256-3.274 3.36-4.496 3.36-.781 0-1.417-.672-1.905-2.064l-1.026-3.793C7.54 10.051 7.15 9.38 6.662 9.38c-.392.144-.734.336-1.027.624L5 9.283c.635-.576 1.27-1.104 1.906-1.68.83-.72 1.514-1.105 1.905-1.153 1.026-.096 1.613.576 1.857 2.017.244 1.584.44 2.544.538 2.928.293 1.296.635 1.968.977 1.968.293 0 .684-.432 1.221-1.248.44-.576.733-1.248.88-1.92.098-.72-.196-1.104-.88-1.104-.342 0-.635.096-.977.192.635-2.065 1.857-3.073 3.665-2.977 1.319.048 1.954.912 1.905 2.545z",
    fill: "currentColor"
  }))), _symbol709 || (_symbol709 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-voice-call-1-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "voice-call-1-large"), /*#__PURE__*/React.createElement("path", {
    d: "M34.5 46l7-7.5c.5-.5.5-1.5 0-2l-5-5c-.5-.5-1.5-.5-2 0l-2.5 2s-1.3 2.2-9.8-6.3l-1-1c-8.5-8.5-6.7-9.2-6.7-9.2l2-3.5c.5-.5.5-1.5 0-2l-4-4c-.5-.5-1.5-.5-2 0l-8 7s10 19.1 32 31.5z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol710 || (_symbol710 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-voice-call-1-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "voice-call-1-small"), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 23.3l4-3.8c.2-.2.2-.8 0-1l-3-3c-.2-.2-.8-.2-1 0L16 16.8s-.7 1.1-4.9-3.1l-.5-.5C6.3 8.9 7.5 8.5 7.5 8.5l1-1c.2-.2.2-.8 0-1l-3-3c-.2-.2-.8-.2-1 0l-3.8 4s5.8 9.6 16.8 15.8z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol711 || (_symbol711 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-voice-call-2-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "voice-call-2-large"), /*#__PURE__*/React.createElement("path", {
    d: "M34.5 46l7-7.5c.5-.5.5-1.5 0-2l-5-5c-.5-.5-1.5-.5-2 0l-2.5 2s-1.3 2.2-9.8-6.3l-1-1c-8.5-8.5-6.7-9.2-6.7-9.2l2-3.5c.5-.5.5-1.5 0-2l-4-4c-.5-.5-1.5-.5-2 0l-8 7s10 19.1 32 31.5zM26 11.5c5.8 0 10.5 4.7 10.5 10.5",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol712 || (_symbol712 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-voice-call-2-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "voice-call-2-small"), /*#__PURE__*/React.createElement("path", {
    d: "M13 5.5c2.9 0 5.5 2.7 5.5 5.5m-1 12.3l4-3.8c.2-.2.2-.8 0-1l-3-3c-.2-.2-.8-.2-1 0L16 16.8s-.7 1.1-4.9-3.1l-.5-.5C6.3 8.9 7.5 8.5 7.5 8.5l1-1c.2-.2.2-.8 0-1l-3-3c-.2-.2-.8-.2-1 0l-3.8 4s5.8 9.6 16.8 15.8z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol713 || (_symbol713 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-voice-call-3-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "voice-call-3-large"), /*#__PURE__*/React.createElement("path", {
    d: "M34.5 46l7-7.5c.5-.5.5-1.5 0-2l-5-5c-.5-.5-1.5-.5-2 0l-2.5 2s-1.3 2.2-9.8-6.3l-1-1c-8.5-8.5-6.7-9.2-6.7-9.2l2-3.5c.5-.5.5-1.5 0-2l-4-4c-.5-.5-1.5-.5-2 0l-8 7s10 19.1 32 31.5zM26 1.5c11.3 0 20.5 9.2 20.5 20.5M26 11.5c5.8 0 10.5 4.7 10.5 10.5",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol714 || (_symbol714 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-voice-call-3-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "voice-call-3-small"), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 23.3l4-3.8c.2-.2.2-.8 0-1l-3-3c-.2-.2-.8-.2-1 0L16 16.8s-.7 1.1-4.9-3.1l-.5-.5C6.3 8.9 7.5 8.5 7.5 8.5l1-1c.2-.2.2-.8 0-1l-3-3c-.2-.2-.8-.2-1 0l-3.8 4s5.8 9.6 16.8 15.8zM13 .5C18.7.5 23.5 5.4 23.5 11M13 5.5c2.9 0 5.5 2.7 5.5 5.5",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol715 || (_symbol715 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-voice-call-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "voice-call-large"), /*#__PURE__*/React.createElement("path", {
    d: "M34.5 46l7-7.5c.5-.5.5-1.5 0-2l-5-5c-.5-.5-1.5-.5-2 0l-2.5 2s-1.3 2.2-9.8-6.3l-1-1c-8.5-8.5-6.7-9.2-6.7-9.2l2-3.5c.5-.5.5-1.5 0-2l-4-4c-.5-.5-1.5-.5-2 0l-8 7s10 19.1 32 31.5zM26 1.5c11.3 0 20.5 9.2 20.5 20.5M26 11.5c5.8 0 10.5 4.7 10.5 10.5",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol716 || (_symbol716 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-voice-call-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "voice-call-small"), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 23.3l4-3.8c.2-.2.2-.8 0-1l-3-3c-.2-.2-.8-.2-1 0L16 16.8s-.7 1.1-4.9-3.1l-.5-.5C6.3 8.9 7.5 8.5 7.5 8.5l1-1c.2-.2.2-.8 0-1l-3-3c-.2-.2-.8-.2-1 0l-3.8 4s5.8 9.6 16.8 15.8zM13 .5C18.7.5 23.5 5.4 23.5 11M13 5.5c2.9 0 5.5 2.7 5.5 5.5",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol717 || (_symbol717 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-walk-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "walk-large"), /*#__PURE__*/React.createElement("path", {
    d: "M30.5 7.5c0 1.1-.9 2-2 2h-2c-1.1 0-2-.9-2-2v-2c0-1.1.9-2 2-2h2c1.1 0 2 .9 2 2v2zm-11 19h-4l3-10 3.1-3.1c.6-.6 1.3-.9 2.1-.9h3.8l6 7 3 1v4l-5-1-4-5-2 8 11 18h-5l-12-18L22 18l-2.5 8.5zm0 0v7l-5 11h5l5-10.5",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol718 || (_symbol718 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-walk-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "walk-small"), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 2.5c0 .6-.4 1-1 1h-1c-.5 0-1-.5-1-1v-1c0-.6.4-1 1-1h1c.5 0 1 .5 1 1v1zM8 13.5H5.5l2-5.5 1.8-2.2c.2-.2.5-.3.7-.3h2.5L16 10l1.5.5v2L15 12l-2.5-3-1.2 4.4 6.2 10.1h-3L8 13.5 9.5 9 8 13.5zm1 1.6l-4 8.4h3l2.8-5.8",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol719 || (_symbol719 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-wallbox-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "wallbox-large"), /*#__PURE__*/React.createElement("path", {
    d: "M16 31.5v2a4 4 0 0 1-4 4H8a3.5 3.5 0 0 0 0 7h28.5a4 4 0 0 0 4-4v-19m6-12v6a6 6 0 1 1-12 0v-6h12zm-9 0v-5m6 5v-5m-34-1h13a4 4 0 0 1 4 4v20a4 4 0 0 1-4 4h-13a4 4 0 0 1-4-4v-20a4 4 0 0 1 4-4zm14.5 6H8m13.4 13a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zm-10.8 0a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zm3.6 0a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zm3.6 0a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol720 || (_symbol720 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-wallbox-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "wallbox-small"), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 4.5v3a3 3 0 0 1-6 0v-3h6zm-5 0V1m4 3.5V1m-2 9.5v10a2 2 0 0 1-2 2H4a2 2 0 1 1 0-4h1.5a2 2 0 0 0 2-2v-2m-3-13h6a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-6a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2zm.5 3h5",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol721 || (_symbol721 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-warranty-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "warranty-large"), /*#__PURE__*/React.createElement("path", {
    d: "M37.3 41.288l-5.295-2.123-3.356 4.603-3.532-12.315a12.962 12.962 0 0 0 8.237-3.925l3.946 13.76zm-14.417-9.835L19.35 43.768l-3.365-4.606-5.286 2.126 3.946-13.76M24 31.5c7.18 0 13-5.82 13-13s-5.82-13-13-13-13 5.82-13 13 5.82 13 13 13zm-6-11.9l4.3 4.2 8.1-10.3",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol722 || (_symbol722 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-warranty-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "warranty-small"), /*#__PURE__*/React.createElement("path", {
    d: "M17.255 12.78l2.398 8.364-2.647-1.062-1.678 2.302-2.136-7.45m-1.88.001l-2.136 7.45-1.682-2.304-2.643 1.063 2.397-8.361M12.25 15a6.75 6.75 0 1 0 0-13.5 6.75 6.75 0 0 0 0 13.5zm-3-6.706l2.15 2.1L15.248 5.5",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol723 || (_symbol723 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-weblink-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "weblink-large"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.6 38.7L31.5 29M29 34.3l2.4-5.8 5.8 2.4",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3 19h1.5l2.4 5.6 2.3-5.6h1.3l2.3 5.6 2.4-5.6H45l-3.3 7h-1.3l-2.3-5.6-2.3 5.6h-1.3l-3.2-7zm-14.2 0h1.5l2.4 5.6 2.3-5.6h1.3l2.4 5.6 2.4-5.6h1.4l-3.3 7h-1.3L24 20.4 21.7 26h-1.3l-3.3-7zM3 19h1.5l2.4 5.6L9.2 19h1.3l2.4 5.6 2.4-5.6h1.4l-3.3 7h-1.3l-2.3-5.6L7.5 26H6.3L3 19z",
    fill: "currentColor",
    fillRule: "nonzero"
  })))), _symbol724 || (_symbol724 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-weblink-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "weblink-small"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8 20.5l-3.1-7.7m-1.8 4.4l1.8-4.4 4.4 1.8",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1 7h1.2l1.1 2.7 1-2.7h1.3l1 2.7L22.8 7H24l-1.7 3.8H21l-1-2.6-1 2.6h-1.3L16.1 7zM8 7h1.2l1.1 2.7 1-2.7h1.3l1 2.7L14.8 7H16l-1.7 3.8H13l-1-2.6-1 2.6H9.7L8 7zM0 7h1.2l1.1 2.7 1-2.7h1.3l1 2.7L6.7 7h1.2l-1.7 3.8H5L4 8.2l-1 2.6H1.7L0 7z",
    fill: "currentColor",
    fillRule: "nonzero"
  })))), _symbol725 || (_symbol725 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-wechat-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "wechat-large"), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 21.7c5-4.8 14.7-3.4 17.1 3.5.5 1.5.5 3.2.1 4.9-.3.9-.9 1.8-1.5 2.5L38 33.8c-.4.3-1 .6-1 1 .1.5.2 1 .4 1.4l.4 1.4c-1-.5-2.7-2-3.8-1.7-3.7 1.1-7.7.2-10.6-2.2-2.1-1.9-3-4.8-2.4-7.6.3-1.7 1.2-3.2 2.5-4.4zm-6-11.8c5.3-.6 11.8 2.1 13.5 7.5h-.2c-3.2 0-6.2 1.1-8.6 3.2-1.6 1.4-2.7 3.3-3.1 5.4-.2 1.4-.1 2.9.7 4.1-1.4 0-2.7-.1-4-.4-.4-.1-.8-.1-1.2.1l-3.8 1.9.8-2.5.2-.6c.2-.5.1-.5-.3-.8-1-.7-1.9-1.5-2.6-2.5a8.91 8.91 0 0 1-.5-10c2.1-3.1 5.4-5.1 9.1-5.4zm9.9 13.6c-2 0-1.4 3.2.6 2.6 1.8-.5 1.1-2.6-.6-2.6zm6.6 0c-1.9 0-1.4 3.2.6 2.6 1.8-.5 1.1-2.6-.6-2.6zm-18.9-8.6c-1-.1-1.9.6-2 1.6.1.9 1 1.7 2 1.6.9 0 1.7-.8 1.6-1.6 0-.9-.7-1.6-1.6-1.6zm8.5-.1c-1-.1-1.9.6-2 1.6.1.9 1 1.7 2 1.6.9 0 1.6-.7 1.6-1.6 0-.9-.7-1.6-1.6-1.6z",
    fill: "currentColor"
  }))), _symbol726 || (_symbol726 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-wechat-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "wechat-small"), /*#__PURE__*/React.createElement("path", {
    d: "M11.6 11c2.8-2.6 8.4-1.9 9.7 2 .3.9.3 1.8.1 2.5-.2.5-.5 1-.9 1.4-.2.3-.5.5-.7.7-.2.2-.5.4-.5.6 0 .3.1.6.2.8l.2.8c-.5-.3-1.5-1-2.1-.9-2 .6-4.3.2-5.9-1.2-1.2-1-1.8-2.6-1.5-4.2.2-1 .7-1.8 1.4-2.5zM8.3 4.5c3-.3 6.6 1.2 7.6 4.2h-.1c-1.8 0-3.5.6-4.8 1.8-.9.8-1.5 1.8-1.7 2.9-.1.8-.1 1.7.2 2.5-.7 0-1.5 0-2.2-.2-.3-.1-.5-.1-.7 0l-.4.2-1.7.8.5-1.4.1-.4c.1-.2 0-.2-.2-.4-.5-.4-1-.9-1.4-1.4-1.3-1.7-1.4-3.9-.3-5.6 1.2-1.7 3-2.8 5.1-3zm5.1 7.5c-1.2 0-.9 2 .3 1.6 1-.3.6-1.5-.3-1.6zm4.3 0c-1.2 0-.9 1.9.3 1.6 1-.3.6-1.5-.3-1.6zm-5.9-4.8c-.6-.1-1.2.4-1.2 1 .1.6.6 1 1.2 1s1-.4 1-1-.4-1-1-1zm-4.7-.1c-.7-.1-1.2.4-1.3 1 .1.7.7 1.1 1.3 1.1.5 0 1-.6 1-1.1 0-.5-.4-1-1-1z",
    fill: "currentColor"
  }))), _symbol727 || (_symbol727 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-weibo-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "weibo-large"), /*#__PURE__*/React.createElement("path", {
    d: "M32.5 22.3c-.5-.1-.8-.2-.6-.9.6-1.1.6-2.3 0-3.4-1.1-1.6-4.1-1.5-7.6 0 0 0-1.1.5-.8-.4.5-1.7.5-3.1-.4-4-1.9-1.9-6.9.1-11.2 4.4-3 3.2-4.9 6.6-4.9 9.5 0 5.6 7.2 9 14.3 9 9.2 0 15.4-5.4 15.4-9.6 0-2.6-2.2-4-4.2-4.6zM21.3 34.5c-5.6.6-10.5-2-10.9-5.7-.4-3.7 3.9-7.1 9.5-7.7 5.6-.6 10.5 2 10.9 5.7.4 3.7-3.9 7.2-9.5 7.7zM14.9 27c1.4-2.4 4.2-3.7 6.9-3 2.8.7 4.2 3.1 3.1 5.6-1.4 2.7-4.5 4-7.3 3.1-2.7-.8-3.9-3.3-2.7-5.7zm4.3.7c-.9-.3-2 .1-2.5.9-.1.1-.2.2-.2.3-.4.8-.1 1.7.7 2 1 .4 2.1.1 2.6-.8.1-.1.1-.1.2-.4.3-.8 0-1.7-.8-2zm2.1-.7c-.3-.1-.7.1-.9.4-.1 0-.1.1-.1.1-.1.2 0 .6.3.7.4.1.8-.1 1-.4v-.1c.1-.3 0-.6-.3-.7zm9.12-17.855c3.092-.477 6.153.535 8.28 2.855 2.1 2.4 2.9 5.7 1.7 8.8l-.043.11c-.245.538-.9.878-1.557.69-.6-.2-1-.9-.8-1.6.4-1.1.4-2.2.2-3.3-.7-3.4-4.1-5.6-7.6-4.9-.7.1-1.3-.3-1.5-1-.1-.7.3-1.4 1-1.6zm.68 4.655c1.6-.4 3.2.1 4.2 1.3 1 1.1 1.4 2.8.8 4.3-.2.6-.8.9-1.4.7-.6-.2-.9-.8-.7-1.4.2-.3.2-.7.1-1.1-.2-1.1-1.3-1.8-2.5-1.6h-.1l-.12.013c-.558.033-1.087-.353-1.18-.913-.1-.6.3-1.2.9-1.3z",
    fill: "currentColor"
  }))), _symbol728 || (_symbol728 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-weibo-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "weibo-small"), /*#__PURE__*/React.createElement("path", {
    d: "M5.1 9.3c2.5-2.5 5.3-3.6 6.4-2.5.5.7.6 1.6.2 2.3-.1.5.5.2.5.2 2-.9 3.8-.9 4.4 0 .3.6.3 1.3 0 1.9-.2.4 0 .4.3.5 1.3.3 2.3 1.4 2.3 2.8 0 2.4-3.5 5.5-8.8 5.5-4.1 0-8.2-2-8.2-5.2 0-1.7 1.1-3.7 2.9-5.5zm10.8 5c-.2-2.2-2.9-3.6-6.2-3.3-3.3.3-5.7 2.2-5.5 4.4.2 2.2 3 3.6 6.2 3.3 3.3-.3 5.7-2.3 5.5-4.4zm-9 .1c.7-1.4 2.3-2.1 3.8-1.7.2 0 .4.1.5.2 1.2.5 1.7 1.9 1.2 3.1-.7 1.5-2.4 2.2-4 1.7-.2-.1-.3-.1-.5-.2-1.1-.6-1.6-2-1-3.1zm2.4.4c-.5-.2-1.1 0-1.4.5 0 .1-.1.1-.1.2-.2.4 0 .9.4 1.1.5.2 1.1 0 1.4-.5l.1-.1c.2-.5 0-1-.4-1.2zm1.1-.5c-.2-.1-.4 0-.5.2v.1c0 .1 0 .3.2.4.2.1.4 0 .5-.2.1-.2 0-.4-.2-.5zm5.335-10.147c1.729-.3 3.517.308 4.665 1.647 1.3 1.4 1.7 3.3 1.2 5l-.031.096c-.136.335-.502.496-.869.404-.4-.1-.6-.5-.5-.9.2-.6.2-1.3.1-1.9-.5-2-2.4-3.2-4.4-2.8-.4 0-.8-.2-.9-.6-.1-.4.1-.8.5-.9zM16.1 6.8c.9-.2 1.8.1 2.4.8.6.6.8 1.6.5 2.4l-.039.087c-.14.25-.491.403-.761.313-.3-.1-.5-.5-.4-.8V9c-.2-.7-.8-1.1-1.4-.9l-.107.018c-.346.027-.602-.245-.693-.518-.1-.4.2-.7.5-.8z",
    fill: "currentColor"
  }))), _symbol729 || (_symbol729 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-whatsapp-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "whatsapp-large"), /*#__PURE__*/React.createElement("path", {
    d: "M34.98 12.947C29.493 7.537 20.845 7 14.725 11.684c-6.12 4.686-7.832 13.158-4.011 19.844L8.5 39.5l8.184-2.142a15.388 15.388 0 0 0 7.38 1.877 15.44 15.44 0 0 0 14.26-9.507 15.372 15.372 0 0 0-3.344-16.78zm-10.916 23.69a12.792 12.792 0 0 1-6.53-1.79l-.466-.272-4.878 1.266 1.299-4.718-.31-.486a12.781 12.781 0 0 1-.348-13.001 12.846 12.846 0 0 1 11.233-6.603c7.087.009 12.827 5.74 12.827 12.81-.008 7.062-5.746 12.785-12.827 12.793zm7.034-9.57c-.384-.192-2.28-1.127-2.635-1.252-.354-.125-.613-.191-.863.192-.251.382-.997 1.251-1.226 1.472-.228.22-.45.287-.834.095a10.447 10.447 0 0 1-3.1-1.906 11.717 11.717 0 0 1-2.132-2.643c-.221-.39 0-.596.17-.788.17-.19.384-.449.575-.67.158-.198.29-.415.392-.647a.735.735 0 0 0-.037-.67c-.096-.192-.864-2.083-1.189-2.856-.324-.773-.627-.648-.863-.663h-.738a1.411 1.411 0 0 0-1.026.486 4.286 4.286 0 0 0-1.35 3.21 7.402 7.402 0 0 0 1.579 3.975c.192.257 2.716 4.144 6.583 5.808.723.31 1.462.58 2.214.81a5.32 5.32 0 0 0 2.428.154c.738-.11 2.28-.927 2.605-1.833.25-.574.327-1.208.222-1.825-.133-.177-.392-.273-.775-.464v.015z",
    fill: "currentColor"
  }))), _symbol730 || (_symbol730 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-whatsapp-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "whatsapp-small"), /*#__PURE__*/React.createElement("path", {
    d: "M17.667 6.295a7.984 7.984 0 0 0-10.454-.651 7.935 7.935 0 0 0-2.07 10.241L4 20l4.224-1.106a7.969 7.969 0 0 0 11.17-3.938 7.934 7.934 0 0 0-1.727-8.66zm-5.634 12.227a6.602 6.602 0 0 1-3.37-.923l-.24-.14-2.518.653.67-2.436-.16-.25a6.597 6.597 0 0 1-.18-6.71 6.63 6.63 0 0 1 5.798-3.408c3.658.004 6.62 2.962 6.62 6.61-.004 3.646-2.965 6.6-6.62 6.604zm3.63-4.94c-.198-.098-1.177-.58-1.36-.645-.182-.065-.316-.099-.445.099-.13.197-.514.646-.632.76-.119.113-.233.148-.43.049a5.392 5.392 0 0 1-1.6-.984 6.048 6.048 0 0 1-1.102-1.364c-.114-.202 0-.308.088-.407.088-.098.198-.231.297-.345.082-.103.15-.215.202-.335a.38.38 0 0 0-.019-.346c-.05-.098-.446-1.075-.613-1.474-.168-.399-.324-.334-.446-.342h-.38a.728.728 0 0 0-.53.251 2.212 2.212 0 0 0-.697 1.657 3.82 3.82 0 0 0 .815 2.051c.099.133 1.402 2.14 3.397 2.998.374.16.755.3 1.143.418.406.123.835.15 1.253.08.381-.057 1.177-.479 1.345-.946.129-.297.168-.624.114-.942-.068-.092-.202-.141-.4-.24v.008z",
    fill: "currentColor"
  }))), _symbol731 || (_symbol731 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-work-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "work-large"), /*#__PURE__*/React.createElement("path", {
    d: "M37.529 45.5H27.5v-11h-7v11h-10v-43h27.029v43zM15.5 7.5h6v6h-6v-6zm17 13v6h-6v-6h6zm-11 0v6h-6v-6h6zm11-13v6h-6v-6h6z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol732 || (_symbol732 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-work-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "work-small"), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 21.5h-5v-5h-3v5h-5v-19h13v19zm-5-16h2v2h-2v-2zm-5 0h2v2h-2v-2zm5 6h2v2h-2v-2zm-5 0h2v2h-2v-2z",
    stroke: "currentColor",
    fill: "none"
  }))), _symbol733 || (_symbol733 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-xing-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "xing-large"), /*#__PURE__*/React.createElement("path", {
    d: "M31.2 10c-.6 0-.9.4-1.1.8l-9 15.9 5.7 10.5c.2.4.5.8 1.1.8h4c.2 0 .4-.1.5-.3.1-.2.1-.4 0-.6l-5.7-10.4 8.9-15.8c.1-.2.1-.4 0-.6-.1-.2-.3-.3-.5-.3h-3.9zm-16.9 5.5c-.2 0-.4.1-.6.3-.1.2-.1.4 0 .6l2.7 4.7-4.3 7.6c-.1.2-.1.4 0 .6.1.2.3.3.5.3h4c.6 0 .9-.4 1.1-.8l4.4-7.7c-.9-1.6-1.9-3.2-2.8-4.8-.2-.4-.5-.8-1.1-.8h-3.9z",
    fill: "currentColor"
  }))), _symbol734 || (_symbol734 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-xing-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "xing-small"), /*#__PURE__*/React.createElement("path", {
    d: "M15.2 5c-.3 0-.4.2-.5.4l-4.5 8 2.9 5.3c.1.2.3.4.6.4h2c.1 0 .2 0 .3-.1.1-.1.1-.2 0-.3l-3-5.3 4.5-7.9c.1-.1.1-.2 0-.3-.1-.2-.2-.2-.3-.2h-2zM6.7 7.8c-.1 0-.2 0-.3.1-.1.1 0 .2 0 .3l1.4 2.4-2.1 3.8c-.1.1-.1.2 0 .3.1.1.2.1.3.1h2c.3 0 .4-.2.6-.4l2.2-3.9-1.5-2.4c-.1-.1-.3-.3-.6-.3h-2z",
    fill: "currentColor"
  }))), _symbol735 || (_symbol735 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-yelp-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "yelp-large"), /*#__PURE__*/React.createElement("path", {
    d: "M14.622 23.02l6.227 3.036c1.198.584 1.013 2.346-.28 2.668L13.846 30.4a1.43 1.43 0 0 1-1.765-1.227 12.29 12.29 0 0 1 .561-5.33 1.428 1.428 0 0 1 1.98-.824m2.493 12.82l4.635-5.148c.892-.99 2.534-.328 2.488 1.004l-.242 6.926a1.429 1.429 0 0 1-1.666 1.359c-1.79-.3-3.485-.993-4.964-2.008a1.429 1.429 0 0 1-.25-2.133m10.989-6.851l6.588 2.14c.82.267 1.22 1.195.848 1.973a12.406 12.406 0 0 1-3.294 4.222 1.43 1.43 0 0 1-2.122-.344l-3.672-5.877c-.706-1.13.384-2.527 1.652-2.114m6.7-4.203l-6.66 1.909c-1.282.368-2.323-1.066-1.577-2.17l3.874-5.744a1.428 1.428 0 0 1 2.127-.276 12.291 12.291 0 0 1 3.15 4.335 1.43 1.43 0 0 1-.914 1.946M19.243 8.625a19.943 19.943 0 0 0-3.424 1.26 1.427 1.427 0 0 0-.618 2.002l6.51 11.274c.73 1.265 2.664.747 2.664-.713V9.429c0-.831-.708-1.49-1.537-1.425a19.933 19.933 0 0 0-3.595.62",
    fill: "currentColor"
  }))), _symbol736 || (_symbol736 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-yelp-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "yelp-small"), /*#__PURE__*/React.createElement("path", {
    d: "M7.81 11.51l3.114 1.518c.6.292.507 1.173-.14 1.334l-3.36.838a.715.715 0 0 1-.884-.614 6.145 6.145 0 0 1 .281-2.664.714.714 0 0 1 .99-.412m1.247 6.41l2.317-2.575c.446-.495 1.267-.163 1.244.503l-.121 3.463a.714.714 0 0 1-.833.679 6.202 6.202 0 0 1-2.482-1.004.714.714 0 0 1-.125-1.067m5.494-3.425l3.295 1.07c.41.134.61.597.424.987a6.203 6.203 0 0 1-1.647 2.11.715.715 0 0 1-1.061-.172l-1.837-2.938c-.353-.565.193-1.263.826-1.057m3.35-2.102l-3.33.955c-.64.184-1.16-.533-.788-1.085L15.72 9.39a.714.714 0 0 1 1.063-.138 6.146 6.146 0 0 1 1.576 2.167.715.715 0 0 1-.458.973m-7.78-8.08c-.6.16-1.172.373-1.712.63a.714.714 0 0 0-.31 1.002l3.255 5.637c.365.632 1.332.373 1.332-.357v-6.51a.714.714 0 0 0-.768-.712 9.967 9.967 0 0 0-1.798.31",
    fill: "currentColor"
  }))), _symbol737 || (_symbol737 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-youku-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "youku-large"), /*#__PURE__*/React.createElement("path", {
    d: "M29 20.8l-4.9-3.6c-1.3-.9-2.7-2.3-4.4-1.3-1.2.7-1.7 2.3-.9 3.6.1.1.1.2.2.3.4.5.9.9 1.5 1.2 1.5 1.1 3.1 1.9 4.6 3-1.3.9-2.8 2.1-4.1 3-.5.3-1 .7-1.4 1-1.2.9-1.4 2.5-.6 3.6 0 0 0 .1.1.1 1.5 1.9 3.4.5 4.9-.5l4.8-3.5C30 26.9 32 25.3 32 24c0-1.3-1.9-2.4-3-3.2zm11.7-.1C39.1 12.8 32.1 7.1 24 7 14.6 7 7 14.6 7 24c0 5.1 2.3 9.9 6.1 13.1 7.2 6 18 5 24-2.2 3.3-4 4.6-9.2 3.6-14.2zm-5.1 5.6c-1.3 6.4-7.5 10.6-14 9.3-6.4-1.3-10.6-7.5-9.3-14 1.3-6.5 7.5-10.6 14-9.3 1.3.3 2.6.8 3.8 1.5 4.3 2.7 6.5 7.6 5.5 12.5z",
    fill: "currentColor"
  }))), _symbol738 || (_symbol738 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-youku-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "youku-small"), /*#__PURE__*/React.createElement("path", {
    d: "M14.7 10.3L12 8.4c-.7-.5-1.4-1.2-2.3-.7-.6.4-.9 1.3-.5 1.9 0 .1.1.1.1.2.2.2.5.5.8.6.8.6 1.6 1 2.4 1.6-.7.5-1.5 1.1-2.2 1.6-.3.2-.5.4-.8.5-.6.5-.7 1.3-.3 1.9.8 1 1.8.3 2.6-.3l2.6-1.8c.7-.5 1.8-1.3 1.8-2 0-.6-1-1.2-1.5-1.6zm6.1 0C20 6.1 16.3 3 12 3c-5 0-9 4-9 9 0 2.7 1.2 5.2 3.3 6.9 3.8 3.2 9.5 2.7 12.7-1.2 1.7-2 2.4-4.8 1.8-7.4zm-2.6 2.9c-.7 3.4-4 5.6-7.4 4.9-3.4-.7-5.6-4-4.9-7.4.3-1.4 1-2.7 2.1-3.6 2.6-2.1 6.6-1.8 8.8.9 1.2 1.4 1.7 3.4 1.4 5.2z",
    fill: "currentColor"
  }))), _symbol739 || (_symbol739 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-youtube-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "youtube-large"), /*#__PURE__*/React.createElement("path", {
    d: "M38.7 18s-.3-2.1-1.2-3c-1.1-1.2-2.4-1.2-3-1.3-4.2-.2-10.5-.2-10.5-.2s-6.3 0-10.5.3c-.6.1-1.9.1-3 1.3-.9.9-1.2 3-1.2 3S9 20.4 9 22.9v2.3c0 2.4.3 4.8.3 4.8s.3 2.1 1.2 3c1.1 1.2 2.6 1.2 3.3 1.3 2.4.2 10.2.3 10.2.3s6.3 0 10.5-.3c.6-.1 1.9-.1 3-1.3.9-.9 1.2-3 1.2-3s.3-2.4.3-4.9v-2.3c0-2.4-.3-4.8-.3-4.8zm-17.8 9.9v-8.4l8.1 4.2-8.1 4.2z",
    fill: "currentColor"
  }))), _symbol740 || (_symbol740 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-youtube-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "youtube-small"), /*#__PURE__*/React.createElement("path", {
    d: "M18.9 9.1s-.1-1-.6-1.4c-.5-.6-1.1-.6-1.4-.6C14.9 7 12 7 12 7s-2.9 0-4.9.1c-.3 0-.9 0-1.4.6-.4.4-.6 1.4-.6 1.4S5 10.2 5 11.3v1.1c0 1.1.1 2.3.1 2.3s.1 1 .6 1.4c.5.6 1.2.5 1.5.6 1.1.1 4.8.1 4.8.1s2.9 0 4.9-.1c.3 0 .9 0 1.4-.6.4-.4.6-1.4.6-1.4s.1-1.1.1-2.3v-1.1c0-.7-.1-1.5-.1-2.2zm-8.3 4.6V9.8l3.8 2-3.8 1.9z",
    fill: "currentColor"
  }))), _symbol741 || (_symbol741 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "aui-icon-zhihu-large",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "zhihu-large"), /*#__PURE__*/React.createElement("path", {
    d: "M9 36.8c1.5.5 3.1.4 4.5-.4 2.2-1.3 3.9-7.1 3.9-7.1l5.2 6.4s.5-3.1-.1-3.9c-.6-.8-3.6-4.4-3.6-4.4l-1.3 1.2.9-3.8H24s0-2.3-1-2.4c-1.1-.1-4.6 0-4.6 0v-7h5.1s-.1-2.3-1-2.3h-8.3l1.3-3.8s-2.1.1-2.8 1.4c-.7 1.3-3.1 8-3.1 8s.8.4 2.2-.6c.9-.7 1.5-1.7 1.8-2.7l2.5-.1.1 7.1s-4.2-.1-5.1 0c-.9.1-1.4 2.4-1.4 2.4H16c-.4 2.4-1.1 4.7-2.2 6.8A18.4 18.4 0 0 1 9 36.8zm19.2-.2l3.7-2.6H37V13H25.4v21h2.1l.7 2.6zm-.4-21.2h6.8v16.3h-2.4L29.1 34l-.7-2.4h-.6V15.4z",
    fill: "currentColor"
  }))), _symbol742 || (_symbol742 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "aui-icon-zhihu-small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "zhihu-small"), /*#__PURE__*/React.createElement("path", {
    d: "M3 20.4c.9.3 1.9.2 2.7-.2C7 19.4 8 15.9 8 15.9l3.2 3.9c.2-.8.1-1.6-.1-2.4-.3-.5-2.1-2.6-2.1-2.6l-.8.7.6-2.3h3.4s0-1.4-.7-1.4H8.7V7.5h3.1s0-1.4-.6-1.4h-5L7 3.8s-1.3.1-1.7.9c-.4.8-2 4.9-2 4.9s.5.2 1.3-.4c.5-.4.9-1 1.1-1.7l1.5-.1v4.3H4.1c-.5 0-.8 1.4-.8 1.4h3.9c-.2 1.6-.6 2.9-1.3 4.2-.8 1.2-1.7 2.3-2.9 3.1zm11.6-.1l2.2-1.6H20V6h-7v12.7h1.2l.4 1.6zm-.2-12.9h4.1v9.9H17l-1.9 1.4-.4-1.4h-.4l.1-9.9z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudiSprite);
export default __webpack_public_path__ + "static/media/audi-sprite.c202ebe83271e21dad0f64ce25e1ea75.svg";
export { ForwardRef as ReactComponent };